import { getImgUrl } from "../Utility/Utility";

// start live shows
// export const ShowsPostsData = [

// 	{
// 		id:1,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Tom Jones \n Tel Aviv ",
//         smltitle: "The one and only Tom Jones returns to Tel Aviv for one live performance",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.tomjones.com/">
// 												www.tomjones.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/1/1.jpg"} class="img-responsive" />
// 						</div>

// 						<p>
// 							At the request of the audience and after the success of his sold-out show in 2013, the legendary performer Tom Jones returns to Israel for one live performance, to be held in Tel Aviv on Wednesday, June 28, 2017.
// 						</p>

// 						<p>
// 							Tom Jones, a world-famous living legend, is known for not allowing the diverse audience that fills his halls to sit quietly for a moment. He is a performer who captures the hearts of men and women of all ages, crosses generations and genres with his infinite inherent talent and his powerful and unique voice.
// 						</p>
// 						<p>
// 							Tom Jones has had an amazing stage career and sold over 100 million records. He has been awarded many titles including the Brit Awards for his immense musical contribution and Lifetime Achievement Award for his many achievements in the world of music and live performances at the Silver Clef (annual British Music Awards). For his contribution to the music industry, he won a star on the Hollywood Walk of Fame. In 1999, Tom Jones was awarded the Order of the British Empire (OBE) and in 2006 His Royal Highness Queen Elizabeth gave him the title of nobility and he became Sir Tom Jones.
// 						</p>

// 						<p>
// 							Jones, recognized across the world as a "hit machine", will be hitting the 24/7 city this June for the second time. As he did in his last sold out show in Tel Aviv to the delight of his audience, will be performing his all-time greatest hits.
// 						</p>
// 						`
// 			}
// 		}

//     },

//     {

//       id:2,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Britney Spears \n  Live in Concert",
//         smltitle: "Britney Spears- performing all her greatest hits in the fabulous city of Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											03.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.britneyspears.com">
// 												www.britneyspears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/2/1.jpg"} class="img-responsive" />
// 						</div>

// 						<p>
// 							Pop Icon Britney Spears is coming to Tel Aviv for the first time ever, for one show only, as part of her international tour of Asia. The show will take place in stunning Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
// 						</p>

// 						<p>
// 							Pop Icon Britney Spears will be coming to Israel for the first time ever for one show only as part of her international tour of Asia. The show will take place in Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
// 						</p>
// 						<p>
// 							Multi-platinum, Grammy Award-winning pop icon Britney Spears was born in Mississippi and raised in Louisiana, Spears became a household name as a teenager when she released her first single “…Baby One More Time,” a Billboard Hot 100 No. 1 smash and international hit that broke sales records with more than 20 million copies sold worldwide and is currently 14x Platinum in the U.S.
// 						</p>

// 						<p>
// 							Spears is one of the most successful and celebrated entertainers in pop history with nearly 150 million records worldwide. In the U.S. alone, she has sold more than 70 million albums, singles and songs, according to Nielsen Music.
// 						</p>

// 						<p>
// 							Britney’s live concerts are renowned for their amazing production and nonstop energy. Her first ever show in Tel Aviv is likely to feature some of her most recent songs from her Glory Album, including massive 2016 hit ‘Slumber Party’, and also some of her massive all-time hits such as ‘Baby One More Time’ and ‘Oops I Did It Again’!
// 						</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:3,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Tears for Fears",
//         smltitle: "Tear for Fears in Tel Aviv for the first time ever!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											05.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.tearsforfears.com">
// 												www.tearsforfears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 						<p>
// 							This summer, the trendy city of Tel Aviv is embracing it’s 80s vibe for one performance only by the incomparable Tears for Fears. The legendary British pop/rock band that is responsible for many unforgettable hits is coming to the rocking city of Tel Aviv for a single awesome performance!
// 						</p>

// 						<p>
// 							Originally from Bath, Avon, Tears for Fears was founded in 1981 and was associated at first with the new wave synthesizer bands but later on became a part of mainstream rock and pop and hit international success. During the 80's the band released 3 albums that were a combination of pop, new wave and rock. Their first album from 1983, "The Hurting", reached number one in the UK albums chart and was a platinum-selling album. It included major hits such as "Pale Shelter", "Change", and "Mad World". Their second album, "Songs from the Big Chair", followed the same path and reached number one on the US Billboard 200, getting multi-platinum status in the UK and the US. It contained unforgettable hits such as "Shout", "Head Over Heels" and "Everybody Wants to Rule the World" which won the Brit Award for best British single in 1986. Their third successful album "The Seeds of Love" that came out in 1989 included the epic songs "The Seeds of Love", "Sowing Woman in Chains" and many more.
// 						</p>
// 						<p>
// 							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans
// 						</p>
// 						<p>
// 						Tears for Fears’ albums and singles were sold in tens of millions of copies and their songs were covered by other artists countless times. Last year the band announced they are working on a new album to be released during 2017. This July they will be gracing the nonstop city of Tel Aviv for the first time with a single performance, guaranteed to be a night to remember.
// 						</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:4,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: " Guns N' Roses  \"Not in this Lifetime\"",
//         smltitle: "Legendary Guns N' Roses is Coming Back to Rock Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											15.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.gunsnroses.com">
// 											www.gunsnroses.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/4/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								After their celebrated reunion tour last summer, which became the most profitable musical rock concert in 2016, Guns N' Roses, one of the world's most important and beloved rock bands, is coming to Tel Aviv as part of its successful tour with has already added more than 30 shows in the US and Europe.
// 							</p>

// 							<p>
// 								The concert in Tel Aviv will take place on Saturday, July 15 and, 17 at the Yarkon Park, and will close the European tour.
// 							</p>
// 							<p>
// 								Twenty-three years after standing together on the stage in Tel Aviv for the first time, the three original members of the ensemble will come back again: vocalist Axel Rose, guitarist Slash and bassist Duff McGinn, along with an impressive ensemble of musicians including drummer Frank Ferrer, keyboardist Dizzy Red (who was an integral part of the band in the 1990s) Guitarist Richard Fortus and keyboardist Melissa Reyes.
// 							</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/4/2.jpg"} class="img-responsive" />
// 							</div>

// 							<h3>
// 							"Not in this Lifetime"
// 							</h3>
// 							<p>
// 							Since their first reunion concert at Cochlea Festival last April, the band's tour has become one of the most sought-after shows in America with more than 2 million tickets sold.
// 							</p>
// 							<p>
// 								The success and numbers of the current tour show more than anything else that the audience's love of the band's music and rock music is more relevant and bigger than ever. The historic tour last summer visited 21 cities (25 performances) in North America.
// 							</p>
// 							<p>
// 								The band has recently completed a successful tour in South America, Brazil, Argentina and Mexico. All of band's new tour dates are completely sold out, generating massive interest among audiences. In January, the band will continue to Japan and from there to Australia, Thailand, Singapore, Dubai and will arrive in the “nonstop city” of Tel Aviv in July.
// 							</p>
// 						`
// 			}
// 		}

// 	},

// 	{
//         id:5,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: " RADIOHEAD  \n Tel Aviv",
//         smltitle: "The trailblazing RADIOHEAD bringing their iconic repertoire to Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											19.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.radiohead.com">
// 											www.radiohead.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/5/1.jpeg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Preforming in Tel Aviv for the second time ever, Radiohead has managed to remain innovative, relevant and especially moving since first visiting here 17 years ago . It is a band blessed with superhuman ability to meld together distant musical influences to create a new identity for themselves and their listeners; A band whose compulsive tendency to experiment with groundbreaking sound echoed the impact of entire generations of artists and shattered it to the walls of superfluous genres; A band that changed the way we listen to music, make music, see music, think music and even buy music. Now, 17 years after they last visited here, Radiohead is coming to a concert in Tel Aviv.
// 							</p>

// 							<p>
// 								Watching Radiohead's show, it becomes clear that first and foremost, they are the authors and performers of a huge amount of unforgettable songs. Their repertoire manages to be on the one hand familiar, classical - most of us know it by heart - and on the other hand revolutionary, developing and surprising. The tight performance of the ensemble, along with the unique energy of the soloist, Tom York, transforms each performance into a one-time live experience that attracts huge audiences, to participate in the celebration of artistic evolution, to see how they grew, evolved and reinvented themselves time and time again.
// 							</p>

// 							<p>
// 								Today's Radiohead is a band with a more contemporary presence than ever before, with a glorious past and a variety that transcends all cataloging: a band that began with the Immortal Grange anthem of Creep; Slapped critics over the head with the alternative masterpiece The Bends and then committed commercial suicide - and reached heaven - twice! - with two of the best albums of all time, OK Computer and Kid A.
// 							</p>

// 							<p>
// 								The new generations who discover Radiohead through their new works - In Rainbows a favorite in Israel or the new and acclaimed album A Moon Shaped Pool - discover a band whose influences have permeated every musical genre today: rock, electronic, world, hip hop. Today's Radiohead is more than just another band, it is a world - with a unique visual language, exceptional imagery, an unreplaceable atmosphere and inner humor. Especially in Israel - a country that has always enjoyed an intimate and warm relationship with the band - Radiohead's performance is a cultural experience of the rarest kind.
// 							</p>
// 							<p>
// 							This concert will not have assigned seats, Golden Ring, VIP, unfair prices or any other division of class. Anyone who wants to sit is welcome to bring a blanket, and anyone who wants to stand close to the stage is welcome to arrive early, the ticket price is equal to all, and as many people as possible will be able to enjoy this momentous musical event.
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:6,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Pixies",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											25-26.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pixiesmusic.com">
// 											www.pixiesmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<p>
// 								The Israeli summer is always hot, but the Pixies are returning to Tel Aviv after 3 years to make it even hotter!
// 							</p>

// 							<p>
// 								The famous rock band was founded in 1986 in Boston and released its first EP "Come on Pilgrim" in 1987. A year later, when their first album "Surfer Rose" came out, they became a unique voice in the American Rock. 2 years later, they released their second album "Doolittle" that is considered one of the best rock albums of all times. Their third album "Bossanova" came out in 1990 and included unforgettable songs such as "Hang Wire", "Stormy Weather", and "All Over the World".
// 							</p>
// 							<p>
// 							A year later they released their fourth album "Trompe le Monde" that featured songs such as "Planet of Sound", "Distance Equals Rate Times Time" and many more. They fell apart in 1993 but went back to performing together in 2004. After a decade of touring the world, they released their fifth album "Indie Cindy" which included songs like "Another Toe in The Ocean", "Blue Eyed Hexe", and "Jaime Bravo". To this date they released six albums, the last one, "Head Carrier" came out last year. Their biggest hits include "Hey", "Where Is My Mind", "Monkey Gone to Heaven" and "Here Comes Your Man".
// 							</p>
// 							<p>
// 								The band that is known to influence artists such as PJ Harvey and Kurt Kobain will perform this summer in Tel Aviv, giving only 7000 lucky fans the opportunity to see them live and after the rave reviews of their 2014 performance, it’s shaping up to be an unmissable night!
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:7,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Regina Spektor – Back in Israel",
//         smltitle: "Regina Spektor – Back in Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											19.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.reginaspektor.com">
// 											www.reginaspektor.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<p>
// 								Beloved pianist, songwriter and singer Regina Spektor is coming back to Tel Aviv for the third time, closing the worldwide tour of her recent 2016 album “Remember Us to Life” that has gotten excellent reviews.
// 							</p>

// 							<p>
// 								Regina Spektor, whose past concerts in Israel were sold out in 2007 and 2013, will perform again for one time only in Ra’anana Amphitheater on Saturday, August 19.
// 							</p>
// 							<p>
// 								Grammy and VMA nominee Regina Spektor was born in Russia, where she started her classical music training at the age of six and immigrated shortly after to the New York, where she began writing her own original songs. Her first Album came out in 2001 and a year later she already released her second album, “songs”, but her real success started after her third album, Soviet Kitsch, was out in 2004 and the fans started pouring in.
// 							</p>
// 							<p>
// 								Her international breakthrough came in 2006 with her album “Begin to Hope” that reached gold status and sold more than 500,000 copies (!!!). The album includes the single “Fidelity” that is very popular in Israel and in the rest of the world to this day and was used as part of the soundtrack of TV shows such as “Grey’s Anatomy”. Her success only became stronger when her fifth album “Far” and her sixth album “What We Saw From The Cheap Seats” got to the third place in Billboard's album chart.
// 							</p>

// 							<p>
// 								In 2013 Spektor created the theme song of the successful Netflix series “Orange Is the New Black”, called “You’ve Got Time” that also became a radio hit and got her her first Grammy Award nomination. The following year, she sang “Love Me or Leave Me” for the HBO historical crime series “Boardwalk Empire”.
// 							</p>
// 							<p>
// 								Regina Spektor is coming to the non-stop city of Tel Aviv after her sold-out tour in the United States and her old and new fans can’t wait for her show, guaranteed to light up the beautiful summer night of Tel Aviv with it’s amazing infectious energy.
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:8,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Nick Cave & The Bad Seeds",
//         smltitle: "Rock legend Nick Cave & The Bad Seeds returning to Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											19-20.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.nick-cave.com">
// 											www.nick-cave.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<p>
// 								19 years after his last performance in Tel Aviv, the prince of darkness returns once again with his band The Bad Seeds for two shows only to the joy of his fans in what are set to be intimate and unique performances.
// 							</p>

// 							<p>
// 								Australian musician, singer-songwriter, author, screenwriter, composer and film actor Nick Cave is well known as rock musics' "Prince of Darkness" because of his dark, intense tunes. His music is known to be emotionally intense and is characterized by a variety of influences such as death, religion, love and violence. He was called by NME "the grand lord of gothic lushness".
// 							</p>

// 							<p>
// 							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans.
// 							</p>
// 							<p>
// 								Cave started his musical path in the 1970's when he formed "the Boys Next Door" which became a huge success in Melbourne's post-punk scene. Their name was changed to "the Birthday Party" and the band's sound and shows took a rather violent direction and they became known as one of the darkest groups of the 1980's, they fell apart in 1983
// 							</p>
// 							<p>
// 								The end of the Birthday Party was the beginning of Nick Cave and the Bad Seeds in 1983 and they released their debut album the following year. In 1996 the band released its album "Murder Ballads" which featured "Where the Wild Roses Grow", a duet with Kylie Minogue that is also Cave's biggest commercial success to date.
// 							</p>
// 							<p>
// 								Many artists have covered Cave's songs over the years, including Metallica, Johnny Cash, and even the Arctic Monkeys.
// 							</p>

// 							<p>
// 								Nick Cave & The Bad Seeds will perform at the Menora Arena in Tel Aviv on November 19 and an additional date has been added on November 20 due to high demand. For the mere 7,000 fans who will get the chance to look the legendary Nick Cave in the eyes, this is guaranteed to be an unforgettable show!
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:9,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Justin Bieber",
//         smltitle: "Justin Bieber, is landing in Tel Aviv for a single breathtaking concert",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											03.05.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.justinbiebermusic.com">
// 											www.justinbiebermusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/9/1.png"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The artist with the most followers on Twitter 90,149,014
// 								The artist with the most watched official music channel online 13,518,849,954
// 								The artist with the most mentions on Youtube music channel
// 							</p>

// 							<p>
// 							Justin Bieber, the biggest international star of our day, arrives in Israel for just one concert as part of the PURPOSE WORLD TOUR, a tour bearing the name of his last album, which has sold 640,000 copies in just a week and became his bestselling album.
// 							</p>
// 							<p>
// 								Bieber, born in Ontario, Canada, learned to play piano, guitar and drums as a child. At the age of 13, with the help of his mother, he began posting videos on YouTube where he sang covers to artists such as Asher, Stevie Wonder, Chris Brown and others.
// 							</p>

// 							<p>
// 								Scooter Browne, a former marketing director at “So So Def”, was the first to spot Bieber’s talent and invited him and his mother to recordings in Atlanta.
// 							</p>

// 							<p>
// 								In 2008, Bieber was signed by Universal Records, and in 2009, "My World", the first mini-album by Bieber, including "One Time Lonely", "Love Me" and "Favorite Girl" topped the Canadian Billboard charts and the top 40 Billboard Hot 100 hits
// 							</p>
// 							<p>
// 								In 2010, he released his second album, "My World 2.0" with the single "Baby", which became a huge hit and was accompanied by the most watched YouTube video by November 24, 2012.
// 							</p>
// 							<p>
// 								In October 2015, Bieber released the second single from the album "Sorry". The dance clip for the song accumulated over 10 million views in the first 24 hours since its release.
// 							</p>

// 							<p>
// 								In November 2015 he released his fourth album "Purpose", which sold 640,000 copies in the first week and became Bieber’s best-selling album with hits such as "Love Yourself." That same month Bieber made history by placing 17 songs on the American charts and breaking the record held by the Beatles since 1964.
// 							</p>

// 							<p>
// 								In December 2015, Bieber and Skrillex won the Grammy Award for "Where are You Now".
// 							</p>

// 							<p>
// 								Justin Bieber will be performing in Israel on May 3 at Hayarkon Park, with his latest hits "love yourself" and "Sorry" and with the hits "Baby" and "As long as you love me".
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:10,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "AEROSMITH \n \"AERO-VEDERCI BABY\" ",
//         smltitle: " Aerosmith launching its tour in the rocking city of Tel Aviv  ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.aerosmith.com">
// 											www.aerosmith.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/10/1.png"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Aerosmith’s farewell concerts began several months ago in South America and will continue in 2017 in the United States and Europe. the European leg of the tour will begin in Tel Aviv and the band will go on to perform in Georgia, Russia, Germany, Poland, Denmark, Ireland, Italy, Portugal and Spain, including appearances in some of the world's leading rock festivals.
// 							</p>
// 							<p>
// 								For over 45 years, Aerosmith has been the quintessential Rock & Roll band, becoming one of the most influential and loved groups in the world. An endless list of amazing songs, many of them becoming massive worldwide hits, and their groundbreaking live shows have gained the band mass appeal for nearly half a century. Rock & Roll Hall of Fame inductees, Aerosmith, have sold over 100 million albums and won countless awards (including four Grammy Awards, eight American Music Awards, six Billboard Awards, and 12 MTV Awards).
// 							</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/10/2.jpg"} class="img-responsive" />
// 							</div>

// 							<p>
// 								<strong>Steven Tyler</strong> – "Aerosmith just got done ripping through South America like true ambassadors of rock...The band is unstoppable right now and in Europe, we're going to keep doing what we do best... Let The Music Do The Talking...Living On The Edge, and living to rock another day."
// 							</p>

// 							<p>
// 								<strong>Joe Perry </strong> – “It’s been 3 years since we have been on tour in Europe and I can speak for my brothers that we can’t wait to get over there and take it up a few notches. Last tour in South America we were running on all cylinders and I can see no reason to let up now." ;
// 							</p>

// 							<p>
// 							This May, the city of Tel Aviv will be hosting Steven Tyler, Joe Perry, Joey Kramer, Tom Hamilton and Brad Whitford in the beautiful Ganei Yehoshua Park for what promises to be an unforgettable experience and the concert of a lifetime.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:11,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Frankie Valli & The Four Seasons  ",
//         smltitle: " An American Legend in the heart of Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											4.007.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.frankievallifourseasons.com/">
// 											www.frankievallifourseasons.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/11/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The American legend comes to the rocking city of Tel Aviv for the first time ever for an unforgettable 4th of July celebration with the best timeless classics!
// 							</p>
// 							<p>
// 								The original Jersey boy, musical legend Frankie Valli, comes Tel Aviv for the first time for one single performance. Back in the 50’s, Valli started singing in harmonies with different bands in New Jersey, but the success only struck him when he grabbed the microphone in the early 60’s as the lead singer for The Four Seasons that rocked the music world in the next decades with major hits such as “Big Girls Don’t Cry”, “Sherry”, “Walk Like a Man” and more. Valli scored 29 Top 40 hits with The Four Seasons and nine Top 40 hits as a solo artist. The band sold more than 175 million albums and Valli, Tommy DeVito, Nick Massi and Bob Gaudio – the original members of The Four Seasons – were inducted into the Rock and Roll Hall of Fame in 1990 and the Vocal Group Hall of Fame in 1999.
// 							</p>

// 							<p>
// 								At the same time, Valli also has a successful solo career with songs such as the theme song for Grease, and “Can’t Take My Eyes Off You” that was covered by hundreds of artists, from The Pet Shop Boys to Muse. Younger generations got to know Valli from the remarkable musical “Jersey Boys” that tell the story of the band that is responsible for songs that became a part of our life’s soundtrack for over four decades and was turned into a movie which was directed by Clint Eastwood.
// 							</p>

// 							<p>
// 								Ever since he began, Frankie has been performing all over the world, and soon the magic will come to Tel Aviv for one unforgettable show.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:12,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Unite With Tomorrowland",
//         smltitle: "The world’s number one leading EDM festival is coming to Tel Aviv! ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											29.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tomorrowland.com/en/unite-israel/en/welcome">
// 											www.tomorrowland.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/12/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The famous Tomorrowland festival might take place in Belgium, but Tel Aviv is also up for the party! Unite with Tomorrowland brings the party to the hottest city in the Middle East with live connection from the Tomorrowland Mainstage, live local and international DJ’s on the UNITE stage and of course – the magical Tomorrowland atmosphere.
// 							</p>
// 							<p>
// 								The live connection with the Mainstage in Belgium will give the People of Tomorrow the chance to connect with the crowd in Israel and vice versa. 3 mainstage headliners will be broadcasted live on a unique UNITE with Tomorrowland stage and special effects will be synchronized with the show in Belgium, creating a special global connection.
// 							</p>

// 							<p>
// 								The main headliners in Belgium will be Armin Van Buuren who has won best trance DJ at the DJ Awards 9 years in a row, was ranked among the world’s top 4 DJ’s at DJ Magazine 13 years in a row, the known electro-house duo Dimitri Vegas & Like Mike and the house sensation KSHMR. On the UNITE stage in Israel the DJs will be Steve Angello who won the DJ award for best house in 2010, the Israeli trance artist Alien Project, DJ Tomer Maizner, Dor Dekel, Teamworx, and TRIPL.
// 							</p>

// 							<p>
// 								EUnite with Tomorrowland isn’t just a livestream, it’s a one of a kind show that allows you to escape reality and join the magical world of tomorrow.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:13,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "The Chainsmokers",
//         smltitle: "The world’s number one leading EDM festival is coming to Tel Aviv! ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											NEAR Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											3.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thechainsmokers.com/">
// 											www.thechainsmokers.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/13/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Tel Aviv is known for its great dance scene, so it makes perfect sense that the hottest DJ/production duo that everyone is talking about to come to get the city on its feet! The duo is responsible for many current hits such as “Don’t let me go”, “Roses”, and their recent collaboration with Coldplay “Something Just Like This”, and they will perform in Israel as part of their international tour “Memories Do Not Open”.
// 							</p>
// 							<p>
// 								The Chainsmokers consists of Andrew Taggart and Alex Pall. The duo performed live for the first time as the opening for Timeflies in 2014, and their single "#Selfie" was re-released at the same year, leading to breakthrough success as "#Selfie" became a worldwide hit and peaked on the Dance/Electronic chart. In 2015 they released their first EP “Bouquet”, featuring “New York City”, “Until You Were Gone, “Good Intentions” and “Roses”, all of which climbed the international charts and became major hits.
// 							</p>

// 							<p>
// 								A year later, the duo released their singles “Don’t Let Me Down” featuring Daya, “Inside Out”, featuring Charlee, and “Closer” featuring Halsey. The latter peaked at number one in the United Kingdom and the United States. Their success didn’t stop there and after releasing “All We Know” featuring Phoebe Ryan, they were ranked 18th in DJ Magazine’s annual list of “Top 100 DJ’s” in 2016. The same year the duo won favorite electronic/dance music artist at the American Music Awards and top dance/electronic artist at the Billboard Music Awards. A year later “Closer” also won top hot 100 songs, top collaboration and top electronic/dance song at the same Awards ceremony.  “Don’t Let Me Down” also won best dance recording in 2017 at the Grammy awards.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:14,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Dire Straits Experience",
//         smltitle: "Get a shiver in the dark in Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											14.09.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.direstraitsexperience.com/">
// 											www.direstraitsexperience.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/14/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								25 years have passed since Dire Straits disbanded and we last heard that unmistakable sound of Mark Knopfler’s guitar…
// 							</p>
// 							<p>
// 								Close your eyes and get transported back to an original Dire Straits gig. Beautiful inspiring tracks, quality sound, amazing atmosphere, spine tingling riffs, vocals, instrumentals and an outstanding performance.
// 							</p>

// 							<p>
// 								After selling over 25,000 tickets in Israel within the past three years, and in light of the high demand for yet another show, The Dire Straits Experience are coming to Tel Aviv for only one night.  A single performance on the 14th of September at the Menora Mivtachim Arena.
// 							</p>

// 							<p>
// 							   The Dire Straits Experience was founded by saxophonist Chris White after their successful debut playing for a charity event at the Royal Albert Hall where members of the legendary band got back together on stage. News travelled fast, and an increasing global demand to hear the most dramatic songs in rock history played live eventually led to a worldwide tour.
// 							</p>

// 							<p>
// 							    Chris White, who recorded and performed with the rock legends for over a decade, joined Dire Straits for their record breaking “Brothers in Arms” world tour in 1985. This included their famous performance at Live Aid and later the renowned Nelson Mandela 70th birthday concert. White has played with some of the greatest rock stars the world has known, such as Paul Mccartney, Joe Cocker, Mick Jagger, Robbie Williams and many others. Joining Chris White is a stellar band consisting of some of the finest professional musicians the UK has to offer.
// 							</p>

// 							<p>
// 							   “When I was first approached to put together a band to play Dire Straits songs, I didn’t believe it would be possible to find someone who would be able to stand in Mark’s shoes without sounding like an imposter. I was wrong. In Terence Reis, I think we may have found the only person on the planet that is able to play and sing like Mark but maintain his own integrity and identity.”
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:15,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Alan Parsons",
//         smltitle: "The man that said no to Pink Floyd, live in TA",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											11.11.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.alanparsonsmusic.com/">
// 											 www.alanparsonsmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/15/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The musical legend Alan Parsons and his band are coming to Israel for two shows, the first at the Congress Centre in Haifa and the second at the Menorah Mivtachim Arena in Tel Aviv.
// 							</p>
// 							<p>
// 								Parsons has a large following in Israel. In fact, this will be his third visit to the country in order to play on stage. This time they’ll be performing their new “I Robot” tour, commemorating 40 years for the release of the similarly titled mythological album in 1977. You can expect to hear all of their greatest hits of course.
// 							</p>

// 							<p>
// 								Alan Parsons is a renowned musician and one of the most influential musical producers in history. He started out as a sound technician working in the notorious Abbey Road recording studio. Alan became famous after helping to produce Pink Floyd’s masterpiece album “Dark Side of the Moon”. He has worked as a sound technician with others such as The Beatles, Wings, Al Stewart and many more.
// 							</p>

// 							<p>
// 							   In 1975, Pink Floyd invited him to work on their next album “Wish You Were Here”. Alan declined the offer in order to form his progressive rock band “The Alan Parsons Project”. The band succeeded immediately, receiving international acclaim for their huge hits “Eye in the Sky”, “Time” and “Old and Wise” to name a few.
// 							</p>

// 							<p>
// 							   An accomplished vocalist, keyboardist, bassist, guitarist and flautist receiving gold and platinum awards from many nations, Parsons also has ten Grammy Award nominations for engineering and production. Up until today The Alan Parsons Project is one of the most popular events in Europe, with tickets being sold out within hours.
// 							</p>

// 							<p>
// 							   Come indulge your ears and listen firsthand to some of the classics of our time. You can catch the concerts either in Haifa on the 9th of November or in Tel Aviv on the 11th of November.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:16,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Bryan Adams",
//         smltitle: "Bryan Adams to warm our winter with 3 shows",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv & Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											4+5+6.12.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bryanadams.co.il/">
// 											 www.bryanadams.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/16/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								With the summer days way behind us and the days getting shorter, a little winter comfort is necessary. What better way to warm up from the inside than with some romantic ballads and timeless rock anthems. Treat yourself (and someone you love) to a throwback of nostalgia from our younger days, reminding us those sweet moments of slow dancing, first crushes and innocent youth.
// 							</p>
// 							<p>
// 								The Canadian pop rock icon with hits spanning over four decades is coming to Israel for three consecutive shows! Two will performances in Tel Aviv on the 4th and 5th of December at the Menora Mivtachim Arena and one more concert in Jerusalem on the 6th of December at the Pais Arena.
// 							</p>

// 							<p>
// 								Born in 1959 in Kingston, Ontario, Bryan Adams’ music career took off in the early 80’s with the release of his third album “Cuts Like A Knife” which included the hit “Straight From The Heart”. It was his following album “Reckless” that skyrocketed his career and brought his rise to stardom with the hits “Run To You”, “Heaven” and “Summer of ‘69”. Following these hits Adams later brought us the U.S. Billboard Hot 100 number-one singles "Heaven", "All for Love" and "Have You Ever Really Loved a Woman?".
// 							</p>

// 							<p>
// 							  Besides topping the charts in North America and Europe, his songs were nominated for several Grammy, Golden Globe and Academy Awards. His records have collectively sold over 100 million copies worldwide, making him one of the best-selling music artists of all time.
// 							</p>

// 							<p>
// 							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
// 							</p>

// 							<p>
// 							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
// 							</p>

// 							<p>
// 							   Make sure you don’t miss this time-defying legend.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {
//         id:17,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Chris Rock",
//         smltitle: "Coming to Tel Aviv to rock your world ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											8+9.01.18
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.chrisrock.com/">
// 											 www.chrisrock.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/17/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Chris Rock, one of the greatest standup comedians of all time and the funniest people in the world is going on a rare, highly awaited tour for the first time in 9 years. One of his few stops will be in Tel Aviv.
// 							</p>
// 							<p>
// 								The hilarious comedian has put on a new live act, after nearly a decade of focusing on television and film. Chris Rock will make his first ever live on stage appearance in Israel as part of his 2017 “Total Blackout” tour.
// 							</p>

// 							<p>
// 								Born in 1965, he made his breakthrough on SNL (Saturday Night Live) starring next to Adam Sandler, David Spade and Chris Farley. Eddie Murphy helped accelerate his stardom by giving him a role in Beverly Hills Cop 2. Since then it’s been a long line of success, from Lethal Weapon 4, Madagascar, Scary Movie, Nurse Betty and the list goes on. He’s hosted the Academy Awards twice and has also written, directed and produced several movies and TV shows. Despite all this, Chris Rock has and always will shine brightest where he truly belongs, on stage with a microphone.
// 							</p>

// 							<p>
// 							  His previous standup acts: Bigger and Blacker, Born Suspect, Bring the Pain and Kill the Messenger all broke records and are considered to be classics, with bits that are still quoted today.
//                               Rock is often compared to the greatest comedians in the field, alongside Jerry Seinfeld, Louis CK and Dave Chappelle (all of which he’s also collaborated with).

// 							</p>

// 							<p>
// 							   He made it to the top 5 in Rolling Stone magazine’s 50 greatest comedians of all time.
// 							</p>

// 							<p>
// 							   When he gets on stage it’s like seeing a boxer, a preacher and a poet all bundled together into one man. Chris delivers powerful, fast paced, side-splitting punches. His views on relationships, race and politics challenge his listeners and make them rethink everything they know. Rock dares to cross boundaries with his material and is not afraid to shock and surprise.
// 							</p>

// 							<p>
// 							   In an interview he recently gave to Rolling Stone magazine, he talked about his divorce after 18 years of marriage and how he decided to devote himself to standup again. According to him, these events gave rise to the world tour in which he will be performing in Tel Aviv.
// 							</p>

// 							<p>
// 							   Catch Chris live on January 8th at the Menorah Mivtachim Arena.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:18,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Patricia Kaas",
//         smltitle: "The great French singer returns to the white city once again",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											28.09.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.patriciakaas.net/">
// 											  www.patriciakaas.net
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/18/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The famous French singer and actress Patricia Kaas is coming back to Tel Aviv for the third time after her previous performance three years ago became a huge success and recieved incredible reviews. Kaas is considered one of the all-time most successful French singers and her music is a mix of pop, cabaret, jazz, and chanson. She started her career in the late 80’s and very quickly she climbed the charts in France.
// 							</p>
// 							<p>
// 								Kaas’s first single “Mademoiselle chante le blues” that came out in 1987 became a huge hit and got to the top 10 in the French chart. A year later she released her second single “D’Allemagne”, followed by her first album “Mademoiselle chante…” that was ranked number two at the French chart. The album sold over 100,000 copies within less than two months and became a gold album. It didn’t take long and within less than three months more than 350,000 copies were sold and it became a platinum album. Kaas received a platinum album status in Belgium, Switzerland and Canada as well, and at the same year she won the most important French music award – Victories de la Musique.
// 							</p>

// 							<p>
// 								Since then the French phenomenon sold more than 17 million albums worldwide. Her third album “Je te dis vous” brought her major success in Germany, Belgium, Switzerland, Canada, Russia, Finland, Ukraine and Korea. In 2002 she acted in a movie for the first time, it was “And now… Ladies and Gentlemen” in which she performed with the British actor Jeremy Irons. In 2009 she represented France at the Eurovision contest and got to the 8th place.
// 							</p>

// 							<p>

//                                    Patricia Kaas is responsible for many hits and her songs became a part of our lives. The talented musician is coming back to Tel Aviv to sing her famous repertoire and bring back the nostalgia to the nonstop city.

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:19,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Blue Man Group",
//         smltitle: "The phenomenal musical group is returning to Tel Aviv once again for a show like no other!  ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											 7-23.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.blueman.com/">
// 											  www.blueman.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/19/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Blue Man Group is coming to Tel Aviv as a part of their 25 years of living in full-color tour! This is a show unlike anything you have ever seen before that combines music, theater, art and technology.
// 							</p>
// 							<p>
// 								Originally Formed in New York in 1988 by three close friends, Chris Wink, Matt Goldman and Phil Stanton, Blue Man Group originated as a celebration of the end of the 1980s. The three men wore blue masks and led a procession that included the burning of a Rambo doll and a piece of the Berlin Wall. They caught the eye of an MTV reporter and gained attention. They started with small acts on the streets of New York, growing into shows at downtown clubs, eventually becoming a full performance at the Astor Place Theatre in 1991.
// 							</p>

// 							<p>
// 								In 1999 the band released its first gold album “Audio” and it was nominated for the Grammy Award for Best Pop Instrumental Performance. Their second album, “The Complex” (2003), features collaborations with various musicians like Gavin Rossdale, Dave Matthews and many others. It charted four songs on the Billboard charts. In 2006 they released “Live at The Venetian – Las Vegas” which was an iTunes exclusive, and their most recent album, “THREE”, came out in 2016 and was also nominated for the Grammy Award.
// 							</p>

// 							<p>

//                                  Currently, the Blue Man Group is performing on a regular basis in five theaters around the world- in Vegas, New York, Boston, Orlando and Berlin. They recently launched their new book “Blue Man World” that tells the story of the blue man from their perspective.  Three blue people that will take you on a crazy adventure full of music, laughter and surprises. More than 35 million people worldwide have already seen them, not it’s your turn!

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:20,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Sean Paul",
//         smltitle: "The international mega star is coming to make our summer sizzle!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv Outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											22.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.allseanpaul.com/">
// 											  www.allseanpaul.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/20/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The Grammy winner dancehall artist, Sean Paul will return to Tel Aviv for a single hot hot hot hot performance.
// 							</p>
// 							<p>
// 								Sean Paul will arrive in Tel Aviv for the third time as part of his new international tour. The artist is currently storming the international charts with a string of hits that including collaborations with some of the most popular names in music including Sia, Anne-Marie and more.
// 							</p>
// 							<p>
// 							    His extraordinary voice, rhythms, catchy songs and super-polished productions all combine the winning recipe of the Grammy winner and international star - Sean Paul. Originally known as Sean Paul Ryan Francis Henriques, Sean Paul was born in Jamaica in 1973. His musical career soared in 2002 with the tremendous success of his second studio album, "Dutty Rock," mainly for the songs "Gimmie The Light" and "Get Busy" Hot 100 chart toppers). Sean Paul has managed to maintain his relevance in the music industry since breaking into fame in the year 2000 until now with a string hits such as Cheap Thrills, Rockabye, No Lie, and Body.
// 							</p>

// 							<p>
// 							   Sean Paul studied at the University of Technology in Jamaica with aspirations for a career in the hotel industry, but his passion for music took over. The single ‘Baby Girl’ was the first to mark his successful career as a recording artist and led to his debut album ‘Stage One’ at VP Records. To date, he has released six studio albums; the last five were all nominated for the Grammy Award.
// 							</p>
// 							<p>
// 							   The album "Dutty Rock," 2002, earned him the Grammy Best Reggae Album. "The Trinity," 2005, reached platinum status in Europe and the Recording Industry Association in the United States. His albums, "Imperial Blaze" in 2009 "Tomahawk Technique" in 2012, and the last one was released in 2014 - "Recent Full Frequency" – were all warmly received and highly acclaimed.
// 							</p>

// 							<p>

//                                   His hard work, perseverance, and dedication over the years have earned him several nominations for the Grammy and Billboard awards. His most notable accomplishments include An American Music Award, Mobo Awards, Soul Train Awards, MTV Music Awards, ASCAP Rhythm and Soul Music Awards, a Source Award and a BET Award.

// 							</p>

// 							<p>
//                                 Sean Paul maintains a multinational presence thanks to his collaborations with artists in a wide variety of genres such as EDM, Soca, Pop, Afro-Beat and Latin music. His icon status allows him to maintain an immense fan base in Latin America, Japan, Europe and the US and his relationship with the Spanish audience received a serious boost, following his collaboration with the singer Farruko in the single Passion Whine and of course the legendary collaboration with Enrico Iglesias ‘Bailando’ which became no.1 in 33 (!) countries and gained millions of views on YouTube.
// 							</p>

// 							<p>
//                                Sean's collaborations throughout his career include numerous international collaborations with hip-hop stars such as Busta Rhymes, Beyoncé, Rihanna, Keyshia Cole, Kelly Rowland, Juicy J, 2Chainz and Nicki Minaj.
// 							</p>

// 							<p>
//                                Sean Paul performs regularly on the biggest most respectable venues in the world and enjoys a huge following from a worldwide audience of all ages.
// 							</p>

// 							<p>
//                                His last performance in Tel Aviv received fantastic revues from critics and fans alike, and he is back on popular demand, promising to make the hot summer scorch even more with a what is guaranteed to be a party like no other!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:21,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "The Pretenders",
//         smltitle: "The legendary rock band and Chrissie Hynde are coming to rock out Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											23.09.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thepretenders.com/">
// 											  www.thepretenders.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/21/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								For the past three decades Chrissie Hynde and The Pretenders stayed at the top of the British rock and won the hearts of millions of fans. Hynde took a long break from writing and recording new materials but after the raving reviews the band’s most recent album, “Alone” got, she and The Pretenders are back on a world tour and are now coming for one unforgettable show in Tel Aviv!
// 							</p>
// 							<p>
// 								The band started its way in the music world in England in 1978 and experienced numerous subsequent personnel changes, with Chrissie Hynde being the only consistent member. The original band was active until 1982 and released its first album (Pretenders) that was a success in the United Kingdom and the United States both critically and commercially. The band got to No. 1 in the UK with its single "Brass in Pocket", which was also successful in the US, reaching No. 14 on the Billboard Hot 100.
// 							</p>

// 							<p>
// 								Later on the band released nine more albums - Pretenders II (1981), Learning to Crawl (1984), Get Close (1986), Packed! (1990), Last of the Independents (1994) which was rated gold in the US, Viva el Amor (1999), Loose Screw (2002), Break Up the Concrete (2008) which was among the Top 40 album in the US, and The Pretenders’ most recent album - Alone (2016). During March 2005, the Pretenders were inducted into the Rock and Roll Hall of Fame. Among their most famous song one can remember “Brass in pocket”, “Hymn to her”, “Don’t get me wrong”, “I’ll stand by you”, and many others.
// 							</p>

// 							<p>

//                                   The Pretenders worked carefully on their new show and started their new tour at the Royal Albert Hall in London, which was full with fans that showed how much they missed the incredible band. Hynde and The Pretenders performed in music festivals all over the world, and they’ll start the second part of their tour right here in the rocking city of Tel Aviv, make sure not to miss it!

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:22,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Cliff Richard",
//         smltitle: "The incomparable Cliff Richard coming back to Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											10.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.cliffrichard.org/">
// 											  www.cliffrichard.org
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/22/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Cliff Richard, the beloved British artist who previously performed in the fabulous city of Tel Aviv more than 20 years back, is coming back to the delight of his local fans.
// 							</p>
// 							<p>
// 								Over his long and illustrious career, the 72-year-old Cliff Richard has sold more than 260 million records worldwide and is best known for his tunes "Fallen angel Woman," "We Don't Talk Anymore," "The Young Ones," "Summer Holiday," and "Congrats" .
// 							</p>

// 							<p>
// 								Richard has a long list of hits and is responsible for many worldwide beloved songs. He has sold over 21 million singles in the UK and has become an intrinsic part of the nation’s soundtrack.
// 							</p>

// 							<p>

//                                  Richard has had eight US Top 40 singles, including the million-offering "Demon Woman" and "We Don't Talk Anymore". In Canada, Richard made a real splash during the mid-1960s, and again in the late 1970s and mid-1980s with a few singles and collections achieving gold and platinum status. He has remained a prominent music, film, and TV character in Australia, New Zealand, South Africa, Northern Europe and Asia, and has a strong following.

// 							</p>

// 							<p>
// 							   Throughout his career, spanning over 50 years, Richard has amassed numerous gold and platinum records and awards, including three Brit Awards—winning Best British Male Singer twice and the Brit Award for Outstanding Contribution to Music, as well as two Ivor Novello Awards. He has had more than 130 singles, collections and EPs make the UK Top 20, more than any other artist.
// 							</p>

// 							<p>
// 							   Richard has had 67 UK top ten singles, including one written for the great Elvis Presley.  He has had 14 UK No. 1 singles and is the leading vocalist to have had a No. 1 single in the UK in five back to back decades: the 1950s through to the 1990s.
// 							</p>

// 							<p>
// 							   This October, after much anticipation, Cliff Richard is coming to Tel Aviv to sing his mind-blowing songs live, in his unmatchable performing style. Come watch the living legend himself on-stage in the exciting city of Tel-Aviv!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:23,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "DGTL Festival",
//         smltitle: "An awesome digital celebration in the one of the world’s Digital Capitals",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											05.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://tlv.dgtl.nl/en/?skip_portal=1">
// 											  www.tlv-digital.nl
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/23/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The first ever of its kind in the country, the DGTL festival is a dream come true for the music and nightlife scene of this buzzing metropolis. The DGTL festival is set to be by far the biggest electronic music event held in Tel Aviv, which is considered one of the nightlife capitals of the world.
// 							</p>
// 							<p>
// 								DGTL Festival, making its Tel Aviv debut this October originates in Holland and takes place each year in the most trendy capitals including Amsterdam, Sau Paulo, and Barcelona.
// 							</p>

// 							<p>
// 								The festival is an innovative technology centered event showcasing some of the world’s greatest biggest names in the digital scene alongside new hot up and comers from the industry. Tickets are often sold out in advance, and dozens of DJs and leading artists show off their talents in this a multi-sensory experience of art, music, lighting and uncompromising production standards throughout the:
// 							</p>

// 							<p>

//                                The festival has a unique and electrifying atmosphere, and audiences will also get to enjoy a variety of food stalls, art, and meticulous sound.

// 							</p>

// 							<p>
// 							   The festival will include three stages featuring excellent music at any given moment.
// 							</p>

// 							<p>
// 							   The fantastic international line up is set to include:
// 							</p>

// 							<p>
// 							  Maslow Flux, Marcel Dettman, John Talabot, Red Access, Jennifer Cardini, Avalon Emerson, Young Marko, Yotam Avni, Otarki, Joba Jobsa and many others.
// 							</p>

// 							<p>
// 							  This huge production will be launched for the first time in October 2017. In addition to being an innovative music festival, DGTL is held under the theme of environmental preservation and sustainability and is considered the greenest festival in Europe. Also, DGTL festival promotes vegetarian food only and develops a unique program for recycling materials. Alongside the local audience, the festival will be marketed in 50 countries, and thousands of music fans from all over the world are expected to arrive in Tel Aviv to take part in the party.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:24,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Richard Clayderman",
//         smltitle: "The famous pianist returns to perform in Israel with all his unforgettable hits!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											17.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.clayderman.co.uk/">
// 											  www.clayderman.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/24/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Romance lovers, prepare yourselves – after his last show in Israel three years ago, the famous French pianist Richard Clayderman returns to the holy land as a part of his new tour that marks 40 years of an outstanding career!
// 							</p>
// 							<p>
// 								Clayderman recently turned 63 and he is one of the world’s most successful pianists with a rich and diverse career that started four decades ago. He recorded over 1200 songs and his biggest hit ever is “Ballade Pour Adeline” that was sold in 22 million copies in 38 different countries. Clayderman is considered one of the world’s most successful instrumental artists along with others like Kenny G and more.
// 							</p>

// 							<p>
// 								During his career, Richard Clayderman sold more than 85 million albums and had more than 340 gold and platinum albums. He created a new romantic style through a repertoire that combines his original melodies with classics and pop standards. The phenomenal artist devoted much of his time to performing, going as far as playing 200 shows in 250 days. The Guinness Book of World Records noted him as “the most successful pianist in the world”.
// 							</p>

// 							<p>

//                                His previous visits in Israel were extremely successful with multiple sold out concerts. In his upcoming shows in Israel, Clayderman will play a selection of his best pieces, including the 12 minutes of the “Titanic Symphony”, “Don’t Cry for Me Argentina”, “Love Story”, “Ballade Pour Adeline”, and song from other famous movies such as “West Side Story”, “Harry Potter Melody” and “The Schindler List”. Come listen to the outstanding pianist who has touched the heart of millions around the world!

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:25,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Smokie",
//         smltitle: "Smokie, coming to light up the stage this fall in Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv + Jerusalim
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											28+31.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//smokie.co.uk/Band">
// 											  www.smokie.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/25/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Smokie, the iconic British rock band is coming back to Tel Aviv to rock it out in the city this fall.
// 							</p>
// 							<p>
// 								Smokie initially rose to fame in the 1970's and is most know for its chart topping hits 'Living Next Door to Alice', 'Lay Back in the Arms of Someone', and "If You Think You Know How to Love Me.'
// 							</p>

// 							<p>
// 								The band has had 13 top twenty hits during the 1970s and has sold more than 30 million albums.
// 							</p>

// 							<p>

//                               Initially formed in Yorkshire, England, in 1966, Smokie hit the British pop charts a few times amid the late '70s with a fresh pop style.  The quartet recorded many singles amid the late '60s and mid '70s, and in 1975 hit number three in the U.K. with "If You Think You Know How to Love Me."

// 							</p>

// 							<p>
// 							   After another Top Ten hit, "Don't Play Your Rock’n’ Roll to Me,” the band made it big with three Top 20 hits, including "Living Next Door to Alice." Smokie hit number five both in 1977 ("It's Your Life") and 1978 ("Oh Carol(".
// 							</p>

// 							<p>
// 							   The band has performed in Tel Aviv several times and are returning shortly after their last visit to the non stop city with an extremely successful run two years ago. The Tel Aviv concert will be a part of the band’s new tour which includes England and many countries around Europe and which also includes musicians Martin Bullard, Mick McConnell, Mike Craft, Steve Pinnell and Terry Uttley.
// 							</p>

// 							<p>

// 							    Smokie’s songs have gained iconic status over the years and have been covered multiple times due to their catchy style. The band enjoys a strong fan base in the country and regularly fills every seat in the house in each of their performances. The band will be playing its greatest hits to the joy of their fans which will flock to see the rock legends in action in Tel Aviv.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:26,
//         bgImage :"/posts/bank/15/1.jpg",
//         mobBgImage :"/posts/bank/15/M.jpg",
//         title: "Foreigner",
//         smltitle: "The 80's are back to rock Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											02.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.foreigneronline.com/">
// 											  www.foreigneronline.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/26/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The 80's are coming back! The British-American hard rock group is returning once again to the amazing city of Tel Aviv. The band is returning to Israel again after 3 sold out concerts in the past – one in 2014 and two in 2016, which got incredible reviews.
// 							</p>
// 							<p>
// 								Foreigner was founded in New York in 1976 by veteran English musician Mick Jones, ex-King Crimson member Ian McDonald and American vocalist Lou Gramm. The band focused more on commercial rock and is remembered mostly for its soft ballads that topped the charts worldwide.
// 							</p>

// 							<p>
// 								The rock group released its debut album in 1977 which provided one of its most popular hits "Cold As Ice", but the band's real breakthrough happened in the early 1980's when they released the album "4". Their success continued as they released their next album "Agent Provocateur" in 1984, as well as in their last one- "Can't Slow Down", in 2009.
// 							</p>

// 							<p>

//                               The band has sold over 80 million records worldwide in the past 3 decades, out of them 37.5 were sold in the United States alone, making it one of the bestselling bands in the history. Their most memorable hits include "Waiting for a Girl Like You", "I Want to Know What Love Is", "Urgent", "Juke Box Hero", and "That Was Yesterday".

// 							</p>

// 							<p>
// 							  Come rock with the American-British legend and bring the 80's back to life in a one of a kind concert!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:27,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Carcass",
//         smltitle: "The British metal legends are coming <br>to rock the city that never sleeps!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											09.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.facebook.com/OfficialCarcass/">
// 											  facebook.com/OfficialCarcass
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/27/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The British extreme metal band was formed in 1985. They started as a school band by Bill Steer and Ken Owen, and the latter left the band soon after. Steer then joined the D-beat band Disattack and played with drummer Middie, bassist Paul and the lead singer Andrew Pek. The band later changed its name to Carcass as the members changed their musical direction. The band recorder only one album with Pek, who changed his name to Sanjiv, and shortly after "Flesh Ripping Sonic Torment" was released he left the group.
// 							</p>
// 							<p>
// 								The vocal duties were shared between Walker, Steer and Owen, and together they recorded a debut album in only four days.  The band wasn't pleased with the poor production of their album "Reek of Putrefaction" but it became a favorite of Radio 1 DJ John Peel. His interest in them made them participate in his first "Peel Session", in which they released materials for their second album.
// 							</p>

// 							<p>
// 								Carcass are considered to be the pioneers of the grindcore genre, although their early work is considered to be more splatter death metal, hardgore and goregrind. The band also became one of the pioneers of melodic death metal with their album "Heartwork" which was released in 1993. Their lyrics usually focus on animal rights issues, as both Jeff Walker and Bill Steer are vegetarians.
// 							</p>

// 							<p>

//                               In 2013 the band signed with Nuclear Blast, and in Japan they signed with Trooper Entertainment for the release of their new album. They released "Surgical Steel", which received extremely positive reviews and earned Top 50 position on the US Billboard 200 charts. Soon afterward they headlined Damnation Festival in Leeds and then performed at 70000 Tons of Metal in 2014 and headlined the Agglutination Festival the same year.

// 							</p>
// 							<p>
// 							   The band is coming to give only one show in the nonstop city of Tel Aviv, which is guaranteed to be an extraordinary experience for all the metal fans out there, make sure to get your ticket now!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:28,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Kygo",
//         smltitle: "The Norwegian house phenomena for the first time ever in Tal Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											02.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.kygomusic.com/">
// 											  www.kygomusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/28/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Kygo, originally a Norwegian pianist, became a tropical house music producer in no time. "Spotify" announced him as the biggest discovery of 2015 after his songs "Firestone" and "Stole the Show" were played over a billion times. Both of these songs also received gold and platinum status in 16 countries.
// 							</p>
// 							<p>
// 								His first album, "Cloud Nine", reached the top of the dance albums chart on "Itunes" and also on the electronic albums chart of Nielsen Soundscan. The house sensation preformed in the most popular TV shows in the United States such as "The Late Late Show" with James Corden, "The Tonight Show", "Good Morning America" with Jimmy Fallon and on Ellen Degeneres. Moreover, he was on the cover of the biggest magazines – "The Billboard", "Haute Living Magazine", "LA Times", "USA Today", "The Wall Street Journal", "The Rolling Stones", "Forbes" and more.
// 							</p>

// 							<p>
// 								Kygo started his musical journey at the age of 6 when he started learning how to play the piano. It took almost a decade for the classical music to step aside and for the new love in his life to take over – Electronic music. He only decided that he wants a career in the music industry a moment before he was about to graduate from his economics and business degree.
// 							</p>

// 							<p>

//                               His first significant breakthrough was with the hit "Firestone" that shortly grabbed the attention of tens of millions of listeners. Aviici played it in his sets and in festivals. Afterwards Coldplay's lead singer, Chris Martin, gave him permission to create a remix of their song "Midnight". Kygo's unique sound led him to incredible achievements, such as the hit "ID" that was featured in Ultra Festival's official trailer and in the playlist of FIFA 2016.

// 							</p>
// 							<p>
// 							  The extraordinary house sensation is coming to rock Tel Aviv for the first time ever, for one show only. His shows in New York and Hollywood were sold out, and the reviews were incredible. This is guaranteed to be a night to remember, you definitely want to be there!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:29,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Led Zeppelin 2",
//         smltitle: "Don’t Miss the Zeps in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv, Haifa and Be'er Sheva
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											07-10.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//zep2.com/">
// 											  www.zep2.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/29/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The tribute band from Chicago Led Zeppelin 2, which was named after the mythological band's second album, is coming to Israel for 4 shows only. Come feel the old Led Zeppelin vibes and kick it with the ultimate Led Zeppelin experience here in rocking Tel Aviv
// 							</p>
// 							<p>
// 								Led Zeppelin 2 have been performing  for over a decade and are considered to be the ultimate Led Zeppelin experience. The band consists of 4 musicians from the indie-rock, jazz and metal scene in Chicago. The lead singer, Bruce Lamont, who took the place of the legendary Robert Plant, is also a part of the avant-garde metal group "Yakuza", and he has collaborated with bands like "Dyslexic Apaches", and "Circle of Animals". His solo album "Feral Songs for The Epic Decline" was recently rated among SPIN magazine's top 20 metal albums.
// 							</p>

// 							<p>
// 								Greg Fundis, the group's drummer, is playing with leading musicians among which one can find the singer and jazz guitarist George Benson, the musician Joey De Francesco, the saxophonist Joe Lovano and more. The bassist Matthew Longbons participates in more than 200 shows a year next to leading international artists such as Alice Cooper and Matt Walker from the "Smashing Pumpkins". Paul Kamp, the group's guitarist, is known mostly from his collaboration with "Busker Soundcheck", a well-known alternative rock band.
// 							</p>

// 							<p>

//                              Led Zeppelin is considered until today to be one of the most revolutionary, influencing and successful bands in the history. They sold more than 300 million albums worldwide, with 'Led Zeppelin IV' alone selling over 37 million copies and being ranked as the third all-time best-selling album in the U.S. All 9 of the band's albums were rated in the top 10 in the U.S. chart, and 6 of them even top over the top 5. Their second album that was recorded during their first tour was a huge success both in the U.S. and in the UK, and it featured the hit 'Whole Lotta Love' that sold over a million copies.

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:30,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Oh Wonder",
//         smltitle: "Live in Tel Aviv for the first time ever!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											16.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//ohwondermusic.com/">
// 											  www.ohwondermusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/30/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Oh Wonder consist of Josephine Vander Gucht and Anthony West. In 2014 they started releasing singles every month and then they combined all of them and released a debut album that's named after them and sold over 500 million copies. This year they released their second album, "Ultralife", which had even a bigger success and reached the Top 10 in the UK charts.
// 							</p>
// 							<p>
// 								In 2015 the duo was announced by Billboard as one of the 5 biggest breakthroughs. They come to Israel this year after a long tour and performing in the biggest festivals around the world as part of the promotion of their new album, which includes hits such as "Without You" and "Drive".
// 							</p>

// 							<p>
// 								Gutcht and West played sold out shows in New York, Los Angeles, Paris and London, and now they're coming for one show only to give the people of Tel Aviv a taste of their alt-pop hits. The successful duo is guaranteed to get you dancing and give the ultimate pop experience, this will be one night in Tel Aviv you are sure to remember.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:31,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Ott & The All Seeing I",
//         smltitle: "Electro explosion in the city that never sleeps",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											15.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//ottsonic.com/">
// 											  www.ottsonic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/31/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Ott and the All Seeing I are coming to take Tel Aviv by a storm this December.
// 							</p>
// 							<p>
// 								Ott is considered to be one of the pioneers of calm, groovy electronic music and likes to record the sounds of nature in his mobile studio, with which he tours England. The British record producer and musician has worked with Sinead O'Connor, The Orb, Brian Eno and Embrace, and has achieved recognition since 2002. He's known for psychedelic dub tracks and his collaborations with other artists. He has released two albums on Twisted Records – "Blumenkraft" in 2003 and "Skylon" in 2008, and two other albums on Ottsonic – "Mir" in 2011 and "Fairchildren" in 2015.
// 							</p>

// 							<p>
// 								The electro genius performed at the Glastonbury Festival in 2007, and then in 2011 he performed at Glade Festival, a show that was described as "the perfect opening act" in an article at Virtual Festivals. The same publication also called Ott a "Psy-dub maestro" and ranked his performance 10/10. The Israeli crowd was first exposed to Ott in the early 2000's with the album "Hallucinogen in Dub", the remix album he produced for Simon Posford. All the albums he released later only enhanced the effect he has with his powerful and addictive music.
// 							</p>

// 							<p>
// 							   The All Seeing I are an English electronic music group from Sheffield, consisting of Dean Honer, Jason Buckle and DJ Parrot. Their first single "I Walk" came out in 1997, but it was only in the following year that they gained mainstream commercial success with the song "Beat Goes On". The trio worked with artists such as Tony Christie, Jarvis Cocker, Babybird, Phillip Oakey and many others.
// 							</p>

// 							 <p>
// 							    Ott has performed Tel Aviv twice in the past and his shows received incredible reviews. This is guaranteed to be a one of a kind night that you definitely don't want to miss!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:32,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Take That",
//         smltitle: "Take That – Taking Tel Aviv By Storm!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											27.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//takethat.com/">
// 											  www.takethat.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/32/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The legendary British pop band is this coming November to rock Tel Aviv for one show only!
// 							</p>
// 							<p>
// 								Take That started in Manchester in 1990 and currently includes Mark Owen, Gary Barlow, and Howard Donald. The original band also featured Robbie Williams and Jason Orange. Barlow is the band's lead singer and songwriter, while Owen and Donald act as backing vocals.
// 							</p>

// 							<p>
// 								Their most memorable songs include "Pray" which won The Guardian Music Award for Best Number 1 Single, "Back For Good" which won BRIT Award for Best British Single, "Everything Changes" and "Could It Be Magic." The band released 28 top 40 singles and 17 top 5 singles in the United Kingdom, out of which 12 reached number one, and they have 7 number one albums. Internationally, the band released 56 number one singles and 37 number one albums. They won 8 Brit Awards, including awards for Best British Live Act and Best British Group.
// 							</p>

// 							<p>
// 							   The British pop sensation set the record in 2011 for the fastest-selling tour of all time in the United Kingdom with "Progress Live", beating their own personal record from 2009 with their "Circus Live Tour". They were named as Amazon's top-selling music artist of all time, and in 2012 Forbes announced them as the fifth highest-earning music stars in the world. During the same year, the Official Charts Company announced the biggest-selling singles artists in the British music chart history with Take That being placed at 15th overall and having four of the best-selling albums of the millennium, which makes them the most successful boy band in the UK chart history.
// 							</p>

// 							 <p>
// 							   The band will come to Israel as a part of its international tour in order to promote its last album "Wonderland". Their previous tours have gotten raving reviews, with "Progress" winning Audio Pro International Awards for Best Live Sound Event and Audio Pro International Awards Grand Prix Award. Their performance in Tel Aviv will for sure be a one to remember, don't miss out!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:33,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Kooks",
//         smltitle: "Getting it on with the Kooks in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											27-28.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thekooks.com/">
// 											  www.thekooks.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/33/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The Kooks – one of the ultimate British rock/pop bands of the century are coming this January to rock Tel Aviv as a part of "The Best of The Kooks" tour that marks a decade to their existence.
// 							</p>
// 							<p>
// 								The band was formed in Brighton, UK, in 2004 by lead singer Luke Pritchard and consists of Hugh Harris the lead guitarist, drummer Alexis Nunez and bassist Peter Denton. The band released its debut album, "Inside In/Inside Out" in 2006, which included hits such as "Ooh La" and "She Moves in Her Own Way" and achieved quadruple platinum status in the UK within a year and also abroad in the form of a platinum certification in Australia and two times platinum in Ireland.
// 							</p>

// 							<p>
// 								The group released its second album "Konk" in 2008 which debuted at number one on the UK Albums Chart and recorded first week sales of 65000, achieving gold status in both the UK and Ireland, which continued to establish their reputation as one of the world's most beloved brit-pop and post-punk bands. In 2011 their third album "Junk of the Heart" came out, followed by "Listen" in 2014 which debuted at No. 16 on the UK Albums Chart. Besides the fact that they quickly signed with "Virgin Records" only 3 months after forming, they also won several awards, such as MTV's best band of 2006 award, Best UK & Ireland Act at the MTV Europe Music Awards 2006 and even a nomination for the famous Brits award.
// 							</p>

// 							<p>
// 							  The band's music is primarily influenced by the 1960s British Invasion movement and post-punk revival of the new millennium. The Kooks have experimented in genres such as pop, reggae, ska, Britpop, rock, funk and hip-hop, and released songs that were describes as "catchy as hell".
// 							</p>

// 							 <p>
// 							  The Kooks are known for their amazing sold out shows and this one is due to be no different, so make sure to get your ticket now!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:34,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Willy William and Farruko",
//         smltitle: "The reggaetón superstars coming to get you movin’ in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											  Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											28.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.reggaetontelaviv.co.il/indexEN.php">
// 											  www.reggaetontelaviv.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/34/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The reggaetón superstars coming to get you movin’ in Tel Aviv!
// 							</p>
// 							<p>
// 								Willy William and Farruko, the reggaeton megastars are coming this fall to perform as a part of the "Reggaeton Tel Aviv" festival and get the people of Tel Aviv on their feet in one extraordinary show only!
// 							</p>

// 							<p>
// 								Farruko , the 26-year-old world famous reggaton singer comes from Puerto Rico. He started his professional career in 2009 through Myspace. Since then, he released six albums and collaborated with Sean Paul, Daddy Yankee, Maluma, Don Omar, Shaggy, Nicky Jam, Ky-Many Marley, Chino&Nacho, J Balvin, Ozuna and many other successful reggaeton legends, and he was nominated for the Latin Grammy awards in 2012. His hits got millions of views on Youtube, and among them, one can find the famous "6 AM", "Passion Wine", "Me Voy Enamorando", "Krippy Kush", "Sunset" and "Chillax".
// 							</p>

// 							<p>
// 							  The 36-year-old singer, producer and DJ, Willy William is coming to Tel Aviv all the way from France. He's known for his remixes and collaborations with dance artists. His big breakthrough was in 2003 when he collaborated with DJ Flex and released his hit "B Boyz Shake da Body" and right afterwards his next song "Tragedie" and the name "Lord William". His most famous hits are "EGO" and "Mi Gente" which topped the charts in many radio stations worldwide, including Israel.
// 							</p>

// 							 <p>
// 							  Come get the addictive reggaetón vibes in you and dance the night away in the city that just won't quit!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:35,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Buena Vista",
//         smltitle: "The ultimate Cuban experience in Tel Aviv & Jerusalem!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											21-26.12.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pasion-de-buena-vista.com/">
// 											  www.pasion-de-buena-vista.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/35/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   The ultimate Cuban experience in Tel Aviv & Jerusalem!
// 							</p>
// 							<p>
// 								After 600 shows worldwide -  the extraordinary Buena Vista Cuban sensation is coming for first time to give Tel Aviv and Jerusalem a taste of Cuba!
// 							</p>
// 							<p>
// 								The show is a one-of-a-kind experience that expresses love to the Cuban culture with all the known Cuban hits such as La Vida es un Carnaval. The Buena Vista Band includes 11 talented musicians, working together with a group of unbelievable dancers to provide an experience you never had before.
// 							</p>

// 							<p>
// 								The show will be held in two separate dates in Tel Aviv and Jerusalem, both awesome choices offering a huge host of activities and experiences in a unique unrivaled atmosphere. Jerusalem is known for its rich history, interesting architecture and incredible cultural diversity, while Tel Aviv is known for its fast tempo, warm exotic weather, amazing beaches and non-stop nightlife! Whatever city you'll choose- you visit is bound to be exciting and packed with unforgettable experiences!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:36,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Jerry Seinfeld",
//         smltitle: "Comedy King Closing 2017 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											30.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jerryseinfeld.com/">
// 											  www.jerryseinfeld.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/36/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Comedy King Closing 2017 in Tel Aviv!
// 							</p>
// 							<p>
// 								Jerry Seinfeld, the undisputed king of American comedy is returning to Tel Aviv for two performances which will be held on the same night in Tel Aviv.
// 							</p>
// 							<p>
// 								Home to incredible comedy venues a sought-after location for many international comedians such as Eddie Izzard, Jim Jeffries, Chris Rock and many others, Tel Aviv has a hedonistic vibe, incredible vibrancy and energy and a liberal loose spirit making in a comedy heaven.
// 							</p>

// 							<p>
// 								Seinfeld, hailed as one of the top comedians of his generation has without a doubt shaped the way we watch television and sitcoms, with his iconic show “Seinfeld” which ran from 1990-1998 and reigned over primetime TV for nearly a decade.
// 							</p>

// 							<p>
// 							   However, Seinfeld is a man loyal to his roots and has often declared that performing live is one of his favorites and he’s coming to Tel Aviv to do Just that.
// 							</p>

// 							<p>
// 							  This December, Seinfeld will strut his stuff onstage live in his hilarious laugh- a – second style, performing two consecutive shows in the nonstop city of Tel Aviv, and what better city is there to close the 2017 with a smile?
// 							</p>

// 							<p>
// 							   For visitors coming to check out Seinfeld’s show, the city of Tel Aviv, with its winter sunshine and world-famous nightlife is without a doubt THE place to spend a fantastic and absolutely unforgettable Tel Aviv Style New Year’s Eve.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:37,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Alt-J",
//         smltitle: "Comedy King Closing 2017 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											29.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.altjband.com/">
// 											  www.altjband.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/37/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  The British indie band is returning to Tel Aviv once again after their last successful sold-out show in Israel two years ago. The band was formed in 2007 in England, and their debut album “An Awesome Wave” was released in 2012 and won the Mercury award the same year. The band is a combination of electro-pop, psychedelic folk, African beats, post-dubstep and rock n’ roll. The band members met through their mutual love for Radiohead while they were in college, and their sound was affected by the fact that they weren’t allowed to use a bass guitar and drums when they were students.
// 							</p>
// 							<p>
// 								The band comes to rock Tel Aviv this spring and invites fans from all over the world to come and enjoy the wonderful alternative music scene that the city that never sleeps can offer. From extraordinary art galleries to unique theatre shows to live music concerts – the cultural scene in Tel Aviv is one of a kind. It’s a home for many musicians and artists, and now it welcomes every culture lover.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:38,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Ozzy Osbourne",
//         smltitle: "Ozzy O -  coming to say goodbye to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											08.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.ozzy.com/">
// 											  www.ozzy.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/38/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Ozzy O -  coming to say goodbye to Tel Aviv!
// 							</p>
// 							<p>
// 								Ozzy Osbourne, the world-famous metal legend returns to Tel Aviv for the last time as part of his farewell tour. While known to younger audiences mainly from the reality show “The Osbournes”, Ozzy was already a musical icon and a huge star since way before – from his role as the lead singer for Black Sabbath, to being the headliner in the international metal festival that was named after him, the “Ozzfest”.
// 							</p>

// 							<p>
// 							   After 2500 shows all around the world, the star comes to say goodbye to his fans in Tel Aviv, a city known around the world for its rich rock and metal scene. Being the most liberal city in Israel, Tel Aviv is always full of action and attracts both younger and older visitors who craving a taste of the underground culture. The rocking city is full of bars with rock themes, alternative clubs, live music venues and is known to attract music lovers from every country.
// 							</p>

// 							<p>
// 							   Don’t miss your chance to see the metal star for the very last time, make sure to get your ticket now and come rock it with ozzy in rockin’ Tel Aviv!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:39,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jim Jefferies",
//         smltitle: "Jim Jefferies Kicks Off 2018 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											16.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//jimjefferies.com/">
// 											  www.jimjefferies.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/39/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Jim Jefferies Kicks Off 2018 in Tel Aviv!
// 							</p>
// 							<p>
// 								One of the most popular comedians worldwide, Jim Jefferies, is returning to Tel Aviv after only a year. He will be kicking off 2018 and unleashing his famous humor with new material in a new show, “The Unusual Punishment Tour”.
// 							</p>

// 							<p>
// 							  The show will take place on a special 360-degree platform at the Menorah Mivtachim Hall in Tel Aviv, the perfect location for a comedian of his stature. Catching the show with the hilarious Australian performer is just the right excuse to come visit Tel Aviv, renowned for its exciting atmosphere and diverse nightlife scene.
// 							</p>

// 							<p>
// 							  Take the opportunity to visit one of the exciting bars or clubs which attract top International DJs, or visit one of the smaller neighborhood bars or cafes with its atmospheres to suit all tastes. Whether it’s food, drink or dancing you are after, Tel Aviv has it all.
// 							</p>

// 							<p>
// 							    After creating, writing, producing and starring in the critically acclaimed FX series, Legit, Jefferies and his material have gained a cult following. His voice has become well-known in late-night entertainment, making his show a must-see in Tel Aviv. Those coming to the Tel Aviv for Jefferies’ show will enjoy some good laughs, set on a background of stunning warm winters and an exciting night vibe.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:40,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Gerard Depardieu & Isabelle Adjani",
//         smltitle: "“Love Letters” Coming to Tel Aviv from France!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											05.03.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/40/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 “Love Letters” Coming to Tel Aviv from France!
// 							</p>
// 							<p>
// 								From France with love! French actors, Gerard Depardieu and Isabelle Adjani, will be performing “Love Letters” in March in Tel Aviv. Written by the late A.R. Gurney, the show has been performed on and off-Broadway by actors and actresses around the world.
// 							</p>

// 							<p>
// 							 The Pulitzer Prize-nominated show is now coming to Israel and will be performed by Gerard Depardieu and Isabelle Adjani in French, with Hebrew and Russian subtitles. With the performance taking place in Tel Aviv, visitors to the city will have the chance to enjoy some of the exotic and exciting nightlife that makes Tel Aviv so popular.
// 							</p>

// 							<p>
// 							  With restaurants to suit all palettes, dinner is just the thing for before the show, and with a nightlife that just starts to come alive around midnight, those who are looking for some adventure after the show will have plenty of options open to them. Anyone visiting the city especially for the show is sure to come away dazzled, both by the liveliness of the atmosphere and from the two well-known French stars.
// 							</p>

// 							<p>
// 							   While this is Adjani’s first trip to Israel, Depardieu has been here a number of times, and this occasion is sure to be memorable.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:41,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "A-HA",
//         smltitle: "An Electric Summer with A-HA!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											21.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://a-ha.com/">
// 											  www.a-ha.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/41/1.gif"} class="img-responsive" />
// 							</div>

// 							<p>
// 							 An Electric Summer with A-HA!
// 							</p>
// 							<p>
// 								Israel will be treated to an exciting performance from Norwegian band, A-HA, in June, 2018. Coming to Israel as part of their Electric Summer Tour 2018, the band will perform in Tel Aviv at the Exhibition Grounds in a show that promises to be a hit.
// 							</p>

// 							<p>
// 							 Formed in Oslo in 1982, A-HA has been talked about for more than three decades, and since their hit “Take On Me” in 1985, they have grown to be one of the most popular Scandinavian bands in the world. While they originally split up in 2010, they have come back together again for a number of tours and Tel Aviv is honored to be among their stops this time around.
// 							</p>

// 							<p>
// 							 Fans of the band will be treated to an exciting performance by the well-known group, while having the chance to enjoy some of the best entertainment venues in the country. From museums to theatres, restaurants to clubs, there is something to suit everyone in the bustling city of Tel Aviv.
// 							</p>

// 							<p>
// 							  Take the opportunity to enjoy a walk along the brilliant beachfront as the city’s locals get ready for the summer sun, and enjoy the vibe as diverse cultures come together for the band’s latest show.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:42,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Ringo Starr",
//         smltitle: "Ringo’s All Starr Band Headed to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											23-24.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.ringostarr.com/">
// 											 www.ringostarr.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/42/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Ringo’s All Starr Band Headed to Tel Aviv!
// 							</p>
// 							<p>
// 								It’s been a year of stars in Tel Aviv and the latest concert to come to the dynamic city, has everyone talking! Ringo Starr will be coming to Israel as part of his European Tour and will be performing two concerts with his All Starrs Band at the Menorah Mivtachim Arena in June 2018.
// 							</p>

// 							<p>
// 							Starr, an English songwriter, singer and actor, first became famous as the drummer for the Beatles; however, since 1989, he has toured with his All Starr Band. The 77-year old released his 19th studio album in September, known as “Give More Love.”
// 							</p>

// 							<p>
// 							Tel Aviv is the ideal location for a concert with such a big name. Known as the New York City of Israel, Tel Aviv is the center of excitement, fun and initiatives in the country. As the city that attracts over a million tourists each year, whether for business or pleasure, Tel Aviv offers a beautiful beach, unique restaurants, theatres, museums and pulsing bars.
// 							</p>

// 							<p>
// 							  If you are joining the many fans who are coming to Tel Aviv to hear Ringo and his All Starrs Band perform, make sure not to miss out on the rest of what Tel Aviv has to offer and come away with an experience to remember.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:43,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "The Scorpions",
//         smltitle: "Tel Aviv to Go Crazy in July with The Scorpions!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											19.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.the-scorpions.com/">
// 											 www.the-scorpions.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/43/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Tel Aviv to Go Crazy in July with The Scorpions!
// 							</p>
// 							<p>
// 								One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
// 							</p>

// 							<p>
// 							One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
// 							</p>

// 							<p>
// 							Those looking to make a day of it in Tel Aviv, will have their pick of food and entertainment venues. The spirited city has become a melting pot of cultures and this is reflected in the museums, restaurants and street stalls that can be found all around the city. Enjoy cuisine to suit every palate, stroll around the interesting streets or pop into one of the many unique exhibitions that can be found around the city.
// 							</p>

// 							<p>
// 							  With the show scheduled for the beginning of the summer, it will be daylight until late and the locals will be out enjoying the sunshine. Soak up the vibe before you go on to rock the night away with The Scorpions!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:44,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Natalia Oreiro",
//         smltitle: "Natalia to Wow Tel Aviv in March",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											20.03.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.nataliaoreiro.com/">
// 											 www.nataliaoreiro.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/44/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							Natalia to Wow Tel Aviv in March
// 							</p>
// 							<p>
// 								South American singer and actress, Natalia Oreiro, is headed to Israel in March, where she will be performing a live concert at Menora Mivtachim Arena in Tel Aviv. Coming back to Tel Aviv, straight from Argentina, fans are looking forward to seeing the Latin star once again.
// 							</p>

// 							<p>
// 							Having performed in numerous daily series, including telenovelas and movies, and after producing 3 CDs, she will bring some of her biggest hits to the show, such as Cambio dolor, Corazon Valiente, Me Muero de Amor and Rio de la Plata y más, as she opens her new World Tour.
// 							</p>

// 							<p>
// 							Tel Aviv, which attracts celebrity singers, actors and performers from around the world, is the perfect location for the Grammy-nominated singer from Uruguay. The pumping city offers entertainment beyond the walls of the Menora Mivtachim Arena, with its trendy restaurants, upscale bars, and clubs.
// 							</p>

// 							<p>
// 							 Natalia, who has performed in Israel many times in the last 20 years, already has a following here. The show is sure to attract a large audience. Join the excitement before the performance by satisfying your taste buds in one of the many highly-acclaimed restaurants in the area or continue the celebration after the curtains have closed with a drink at a pub. Whatever your tastes, Tel Aviv is a great complement to Natalia Oreiro.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:45,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "André Rieu",
//         smltitle: "Tel Aviv to Be Treated to Rieu in 2018",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											04-05.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.andrerieu.com/">
// 											 www.andrerieu.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/45/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Tel Aviv to Be Treated to Rieu in 2018
// 							</p>
// 							<p>
// 								World-class Dutch composer and violinist, André Rieu, is coming to Tel Aviv with his Johann Strauss Orchestra for a performance that promises to be unforgettable. The two events, which are Rieu’s first in Israel, will be held at the Menora Mivtachim Arena in Tel Aviv.
// 							</p>

// 							<p>
// 							Rieu will be conducting his 60-piece orchestra while playing his famous Stradivarius violin, treating the audience to their repertoire of renowned ballads and waltzes. The event will be particularly captivating as Rieu will be presenting his new album, “Amore,” which includes a unique interpretation of Naomi Shemer’s “Jerusalem of Gold.”
// 							</p>

// 							<p>
// 							Tel Aviv, with its many facets, is just the right location for the range of musical pieces that Rieu and the Johann Strauss Orchestra will be performing. From the beach to the theater, classy restaurants to lively pubs, Tel Aviv has it all. Sit down to a posh dinner, visit a charming cafe, or enjoy a drink at a chic bar, before you end off your evening with a concert that promises no shortage of exquisite music.
// 							</p>

// 							<p>
// 							  André Rieu has become one of the most popular live acts around the world and Tel Aviv is about to find out why! Make sure you don’t miss out on the experience!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:46,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Foreigner",
//         smltitle: "Foreigner Returning to Israel in May!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											05.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.foreigneronline.com/">
// 											 www.foreigneronline.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/46/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Foreigner Returning to Israel in May!
// 							</p>
// 							<p>
// 								Popular British hard rock band, Foreigner, is returning to Tel Aviv in May 2018. After recently playing 2 concerts in Caesarea, the band will now be performing in the entertainment capital of the country, Tel Aviv.
// 							</p>

// 							<p>
// 							Since being founded in 1976 by Mick Jones, Foreigner has sold nearly 80 million albums across the globe. It reached the height of its popularity in the 1980s, with some of its most well-known hits including “I Want to Know What Love Is,” “I Don’t Want to Live Without You,” “That Was Yesterday” and “Waiting for a Girl Like You.”
// 							</p>

// 							<p>
// 							With the band performing at the Menora Mivtachim Arena in Tel Aviv, fans and visitors will be able to make the most of the concert and enjoy the vibe and energy of the city. Soak up the rays on the beach as the summer sun starts to make an appearance or spend the day in one of the many museums or exhibitions of the city.
// 							</p>

// 							<p>
// 							 You will be transported back to the 80’s with this popular band, while enjoying the best that Tel Aviv has to offer. Don’t miss out on the great nightlife of the clubs and pubs after the show, as you complete your evening with style!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:47,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Don Mclean",
//         smltitle: "Enjoy a Piece of “American Pie” in June!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											16.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://don-mclean.com/">
// 											 www.don-mclean.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/47/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Enjoy a Piece of “American Pie” in June!
// 							</p>
// 							<p>
// 								Famous American songwriter, Don McLean, will perform in the outskirts of Tel Aviv in June, 2018. After almost 60 years of career, McLean remains most famous for his hit song, American Pie, which came out in 1972 and is still covered by big names in the industry, such as Madonna.
// 							</p>

// 							<p>
// 							   McLean has released 40 gold and platinum records, but it is his attachment to Israel that makes him so popular here. This is particularly clear with his song, Jerusalem, which he wrote in support of the country. This time, he will be performing closer to the entertainment capital of Israel, Tel Aviv.
// 							</p>

// 							<p>
// 							    With the show taking place only 10 minutes from the hustle and bustle of the lively city, there are plenty of options for fans to make a full day of the concert. Visit one of a number of world-class museums or take in one of the many temporary exhibitions that come to the city. If you’re looking for food, there is certainly no shortage in Tel Aviv with a range of styles and tastes to suit all visitors. Soak up the sun as summer begins to arrive or enjoy the sounds and scenes of the nightlife that Tel Aviv is famous for.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:48,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Enrique Iglesias",
//         smltitle: "Tel Aviv to Host Spanish Pop Legend!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											28.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://enriqueiglesias.com/">
// 											 www.enriqueiglesias.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/48/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Tel Aviv to Host Spanish Pop Legend!
// 							</p>
// 							<p>
// 								Spanish pop legend, Enrique Iglesias, will be returning to Israel for his fourth visit, this time to perform at the Yarkon Park in Tel Aviv. While this won’t be his first time in the entertainment capital of the country, it is expected to be his largest performance to date.
// 							</p>

// 							<p>
// 							  This visit comes close on the heels of the Hebrew remix of his popular piece, “Subleme La Radio,” together with Israeli singer, Rotem Cohen. Concert-goers can look forward to hearing some of Iglesias’ hit songs which may include “Bailamos,” “Hero,” “Be With You” and “I Like It.” He is expected to perform together with his long-time guitarist, Israeli Sean Hurwitz.
// 							</p>

// 							<p>
// 							   Iglesias is predicted to be one of the most popular concerts of the year judging by the fact that it will be held in the Yarkon Park venue which can accommodate up to 100,000 people. Those looking to make a whole evening of the event will find plenty to keep them entertained in Tel Aviv before the concert starts.
// 							</p>

// 							<p>
// 							    With a wide range of eateries and pubs, there is something to suit all tastes. Enjoy the limitless choices when it comes to restaurants and pick up the vibe of the city before heading off to the main event.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:49,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Blood Sweat and Tears",
//         smltitle: "Blood, Sweat & Tears Headed to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											22.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//bloodsweatandtears.com/">
// 											 www.bloodsweatandtears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/49/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Blood, Sweat & Tears Headed to Tel Aviv!
// 							</p>
// 							<p>
// 								Legendary rock band, Blood, Sweat & Tears, is heading to Israel for one concert to be held in Hangar 11 in Tel Aviv. The band was last in Israel 10 years ago when they played in Tel Aviv and Caesarea.
// 							</p>

// 							<p>
// 							  Established in 1967 in New York City, their best-known hits include “I Love You More than You’ll Ever Know,” “I Cannot Quit Her,” “When I Die” and “You’ve Made Me So Very Happy.” There are no original members of the band left, but seven current members will take to the stage when they perform in March. These include lead vocalist and popular runner-up to American Idol in 2005, Bo Bice.
// 							</p>

// 							<p>
// 							   Tel Aviv promises a full day of excitement for concert-goers with the opportunity to enjoy the beautiful beaches, parklands and entertainment options that the city offers before the concert even begins. Make sure to eat in one of the many restaurants scattered around the city and immerse yourself in the character of Tel Aviv by visiting one of the popular pubs or clubs that make up its charming nightlife.
// 							</p>
//                             <p>
//                                 Create the perfect night out as you combine the atmosphere of Tel Aviv with jazz and rock in a unique concert from Blood, Sweat & Tears.
//                             </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:50,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jamiroquai",
//         smltitle: "Jamiroquai Heads to Israel in May!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											02.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jamiroquai.com/">
// 											 www.jamiroquai.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/50/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Jamiroquai Heads to Israel in May!
// 							</p>
// 							<p>
// 								British band, Jamiroquai, is heading to Israel in May 2018, where they will perform in the outskirts of the bustling city of Tel Aviv. With only one performance in Israel, the popular band from the 90s is expected to attract a large crowd.
// 							</p>

// 							<p>
// 							  The band has published 8 studio albums, with “Automaton” being their latest from 2017. The hip city of Tel Aviv is the ideal location for a concert that promises an exciting performance by the group that introduced “future funk” and took the world by storm. Founded in 1992 by Jay Kay, Jamiroquai holds the Guinness Book of World Records listing for “Best Selling Funk Album” of all time.
// 							</p>

// 							<p>
// 							   Anyone looking for a lively night out will do well to head to this concert. Being held a short drive from the center of Tel Aviv, concert-goers will be able to begin the party early at one of the city’s top-notch restaurants, clubs or pubs. Start your evening with a quality dinner at any one of dozens of stylish restaurants and then move onto one of Tel Aviv’s famous clubs before making your way to the concert for an unforgettable night out.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:51,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Backstreet Boys",
//         smltitle: "The Backstreet Boys are Back and Larger Than Life",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											22.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.backstreetboys.com/">
// 												www.backstreetboys.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/51/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    The Backstreet Boys are Back and Larger Than Life
// 							</p>
// 							<p>
// 									The Backstreet Boys will be back in Israel this year for a concert. To be held in the outskirts of Tel Aviv in April, concert-goers will be able to enjoy the incredible vibe of the city together with some of the greatest hits in history.
// 							</p>

// 							<p>
// 									Tel Aviv is one of the most sought-after locations for big names in the entertainment industry, with its energy, vitality and spirit. There is no shortage of eateries, pubs and coffee shops for those looking for a culinary experience. Or, if you prefer to make a full day of it, you can visit some of the world-class museums, theaters or galleries around the city.
// 							</p>

// 							<p>
// 									Formed almost 20 years ago, the Backstreet Boys have produced 7 multi-platinum albums and sold more than 130 million records worldwide, with some of their most popular hits such as “I Want It That Way,” “As Long as You Love Me” and “Larger Than Life”.
// 							</p>
// 							<p>
// 									Visitors heading to the concert will be able to enjoy Tel Aviv at its best with beautiful Spring weather enticing locals and guests to the beach, before making their way to hear the best-selling boy band of all times!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:52,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Alice in Chains",
//         smltitle: "Alice in Chains Announces Debut Show in Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											17.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.aliceinchains.com/">
// 												www.aliceinchains.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/52/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Alice in Chains Announces Debut Show in Tel Aviv
// 							</p>
// 							<p>
// 									Making their debut appearance in Israel, rock band and grunge pioneer, Alice in Chains, will perform in July, north of Tel Aviv, in what promises to be an electrifying concert.
// 							</p>

// 							<p>
// 									Having come together in the late 80’s, Alice in Chains is one of four major groups that led the grunge revolution, and they became one of the most influential bands of all time. With music that combines rock, alternative rock and metal, the band was nominated for 9 Grammy awards and sold more than 20 million albums.
// 							</p>

// 							<p>
// 									Taking place in the middle of summer, Tel Aviv is the perfect location to start the day’s activities. If you’re looking for some indoor entertainment, visit one of the city’s world-class museums or galleries, or head over to one of the many restaurants around the city. For something a bit different, soak up the rays walking along the promenade of a beautiful beach or pop into a club or pub in the area before heading north for the concert.
// 							</p>
// 							<p>
// 									This show is part of the first European tour the band has been on in four years, and being its first appearance ever in Israel, it promises to be a night full of excitement.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:53,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Hardwell",
//         smltitle: "Hardwell Headed to Israel in April",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											06.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.djhardwell.com/">
// 												www.djhardwell.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/53/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Hardwell Headed to Israel in April
// 							</p>
// 							<p>
// 									Number 1 ranking DJ, Hardwell, is coming to Israel in April where he will thrill crowds just outside Tel Aviv. This will be his third concert in the country, after performing to sell-out audiences in 2013 and 2017.
// 							</p>

// 							<p>
// 									Robbert van de Corput, better known as DJ Hardwell, first made a name for himself at the young age of 14, but it was at age 25 when he truly became famous, named World’s #1 DJ by the 2013 DJ Mag. Hardwell has become an International name, hosting his own radio show which is broadcast around the world, and producing a consistently top 10 iTunes podcast. He is also well known for his remix of The Wanted’s “Chasing the Sun”.
// 							</p>

// 							<p>
// 									Tel Aviv is the ideal location for a concert of this type with the natural vibe and energy of the city adding to the excitement that will be in the air. Tel Aviv in Spring is full of blue skies and warm weather, attracting crowds to the beach and the outdoor cafes and restaurants that can be found throughout the city. Enjoy a full day out or join the gathering of people at one of the city’s world-class restaurants before heading to the concert.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:54,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jethro Tull",
//         smltitle: "Jethro Tull’s 50th Anniversary Tour Heads to Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											27-28.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.jethrotull.com/">
// 												jethrotull.com/
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/54/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Jethro Tull’s 50th Anniversary Tour Heads to Israel
// 							</p>
// 							<p>
// 									Ian Anderson, vocalist, flutist, and guitarist of the popular British rock band, Jethro Tull, is coming to Israel for the band’s 50th anniversary tour. Performances will take place at Heichal Hatarbut in Tel Aviv on October 27, followed by the International Convention Center in Jerusalem on October 28.
// 							</p>

// 							<p>
// 									Formed in 1967, the band initially played blues rock, but later evolved and developed elements of hard rock. Their greatest success came in the 1970s with hit songs such as “Bungle In The Jungle,” “Living In The Past,” and “The Witch’s Promise.” The band has performed in Israel numerous times in the past, and Anderson who is the only remaining member of the band who is coming on tour, is expected to receive a warm welcome.
// 							</p>

// 							<p>
// 									Performing in both Tel Aviv and Jerusalem will appeal to a wide audience. Join the energy and vibe of the lively city of Tel Aviv with its nightlife, culinary experiences and beautiful beaches, or enjoy the concert in the cultural and historic center of the country, which is Jerusalem. No matter which flavor of the region you prefer, there are plenty of restaurants, cafes, museums or galleries to visit in each of the cities before the venues open their doors.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:55,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Israel Calling",
//         smltitle: "Good Evening Europe, This is Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											08-10.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 						<!--	<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>-->

// 							<h2>
// 							   Good Evening Europe,<br class="show-on-mobile"> This is Tel Aviv!
// 							</h2>
// 							<p>
// 								Eurovision fever is sweeping over Tel Aviv as it confirms hosting the star and glitter studded event - “Israel Calling”, for the 3rd consecutive year!
// 							</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/55/1.jpg"} class="img-responsive" />
// 							</div>

// 							<p>
// 								About 30 delegates from Eurovision participating countries worldwide will be gathering at the beginning of April in the nonstop city of Tel Aviv, for the largest Eurovision promo-event to ever take place in front of a crowd of thousands from Israel and around Europe.
// 							</p>

// 							<p>
// 								This unique and exciting event, held only in Tel Aviv, will give Eurovision fans from far and wide an amazing and completely free of charge opportunity to take part in the glamour of the Eurovision right here in the beautiful city of Tel Aviv.

// 						</p>

// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/55/2.jpg"} class="img-responsive" />
// 						</div>

// 						<p>
// 						The event will be held for three days starting on the 8th of April. The main stage will be set in Rabin Square, Tel Aviv’s main square and one of the city’s favorite outdoor venues, located at the heart of the buzzing city.
// 						</p>

// 						<p>
// 						The main event will take place on Tuesday and will include a mini Eurovision show in front of a live audience, featuring performances by the various Eurovision contenders performing the songs they will be competing with on the main event in May.

// 						</p>

// 						<p>
// 						This much anticipated pre-Eurovision event is set to take place just a few minutes’ walk from the stunning Tel Aviv beach. Fans and music lovers coming to see the show will get to take in all the city has to offer, including the excellent bars, restaurants and the awesome nightlife in this world-famous ultimate vacation destination called Tel Aviv.
// 						</p>

// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/55/3.jpg"} class="img-responsive" />
// 						</div>

// 						`
// 			}
// 		}

//     },

//     {

//       id:56,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Clean Bandit",
//         smltitle: "Clean Bandit Announces First Visit to Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											26.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//cleanbandit.co.uk/">
// 												cleanbandit.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/56/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Clean Bandit Announces First Visit to Israel
// 							</p>
// 							<p>
// 									British electro-pop group, Clean Bandit, which has become one of the leading dance acts around the world, has announced their debut performance in Israel. Visiting as part of their European tour, the band will play on the outskirts of Tel Aviv on June 26.
// 							</p>

// 							<p>
// 									Formed in 2008, they became well-known for merging classical instruments and pop with a unique and masterful outcome and they became a sensation with their smash hits “Rather Be,” “Real Love,” “Rockabye,” and “Symphony.” Since its release in 2016, “Rockabye” has been viewed almost 2 billion times on YouTube, while they won a Grammy for “Rather Be” in 2015.
// 							</p>

// 							<p>
// 									The band has been together for ten years and has seen incredible success in the that time. Join the throngs of people heading to Tel Aviv for the group’s first visit.
// 						    </p>

// 						    <p>
// 									Tel Aviv is just the venue for the unforgettable night that this concert offers. With cafes, bars, clubs, and pubs throughout the city, there is no shortage of activities in Tel Aviv. Known as “the city that doesn’t stop”, you can take advantage of the buzz of the nightlife and enjoy the vibe of the bustling beachfront at any hour before or after the concert.
// 						    </p>

// 						`
// 			}
// 		}

//     },

//     {

//        id:57,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Alanis Morissette",
//         smltitle: "Alanis Morissette to Turn Up The Heat with Summer Performance in Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											30.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//alanis.com/">
// 												alanis.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/57/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Alanis Morissette to Turn Up The Heat with Summer Performance in Israel
// 							</p>
// 							<p>
// 									Canadian singer and songwriter, Alanis Morissette, will return to Israel in the summer for one show which will take place on the outskirts of the lively city of Tel Aviv. Morissette has performed in Israel a number of times, including in 2000 and 2012, since she released her first album, “Jagged Little Pill” in 1995.
// 							</p>

// 							<p>
// 									The popular alternative rock singer is expected to rock Tel Aviv with some of her top hits, including “All I Really Want,” “Hand in My Pocket,” “Head Over Feet,” “Ironic,” “You Learn,” and “You Ought to Know.” Having taken home seven Grammy Awards and with eight albums having sold more than 60 million copies across the globe, her upcoming visit is already causing much excitement.
// 							</p>

// 							<p>
// 									The Tel Aviv area is the perfect location for a concert of this calibre, with visitors to the city given an exceptional choice of wining, dining and entertainment options. Begin your night at one of the many world-class restaurants or head out to one of the quaint coffee shops or bustling bars to end off your evening. The music scene will be hotter than ever with Alanis Morissette this July!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//        id:58,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Marc Almond",
//         smltitle: "Marc Almond’s Amazing Summer Concert",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											14.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.marcalmond.co.uk/news/index.html">
// 												marcalmond.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/58/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Marc Almond’s Amazing Summer Concert
// 							</p>
// 							<p>
// 									English musician, Marc Almond, will be heading to Israel in the summer for a much-awaited concert. The singer, who is most famous for his part in the new wave duo Soft Cell, will be playing north of Just north of the nonstop city of Tel Aviv in August.
// 							</p>

// 							<p>
// 									Soft Cell became famous for its 80’s hits “Tainted Love,” “Torch,” “Say Hello, Wave Goodbye,” and others, while Almond’s solo career took off when the duo split in the mid-80’s with hits including “Jacky” and “Something’s Gotten Hold of My Heart.” In another tribute to the decade, the Israeli rock group, Tattoo, which broke up in 1989, will open the concert in a historic reunion.
// 							</p>

// 							<p>
// 									Fans have been waiting for this performance since 2011, when his planned concert was canceled due to technical reasons. The 2018 concert promises to be an experience to remember.
// 							</p>

// 						    <p>
// 									From music to art, culture to fun, Tel Aviv has something for everyone. Spend the day wandering the vibrant streets of the city or pop into one of the many museums, theatres or galleries downtown. Make sure to stop off for a bite to eat at any of the city’s many world-class restaurants so you’ll be energized for what is sure to be an awesome concert.
// 							</p>

// 						`
// 			}
// 		}

//     },
//     {

//         id:59,
//         bgImage:"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title : "Shakira",
//         smlTitle : "Shakira to heat up the summer in sizzling Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											09.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.shakira.com/">
// 												shakira.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/59/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Shakira to heat up the summer in sizzling Tel Aviv
// 							</p>
// 							<p>
// 									The worldwide sensation Shakira is set to perform for the first time on the big stage in Tel Aviv this coming July and the city’s a buzz. The 41-year-old Colombian superstar who has sold close to 200 million albums and has won over 250 awards including three Grammys is just the perfect fit for a summertime concert in Tel Aviv.
// 							</p>

// 							<p>
// 									With a long and illustrious list of hit songs, including “Waka-Waka”, “Chantage” and “Whenever, whenever” Shakira is one of the most celebrated artists in the world today and nearly every song she records tops the international charts and receives hundreds of millions of Youtube views.
// 							</p>

// 							<p>
// 									Shakira’s concert is due to be held on July 9th in Yarkon Park, Tel Aviv’s massive park also dubbed the city’s “Green Lung”, which boasts, in addition to beautiful greenery, a stunning lake and excellent bike trails, a huge outdoor live music venue.
// 							</p>
// 							<p>
// 							        The party atmosphere of the nonstop city in July, the beautiful beaches and amazing nightlife and cool street vibe, all set the scene for perfectly Shakira’s show-stopping style and what is guaranteed to be an explosive musical celebration in the heart of cool city of Tel Aviv.
// 							</p>

// 	                    `
// 			}
// 		}
//       },
//   //     {

//   //     id: 60,
//   //     bgImage:"/posts/bank/16/1.jpg",
//   //     mobBgImage:"/posts/bank/16/M.jpg",
//   //     title: "White Night TLV",
//   //     smlTitle: "A “White Night” Rager In the Non-Stop City!",
//   //     html: function(){
// 		// 	return {
// 		// 		__html: `

// 		// 					<h2 class="align-center">
// 		// 					   16.05.2019
// 		// 					</h2>
// 		// 					<h1 class="align-center">
// 		// 					   A “White Night” Rager In the<br class="show-on-mobile"/> Non-Stop City!
// 		// 					</h1>
// 		// 					<div class="responisve-iframe">
// 		// 						<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 		// 					</div>
// 		// 					<p>
// 		// 						When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat. “White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open and everything is happening across the city at the same time…
// 		// 					</p>

// 		// 					<p>
// 		// 						From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo By: Adam Primer
// 		// 					</small>
// 		// 					<p>
// 		// 						The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City", Tel Aviv’s largest architectural collection of Bauhaus style buildings a world cultural heritage site, giving it a unique status in the architectural heritage of the modern era.
// 		// 					</p>
// 		// 					<p>
// 		// 						This historic declaration has been celebrated yearly ever since by Tel Aviv-Jaffa in a series of white night events, named after the "White City" and Tel Aviv’s other well-known characteristic: being “The City That Doesn’t Stop”.
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo By: Kfir Sivan
// 		// 					</small>
// 		// 					<p>
// 		// 						The White Night is a celebration of numerous events held throughout the city, which seems to expand with every passing year. In recent years, the celebrations  included (to name just a few): a unique midnight public picnic, an epic headphones party in the city’s main square, countless live music concerts, amazing indoor as well as street theatre performances, fascinating nighttime tours, night sports classes , Yoga at sunrise, and of course countless epic parties, all taking place all night across the city at the same time.
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo by Moshik Lindenbaum
// 		// 					</small>
// 		// 					<p>
// 		// 						So you better get your rest on- you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo by: Guy Yechiely‎.
// 		// 					</small>

// 		// 			               `
// 		// 	}
// 		// }
//   //   },
//       {
//       id: 60,
//       bgImage:"/posts/bank/16/1.jpg",
//       mobBgImage:"/posts/bank/16/M.jpg",
//       title: "White Night TLV",
//       smlTitle: "All Night Citywide party in Tel Aviv on Eurovision Semifinal!",
//       html: function(){
// 			return {
// 				__html: `

// 							<h2 class="align-center">
// 							   16.05.2019
// 							</h2>
// 							<h1 class="align-center">
// 							   All Night Citywide party in Tel Aviv on Eurovision Semifinal!
// 							</h1>
// 							<div class="responisve-iframe">
// 								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 							</div>
// 							<p>
// 								When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat, and this year the treat is going to be especially epic!
// 							</p>

// 							<p>
// 								As part of the warm and exciting welcome awaiting visitors during Eurovision week, the powers that be have decided to combine Tel Aviv’s annual “White Night” extravaganza with the Eurovision Semifinal set to be held on 16.05.2019.
// 							</p>
// 							<p>
// 								“White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open, and everything is happening throughout the city simultaneously.
// 							</p>
// 							<p>
// 								The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City as a world cultural heritage site, setting off annual citywide celebration in a series of white night events in the city that (truly) doesn’t sleeps.
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Adam Primer
// 							</small>
// 							<p>
// 								From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Kfir Sivan
// 							</small>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by Moshik Lindenbaum
// 							</small>
// 							<p>
// 								So you better get some rest - you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by: Guy Yechiely‎.
// 							</small>

// 					               `
// 			}
// 		}
//     },
//     {

//         id:61,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Brian Wilson",
// 	    smlTitle: "The legendary Brian Wilson returning to rock Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											07.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.brianwilson.com/">
// 												brianwilson.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/61/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 The legendary Brian Wilson returning to rock Tel Aviv!
// 							</p>
// 							<p>
// 									He returns to the white city with Al Jardine and Blondie Chaplin as a part of his world tour that celebrates his biggest hits from the last 54 years. The Beach Boys is one of the world’s most successful bands, the band has won many Grammy awards, got their own star in Hollywood and entered the Rock N’ Roll hall of fame.
// 							</p>

// 							<p>
// 									The band sold over 100 million records over the years and produced more hits than any other American band. They’re known especially for their hits “God Only Knows”, “Get Around”, “California Girls” and “Good Vibrations”. Wilson’s solo career is also successful, he recorded 11 albums and won 2 Grammy awards.
// 							</p>

// 							<p>
// 									Wilson’s concert will take place in Tel Aviv on August’s 7th. The summertime provides long daylight hours that give visitors the perfect opportunity to see what Tel Aviv has to offer; from an incredible art scene to fantastic theatres, to phenomenal live music shows and world-class restaurants – there are so many options in the spectacular city of Tel Aviv for  everyone will to find their brand of fun and excitement in the nonstop city.

//                             </p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 62,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Jason Derulo and Rita Ora",
// 	    smlTitle: "Jason Derulo and Rita Ora to raise it up in Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											The outskirts of Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											01.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jasonderulo.com/">
// 												jasonderulo.com
// 											</a><br>
// 											<a target="_blank" href="//ritaora.com/">
// 												ritaora.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/62/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						         	Jason Derulo and Rita Ora to raise it up in Tel Aviv!
// 							</p>
// 							<p>
// 									The two mega pop stars will perform at the “Lollipop” festival that will take place at the outskirts of Tel Aviv on the first of August. Derulo, that made his big breakthrough in 2009 with the hit “Whatcha Say”, became over the last decade one of the biggest stars in the international music industry with his huge hits such as “Wiggle”, “Want to Want Me”, “Swalla”, “Tip Toe” and “Talk Dirty”. The popular British Pop star, Rita Ora, is known especially for her famous hits “I Will Never Let You Down”, “Anywhere”, “R.I.P” and “Hot Right Now”.
// 							</p>

// 							<p>
// 									The festival provides a great opportunity to explore the city that never sleeps and enjoy its famous nightlife scene – from world-class bars, to secret underground clubs, to live music shows and various culinary options and even alternative art galleries, Tel Aviv for sure has something for everyone to enjoy. Whether you’re following a map or letting yourself get lost in the streets, you’re sure to fall in love with Tel Aviv!
// 							</p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 63,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Julio Iglesias",
// 	    smlTitle: "The Latin legend returning to wow Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											06.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.julioiglesias.com/">
// 												julioiglesias.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/63/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						             The Latin legend returning to wow Tel Aviv!
// 							</p>
// 							<p>
// 									Tel Aviv can’t wait for the return of the beloved Spanish star! With a great cultural scene, incredible culinary options, amazing beaches, phenomenal museums and galleries and plenty of unique spots to explore – those who come to enjoy Iglesias’s concert have plenty of different ways to spend their time in the cultural capital.
// 							</p>

// 							<p>
// 									The hot climate and long daylight hours just reminiscent of the phenomenal singer’s origin country, Tel Aviv offers a variety of options that suit all ages and therefore attracts a big amount of visitors all around the year.
// 							</p>
// 							<p>
// 							        Iglesias has an ongoing love affair with the nonstop city and his past shows were sold out. He’s one of the most successful singers in the history and during his career became a phenomenal success story all around the world. He has 77 different albums that sold over 300 million copies!
// 							</p>

// 							<p>
// 							         Many of the Spanish phenomenon’s hits have reached the top of the charts and he won numerous awards, such as the Grammy. His fans are incredibly excited about his return and tickets are selling like hot falafels. This is guaranteed to be a show to remember!
// 							</p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 64,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Maluma",
// 	    smlTitle: "The Reggaeton sensation returns to the white city!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fame.malumaofficial.com/">
// 												fame.malumaofficial.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/64/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						           The Reggaeton sensation returns to the white city!
// 							</p>
// 							<p>
// 									After winning over the crowd’s hearts during his last visit, the Colombian reggaetón singer and songwriter Juan Luis Londoño Arias, better known by his stage name Maluma returns to the city that never stops for one show only!
// 							</p>

// 							<p>
// 									Maluma has several singles that have charted within the top 10 on Billboard Hot Latin Songs, including "Felices los 4", "Borro Cassette", "El Perdedor" and "Corazón". During his career he won several awards, among which there is MTV Europe’s award for best world tour. The phenomenal performer is known among his fans as “the Latin lover” despite being only 24 years old.
// 							</p>
// 							<p>
// 							       His show will be held on June’s 28th in HaYarkon Park, located in the heart of Tel Aviv. Fans from all over the world who come to the show can enjoy the lovely beaches the city has to offer, the variety of restaurants and cafes, the remarkable art scene, the world-class bars and clubs, the various shopping venues spread all across the city – Tel Aviv has something for everyone.
// 						    </p>

// 							<p>
// 							         The Latin superstar is known to be quite a charmer and win everyone over in his shows – don’t miss this fantastic mix of Maluma and Tel Aviv -  come see the legend live in the hot hot city!
// 						    </p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 65,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Martin Garrix",
// 	    smlTitle: "The 1# DJ comes to the nonstop city!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											10.09.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Weitere Informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.martingarrix.com/">
// 												martingarrix.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/65/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						           The 1# DJ comes to the nonstop city!
// 							</p>
// 							<p>
// 									Martin Garrix , hailed as “the world’s best DJ” by DJMag is coming to get the party going in the nightlife capital of the middle east! With tons of world known clubs, bars, pubs and a one of a kind atmosphere, Tel Aviv is known for its vibrant vibe and incredible night scene.
// 							</p>

// 							<p>
// 									At 20 years old, the Dutch wonderkid is coming at the height of his career for one unforgettable show in Tel Aviv! The international hits machine became famous when he was only 17 and since then has released many loved tracks and climbed the charts all over the world.
// 							</p>
// 							<p>
// 							       Garrix is considered by many is the undeniable king of the industry. With remarkable hits such as “Animals”, “Tremor”, “In the Name of Love” and “Scared to Be Lonely”, the phenomenal DJ is one of the most popular performers in the world and is a must-have headliner for every well-known festival.
// 							</p>

// 							<p>
// 							        The show will be held in HaYarkon Park, in the heart of the awesome city, on September 10th. The international vibe, gorgeous location and great nightlife scene attract an extraordinary crowd that comes from different corners of the world and is guaranteed to make this show a once in a lifetime experience!
// 						    </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 66,
// 	    bgImage:"/posts/bank/59/1.jpg",
// 	    mobBgImage:"/posts/bank/59/M.jpg",
// 	    title: "Eurovision Tel Aviv",
// 	    smlTitle: "Epic song contest in the Non-Stop City",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											14-18.05.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<!--<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>-->

// 							<h3>A once in a lifetime opportunity to visit Tel Aviv as it hosts the Eurovision song contest.</h3>
// 							<p>
// 						     Epic song contest in the Non-Stop City
// 							</p>
// 							<p>Semi-final 1: 14 May 2019</p>
//                             <p>Semi-final 2: 16 May 2019</p>
//                             <p>Grand Final: 18 May 2019</p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/67/1.svg"} class="img-responsive" />

// 							</div>
//                             <p>It’s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city. </p>
//                             <p>Tel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak.  Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest. </p>
//                             <div class="img-wrapper">

// 							    <img src=${getImgUrl() + "/Concerts/67/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Major productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega “Euro Village” which will be situated merely a minutes’ walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest’s semifinal and final. The contest itself will take place in the Expo Tel Aviv. </p>

//                             <p>The Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all! </p>

// 					               `
// 			}
// 		}
//     },

//    {

//         id: 68,
// 	    bgImage:"/posts/bank/68/1.jpg",
// 	    mobBgImage:"/posts/bank/68/M.jpg",
// 	    title: "",
// 	    smlTitle: "36 Years of Cinema Magic!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											25.07-04.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.jff.org.il/en">

// 												www.jff.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<h2>Jerusalem Film Festival (JFF)</h2>
// 							<p>Time to start preparing your Summer 2019 checklist: Buy suntan lotion, pick wildflowers, host a barbeque, make plans to attend the 36th Annual Jerusalem Film Festival! It’s 11 days, over 200 films, prizes awarded to the very best, and you’ll be a part of it all! From star-studded international features to independent productions and the best of Israeli cinema, this unique film fest showcases excellence from various genres. </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/68/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>Take advantage of the opportunity to meet festival guests, including world-renown stars, writers, directors, cinematographers and other movie-making professionals. Film enthusiasts will enjoy Jerusalem’s many cinema spaces and be delighted by JFF on the Go, which presents films under the stars throughout the festival, and Cinema Park, which includes a 300 square meter pool with rubber boats, a giant LED screen, and a concert stage featuring live musical performances nightly. </p>
//                             <p>As you travel across the city to attend screenings, workshops, master classes, parties, musical shows and other festival events, you’ll experience how ancient cultures give modern spice to the contemporary vibe and personality of this global city. Fill your spare time strolling through neighborhood streets, exploring local shops, and taking your pick of Jerusalem’s wide variety of restaurants and cafes. You may have attended other film fests, but you won’t find one quite like this and, certainly, none other can boast the grandeur of the eternal City of Peace! </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 69,
// 	    bgImage:"/posts/bank/69/1.jpg",
// 	    mobBgImage:"/posts/bank/69/M.jpg",
// 	    title: "",
// 	    smlTitle: "Jerusalem Wine Festival (JWF)",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											01-31.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
// 												www.imj.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Jerusalem Wine Festival (JWF)</h2>
// 							<p>
// 								Relaxing summer evenings were made for an exquisite glass of fine wine! And for four days in August, you can enjoy world class selections and award-winning food at the 16th Annual JWF. Hosted in the beauty of the Japanese Art Garden of the Israel Museum, this is considered by many to be Jerusalem’s premiere social event. It’s a wine festival unlike any other, whose ambiance and stunning views of this historic city combine to make the JWF a not-to-be-missed experience.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Hundreds of wines will be served by dozens of well-known and boutique wineries. There’ll be free wine tasting opportunities, along with a culinary oasis of stalls offering cheeses, chocolates, olive oils, exceptional sauces, and tasty jams. And speaking of tasty jams, the festival will get your party started every night with two different live music concerts.
// 							</p>
//                            <p>
// 								Every year, the JWF welcomes a diverse and refined crowd of over 20,000 wine and culture lovers to Jerusalem. Many attend over multiple evenings simply to soak in the atmosphere. You could even build your stay in the city around the festival! Certainly, your days will be filled with sightseeing, shopping, and loads of walking about. The perfect way to unwind after your busy days might well be several fun-filled nights at the Jerusalem Wine Festival!
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//         id: 70,
// 	    bgImage:"/posts/bank/70/1.jpg",
// 	    mobBgImage:"/posts/bank/70/M.jpg",
// 	    title: "OPEN RESTAURANTS TLV",
// 	    smlTitle: "Feed Your Curiosity!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											2019 y.
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Feed Your Curiosity!</h2>
// 							<p>
// 								Ever wanted to get more than a taste of what gets created in a truly fine restaurant? Have you ever fantasized about what it would be like to be a top chef? Well, now’s your chance!
// 							</p>
// 							<p>
// 								OpenRestaurants is more than a culinary event, it’s a cultural happening that showcases Tel Aviv’s wide array of restaurants, chefs, and local culinary personalities. Guests get to meet with chefs from around the city, wander through open markets, and try their hands at cooking up flagship dishes under the supervision of first-class professionals. It’s your opportunity to experience a day in the life of the sophisticated chefs, line cooks, restaurateurs, food vendors, and others who make gastronomy in Tel Aviv as palate pleasing as it is.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/70/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Beyond peeking behind many kitchen curtains, OpenRestaurants hosts a range of events that include curated dinners, history presentations, and exhibitions of culinary-themed art, design, music, and technology!
// 							</p>
//                            <p>
// 								Many events are available at no charge, including the Culinary Innovation Summit, the Food & Hospitality Hackathon, and various food talks. There are also family-oriented events that focus on cooking activities for children and several market tours.
// 							</p>
//                            <p>
// 								Everyone’s gotta eat and there’s no one who doesn’t enjoy good food that’s well prepared. So, whether you like to understand the process behind the preparation, you like to do the preparing, or you just have a hearty appetite, there’ll be plenty to delight your senses at OpenRestaurants: Tel Aviv!
// 							</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 71,
// 	    bgImage:"/posts/bank/71/1.jpg",
// 	    mobBgImage:"/posts/bank/71/M.jpg",
// 	    title: "CULINARY FESTIVAL",
// 	    smlTitle: "Round Tables Culinary Festival",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											09-23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Round Tables Culinary Festival</h2>
// 							<p>
// 								The 4th edition of this celebrated culinary experience that brings renowned chefs from around the globe and invites them to take over the kitchens of several of Tel Aviv’s most notable restaurants.
// 							</p>
// 							<p>
// 								This year offers a new twist: The eight visiting chefs are all women – hailing from Mexico, South Korea, Italy, Switzerland, Colombia, Slovenia, Spain, and the United States. They’ll work with their local counterparts in the creation of culture crossover chowdowns featuring signature dishes from the guest chefs alongside flavors offered by the local chefs from the host restaurants.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/71/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Everyone involved agrees that creative cooking is always intensely steeped cultural context and a deeply felt sense of place. All of them are passionate about using local ingredients. Of course, each of these chefs has received accolades and awards from international critics and guides.
// 							</p>
//                            <p>
// 								There’s no better way to showcase Tel Aviv’s growing prominence on the global stage of gastronomy than the annual Round Table event. Seats get reserved quickly and must be made in advance. So, don’t miss your chance for a place at these prestigious tables – your taste buds will never forgive you!
// 							</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 72,
// 	    bgImage:"/posts/bank/72/1.jpg",
// 	    mobBgImage:"/posts/bank/72/M.jpg",
// 	    title: "TEL AVIV FASHION WEEK",
// 	    smlTitle: "Tel Aviv Fashion Week (TAFW)",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fashionweektelaviv.com/">
// 												fashionweektelaviv.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Tel Aviv Fashion Week (TAFW)</h2>
// 							<p>
// 								Fashion events are always occasions for the celebration of elegance, imagination, creativity, and style. But the TAFW has been making its mark in the international fashion industry with its recent attention to changing ideals of beauty, featuring models, both male and female, of different ages, sizes, heights, colors, and religions. The 4-day event showcases uncommon displays from around the world and those close to home in and around Tel Aviv’s vibrant design scene.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/72/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								TAFW also embraces leading edge fashion concepts by exhibiting innovative uses of technology and textiles. And it’s especially proud of the support it provides to young designers. As in past editions, this 7th annual event will feature an Upcoming Designers show in which new talent will have an opportunity to share their wares with you!
// 							</p>
//                            <p>
// 								In 2019, Tel Aviv Fashion Week will once again take place in the historic Tachana complex. Formerly the final stop of the old Jaffa-to-Jerusalem railway, the station has been transformed into one of Tel Aviv’s coolest and most lively public spaces. Located in a trendy neighborhood of pastel-colored homes, unique boutiques, and numerous cafes, you’ll want to explore the entire area while you’re getting your vogue on at the TAFW!
// 							</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 73,
// 	    bgImage:"/posts/bank/73/1.jpg",
// 	    mobBgImage:"/posts/bank/73/M.jpg",
// 	    title: "DGTL FESTIVAL",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">

// 												tlv.dgtl.nl/en
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
//                             <p>After its stellar debut in Tel Aviv, DGTL Festival is back, bringing yet another excellent musical program to Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>

//                             <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now Tel Aviv and bringing together the worlds of music, technology and art, as well as the latest discoveries in production and sound. </p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/73/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include three stages which will operate simultaneously at any given moment.</p>
//                             <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for saving electricity, vegetarian food only, a recycling plan and more. </p>
//                             <p>The Festival will be held in the fabulous Yarkon Park in the heart of the buzzing city of Tel Aviv, a hub of innovation, trendiness and exciting nightlife scene, making it the host for DGTL. </p>
//                             <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! </p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 74,
// 	    bgImage:"/posts/bank/74/1.jpg",
// 	    mobBgImage:"/posts/bank/74/M.jpg",
// 	    title: "Tel Aviv Marathon",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											22.02.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>

// 											<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=5418">
// 												www.tlvmarathon.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>Run and fun in the city that doesn’t stop</h2>
//                             <p>Tel Aviv Marathon is the country’s biggest international sports event and a unique and exciting celebration for runners worldwide. The Marathon is held in the heart of the fabulous city of Tel Aviv, giving participants the opportunity to take in its awesome sites and views and feel their heart beat become one with the pulse of this adrenaline charged metropolis. </p>
//                             <p>The Tel Aviv Marathon is city wide celebration stretching along the stunning beachfront, the amazing sites of the white city - a UNESCO World Heritage Site, and the city’s many buzzing stylish streets, packed with over 150,000 people taking part in the many side events, cheering the runners along the race’s flat and friendly course.   </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/74/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Around 40,000 runners come from far and wide to take part in this multi-course annual even. Allowing runners in all levels and styles, from professional long-distance runners to beginners, to take part.</p>
//                             <p>Much more than just a run, the marathon is in fact a huge festival featuring a host of dedicated lively events before and after the race, full of live music, dancing and many other attractions to the delight of runners and supporters alike.  </p>
//                             <p>Dubbed ‘The Mediterranean Capital of Cool’ By the New York Times and among Lonely Planet’s ‘Top 10 Action-Packed Cities’. Tel Aviv offers a host of fascinating attractions from all walks of life including dazzling stretches of golden beaches, colorful markets, cutting edge culture and entertainment, outstanding nightlife & an exciting culinary scene. </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 75,
// 	    bgImage:"/posts/bank/75/1.jpg",
// 	    mobBgImage:"/posts/bank/75/M.jpg",
// 	    title: "Jerusalem Marathon",
// 	    smlTitle: "The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											15.03.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://jerusalem-marathon.com/Register.aspx">

// 												jerusalem-marathon.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem</h2>
//                             <p>The International Jerusalem Winner Marathon is one of Israel's largest marathons, with 30,000 participants including hundreds of elite runners from Israel and around the world.</p>
//                             <p>The marathon offers a variety of tracks, from professional to family friendly, which pass by fascinating historical sites that illuminate 3,000 years of the history of Jerusalem, Israel's capital guaranteeing a challenging, thrilling and unforgettable experience for all runners. </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/75/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>With a series of cultural happenings planned around the central event, the Jerusalem International Marathon provides international runners with the perfect opportunity to visit the ancient city while participating in a truly modern and excitement-filled competitive sporting event. </p>
//                             <p>The Jerusalem marathon allows runners the chance to compete in a setting of unparalleled natural and cultural beauty unlike any other international marathon course. The topography of the city lends itself to a challenging route that will test even the most experienced of runners.</p>
//                             <p>The course takes the runner on a unique path through Jerusalem’s 3,000-year historical narrative, on the cobblestones of the ancient and holy walled city of Jerusalem and through the modern city center of Israel’s capital. The course includes the city’s best known sites including, among others, the Knesset, the Old City, Sultan's Pool, Mount Zion, the German Colony, the Jerusalem Promenade and the Mount of Olives.</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 76,
// 	    bgImage:"/posts/bank/76/1.jpg",
// 	    mobBgImage:"/posts/bank/76/M.jpg",
// 	    title: "Bon Jovi",
// 	    smlTitle: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, TLV
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											25.07.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bonjovi.com/">

// 												bonjovi.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!</h2>

//                             <p>Bon Jovi, all-time favorites in Tel Aviv, are making their way back to the city, famed for its lively music scene once more to appear in the famous Yarkon Park, the beautiful green lung of the city.
//                             <p>Currently touring America to sold out venues, Bon Jovi will arrive here as part of a new European tour in the summer of 2019, entitled "This House is not for Sale". The tour is set will begin on May 31, 2019 in Moscow and will probably end on July 25, 2019 with their show in Tel Aviv.
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/76/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>The band, considered e one of the most successful American bands of all times has sold more than 100 million copies, performed in over 2700 concerts in 50 different countries to more than 34 million viewers worldwide.
//                             <p>This is not Bon Jovi's first stint in the city. The band gave a truly memorable performance about three years ago at the Hayarkon Park in Tel Aviv to 50,000 adoring fans, singing along to every lyric .
//                             <p>Those coming to see the band play in Tel Aviv are in for a special treat as they will get to experience Tel Aviv in July, the city’s summer finest,  sunbathe on the fabulous beaches, enjoy the awesome culinary options, take in  the epic hot night life and best of all see Bon Jovi raise it live on stage in the city that doesn’t stop!

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 77,
// 	    bgImage:"/posts/bank/77/1.jpg",
// 	    mobBgImage:"/posts/bank/77/M.jpg",
// 	    title: "TAG 2019",
// 	    smlTitle: "Tel Aviv Games are Back!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											TAG 2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											27-30.3.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bonjovi.com/">
// 												www.telavivgames.org
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                            <h2>
//                             	Tel Aviv Games are Back!
//                           	 </h2>

//                             <p>
// 								Tel Aviv, declared one of the best gay travel destinations in the world, is joining a list of renowned capitals such as Paris, New York, Berlin and Rome, organizing its own LGBT multinational sports event – Tel Aviv Games – TAG2019. TAG 2019 offering the LGBT+ traveler a unique and exciting sports experience.
//                             </p>
//                             <p>
// 								With over 250 athletes from all over the world already signed up, and an estimated 500 more expected, Tel Aviv Games 2019 is anticipated to become the biggest LGBT+ Sports event in the middle east and one of the biggest in Europe.
//                             </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/77/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>
// 								LGBT+ athletes from more than 17 countries (including France, Germany, UK, US, Australia, Canada, Belgium, Czech Rep., Greece, Netherlands, Norway, Spain, Russia, Surnami and more) will come together for a 3-day multi-national celebration of participation, inclusion and personal best.
//                             </p>
//                             <p>
// 								The tournament will include individual and team events in 7 sporting categories: Swimming, Tennis, Basketball, Soccer, Volleyball, Same Sex Dance, and 5K and 10K Competitive Running.
//                             </p>
//                             <p>
// 								This year Tel Aviv Games will also introduce the city’s first ever “Pride Run - Running for the youth”, supporting Healthy LGBT+ Youth lifestyle in a 5K race along Tel Aviv’s beautiful shore.
// 							 </p>

// 					               `
// 			}
// 		}
//     },

//   //   {

//   //       id: 78,
// 	 //    bgImage:"/posts/bank/100/1.jpg",
// 	 //    mobBgImage:"/posts/bank/100/M.jpg",
// 	 //    title: "Purim 2019",
// 	 //    smlTitle: "",
// 	 //    html: function(){
// 		// 	return {
// 		// 		__html: `

// 		// 					<div class="col col-30">
// 		// 						<div class="top-box yellow">
// 		// 							<h2>Ort</h2>
// 		// 							<div class="text">
// 		// 								<p>
// 		// 									Tel Aviv and Jerusalem
// 		// 								</p>
// 		// 							</div>
// 		// 						</div>
// 		// 					</div>

// 		// 					<div class="col col-30">
// 		// 						<div class="top-box yellow">
// 		// 							<h2>Datum</h2>
// 		// 							<div class="text">
// 		// 								<p>
// 		// 									20-22.03.2019
// 		// 								</p>
// 		// 							</div>
// 		// 						</div>
// 		// 					</div>

// 		// 					<div class="col col-30">
// 		// 						<div class="top-box yellow">
// 		// 							<h2>weitere informationen</h2>
// 		// 							<div class="text info">
// 		// 								<p>
// 		// 									<a target="_blank" href="https://www.tel-aviv.gov.il/en/Pages/MainItemPage.aspx?WebID=9336473c-1537-4ab6-8a69-d299b5db8bcc&ListID=0ac6b290-896c-4fcb-bb36-0c5252101eff&ItemId=123">
// 		// 										Tel Aviv Purim 2019
// 		// 									</a>
// 		// 								</p>
// 		// 							</div>
// 		// 						</div>
// 		// 					</div>
// 		// 					<div class="clear"></div>
//   //                          <p>Every year in March, the people of Tel Aviv & Jerusalem dress up in costumes, the cities are a party and it’s all because of Purim – the most colorful and fun holiday of them all!
//   //                           <div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/78/1.jpg"} class="img-responsive" />
// 		// 					</div>

//   //                           <p>As expected, the party capital doesn’t disappoint, as there are tons of events to choose from – the annual street party is Tel Aviv’s biggest event. Thousands of dressed up people will gather together in “Kikar Hamedina” (State’s Square)  to enjoy performances from top musicians and dance together! The best part? It’s free of charge! If you won’t be too exhausted, you can also participate in Tel Aviv’s Zombie Walk. The name is self-explanatory, as the walk features hundreds of zombies walking through the streets of the city that never sleeps. Other events include Tel Aviv Street Party in Rothschild boulevard and many more.
//   //                           <div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/78/2.jpg"} class="img-responsive" />
// 		// 					</div>
//   //                           <p>If your prefer to spend the holiday in the city of gold, have no fear as there are plenty of events taking place across Jerusalem – from carnivals to parties there is something for everyone: The official Jerusalem Purim events is at Safra Square, featuring activities and performances for kids. Another option is the event at the Israel Museum that’s meant for the whole family. There’s also a Purim Rave Party at The Tower of David, the traditional parade at Nachlaot street, a party at Downtown Jerusalem building, a Purim party at the Shuka and more events to be confirmed!
//   //                           <div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/78/3.jpg"} class="img-responsive" />
// 		// 					</div>
//   //                           <p>So choose your costume and come celebrate with us!
//   //                           <div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/78/4.jpg"} class="img-responsive" />
// 		// 					</div>

// 		// 			               `
// 		// 	}
// 		// }
//   //   },

//     {

//         id: "J_Lo",
// 	    bgImage:"/posts/bank/J_Lo/1.jpg",
// 	    mobBgImage:"/posts/bank/J_Lo/M.jpg",
// 	    title: "J.LO",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Hayarkon Park
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											01.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<h3>
// 								J.LO HEADING TO TEL AVIV TO SET THE SUMMER ON FIRE!
// 							</h3>
// 							<p>
// 								Yes, it's true! after weeks of rumors flying around it is officially confirmed the J.Lo, AKA Jeniffer Lopes, AKA Jenny from the block, the hottest name worldwide as queen of pop for the past 2 decades, is coming to light up your summer in Tel Aviv!
// 							</p>
//                          <p>
// 								Performing for the first time in this country, J.Lo will be getting loud on the floor on August 1st at the Yarkon Park. The show, part of the maga star’s “It’s My Party” worldwide tour is expected to be one of the summer’s biggest concerts, along with Bon Jovi’s highly anticipated performance on the very same Tel Aviv stage on the 25th July.
// 							</p>
// 							<p>
// 								Hayarkon park is Tel Aviv’s green lung. This is the perfect place to get some respite after spending a wild night in Tel Aviv. Here you can spend the day cycling, walking or relaxing in the beautiful outdoor scenery and even enjoy flying high on a hot air balloon before heading to take your place in the stunning amphitheater. Whatever you choose, make sure to come packed with energy for J.Lo’s once in a lifetime performance in sunny awesome Tel Aviv!
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//         id: "Pride_Parade_2019",
// 	    bgImage:"/posts/bank/Pride_Parade_2019/1.jpg",
// 	    mobBgImage:"/posts/bank/Pride_Parade_2019/M.jpg",
// 	    title: "Pride Parade 2019",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											14.6.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<h3>
// 								The  most fabulous event of the Year
// 							</h3>
// 							<p>
// 								<strong>
// 									Tel Aviv 2019 Pride Celebrations – guaranteed to blow your mind!
// 								</strong>
// 							</p>
// 							<p>
// 								Tel Aviv, one of the most celebrated gay capitals in the world, is famous for its round the clock energy and extravagant nonstop parties. One of the biggest and hottest events, by far in the city is the ‘Gay Pride Week’ parties ending with the awesome Friday Pride Parade.
// 							</p>
//                          <p>
// 								The parade, a tradition which began as early as 1998, draws a huge crowd of the coolest people and thousands of participants from around the world. All them come together to celebrate and support freedom and embrace all lifestyles and genres in an open minded, off the charts, celebration.
// 							</p>
// 							<p>
// 								The parade is the highlight of a week of gay pride events which take place around the city of Tel Aviv and include pride-themed parties, exhibitions, movie festivals, music concerts and so much more.
// 							</p>
// 							<p>
// 								The parade itself takes place along the buzzing main streets of marvelous Tel Aviv, and features, in the tradition of pride parades from across the world, fantastic extravagant floats, live music, dance performances and revelers dressed in a colorful festival dress.
// 							</p>
// 							<p>
// 								The parade stops and rests at the stunning Tel Aviv promenade by the shores of the beautiful coastline, where it turns into an epic adrenaline-charged beach party featuring leading DJs and live performances, lasting well into the small hours of the night.
// 							</p>
// 							<p>
// 								The 2019 parade will take place on June 14th 2019 and participation, as always, will be completely free of charge.
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {

// 	              id: "TelAviv_Marathon",
// 	              bgImage:"/posts/bank/tlv-marathon2020/1.jpg",
// 	              mobBgImage:"/posts/bank/tlv-marathon2020/M.jpg",
// 	              title: "Tel Aviv Marathon",
// 	              smlTitle: "",
// 	              html: function(){
// 			              return {
// 				              __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Ort</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Datum</h2>
// 											<div class="text">
// 												<p>
// 													28.02.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>WeiteRe informationen</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=6607">

// 														www.tlvmarathon.co.il
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>

//                                       <h2>SPORT UND SPASS IN DER STADT DIE NIEMALS SCHLÄF</h2>
//                                       <p>Der Tel Aviv Marathon ist das größte internationale Sportereignis des Landes. Ein einzigartiges und spannendes Event für Läufer aus aller Welt. Der Marathon findet im Herzen der wunderschönen Stadt Tel Aviv statt und gibt den Teilnehmern die Möglichkeit, deren berühmte Sehenswürdigkeiten und traumhafte Ausblicke zu genießen, während ihr Herzschlag eins wird mit dem Puls der aufregenden Metropole.</p>

//                                       <p>Rund 40.000 Läuferinnen und Läufer kommen aus aller Herren Länder, um an diesem jährlich stattfindenden Wettbewerb mit seinen diversen Rennen teilzunehmen. Es ist für jeden etwas dabei, vom echten Marathon-Profi bis zum Anfänger.</p>

//                                       <p>Während des Tel Aviv Marathon wird die ganze Stadt zu einem einzigen großen Fest, das sich entlang der traumhaften Strandpromenade, dem beeindruckenden UNESCO-Weltkulturerbe der "Weißen Stadt" und den vielen belebten, stilvollen Straßen der Stadt erstreckt, in denen mehr als 150.000 Menschen am Rahmenprogramm teilnehmen – und die Läufer auf der flachen, entspannten Marathonstrecke anfeuern.</p>

//                                       <p>So ist der Marathon ein riesiges Festival mit einer Vielzahl einzigartiger und besonderer Events vor und nach dem Rennen, mit Live-Musik, Tanz sowie vielen weiteren Erlebnissen. Sehr zur Freude der Läufer und der Fans an der Strecke.</p>

//                                       <p>Von der New York Times als "Mediterrane Hauptstadt der Coolness" bezeichnet und von Lonely Planet unter die Top 10 der erlebenswertesten Städte der Welt gewählt, bietet Tel Aviv in allen Lebensbereichen eine Vielzahl faszinierender Attraktionen: Golden schimmernde Strände, farbenfrohe Märkte, eine lebendige Kulturlandschaft und abwechslungsreiche Unterhaltung, ein überragendes Nachtleben und eine aufregende kulinarische Szene.</p>
// 	                            `
// 			}
// 		}
//     },
//     {

// 	              id: "Jerusalem_Marathon",
// 	              bgImage:"/posts/bank/jerusalem5/1.jpg",
// 	              mobBgImage:"/posts/bank/jerusalem5/M.jpg",
// 	              title: "JERUSALEM MARATHON",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Ort</h2>
// 											<div class="text">
// 												<p>
// 													Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Datum</h2>
// 											<div class="text">
// 												<p>
// 													20.03.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>WeiteRe informationen</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://jerusalem-marathon.com/default.aspx">

// 														jerusalem-marathon.com
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>

//                                     <h2>EIN FASZINIERENDER LAUF DURCH 3.000 JAHRE GESCHICHTE</h2>
//                                     <p>Mit 30.000 Teilnehmern, darunter viele der weltbesten Läufer, feiert der International Jerusalem Marathon ein großartiges Miteinander von Körper und Geist im Herzen einer der bezauberndsten Städte der Welt.</p>

//                                     <p>Der Lauf bietet den Teilnehmern eine perfekte Gelegenheit, diese Jahrtausende alte Stadt im Zuge eines ebenso richtungsweisenden wie spannenden sportlichen Wettbewerbs zu entdecken – und ein facettenreiches kulturellen Rahmenprogramm zu erleben.</p>

//                                     <p>Mit einer Vielzahl von Streckenführungen eignet sich dieser Marathon für Läufer jeden Levels – ob Profi oder Einsteiger, ob Ausnahmeathlet oder laufbegeisterte Familie. Die Route führt mitten durch die 3.000jährige Geschichte, vorbei an faszinierenden historischen Stätten, über das Kopfsteinpflaster des alten, heiligen Jerusalem und durch das moderne Zentrum der israelischen Hauptstadt.</p>

//                                     <p>Und natürlich liegen einige ihrer berühmtesten Sehenswürdigkeiten auf dem Weg, darunter die Knesset, die Alte Stadt, das Merrill Hassenfeld Amphitheater (auch bekannt als Sultan‘s Pool), der Berg Zion, die Deutsche Kolonie, die Haas-Promenade und der Ölberg.</p>

//                                     <p>Mit großartiger Natur und Kultur, wie sie bei keinem anderen Marathon zu finden sind, ermöglicht der Jerusalem Marathon den Teilnehmern einen Lauf in unvergleichlicher Umgebung. Die Topographie der Stadt sorgt für einen anspruchsvollen Streckenverlauf, der auch noch die erfahrensten Läufer in seinen Bann zieht – und zu einem herausfordernden, spannenden und unvergesslichen Erlebnis wird.</p>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Celine_Dion",
// 	              bgImage:"/posts/bank/Celine_Dion/1.jpg",
// 	              mobBgImage:"/posts/bank/Celine_Dion/M.jpg",
// 	              title: "Our Heart Goes On \n for Celine Dion in Tel Aviv!",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											04.08.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>WeiteRe informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.celinedion.com">

// 												www.celinedion.com

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2>Our Heart Goes On – for Celine Dion in Tel Aviv!</h2>
// 										<p>The Diva is coming! Now it’s official: Celine Dion will perform in Tel Aviv on August 4th of next summer and it’s going to be a hot one! This will be Dion’s first ever concert here, and boy are we excited.</p>

//                                         <p>The 6 Grammy award-winner will visit Tel Aviv, the city that never sleeps, to keep the party going all Night. Dion’s countless hits, “Because you Loved Me”, “Just Walk Away” and of course her all-time greatest hit – “My Heart Will Go On” – will hopefully make their debut live in Tel Aviv.</p>

//                                         <p>Tel Aviv has also hosted some of the largest art exhibitions, live shows and festivals, making it one of the liveliest cities in the world. With a combination of sun, rich nightlife scene, spectacular sights in every corner and the Dion’s first appearance – Tel Aviv is the place to be next summer.</p>

//                                         <p>Ticket sales have yet to open, but it’s never too early to start planning your next visit to Tel Aviv!

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Nickcave-Badseeds",
// 	              bgImage:"/posts/bank/Nickcave_Badseeds/1.jpg",
// 	              mobBgImage:"/posts/bank/Nickcave_BadseedsM.jpg",
// 	              title: "NICK CAVE & BAD SEEDS",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Bloomfield Stadium, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											17.06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>WeiteRe informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.celinedion.com">

// 												www.celinedion.com

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2>NICK CAVE AND THE BAD SEEDS LIVE IN TEL AVIV!</h2>
//                                     <p>Nick Cave is coming to Tel Aviv to blow the roof off! Returning to the city that never sleeps in June 2020, the Australian pop-punk musician is coming to rock you.</p>

//                                     <p>Having recorded no less than 17 studio albums with his band, the talented musician is excited about his visit – which will be hotter than ever.</p>

//                                     <p>Coming back just a little more than two years after his previous performance here, this time, lighting up the newly renovated Bloomfield Stadium (which has hosted a long line of international artists). Judging by the last performance, this one should be truly sensational.</p>

//                                     <p>Tel Aviv has been known to attract and feature some of the biggest names in the world, making it one of the hottest cities when it comes to live concerts and the nightlife scene. This performance shouldn’t be any different and is a great opportunity to catch Nick Cave live, as part of his summer tour.</p>

//                                     <p>Warm summer nights, soft sand beaches and the mesmerizing music of a world-renowned artist – what more could you ask for? Tel Aviv has it all!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//         id: "Open_Restaurants_Jerusalem",
// 	    bgImage:"/posts/bank/Open_Restaurants_Jerusalem/1.jpg",
// 	    mobBgImage:"/posts/bank/Open_Restaurants_Jerusalem/M.jpg",
// 	    title: "Open Restaurants Jerusalem",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											19-23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												www.open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							<h3>
// 								Open Restaurants Jerusalem
// 							</h3>
// 							<p>
// 								Taking place in the iconic city of Jerusalem at varying hours, \‘Open Restaurants\’ is a unique culinary festival giving visitors a glimpse into the fascinating cultural and culinary diversity of Jerusalem.
// 							</p>
// 							<p>
// 								The festival includes about 100 different events held all over the city of Jerusalem, even in places which are less culinary oriented, as well as in culinary adequate venues and combine food with art, culture, innovation and technology.
// 							</p>
//                          <p>
// 								Festival-goers will also have a chance to participate in a series of meetings, workshops and lectures by prominent local personalities, and visits to the city\'s famous restaurant kitchens.
// 							</p>
// 							<p>
// 								As part of the festival program, day and night tours will be held at various culinary centers throughout Jerusalem including flavors tours in the Old City,Ein Kerem and more. You are encouraged to take at least one of them!
// 							</p>
// 							<p>
// 								In addition, FoodTalks meetings will be held with leading culinary experts (we can’t reveal who they are, so keep guessing…), photographers and chefs. The top hotels in Jerusalem will also collaborate with their private chefs at special prices.
// 							</p>
// 							<p>
// 								Whether you’re a foodie or just a curious visitor, you are sure to enjoy this unique taste of magical Jerusalem’s culinary side happening between the 19th -23rd , November,2019.
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

// 	              id: "Purim_2020",
// 	              bgImage:"/Concerts/bank/purim2020/1.jpg",
// 	              mobBgImage:"/Concerts/bank/purim2020/M.jpg",
// 	              title: "Purim 2020",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Ort</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv und Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Datum</h2>
// 											<div class="text">
// 												<p>
// 													09-10.03.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									</div><div class="clear"></div>

//                                     <p>Jedes Jahr im März verkleiden sich die Menschen in Tel Aviv und Jerusalem und feiern in den Städten eine große und vor allem großartige Party – und all das dank Purim, dem buntesten und lustigsten Feiertag von allen!</p>
//                                     <div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/1.jpg"} class="img-responsive" />
// 									</div>
//                                     <p>Erwartungsgemäß enttäuscht die Party-Hauptstadt dabei in keinster Weise, schließlich gibt es unsagbar viele Veranstaltungen zur Auswahl – wobei das jährliche Straßenfest eines von Tel Avivs größten Ereignissen ist. Tausende verkleideter Menschen versammeln sich auf dem Kikar Hamedina Platz – dem „Rodeo Drive“ von Tel Aviv-, um die Auftritte von Top-Musikern zu erleben und gemeinsam zu tanzen! Das Beste daran? Es ist kostenlos! Wenn Sie danach nicht zu erschöpft sind, können Sie am Zombie Walk teilnehmen. Der Name ist Programm, wanken doch bei diesem Event hunderte von Zombies durch die Straßen der Stadt, die niemals schläft. Weitere Veranstaltungen sind die Tel Aviv Street Party auf dem Rothschild-Boulevard und viele andere.</p>
//                                     <div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/2.jpg"} class="img-responsive" />
// 									</div>
//                                     <p>Wenn Sie Ihren Urlaub lieber in der Goldenen Stadt verbringen möchten, seien Sie unbesorgt! In ganz Jerusalem finden zahlreiche Veranstaltungen statt – vom Karneval bis hin zu den zahlreichen Partys ist für jeden etwas dabei: Die offiziellen Purim-Veranstaltungen finden auf dem Safra-Platz statt, mit zusätzlichen Aktivitäten und Aufführungen für Kinder. Eine weitere Möglichkeit ist die Veranstaltung für die ganze Familie im Israel Museum. Darüber hinaus gibt es eine Purim Rave Party im Davidsturm, die traditionelle Parade in der Nachlaot Straße, eine Party in Downtown Jerusalem, eine Purim Party in der Shuka Bar – und ständig kommen weitere Veranstaltungen hinzu!</p>
//                                    <div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/4.jpg"} class="img-responsive" />
// 									</div>
//                                     <p>Wählen Sie Ihr Kostüm aus und feiern Sie mit uns!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//         id: "TelAviv_Fashion_Week_2020",
// 	    bgImage:"/Concerts/bank/fashion-week-2020/1.jpg",
// 	    mobBgImage:"/Concerts/bank/fashion-week-2020/M.jpg",
// 	    title: "TEL AVIV FASHION WEEK",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											03.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>WeiteRe informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fashionweektelaviv.com/">
// 												fashionweektelaviv.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Voll im Trend!</h2>
//                             <p>Viele Mode-Events stellen Glamour, Extravaganz, Kreativität und Stil ins Rampenlicht. Der  Tel Aviv Fashion Week kommt jedoch eindeutig eine Sonderstellung innerhalb der  internationalen Modeszene zu. Hier wird das aktuelle Schönheitsdeal neu- und umgedacht. Weibliche und männliche Models verschiedenen Alters, verschiedener Hautfarbe, Religion und Konfektionsgrößen präsentieren in der Fashion City die neuesten Trends. Auf dem 4-tägigen Event begeistern die bis dato ungesehene Entwürfe aus aller Welt wie auch aus Tel Avivs lebhafter Design-Szene das Publikum.</p>
//                             <p>Indem sie den innovativen Umgang mit Technologien und Textilien präsentiert, ist die Tel Aviv Fashion Week ein Synonym für richtungsweisende Mode-Ideen. Besonders stolz ist man dabei auf die Unterstützung junger Designer. Wie bereits in der Vergangenheit wird es auch bei der achten Auflage eine Newcomer Show geben, in deren Rahmen der Design-Nachwuchs Gelegenheit hat, das Publikum mit seinen Entwürfen zu begeistern.</p>
//                             <p>Einmal mehr findet die Tel Aviv Fashion Week 2020 in der historischen Bahnstation „Tachana“ statt. Ehemals Endstation der Strecke Jaffa – Jerusalem, zählt sie heute zu den coolsten und dynamischsten Locations in Tel Aviv. Dank ihrer Lage in einem Viertel mit pastellfarbenen Häusern, außergewöhnlichen Boutiquen und zahlreichen Cafés, lädt der Besuch bei der Tel Aviv Fashion Week gleichzeitig ein, die Gegend ausgiebig zu erkunden. Trends finden hier schließlich nicht nur auf dem Catwalk statt!</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: "The_Jerusalem_March_2020",
// 	    bgImage:"/Concerts/bank/jerusalem-march/1.jpg",
// 	    mobBgImage:"/Concerts/bank/jerusalem-march/M.jpg",
// 	    title: "Der Jerusalem-Marsch",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											30.09.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<p>Der im Oktober stattfindende Jerusalem-Marsch ist eines der farbenfrohsten und faszinierendsten Ereignisse des Landes, das Zehntausende Teilnehmer aus aller Welt zusammenbringt.</p>
//                              <p>Der Jerusalem-Marsch umfasst drei Veranstaltungen – einen Morgenspaziergang auf Naturpfaden, ein Happening im Sacher-Park und eine festliche Parade, die im Zentrum von Jerusalem stattfindet.</p>
//                              <p>Damit alle, die mitmachen wollen, auch dabei sein können, bietet der Marsch eine Vielzahl von Routen unterschiedlicher Länge und Schwierigkeitsgrade.</p>
//                              <p><strong>Morgen-Routen</strong><br/>
//                              <u>Route A </u>– Für erfahrene Läufer, ungefähr 12 km (07:00 bis 09:00 Uhr)</p>
//                               <p><strong>Vom Munitionshügel zum Sacher Park.</strong><br/>
//                              <u>Route B</u> – Mittlerer Schwierigkeitsgrad, ungefähr 9 km (07:30 bis 09:30 Uhr)</p>
//                              <p><strong> Vom Skopusberg zum Sacher Park.</strong><br/>
//                              <u>Route C</u> – Einfach, für Familien geeignet, ungefähr 4 km (08:00 bis 10:00 Uhr)</p>
//                              <p>Vom Safra Platz zum Sacher Park.<br/>
//                              Sacher Park Festival </p>
//                              <p>Zwischen 10:00 und 16:00 Uhr findet im Sacher Park ein Festival mit Auftritten, Live-Musik und Kindershows sowie einem eigens für Kinder eingerichteten Bereich statt.</p>
//                              <p>Die Parade beginnt um 15:00 Uhr und folgt dem Verlauf der Bezalel-, Hillel- und König-David-Straße und endet neben dem Glockenpark. Auch dieses Jahr nehmen wieder zahlreiche Festwagen, bunte Teilnehmergruppen aus Israel und der ganzen Welt, verschiedene Orchester und Tanzgruppen, IDF-Soldaten, Straßenkünstler, Sportmannschaften und mehr an diesem farbenfrohen Festumzug teil.</p>
//                              <p>Lassen Sie sich die Chance nicht entgehen, an diesem wunderschönen und fröhlichen Jerusalem-Fest teilzunehmen!</p>

// 				`
// 			}
// 		}
//     },

//     {

//         id:"The_Pixies_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Pixies",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											14.07.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>WeiteRe informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pixiesmusic.com">
// 											www.pixiesmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							<h2>The Pixies sind zurück um Tel Aviv zu rocken!</h2>

// 							<p>The Israeli summer is always hot, but the Pixies are returning to Tel Aviv after 3 years to make it even hotter!</p>
// 			                         <p>The famous American band, well known for its signature style of aggressive punk rock and pop, is responsible for some of the most iconic tunes in music history, including their all-time audience favorite ‘where is my mind’. The pixies are returning to Tel Aviv for the third time as part of their promotional tour for their new album, ‘Beneath the Eyrie’. </p>
// 			                         <p>The pixies will be giving a single performance in the nonstop city of Tel Aviv, the perfect way to rock your beach, sun and fun Tel Aviv holiday.  The concert is set to be held in July, a fabulous time to enjoy the famous Tel Aviv summer, the parties, the amazing cuisine, and the stunning beaches. </p>
// 			                         <p>Tickets are selling fast so hurry up and book your trip today!  </p>

// 						`
// 			}
// 		}
// 	},

// 	{

//         id:"White_Night_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "White Night",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							<h2>Die Party des Jahres in der Party-Hauptstadt der Welt!</h2>

// 							<div class="responisve-iframe">
// 								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 							</div>
// 							<p>Feiert die weltbekannte “Stadt, die niemals schläft” ein Event wie die „White Night“, dann wartet ein unvergessliches Erlebnis auf Sie! Als eine der größten Veranstaltungen Tel Avivs macht die jährliche „White Night“ die Nacht zum Tag – in der alles in der Stadt geöffnet hat und es jede Menge zu erleben gibt!</p>
//                             <p>Von den frühen Abendstunden bis zum Morgengrauen wird die City zur belebten Partymeile für Besucher und Einheimische, die das Leben und die facettenreichen Angebote genießen. In Geschäften und Restaurants, in Kinos und an kulturellen Schauplätzen – und das entweder kostenlos oder zu vergünstigten Preisen!</p>

//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Adam Primer
// 							</small>
// 							<p>Die Wurzeln des mittlerweile schon weltberühmten Events reichen zurück in das Jahr 2003, als die “Weiße Stadt” – Tel Avivs größte Sammlung weißer Bauten im Bauhaus-Stil von der UNESCO zum Weltkulturerbe erklärt wurde und ihr damit einen einzigartigen Status im architektonischen Kontext der Gegenwart verlieh.</p>

//                             <p>Seit dieser Zeit feiert Tel Aviv-Jaffa den historischen Anlass mit den “White Night”-Events, benannt nach der “Weißen Stadt” und einer weiteren Charakteristik Tel Avivs – als “Stadt, die niemals stillsteht“.</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Kfir Sivan
// 							</small>
// 							<p>Während der “White Night” findet überall in der Stadt eine Vielzahl von Events statt – und es werden Jahr für Jahr mehr. In der Vergangenheit gehörten dazu zum Beispiel ein einzigartiges Mitternachtspicknick, eine Silent Disco auf dem zentralen Platz der Stadt, unzählige Live-Konzerte, großartige Theater-Aufführungen sowohl auf der Hauptbühne als auch in den Straßen, faszinierende Nachtspaziergänge, nächtliche Sportkurse, Yoga-Sessions bei Sonnenaufgang und natürlich viele coole Parties, die die ganze Nacht und überall in der Stadt gefeiert werden.</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by Moshik Lindenbaum
// 							</small>
// 							<p>Tanken Sie Kraft – wir versprechen Ihnen, Sie werden sie für die erlebnisreiche „White Night“ in der fantastischen Stadt Tel Aviv brauchen!</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by: Guy Yechiely‎.
// 							</small>

// 						`
// 			}
// 		}
// 	},
// 	{

//         id: "Pride_Week_2020",
// 	    bgImage:"/posts/bank/Pride_Parade_2019/1.jpg",
// 	    mobBgImage:"/posts/bank/Pride_Parade_2019/M.jpg",
// 	    title: "Pride Week 2020",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											12.6.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<div class="responisve-iframe">
// 					             <iframe width="560" height="315" src="https://www.youtube.com/embed/U8KwXVP3Xng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 				             </div>
// 				             <div class="ac-cradit" style="margin-top: -15px;margin-bottom: 40px;">
// 							<span class="ac-cradit-text">Credits:</span>

// 								<span class="ac-cradit-text-1"><a href="https://www.youtube.com/channel/UCWN-mUP4IzdHLH7gaXHEKVw" target="_blank">Basti Hansen</a><br/>
// 							</div>
// 							<p></p>
// 							</div>
// 							<h2 class="ac-align-center">Das schillerndste Event des Jahres</h2>
// 							<p class="ac-align-center ac-margin-bottom-20"><strong>Die Tel Aviv 2020 Pride Celebrations – einzigartig und unvergesslich!</strong></p>
// 							<p>Tel Aviv ist unter den LGBT-Hauptstädten der Welt weit vorn und bekannt für seine einzigartig energiegeladene Atmosphäre und ausgefallenen Nonstop-Partys. Eines der größten und angesagtesten Events der Stadt ist die „Gay Pride Week", die ihr grandioses Finale mit der Pride Parade am Freitag feiert.</p>
//                             <p>Bereits seit 1998 treffen bei dieser Parade unzählige ausgelassene Menschen und tausende Teilnehmern aus aller Welt zusammen. Sie feiern die Freiheit und setzen sich im Rahmen dieses grandiosen Happenings für Offenheit gegenüber allen Lebensstilen und Orientierungen ein.</p>
//                             <p>Die Parade ist der Höhepunkt einer Woche von Gay Pride Events, die in ganz Tel Aviv stattfinden und zu denen unter anderem Themen-Partys, Ausstellungen, Filmfestivals, Konzerte und vieles mehr gehören.</p>
//                             <p>In schönster Tradition der Gay Pride-Paraden in aller Welt findet die Pride Parade entlang der pulsierenden Hauptstraßen Tel Avivs statt – mit extravaganten Wagen, Live-Musik, Tanz-Performances und bunt gekleideten Feiernden.</p>
//                             <p>Ihren Endpunkt findet die Parade an Tel Avivs traumhafter Promenade direkt am Meer und wird dort zur unvergesslich aufregenden Beachparty, die mit Top-DJs und Live-Auftritten bis in die frühen Morgenstunden dauert.</p>
//                             <p>Die Parade findet am 12. Juni 2020 statt und wie in jedem Jahr ist die Teilnahme absolut kostenlos!</p>

// 					               `
// 			}
// 		}
//     },

//     {
// 	              id: "Hutzot_Hayotzer_Jerusalem_2020",
// 	              bgImage:"/posts/bank/international-arts/1.jpg",
// 	              mobBgImage:"/posts/bank/international-arts/M.jpg",
// 	              title: "Hutzot Hayotzer Jerusalem",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Ort</h2>
// 											<div class="text">
// 												<p>
// 													Merrill Hassenfeld Amphitheater
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Datum</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p></p>
// 											</div>
// 										</div>
// 									</div>
// 							        <div class="clear"></div>
// 							        <h2>Internationale Kunsthandwerksmesse</h2>
//                                     <p>Den ganzen Sommer über bietet Jerusalem eine Vielzahl großartiger Veranstaltungen. Eine der bekanntesten ist die bunte internationale Kunsthandwerksmesse "Hutzot Hayotzer".</p>
//                                       <p>Das große jährliche Festival findet in der Gegend Hutzot Hayotzer und im Merrill Hassenfeld Amphitheater (auch bekannt als The Sultan’s Pool) gegenüber dem Davidsturm und am Fuße der Altstadt-Mauern statt.</p>
//                                       <p>Seit mehr als 35 Jahren in Folge lockt das mittlerweile schon legendäre Hutzot Hayotzer Besucher aus aller Welt an – und ist längst zu einer der beliebtesten touristischen und künstlerischen Veranstaltungen Jerusalems geworden.</p>
//                                       <p>Regelmäßig gibt es hier die Werke von weit mehr als 150 einheimischen Künstler zu bewundern, darunter Gemälde, Drucke, Keramik, Schmuck und mehr. Darüber hinaus präsentiert eine internationale Ausstellung die Arbeiten ausländischer Künstler.</p>
//                                       <p>Nehmen Sie als Gast an den inspirierenden Kunstgesprächen und einzigartigen Workshops teil und erleben Sie die zahlreichen Live-Performances, einen irischen Pub, gigantische Skulpturen, Live-Jazzmusik und eine echte europäische Karnevalsatmosphäre.</p>

//                                       <p>Das Festival ist jeden Abend (außer freitags) zwischen 18:00 und 23:00 Uhr sowie samstagabends von 21:00 bis 24:00 Uhr im Hutzot Hayotzer, Mitchell Park und im Merrill Haasenfeld Amphitheater geöffnet.</p>

//                                       <p>Last but not least sollten Sie sich keinesfalls "Food around the world" entgehen lassen: Diese internationale Kulinarik-Messe bringt an ihren zahlreichen Ständen Genüsse aus aller Welt für Sie nach Jerusalem, darunter natürlich israelisch, als auch thailändisch, chinesisch, koreanisch und viele weitere Nationen.</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//                   id: "Jerusalem_Beer_Festival_2020",
// 	              bgImage:"/posts/bank/jerusalem-beer-festival/1.jpg",
// 	              mobBgImage:"/posts/bank/jerusalem-beer-festival/M.jpg",
// 	              title: "Jerusalem Beer Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Time</h2>
// 											<div class="text">
// 												<p>
// 													18:00 – 00:00
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Datum</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 							        <p>Jerusalem ist stolz darauf, bereits im 16. Jahr (!) in Folge das großartige und weithin beliebte "Beer Festival“ auszurichten – ein weltbekanntes Event, bei dem sich alles um gute Musik, gutes Essen und, wie Sie sicher erraten haben, natürlich um gutes Bier dreht.</p>
//                                     <p>Zur unvergleichlichen Atmosphäre des Festivals trägt selbstverständlich auch der Veranstaltungsort bei: die zauberhafte 3.000 Jahre alte Stadt Jerusalem sorgt für ein wahrhaft unvergessliches Erlebnis!</p>
//                                     <p>Über die Jahre ist das Festival geradezu legendär geworden und nicht mehr aus der Unterhaltungskultur Jerusalems wegzudenken. Es bietet Besuchern aus aller Welt die einzigartige Gelegenheit, eine erfrischende Auswahl kühler Biere, köstlicher Speisen und geselliger Menschen unter freiem Himmel zu genießen.</p>
//                                     <p>In eigens für die Veranstaltung errichteten Pop-up-Bars haben Sie die Möglichkeit, diverse (oder alle) der unterschiedlichen und besonderen Biere aus dem ganzen Land und der ganzen Welt zu probieren – von denen wir mehr als 120 für Sie kaltgestellt haben!</p>
//                                     <p>Das Jerusalem Beer Festival ist das einzige Event seiner Art in Israel. Diverse einheimische Brauereien präsentieren hier Jahr für Jahr ihre Erzeugnisse. Hinzu kommt eine immense Vielfalt internationaler Marken, die man unbedingt probiert und erlebt haben sollte.</p>
//                                     <p>Machen Sie sich auf den Weg und werden Sie Teil der mehr als 15.000 Besucher, die sich an der einzigartigen Atmosphäre, fantastischen Live-Shows, dem leckere Essen und den herzlichen Menschen erfreuen und dabei das weltweite Lieblingsgetränk Bier feiern.</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//         id: "Jerusalem_Wine_Festival_2020",
// 	    bgImage:"/Concerts/bank/jer-wine-festival-2020/1.jpg",
// 	    mobBgImage:"/Concerts/bank/jer-wine-festival-2020/M.jpg",
// 	    title: "Jerusalem Wine Festival",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											08.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>WeiteRe informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
// 												www.imj.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Genussvolle Stunden in der Heiligen Stadt!</h2>
// 							<p>Entspannte Sommerabende sind wie geschaffen für ein Glas hervorragenden Weins – und deshalb können Sie auch in diesem Jahr wieder für vier Tage im August die erstklassige Weinauswahl und preisgekrönte Küche des 17. Jerusalem Wine Festival genießen. Ausgerichtet im traumhaften Japanischen Garten des Israel Museums, gilt es vielen als das gesellschaftliche Ereignis Jerusalems. Seine Atmosphäre und die grandiosen Ausblicke auf die geschichtsträchtige Stadt, machen das JWF zu einem einzigartigen Wein Event, das man einfach erlebt haben muss.</p>
//                             <p>Dabei werden hunderte verschiedener Weine von Dutzenden renommierter, wie auch kleiner, feiner Weingüter angeboten. Freuen Sie sich auf kostenlose Weinverkostungen und auf die kulinarische Vielfalt verschiedener Stände, an denen Käse, Schokolade, Olivenöl, ausgezeichnete Soßen und köstliche Konfitüren angeboten werden. Neben dem Gaumen kommen aber auch die Ohren zu ihrem Recht: Im Rahmen des Festivals erwarten Sie jeden Abend zwei verschiedene Livemusik-Acts.</p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Jedes Jahr zieht das JWF eine facettenreiche Schar von weit mehr als 20.000 Wein- und Kulturliebhabern nach Jerusalem. Viele nutzen die Zeit und sind gleich mehrere Abende vor Ort, um die einzigartige Atmosphäre des Festivals zu genießen.</p>
//                             <p>Planen auch Sie bereits jetzt Ihren Aufenthalt während des Festivals. </p>
//                             <p>Tagsüber erwartet Sie eine Fülle an Möglichkeiten zum Sightseeing, Shopping und abwechslungsreichen Ausflügen in die Umgebung, während das Jerusalem Wine Festival den perfekten Ausklang am Abend bietet – ganz entspannt, mit bester Unterhaltung und jeder Menge Spaß!</p>

// 					     `
// 			}
// 		}
//     },

//     {

// 	              id: "Open_Houses_Festival_2020",
// 	              bgImage:"/posts/bank/openhf/1.jpg",
// 	              mobBgImage:"/posts/bank/openhf/M.jpg",
// 	              title: "Open Houses Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Ort</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv, stadtweit
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Datum</h2>
// 											<div class="text">
// 												<p>
// 													09.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>WeiteRe informationen</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="//www.batim-il.org/DefaultEng.aspx?batim=">

// 														www.batim-il.org
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div><div class="clear"></div>
//                                     <h2>Ein großartiges Erlebnis für Designliebhaber aus aller Welt</h2>
//                                     <p>Bereits zum 15. Mal in Folge findet im September dieses Jahres in Tel Aviv – der Stadt, die niemals schläft – das fantastische Architektur- und Designfestival "Open House" statt.</p>
//                                     <p>Die Teilnehmer erwartet ein spannendes Programm mit unvergesslichen Besuchen und Touren einiger der beeindruckendsten Gebäude der Stadt, darunter Privathäuser, Appartements, historische Gebäude sowie städtische Bauten. Darüber hinaus werden spezielle Führungen und besondere Aktionen an verschiedenen ungewöhnlichen Orten angeboten.</p>
//                                     <p>„Open Houses" öffnet Türen, die die meiste Zeit verschlossen sind und gewährt einen Blick hinter die Kulissen von Design, Lebensentwürfen, Geschichte, Kultur, Technologie, Ökologie und in Häuser mit jenem gewissen Etwas, das sie so anziehend und ansprechend macht.</p>
//                                     <p>Unter den vielen Gebäuden und Bauwerken, die für die Öffentlichkeit zugänglich gemacht werden, sind einige, die nie zuvor geöffnet wurden: das Tel Aviv Velodrome zählt ebenso dazu, wie das Innere eines Schiffes oder eine 1840 erbaute Synagoge in der Altstadt von Jaffa. Zu den Favoriten der Festival Fans zählen u. a. der Hubschrauberlandeplatz auf dem Azrieli-Dach und ein Atomschutzbunker im Dizengoff Center.</p>
//                                     <p>„Open Houses" ist Teil der Open House Worldwide Organisation, die in New York, London, Chicago, Rom, Barcelona, Melbourne, Dublin, Helsinki und anderen Städten rund um den Globus aktiv ist.</p>
//                                     <p>Erleben Sie ein einzigartiges und unvergessliches Fest urbaner Lebenskultur in der großartigen Stadt Tel Aviv!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "DGTL_Festival_2020",
// 	              bgImage:"/posts/bank/dgtl-festival2019/1.jpg",
// 	              mobBgImage:"/posts/bank/dgtl-festival2019/M.jpg",
// 	              title: "DGTL FESTIVAL",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Ort</h2>
// 											<div class="text">
// 												<p>
// 													Hayarkon Park Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Datum</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>WeiteRe informationen</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">

// 														www.tlv.dgtl.nl
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 							        <p> Das DGTL Festival is zurück in Tel Aviv und bringt einmal mehr ein hochkarätiges Musikprogramm in den Yarkon Park – begleitet von den aktuellsten nachhaltigen und technologischen Neuerungen und innovativen Kunstprojekten.</p>

//                                     <p>Als weltweite Veranstaltungsreihe gehört das DGTL Festival zu den Vorreitern der Musik- und Festivalszene und präsentiert sich in Hot Spots rund um den Globus: Amsterdam, Sao Paulo, Barcelona, Santiago und Tel Aviv. DGTL bringt Musik, Technik und Kunst sowie neueste Errungenschaften aus den Bereichen Musikproduktion und Sound zusammen.</p>
//                                     <p>In Tel Aviv präsentiert sich das DGTL Festival in einer erweiterten Ausgabe mit einem gigantischen Line-Up von Künstlern – und mit einem großartigen Programm, das auf vier Bühnen gleichzeitig stattfindet.</p>
//                                     <p>Darüber hinaus ist DGTL nicht nur ein innovatives Musikfestival, sondern setzt sich intensiv für Umweltschutz und Nachhaltigkeit ein und wurde dafür als umweltfreundlichstes Festival Europas ausgezeichnet. Das Festival hat ein richtungsweisendes Programm zur Reduzierung des Stromverbrauchs, bietet ausschließlich vegetarisches Essen, verfügt über einen Recyclingplan und vieles mehr.</p>
//                                     <p>Veranstaltungsort des Festivals ist der wunderschöne Yarkon Park im Herzen Tel Avivs. Als Schauplatz von Innovationen, Trends und aufregendem Nachtleben ist die pulsierende Metropole der perfekte Gastgeber für das DGTL Festival.</p>
//                                     <p>Erleben Sie es am besten selbst und feiern Sie mit bei einem der weltweit außergewöhnlichsten Festivals – im Herzen der aufregendsten Stadt der Welt!</p>

// 	                            `
// 			}
// 		}
//     },

// ];

// End live shows

export const ShowsPostsData = [];
export const newPostdata = [
  {
    id: "eurovision",
    bgImage: "/posts/bank/eurovision/1.jpg",
    mobBgImage: "/posts/bank/eurovision/M/1.jpg",
    title: "EUROVISION TEL AVIV",
    ctg: "eurovision",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

                   	<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/thingsToDo/posts/eurovision/logo.png"} class="img-responsive" />
					</div>
					<h3>
						A ONCE IN A LIFETIME OPPORTUNITY TO VISIT TEL AVIV AS IT HOSTS THE EUROVISION SONG CONTEST
					</h3>
					<p>					
						Epic song contest in the Non-Stop City
					</p>
					<p>
						Semi-final 1: 14 May 2019
					</p>
					<p>
						Semi-final 2: 16 May 2019
					</p>
					<p>
						Grand Final: 18 May 2019
					</p>
					<p>
						It’s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city.
					</p>					
					<p>
						Tel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak. Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest.
					</p>            
                   	<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/thingsToDo/posts/eurovision/1.jpg"} class="img-responsive" />
					</div>
					<p>
						Major productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega “Euro Village” which will be situated merely a minutes’ walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest’s semifinal and final. The contest itself will take place in the Expo Tel Aviv.
					</p>
					<p>
						The Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all!
					</p>

            	`,
      };
    },
  },

  {
    id: "Get_ready_to_party",
    bgImage: "/posts/bank/Get_ready_to_party/1.jpg",
    mobBgImage: "/posts/bank/Get_ready_to_party/M/1.jpg",
    title: "The best Eurovision parties to be at",
    ctg: "eurovision",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

               <h3>
               	Your Total Guide to Tel Aviv Eurovision parties
               </h3>
               <p>
					From the Eurovision Village to the EXPO Centre, these are all the key places you need to know about for Eurovision 2019 in Tel Aviv…
				</p>
				<h3>
					CHARLES CLORE PARTY VENUE
				</h3>
				<h3>
					Charles Clore Park: home to the largest Eurovision Village to have ever been made.
				</h3>
				<p>
					Charles Clore Park is located on the sea-front in the south-west of Tel Aviv. It’s a beautiful green space overlooking Old Jaffa, one of the most ancient places in Tel Aviv. 
					During Eurovision week it will be home to the Eurovision Village, where free concerts from the biggest Eurovision stars will take place. Highlights include Dana International and Conchita Wurst, plus parties and screenings of the live Eurovision TV shows will take place outside, right in-front of the beautiful Mediterranean sea! 
				</p>
				<p>
					Also, some of Israel’s best chefs will be opening food stalls for the public to get first-hand experience of-mouth-watering Israeli and Middle-Eastern cuisine.
				</p>
				<p>
					Charles Clore is easy to get to: It’s a five minute walk from the Carmelit bus terminal, so any bus terminating there is a good choice. Then you can just walk towards the sea and you’ll see the village. If coming by foot, walk along the beach promenade. Or you can cycle or scoot along the sea front to get there. 
					It’s a big park and will be having a Eurovision makeover, so you won’t be able to miss it! In fact, this is the largest village to ever have been made for the Eurovision!
				</p>
				<h3>
					TEL AVIV PORT VENUE (“The Namal”)
				</h3>
				<h3>
					Home to 2019’s official Eurovision Euro Club
				</h3>
				<p>
					With its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!
				</p>
				<p>
					With its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!
				</p>
				<p>
					The club will feature theme parties, live performances, screenings of the Eurovision live shows and many more surprises to be revealed. Former Eurovision acts and winners, both Israeli and international, are set to perform there during the Eurovision week, so the venue will offer much more than just a traditional night-club. Entry to the Euroclub is free for accredited fans, journalists, delegations and artists. Members of the general public can get in to the Euroclub by purchasing a special weekly bracelet, here:
					<a href="https://www.eventer.co.il/euroclub?fbclid=IwAR37-d_19OE7bsq0rQ_gPHAW-sRfn1QAMi-cxp_ID2pFtDODBYzbf5NB6S0" target="_blank">https://www.eventer.co.il</a>
				</p>
				<h3>
					EUROVISION VENUE
				</h3>
				<h3>
					Expo Tel Aviv: home to the Eurovision Song Contest itself
				</h3>
				<p>
					The 2019 Eurovision Song Contest will be held at the Tel Aviv Expo center on the14th, 16th and 18th May. If you’ve got tickets, this is the place you’ll need to get to.
					It’s located on Rokach Boulevard in the north of the city, past HaYarkon Park and near to Tel Aviv University. To get there, use a journey planning app to find a bus route that will drop you right outside. Or, if travelling by train, get off at Tel Aviv University Train Station which is just a few minutes’ away from the convention centre.
				</p>
				<p>
					Don’t forget about the White Night, all the details are in the next article.
				</p>

         	`,
      };
    },
  },

  {
    id: "Tourist_info",
    bgImage: "/posts/bank/Tourist_info/1.jpg",
    mobBgImage: "/posts/bank/Tourist_info/M/1.jpg",
    title: "BESUCHER-INFORMATIONEN",
    ctg: "telaviv",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

					<h3>
                    Der Weg vom Flughafen nach Tel Aviv:
                  </h3>
                  <p>
                    Die günstigste Möglichkeit vom Flughafen Ben Gurion ins Zentrum von Tel Aviv, ist per Zug. Folgen Sie am Flughafen der gut sichtbaren Beschilderung zum angrenzenden Bahnhof und besteigen Sie einen der folgenden Züge: Tel Aviv-HaHagana (für Ziele im Süden der Stadt), Tel Aviv-HaShalom (um ins Zentrum zu fahren), Tel Aviv-Savidor Center (für den alten nördlichen Bereich) oder Tel Aviv-Universität (um direkt zum Eurovision Song Contest zu gelangen). Bitte beachten Sie, dass Tel Aviv HaShalom bis September 2019 freitags geschlossen ist. 
                    Ein Einzelfahrschein in eine Richtung kostet 13 Schekel 50, die Fahrt dauert etwa 25 Minuten. Um vom jeweiligen Bahnhof zu Ihrer Unterkunft zu kommen, empfiehlt es sich ein Taxi zu nehmen. Bitten Sie den Fahrer dabei stets das Taxameter ("monet") einzuschalten und halten Sie Bargeld zur Bezahlung des Fahrpreises bereit. Alternativ können Sie untenstehend mehr über diverse Taxi-Apps erfahren. Für weitere Informationen und die Planung Ihrer Reise lohnt es sich <a href="https://www.rail.co.il/en" target="_blank">https://www.rail.co.il/en</a> zu besuchen (in englischer Sprache).
                  </p>
                  <p>
                      Sie möchten mit dem Taxi vom Flughafen nach Tel Aviv fahren? In diesem Fall stellen Sie sich im Wartebereich für registrierte Taxis vor der Ankunftshalle an. Ein Mitarbeiter wird Sie nach Ihrem Fahrziel fragen, wieviel Mitreisende und wieviel Gepäck Sie haben und Ihnen ein entsprechendes Ticket aushändigen, das Sie Ihrem Fahrer geben. Sie können mit ihm entweder die Nutzung des Taxameters oder auch einen festen Fahrpreis vereinbaren. Fahrten kosten in der Regel 150-170 Schekel für einen Fahrgast.
                  </p>
                  <h3>
                    Der Weg von Tel Aviv nach Jerusalem:
                  </h3>            
                  <h3>
                    Bus
                  </h3> 
                  <p>
                    Fahren Sie zum Hauptbahnhof Tel Aviv Savidor und besteigen Sie den Bus Nr. 480. Die Fahrzeit nach Jerusalem beträgt ca. 45 Minuten. Die Buslinie endet am Jerusalemer Busbahnhof an der Jaffa Road. Von dort können Sie mit der Straßenbahn oder anderen Verkehrsmitteln an Ihr Ziel in der Stadt gelangen.
                  </p>
                  <h3>
                    Zug
                  </h3> 
                  <p>
                    Sie haben auch die Möglichkeit den ganz neuen Zug zu nehmen! Um direkt vom Flughafen Ben Gurion nach Jerusalem zu fahren, besteigen Sie den Zug zur Navon Station in Jerusalem. Die Fahrzeit beträgt ca. 25 Minuten. Von anderen Stationen in Tel Aviv, nehmen Sie einfach einen Zug zum Bahnhof Ben Gurion Airport und steigen dort um in eine Verbindung nach Navon.
                  </p>
                  <h3>
                    Innerhalb Tel Avivs
                  </h3> 
                  <p>
                    Die Stadtverwaltung von Tel Aviv bietet am Wochenende des Eurovision Song Contest kostenlose öffentliche Verkehrsmittel in der ganzen Stadt an. 
                    Kostenlose Busse fahren am Freitag und Samstag, dem 17. und 18. Mai. In der Regel fahren jedoch am Samstag keine öffentlichen Verkehrsmittel in Tel Aviv (mit Ausnahme von Taxis).
                    Während der anderen Tage der Eurovisions-Woche benötigen Sie eine Rav-Kav-Karte: Dabei handelt es sich um eine Smart Card, die mit einem Guthaben aufgeladen wird – und Ihnen erlaubt bargeldlos mit Bussen fahren zu können. Da Busfahrer keine Barzahlung mehr akzeptieren, ist es wichtig eine Rav-Kav-Karte zu erwerben, sobald Sie in Tel Aviv ankommen.
                    Um die Karte zu bekommen, steigen Sie in einen Bus an einer beliebigen Haltestelle und fragen Sie den Fahrer danach – sie kostet 5 Schekel (bitte halten Sie diesen Betrag in bar bereit). Steigen Sie aus dem Bus aus und führen Sie die Karte immer mit sich. Einige örtliche 7/11 Kioske bieten die Aufladung an, lassen Sie sich hier ein kleines Guthaben auf die Karte buchen. 50 Schekel sind meist ausreichend für einen einwöchigen Aufenthalt, da sie die Kosten für diverse lokale Fahrten decken (jede Fahrt kostet 5 Schekel 90).
                    Sie haben auch die Möglichkeit eine Rav-Kav-Karte im Rav-Kav-Büro in der Iban Gabirol Straße 35 zu kaufen (geöffnet Sonntag bis Donnerstag von 8:00 bis 20:00 Uhr, Freitag und an Feiertagen von 8:00 bis 13:00 Uhr). Darüber hinaus ist sie am Tel Aviv Savidor Bahnhof und im zentralen Bahnhof Carmelit erhältlich. Die Aufladung mit Guthaben kann an jedem Bahnhof erfolgen. 
                  </p>
                  <h3>
                    Fahrrad
                  </h3> 
                  <p>
                    Tel Aviv ist ein Fahrradfahrer-Paradies und bietet Radwege in der ganzen Stadt, einschließlich eines, der entlang der Strandpromenade von Jaffa im Süden bis in Tel Avivs Norden und noch weiter verläuft – und sich für eine wunderschöne Fahrradtour eignet, bei der Sie die Atmosphäre und Architektur von Tel Aviv genießen können. Wenn Sie einen eigenen Fahrradhelm besitzen, bringen Sie ihn gerne mit.
                  </p>
                  <h3>
                    Elektro-Roller
                  </h3> 
                  <p>
                    Roller sind voll im Trend in Tel Aviv – und bieten eine bequeme und coole Möglichkeit, die Stadt zu erkunden. Es gibt verschiedene Anbieter und alles was Sie tun müssen, ist die entsprechende App herunterzuladen, den Anweisungen zu folgen und loszurollern. Um besser Balance halten zu können, tauschen Sie Ihre Handtasche gegen einen Rucksack und denken Sie immer daran den Verkehr zu beachten und beim Scooten keine Musik zu hören. Wenn Sie einen Helm haben, empfiehlt es sich diesen beim Scooten zu tragen. 
                  </p>
                  <h3>
                    Laufen
                  </h3>
                  <p>
                    Laufen ist ebenfalls eine gute Möglichkeit die Stadt, die niemals schläft zu erkunden – und Sie werden sehen, wie Ihre Strecken Tag für Tag länger werden. Einen Stadtplan, einen Sonnenhut und eine Flasche Wasser – mehr braucht es nicht, damit es losgehen kann!
                  </p>
                  <h3>
                    Verkehrsmittel-Apps
                  </h3>
                  <p>
                    Es gibt diverse Verkehrsmittel-Apps, die Sie im Vorfeld herunterladen können, um Ihnen bei der Planung Ihrer Reise zu helfen. Wählen Sie aus jeder Kategorie ihren Favoriten: Es gibt Taxi-Apps, Fahrradverleih-Apps, Roller-Verleih-Apps und Fahrplan-Apps. Und natürlich können Sie auch den Concierge Ihres Hotels oder dem Vermieter Ihres Ferien-Appartements fragen, wie man in Tel Aviv am besten von A nach B kommt – sie helfen Ihnen gerne weiter!
                  </p>
                  <h3>
                    WIFI
                  </h3>
                  <p>
                    Tel Aviv verfügt über ein kostenloses WLAN-Netz in der gesamten Stadt. Suchen Sie auf Ihrem Smartphone nach dem ‚FreeTLV‘-Netz – es ist an über 80 Standorten verfügbar. Darüber hinaus haben die meisten Cafés und Bars kostenlose öffentliche WLAN-Netze, die Sie ebenfalls nutzen können: Fragen Sie beim Bestellen einfach nach dem Passwort. Und auch die Hotels bieten kostenloses WLAN – beim Check-in gibt man Ihnen gerne die entsprechenden Informationen.
                  </p>

         	`,
      };
    },
  },

  {
    id: "White_night",
    bgImage: "/posts/bank/White_night/1.jpg",
    mobBgImage: "/posts/bank/White_night/M/1.jpg",
    title: "White night",
    ctg: "eurovision",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

							<h1 class="align-center">
							  White Night Lights Up Tel Aviv on 16th May 
							</h1>
        					<div class="responisve-iframe">
								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
							</div>

							<p>What do you get when you cross a Eurovision Semi-Final with an all-night party in a city that is famous for its 24/7 party energy? The answer is White Night, which will hit Tel Aviv this year on Thursday 16th May, just two days before the 2019 Eurovision Song Contest grand final.</p>
                            <p>Featuring pop-up art installations, live music, dance parties, cultural events, food and drink, all fused together with Tel Aviv’s eclectic atmosphere, White Night is one of the biggest cultural events of the year. </p>
                            <p>And for 2019, it’s taking place a month earlier than usual, so that visitors coming for the Eurovision Song Contest can also experience this magical experience in the White City of Tel Aviv.</p>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/1.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo By: Adam Primer
							</small>

							<p>From sunset until sunrise, the city will be wide-awake with cultural activities. Locals and visitors alike are invited to explore the city and soak up all the activities on offer. Many bars, restaurants and shops will be offering experiences free of charge or at reduced rates, so it’s definitely worth stocking up on sleep so you’re ready to party all night long!</p>
                            <p>And at the Eurovision Village in Charles Clore Park, there’ll be an extra sparkle of Eurovision magic, as several icons of the competition take to the stage to entertain visitors during the night. </p>
                            <p>Last year’s runner-up, Eleni Foureira, who narrowly missed out to Tel Aviv’s own Neta Barzilai with her smash-hit song “Fuego”, will be performing, as will 2014 winner, Conchita Wurst from Austria, who will most likely perform his iconic winning song, “Rise Like a Phoenix” while showcasing his new-look for 2019!</p>
                            <p>They’ll be joined by three more Queens of Eurovision, in the form of 1970s pop icon Anne-Marie David, who won for Luxembourg in 1973, Swedish pop star Carola Häggkvist, who won the contest in 1991, and Loreen, who also won for Sweden in 2012 with her song Euphoria. The performances will take place on the coast, overlooking the Mediterranean; the live semi-final will also be shown on big-screens in the Eurovision Village, off-set by jaw-dropping light compositions, created by the competition’s official lighting partner OSRAM.</p>
                            <p>All in all, White Night is a night not to be missed. So make the 15th May your duvet day and get-set to party all night long on Thursday 16th May 2019. Tel Aviv is ready and waiting to celebrate with you!</p>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/2.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo By: Kfir Sivan
							</small>
							
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/3.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo by Moshik Lindenbaum
							</small>
							
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/4.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo by: Guy Yechiely‎.
							</small>

         	`,
      };
    },
  },

  // //No translation
  // {
  // 	id:13,
  //         bgImage : "/posts/bank/25/1.jpg",
  //         mobBgImage : "/posts/bank/25/M.jpg",
  //         vidId : "k4OwoEk5wMw",
  //        	ctg : "jerusalem",
  //        	isVid:true,
  //         title : "Jerusalem’s Calling",
  //         smltitle : "The most magical and radiant city on Earth ",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 					<p>
  // 						What else can you say about the world’s most unique city? Simply put: Welcome to Jerusalem – where a glorious history is intertwined with modern and dynamic life.
  // 					</p>

  // 					<p>
  // 						Jerusalem is home to innumerable fascinating historic sites, magical walkways, breathtaking views at sunset, a wide variety of entertainment options, restaurants that offer culinary excitement, spirited nightlife and a tremendous offering of centers for the arts and culture.
  // 					</p>

  // 					<h3>
  // 					   The Old City
  // 					</h3>
  // 					<p>
  // 						No other place offers as many attractions and emotionally inspiring sites in a single square kilometer. The Old City of Jerusalem brims with opportunities for you to connect with the city’s resplendent past, history, culture and spirituality. In the Old City, you’ll find archaeological treasures that are thousands of years old, contemporary art and bustling markets where you can purchase delectable delights.
  // 					</p>

  // 					<h3>
  // 					  The Western Wall:
  // 					</h3>
  // 					<p>
  // 						Believed to be the only remaining segment of the Second Temple, the Western Wall has become truly synonymous with Jerusalem. Thousands of years old, it is the most important Jewish prayer site in the world, where thirteen-year-old boys come to celebrate their bar mitzvahs, and where millions of visitors and tourists from around the world place notes with requests and prayers into its cracks.
  // 					</p>
  // 					<h3>
  // 					  Western Wall Tunnels:
  // 					</h3>
  // 					<p>
  // 						Visiting the tunnels is like entering a time machine. Located beneath the Western Wall and the Muslim Quarter, provides visitors with a glimpse of the various periods in the history of Jerusalem.
  // 					</p>
  // 					<h3>
  // 					   City of David:
  // 					</h3>
  // 					<p>
  // 						Located next to the Dung Gate, this site presents the story of Jerusalem during the reigns of King David, King Solomon and King Hezekiah. Many archeological treasures were unearthed in the excavation, including a two-thousand year-old gold earring.
  // 					</p>
  // 					<p>
  // 					   A visit to the site will enable you to take a flashlight and wade through the flowing water of the Siloam Tunnel, which was built during the reign of King Hezekiah.
  // 					</p>

  // 					<h3>
  // 					 Via Dolorosa
  // 					</h3>
  // 					<p>
  // 						Christian faithful follow in the footsteps of Jesus down the Via Dolorosa and the 14 Stations of the Cross, reenacting the fateful path that had an unprecedented impact on the course of history.
  // 					</p>

  // 					<h3>
  // 					  Church of the Holy Sepulchre:
  // 					</h3>
  // 					<p>
  // 						According to Christian tradition, the Church is the site where Jesus was crucified, buried and where he resurrected from the dead. It has long been and continues to be a major pilgrimage center for Christians world over.
  // 					</p>

  // 					<h3>
  // 					 The market in the Old City:
  // 					</h3>
  // 					<p>
  // 						This must-see attraction is made up of a series of alleyways, with numerous stalls offering a staggering variety of souvenirs, clothing, foods (baked goods, spices, sweets, tehini and more); stands hawking juices of all kinds, Armenian ceramics, drums and other musical instruments, earthenware jugs and much more. The colorful market delivers an authentic and extremely enjoyable experience that simply cannot be missed.
  // 					</p>

  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/posts/4/2.jpg"} class="img-responsive" />
  // 					</div>

  // 					<h3>
  // 						Attractions
  // 					</h3>

  // 					<h3>
  // 						Segway tours:
  // 					</h3>
  // 					<p>
  // 						This adrenaline-packed method of seeing the city will allow you to take in the beauty of Jerusalem from an entirely different perspective. The Segway tours leave from various central spots, including the Armon HaNatziv Promenade (East Talpiot), Yemin Moshe, and the Old City, as well as near the Knesset and the museum area.
  // 					</p>

  // 					<h3>
  //                         First Station (Hatachana):
  // 					</h3>

  // 					<p>
  // 					   If you like amusement park rides, you love having your senses scintillated by the Time Elevator. It’s an interactive experience that takes visitors on fabulous voyages to fascinating places, with motion-based seating in a unique hall that is filled with special effects.
  // 					</p>

  // 					<h3>
  //                         Time Elevator:
  // 					</h3>

  // 					<p>
  // 					   The First Station is right in the heart of Jerusalem, between the Old City and the city center, and between the historical neighborhoods of the German Colony and Yemin Moshe. It is the site of the first train station in Jerusalem, which was built in 1892. After undergoing renovation and preservation, the First Station was reopened as a lively entertainment spot.
  // 					</p>

  // 					<h3>
  // 					   Machane Yehuda Market:
  // 					</h3>

  // 					<p>
  // 					   To experience the city as authentically as possible, your itinerary must include a stop at Machane Yehuda Market. It represents Jerusalem of the present and the future. Machane Yehuda uniquely brings together old and new, with its fruit and vegetable market, along with an excellent food and a vibrant entertainment area.
  // 					</p>

  // 					<h3>
  // 					   Museums
  // 					</h3>

  // 					<p>
  // 					   In a city filled with a large number of museums, you have every opportunity to experience and learn about the events of the past and to visit modern and contemporary exhibits.
  // 					</p>

  // 					<h3>
  // 					   Israel Museum
  // 					</h3>

  // 					<p>
  // 					   The Israel Museum is the largest cultural institution in the country. It has many wings and very large collections of art, archeology and Judaica. One of the highlights of any visit to the museum is the Shrine of the Book, with its unique design that has come to be closely associated with the city itself.
  // 					</p>

  // 					<h3>
  // 					   Tower of David Museum:
  // 					</h3>

  // 					<p>
  // 					  Thousands of years ago, Jerusalem was a small city, where kings and prophets walked or rode their horses down the alleys. Since that time, one of the best-known symbols of the city is David’s Tower, with its turret standing proudly above the ancient fortress that has also become one of the city’s important museums.
  // 					</p>

  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/posts/4/3.jpg"} class="img-responsive" />
  // 					</div>

  // 					<h3>
  // 					   Restaurants
  // 					</h3>

  // 					<p>
  // 					  Jerusalem boasts many restaurants, where you can dine on a wide array of delicacies –local and international, standard and exotic. And if you are looking for the gourmet experience, you can reserve a spot at exclusive chef restaurants. The following are five of Jerusalem’s finest and most popular spots, which attract crowds all day long:
  // 					</p>

  // 					<h3>
  // 					   Café Kadosh
  // 					</h3>

  // 					<p>
  // 					 Highly popular, the café serves kosher dairy cuisine – all made in house, and all delicious!
  // 					</p>

  // 					<h3>
  // 					   Tmol Shilshom
  // 					</h3>

  // 					<p>
  // 					  A dairy bookstore café in the city center, favored for its warmth, delicious food and friendly service. Don’t miss the shakshuka or salmon fillet in fig sauce!
  // 					</p>

  // 					<h3>
  // 					   The Eucalyptus
  // 					</h3>

  // 					<p>
  // 					  The kosher restaurant, located in the Artist’s Quarter, serves Chef Moshe Basson’s interpretation of biblical cuisine. Every dish has its origins in biblical scenes and all the spices and herbs used grow, as in ancient times, in the surrounding hills of Jerusalem and Judea. An unforgettable experience.					</p>

  // 					<h3>
  // 					   Darna
  // 					</h3>

  // 					<p>
  // 					  An authentic, glatt kosher, Moroccan restaurant, located in the heart of the city. Experience the warm welcome and the true meaning of Moroccan hospitality, while enjoying the culinary excellence of the Maghreb.
  // 					</p>

  // 					<h3>
  // 					   Ima Restaurant
  // 					</h3>

  // 					<p>
  // 					  Right down the street from Machane Yehuda market, Ima offers excellent kosher Middle Eastern food, served in a relaxed family atmosphere
  // 					</p>

  // 					<h3>
  // 					   And no visit to Jerusalem is complete without scooping up some hummus with a pita right out of the oven. The following are a few centrally located hummus spots:
  // 					</h3>

  // 					<div class="cradit">
  // 							<p>
  // 							<strong>Azura,</strong><small> in the Iraqi section of the Mahane Yehuda Market </small><br>
  // 							<strong>Lina,</strong><small> in the Christian Quarter of the Old City</small><br>
  // 							<strong>Hummus Acramawi,</strong><small>  in the Muslim Quarter of the Old City </small><br>
  // 							<strong>Hummus</strong><small> Ben Sira, in the city center next to the Mamilla Hotel</small><br>
  // 							<strong>Abu Shukri,</strong><small> in the Muslim Quarter in the Old City of Jerusalem </small><br>
  // 							</p>
  // 				    </div>

  // 				    <h3>
  // 				        Nightlife
  // 				    </h3>

  // 				    <p>
  // 				         Jerusalem is filled with scores of restaurants and entertainment spots that are also open on Friday nights (the Jewish Sabbath). All of Jerusalem’s entertainment areas have excellent options for weekend fun on Friday nights as well as Saturdays, and you can most definitely enjoy a delightful evening over a cold beer or dance to great music.
  //                          Below is a small selection of bars and clubs that are hopping on Friday nights and will leave you wanting more…
  // 				    </p>

  // 				    <h3>
  // 				       Mantra
  // 				    </h3>

  // 				    <p>
  // 				       An intimate restaurant and wine bar, where a friendly atmosphere meets superb cuisine.
  // 				    </p>

  // 				    <h3>
  // 				       Gatsby Cocktail Room
  // 				    </h3>

  // 				    <p>
  // 				       The cocktail lounge and bar evokes the magic of the Roaring 20’s and the days of cabarets.
  // 				    </p>

  // 				    <h3>
  // 				        HaTaklit
  // 				    </h3>

  // 				    <p>
  // 				       With a name means “the record” in Hebrew, the trendy bar is decorated with record sleeves. Enjoy full bar, live music, DJs and even independent performers.
  // 				    </p>

  // 				    <h3>
  // 				       Toy Bar (HaTza’atzua)
  // 				    </h3>

  // 				    <p>
  // 				      Centrally located, Toy Bar offers great drinks, great music by some of the best local DJs and great dance bar experience.
  // 				    </p>

  // 				    <h3>
  //                         Sira
  // 				    </h3>

  // 				    <p>
  //                        One of the city’s most eclectic underground clubs, with an arcade room and dance floor. The pub also hosts events and performances.
  // 				    </p>

  // 				    <h3>
  //                         Even / Juke
  // 				    </h3>

  // 				    <p>
  // 				       A music club that showcases the most creative bands in Israel, with an emphasis on jazz, blues and funk.
  // 				    </p>

  // 				    <h3>
  //                        Video Pub
  // 				    </h3>

  // 				    <p>
  // 				       Jerusalem’s only “official” gay bar is home to some of the wildest parties in the city.
  // 				    </p>

  // 				    <p>
  // 				       Jerusalem is the ultimate vacation destination! With so much to see and do, so much to stimulate your senses and pique your curiosity, your trip to Jerusalem promises us an unforgettable experience. Book your vacation now!
  // 				    </p>

  // 				    <div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/posts/4/4.jpg"} class="img-responsive" />
  // 					</div>

  // 					<h3>Box:</h3>
  // 					<h3>
  // 					   Annual events
  // 					</h3>

  // 					<p>
  // 					   Jerusalem plays host to a variety of unique annual events. Check the Internet for dates and further information.
  // 					</p>

  // 					<h3>
  // 					   Festival of Light
  // 					</h3>

  // 					<p>
  // 					   Held in the Old City – May 25, 2016 to June 2, 2016. Come and be part of the enchanting games of light and color, with dozens of displays by Israeli and international artists. Follow the paths set up throughout the Old City, guiding visitors from one mesmerizing work to another.
  // 					</p>

  // 					<h3>
  // 					   International Arts and Crafts Fair (Khutsot Hayotser):
  // 					</h3>

  // 					<p>
  // 					  August 15, 2016 – August 29, 2016. Held against the backdrop of the Old City walls, visitors enjoy a very special nighttime atmosphere and happening with musical performances. Walk through the gardens and stop at the various stands, where artists from Israel and the world exhibit paintings, prints, ceramics, metalwork and jewelry, weaving and textiles, Judaica, toys, crafts in various techniques, woodwork and more.
  // 					</p>

  // 					<h3>
  // 					   The Israel Festival
  // 					</h3>

  // 					<p>
  // 					   May 24, 2016 – June 11, 2016. The festival is Israel’s premiere multi-disciplinary international festival. It takes place annually in the spring, presenting outstanding theater performances, contemporary dance, classical music and performances from around the world, along with ground breaking Israeli works. Numerous festival events are held at unique Jerusalem locations that have historic significance of hundreds, if not thousands, of years. There are also many street performances that are open to the public.
  // 					</p>

  // 					<h3>
  // 					  Jerusalem Film Festival
  // 					</h3>

  // 					<p>
  // 					   July 7, 2016 – July 17, 2016. The festival sprinkles star dust across the city, with quality cinema, actors and writers that are guests. Many famous stars have come to the festival of the years. Over 200 Israeli and foreign films will be screened during the festival, highlighting various genres and competing for prizes. The festival offers opportunities for meetings with artists, workshops, parties and musical events.
  // 					</p>

  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/posts/4/5.jpg"} class="img-responsive" />
  // 					</div>

  //          `
  //     }
  //   }
  // },

  {
    id: 20,
    bgImage: "/posts/bank/40/1.jpg",
    mobBgImage: "/posts/bank/40/M.jpg",
    player_id_post: "20",
    title: "Tel Aviv Abenteuer",
    ctg: "telaviv",
    vidId: "88OV6xU0vPI",
    isVid: true,
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h2>Actionreiche Stadt - perfekt für aktive Menschen.</h2>
               
			<p>
								Menschen in Tel Aviv leben das Leben in vollen Zügen - und sie tun es draußen. Diese Stadt ist randvoll mit Outdoor-Aktivitäten und Sie können daher sehr wählerisch sein. Es ist eine actionreiche Stadt - perfekt für aktive Menschen
          </p>
          <h3>
                Hayarkon Park
          </h3>
          <p>
								Der Hayarkon Park, der als "Central Park" von Tel Aviv bekannt ist, wird jährlich von etwa sechzehn Millionen Menschen besucht. Die Attraktionen reichen von Picknicks auf den riesigen Rasenflächen über Tretbootfahren auf dem wunderschönen künstlichen See bis hin zu Radwegen und Touren durch die vielen wunderschönen Gärten, die die Natur im Herzen der Stadt darstellen.
          </p>
          <h3>
                Die Fahrradszene
          </h3>
          <p>
								Eine der ultimativen Möglichkeiten, Tel Aviv zu entdecken, ist durch seine 100 km langen Radwege, wo Sie das öffentliche Tel-O-Fun Fahrradverleihsystem nutzen können, welches ermöglicht, dass die Bewohner und auch Besucher die grünen Fahrräder beliebig an den 150 Stationen der Stadt abholen und abstellen können.  Wenn Sie es genießen, Ihre Zeit auf Rädern zu verbringen, sollten Sie auch die vielen Eislaufparks besuchen, wo Sie den lokalen Draufgängern bei der Sache zusehen können, oder Sie können sich Ihr eigenes Skateboard oder Rollerblades holen und an der Aktion teilnehmen.
          </p>

         `,
      };
    },
  },

  {
    id: 14,
    bgImage: "/posts/videos/deadsea/1/1.jpg",
    mobBgImage: "/posts/videos/deadsea/1/M.jpg",
    title: "DAS TOTE MEER",
    vidId: "ixFocykfYHo",
    ctg: "deadsea",
    isVid: true,
    smlTitle: "",
    html: function() {
      return {
        __html: `
			                            <h2>Höchster Genuss am  tiefstgelegenen Ort der Erde</h2>

			                            <p>
					                         Ein geologisches Wunder in einer einzigartig ruhigen Umgebung – das Tote Meer ist eine sehr beliebte Touristenattraktion. Erleben Sie die Ruhe des Wassers mit seinen einzigartigen heilenden Eigenschaften und genießen Sie die unvergleichliche Schönheit der umliegenden Landschaft. <strong>Das Tote Meer, auch bekannt als das älteste natürliche Heilbad der Welt, ist mit einer extrem hohen Salzkonzentration von 31,5% gesegnet, was Touristen von nah und fern das erstaunliche Erlebnis ermöglicht, mühelos auf den Gewässern des niedrigsten Ortes der Erde zu schweben. Während Sie hier sind, können Sie auch im gesunden schwarzen Schlamm der Gegend baden</strong> oder die faszinierende und historisch reiche Landschaft in der Umgebung erkunden.
					                  </p>

					                  <p>
					                          Luxuriöse Hotels, eine abwechslungsreiche Küche von Gourmet-Restaurants bis hin zu Fastfood-Restaurants, großartige Souvenirläden, die außergewöhnliche Geschichte der nahegelegenen Festung Masada und viele kulturelle Aktivitäten während des ganzen Jahres machen das Tote Meer zu einem beliebten Ziel für Touristen und internationale Besucher.
					                  </p>
			`,
      };
    },
  },

  {
    id: 3,
    bgImage: "/posts/bank/23/1.jpg",
    mobBgImage: "/posts/bank/23/M.jpg",
    vidId: "iHqD5eHDZm8",
    player_id_post: "3",
    title: "DIE HÄFEN VON TEL AVIV",
    isVid: true,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<p>Hafen Tel Aviv oder der Hafen von Jaffa. Zwei faszinierende Hafenviertel mit jeweils eigenem Charakter und Charme.</p>
					<p>
          Zwei faszinierende Hafenviertel mit jeweils eigenem Charakter und Charme.
          </p>

          <h3>
            Zwei faszinierende Hafenviertel mit jeweils eigenem Charakter und Charme.
          </h3>
          <p>
            Die bescheidenen Wurzeln der modernen Stadt Tel Aviv liegen im Hafen von Jaffa, in dem Immigranten, Armeen und Händler von ihren Schiffen an Land kamen. Der Hafen gehört zu den ältesten seiner Art weltweit und wird immer noch von den lokalen Fischern genutzt, während sich sein historisches Umfeld zu einem beliebten Tourismusziel entwickelt hat.
          </p>
          <div class="img-wrapper">
            <img src=${getImgUrl() + "/posts/3/1.jpg"} class="img-responsive" />
          </div>

          <p>
          In die Lagerhallen am Kai sind Galerien und Kulturzentren eingezogen, z. B. das von Gehör- und Sehbehinderten betriebene Nalaga‘at Zentrum und die Galerie Dvir. Zu den Kaianlagen winden sich gepflasterte Straßen und Gassen zwischen den gemauerten Gebäuden, die das alte Jerusalem lebendig werden lassen. Zwischen den historischen Gebäuden finden sich zahlreiche Galerien, Spezialitätengeschäfte und hervorragende Restaurants. In den höher gelegenen Teilen des alten Hafenbezirks erwarten Sie die Kirche des Sankt Peter, die Wunschbrücke, das Old-Jaffa-Museum und das Ilana-Goor-Museum.
          </p>
          <div class="img-wrapper">
            <img src=${getImgUrl() + "/posts/3/2.jpg"} class="img-responsive" />
            <div class="cradit">
								<small>Dana Friedlander</small>
					    </div>
          </div>
          <h3>
            Hafen Tel Aviv
          </h3>
          <p>
            Im Gegensatz zum Hafen von Jaffa herrscht im Hafen Tel Aviv ein modernes Geschäftsklima. Der Hafen war von 1938 bis 1965 in Betrieb und wurde im Rahmen der darauf folgenden Sanierung in ein Einkaufs- und Freizeitviertel umgewandelt. Direkt am Wasser stehen umgebaute Lagerhäuser an einer großzügigen Küstenpromenade. Sehr beliebt bei Familien ist ein Besuch im Dyada-Center für Kinder. Andere suchen die Zentren für Yoga, Frauen, Konferenzen oder das Cavim Institut für Design und Architektur. Auf der Promenade herrscht immer lebhaftes Treiben mit Straßenkünstlern, Musikern und Marktständen. Der Hafen ist ein modernes und dynamisches Viertel für kreative und kulturelle Aktivitäten. Nach Sonnenuntergang wird der Hafen Tel Aviv mit seinen Bars und Clubs zu einem beliebten Ziel für Nachtschwärmer.
          </p>
          <div class="img-wrapper">
            <img src=${getImgUrl() + "/posts/3/3.jpg"} class="img-responsive" />
            <div class="cradit">
                <small>Dana Friedlander</small>
              </div>
          </div>


         `,
      };
    },
  },

  {
    id: 4,
    bgImage: "posts/bank/17/1.jpg",
    mobBgImage: "posts/bank/17/M.jpg",
    title: "TEL AVIV AM STRAND",
    vidId: "XDei1Zy_cu4",
    isVid: true,
    ctg: "telaviv",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			
			        <h3>
						Tel Aviv Strände\n
						National Geographic Magazine "Eine der 10 besten Strandstädte der Welt"
					</h3>
					<p>Weil sich das Leben in Tel Aviv von der Sonnenseite zeigt  Bereit für eine volle Ladung Spaß in der Sonne?</p>
					<p>
						Mit klarem Wasser und actionreichen Stränden hat jeder der 16 Strände von Tel Aviv seinen eigenen Stil und zieht bestimmte Persönlichkeiten an - von Hippie-Casual bis Riviera Chic. Ob Tag oder Nacht, am Strand zu hängen ist eine der besten Möglichkeiten, Zeit in Tel Aviv zu verbringen.
					</p>

			`,
      };
    },
  },

  {
    id: 7,
    bgImage: "posts/bank/36/1.jpg",
    mobBgImage: "posts/bank/36/M.jpg",
    title: "Sarona Tel Aviv",
    isVid: true,
    ctg: "telaviv",
    // vidId: "AcjsyamDZL8",
    vidId: "MJ-gsGs1tqA",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<p>
				Eine atemberaubende urbane Oase Eine riesige Auswahl von Attraktionen in der überwältigenden sanierten Templerkolonie
			</p>
			`,
      };
    },
  },

  {
    id: 8,
    bgImage: "posts/bank/4/1.jpg",
    mobBgImage: "posts/bank/4/M.jpg",
    title: "Neve Tzedek",
    // vidId: "bHQwLO6cefs",
    vidId: "5jl13Z-38eE",
    smlTitle: "",
    isVid: true,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `

                      	<h2>Schick und einzigartig. Liebenswerte Cafés, Boutiquen, Kunstgalerien, Eleganz und coole Vibes</h2>
					<p>
						Machen Sie eine Pause von der Hektik von Tel Aviv; dieses versteckte Juwel eines Viertels besticht durch seinen wunderschönen orientalischen Architekturstil und die charmanten engen Gassen, die Neve Tzedek zu einer wahren Oase im Herzen der geschäftigen Stadt machen.
					</p>
              
			`,
      };
    },
  },

  {
    id: 9,
    bgImage: "posts/bank/5/1.jpg",
    mobBgImage: "posts/bank/5/M.jpg",
    title: "Modern und lebendig",
    isVid: true,
    ctg: "jerusalem",
    // vidId: "MXtcTm_JXus",
    vidId: "V0Acsw3Hf_M",
    smlTitle: "",
    html: function() {
      return {
        __html: `
            <h2>Es gibt so viel zu sehen in Jerusalems pulsierendem Stadtzentrum</h2>
			<p>
							Die Innenstadt von Jerusalem ist das Herz der modernen Metropole, voller Nachtleben, Restaurants und kulturellen Möglichkeiten, die es mit jeder größeren Stadt der Welt aufnehmen können.
          </p>
          <p>
							Die Gegend besteht aus mehreren Stadtvierteln und den angesagtesten Orten, wie dem charmanten Nachlat Shiva, der belebte Yafo Straße und der Ben Yehuda Straße mit ihrer einzigartigen Persönlichkeit und Atmosphäre, die man nicht verpassen sollte.
          </p>
          <p>
							Das Zentrum von Jerusalem umfasst einige der charmantesten Viertel der Stadt und faszinierende Sehenswürdigkeiten. Für eine unschlagbare kulturelle Erfahrung, sehen Sie sich Jerusalems faszinierende Museen an, darunter das weltberühmte Israel Museum, das Bible-Land-Museum und  Wissenschafts Museum.
          </p>
          <h3>
							Machane Yehuda Market
          </h3>
          <p>
							Entdecken Sie die unvergleichliche Atmosphäre und Vielfalt dieses Marktes, die jeden Tag Tausende von Touristen anzieht. Sobald die Einkäufe erledigt sind und die Verkäufer die Läden zumachen, treffen sich den jungen trendigen Menschen, sowohl aus dem Ausland als auch aus der Region, die auf den Markt kommen, um bis in die frühen Morgenstunden in den Bars, Restaurants und Gassen zu trinken und zu feiern.
          </p>
          <h3>
							Nahalat Shiv’a
          </h3>
          <p>
							Dieses charmante gepflasterte Viertel im Herzen der Stadt bietet eine exzellente Auswahl an Geschäften, Restaurants, Bars und Straßencafés an. Nahalat Shiva ist die Heimat von Kikar Hamusica (Musikplatz)- ein lebhafter und trendiger Platz im Freien, wo jeden Tag während der Woche Live-Musik spielt.
          </p>
          <h3>
							Yemin Moshe
          </h3>
          <p>
							Dieses schöne Viertel mit Blick auf die alten Stadtmauern wurde ursprünglich im 19. Jahrhundert erbaut, um dem Problem der Überfüllung entgegenzuwirken. Yemin Moshe, Heimat von Künstlern, Schriftstellern und Akademikern, ist bekannt für seine schönen Windmühlen und Häuser im orientalischen Stil, grüne Parks, lebhaftes Musikzentrum und atemberaubende Ausblicke.
          </p>
          <h3>
							Ein Kerem
          </h3>
          <p>
							In einem friedlichen Tal zwischen den Bergen und den terrassierten Hügeln südwestlich von Jerusalem gelegen, ist Ein Kerem eines der malerischsten Viertel von Jerusalem. Mit ihren verwinkelten, gepflasterten Gassen, ihren charmanten Steinhäusern, die mit Bögen geschmückt sind, Kirchen, deren Glocken in der klaren Luft läuten, strahlt Ein Kerem Charme und Schönheit aus, wie eine Insel in einem Meer aus grünem Wald.
          </p>  

			`,
      };
    },
  },

  {
    id: 12,
    bgImage: "posts/bank/10/1.jpg",
    mobBgImage: "posts/bank/10/M.jpg",
    title: "Der Markt In Jerusalem",
    vidId: "2CSCe2WC7Ns",
    isVid: true,
    ctg: "culinary",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                    <h2>Donnerstag Nacht auf dem Mahane Yehuda Markt</h2>
					<p>
                          Scharen von Einheimischen und Touristen zieht es tagsüber hierher, um Zeuge der authentischen Atmosphäre des Marktes zu werden, ihn von innen kennenzulernen und natürlich auch um einzukaufen. Und sobald die Verkäufer ihre Stände schließen, kommen die Nachtschwärmer zum Markt – ausländische und einheimische gleichermaßen –um in den Bars, Restaurants und Gassen Spaß zu haben.
                          <br/>
                          Der Shuk ist unter Woche praktisch immer geöffnet, aber wenn Sie eine wirklich elektrisierende Nacht erleben möchten, dann ist Donnerstagabend das Richtige für Sie. Für die Einheimischen ist dies die einzige Nacht an der man richtig ausgehen kann ohne sich Gedanken machen zu müssen am nächsten Morgen aufzustehen und zur Arbeit zu gehen. Und das zeigt sich darin, dass die Bars und Restaurants bis spät in die Nacht geöffnet sind, Partys veranstalten, die sich bis auf die Straße erstrecken und besondere Events organisieren.


                          <br/>
                          Mein „Date“ und ich kamen um 19:20 Uhr an, als viele der Stände noch offen waren und die Gassen mit Kunden, die für das Wochenende noch nach guten Angeboten suchten, überfüllt waren. Doch als die Verkäufer dichtmachten, verschwanden die Kunden schnell und machten Platz für das Partyvolk.
                          <br/>
                          Obwohl es scheint als wäre es erst gestern gewesen, dass der Shuk noch ein Ort war, an dem man einkaufen ging und sich vielleicht noch einen Bissen von einem der lokalenImbisse geholt hat, ist die Anzahl an hippen Bars und Restaurants in den letzten fünf Jahren explodiert. Mittlerweile kann man kaum noch mit den ständig neuen geheimen Hot-Spots, die in irgendeiner, nur den Einheimischen bekannten, Ecke versteckt sind, mithalten.
                           <br/>
                          „Wenn Sie an einem Donnerstagabend die Massen von Partywütigen sehen, kann man leicht vergessen, dass noch vor ein paar Jahren nachts keine Menschenseele zu finden war,“ sagt der örtliche Touristenführer Joel Haber. „Aber die Wahrheit ist, dass dies nicht nur der nächste logische Schritt ist, für die sich ständig entwickelnde Geschichte des Mahane Yehuda Markt ist, sondern auch der dynamischste und neueste Beitrag zum Nachtleben der Stadt. Der Shuk war immer ein Schmelztiegel, in dem sich alle Jerusalemer getroffen haben. Nun finden sich junge und alte, säkulare und religiöse Menschen zusammen um nebeneinander ein Bier zu trinken und die spezielle Atmosphäre zu genießen.”
                           <br/>
                           Hier finden Sie einige der Lokale die mehr oder weniger Star-Status erreicht haben und immer eine gute Zeit versprechen.
                      </p>
                      <h3>
                         Gediegen essen und tanzen
                      </h3>

                      <div class="img-wrapper">
                           <img src=${getImgUrl() +
                             "/posts/7/1.jpg"} class="img-responsive" />
                      </div>

                        <h3>
                            Das CASINO DE PARIS
                        </h3>

                        <p>
                            Versteckt in den Tiefen des georgischen Shuks zwischen den bedeckten und unbedeckten Marktstraßen, liegt das Casino de Paris, das eine bunte Geschichte aufweisen kann. Das Gebäude, in dem es liegt, hat einst als Kasino, Hotel, britischer Offiziersclub und Bordell gedient, doch jetzt ist es einfach einer der nobleren Locations im Shuk. Hier finden sich hauptsächlich berufstätige Leute um die 30 bis 40, aber an Donnerstagabenden ist die Stimmung hier dennoch ausgelassen und jung. Die Bar bleibt bis 2 oder 3 Uhr früh geöffnet und serviert gut zubereitete, originelle Haus-Cocktails inspiriert vom Shuk, Bier und ein paar anständige Weine.
                        </p>

                        <h3>
                            Das CINCO DE MAYO
                        </h3>
                        <p>
                            Wenn Sie nach einer anständigen Party-Atmosphäre suchen, dann ist das Cinco De Mayo ganz sicher eine gute Adresse. Es bietet regelmäßig eine Bühne für DJs, die eine Bandbreite von verschiedenen Musikstilen spielen und Sie werden hier immer Gäste finden die bis um 2.00 Uhr früh trinken, essen und vielleicht sogar tanzen. Die Nachtschwärmer beginnen ab 22.30 Uhr das Lokal zu füllen, seien Sie also nicht überrascht, wenn Sie Schwierigkeiten haben einen Sitzplatz zu finden. Aber man kann es immer wie die Einheimischen machen und ein Getränk (von der Innenbar) draußen in den Gassen genießen.
                            <br/>
                            Trotz des Namens, hat Cinco de Mayo eigentlich nichts mit Mexiko oder dem 5. Mai zu tun. Die Gruppe von Freunden, die die Bar ins Leben gerufen haben, wählten den Namen als Erinnerung an ihre Zeit in einer Kommune außerhalb von Jerusalem, wo niemand am 5. Mai arbeitete.
                        </p>

                        <h3>
                            Die SHUKA BAR
                        </h3>
                        <p>
                            Trotz ihrer Lage abseits der Hauptstraße und relativ kleinem Format, ist die Shuka Bar an der Egozstraße einer der beliebtesten Orte auf dem Shuk. Es ist eine eher bodenständige Bar, die nur israelische Biere, Spirituosen und kleine Snacks anbietet, doch am Donnerstagabend verwandelt sich die Shuk Bar von einer einfachen Bar zu einer Riesenparty.
                        </p>

                       <div class="img-wrapper">
                           <img src=${getImgUrl() +
                             "/posts/7/2.jpg"} class="img-responsive" />
                       </div>



                        <h3>
                           Das QUE PASA
                        </h3>
                        <p>
                            Gleich nebenan liegt das Que Pasa. Dieses Lokal ist der ehrenhafte Versuch von Besitzer Yaniv Kovenshtein die vielgeliebte Tapas-Kultur Spaniens nach Jerusalem zu bringen. <br/>

                            Mitinhaber und Küchenchef Avi Betito Golansky bringt diese Vision mit einem Menü voller Tapasgerichte aus Fisch und Milchprodukten, inklusive des Bruschetta Cuca (Sardinen, Zwiebeln, Paprika Olivenöl auf köstlich knusprigem Brot) und Porcini Bruschetta (in Butter sautierte Steinpilze mit Knoblauch, Mandelöl und Petersilie), feine Artischockenscheiben mit Trüffeln, filetierte Sardinen mit Saint Moore Käse gefüllt und in Salbeibutter gebraten auf einem üppigen Tomatensalat serviert, Meeräschenringe mit gerösteten Paprika gebraten, und vieles mehr. Wenn Sie richtigen Hunger haben, gibt es hier auch große Portionen, wie z. B. Gnocci, Seebarschfilet oder Rotbarbe. <br/>

                            Auch wenn das Motto der Bar „ein Bier am Nachmittag vertreibt alle Sorgen“ ist, lohnt sich ein Besuch im Que Pasa am Donnerstagabend, wenn hier regelmäßig lokale Künstler auftreten.<br/>
                        </p>
                        <h3>
                            das SHEM TOV
                        </h3>

                        <p>
                            Auf der Eshkolstraße, einer Nebenstraße des offenen Shuks,, fängt das Shem Tov wahrlich die Atmosphäre des Shuks ein, mit einem reichen orientalischen Menü und einer ausgedehnten Auswahl an israelischem Bier, Wein, Spirituosen und Musik aus der ganzen Welt lädt es ein bis in die frühen Morgenstunden zu verweilen. <br/>

                            Es ist auch ein erstklassiger Ort, um ein Glas kaltes Sahleb zu trinken, ein Getränk hergestellt aus dem Mehl von Knollen der Orchideen mit Rosenwasser, Milch und Zimt vermischt, das im Shuk in der Regel heiß serviert wird.. Mhmm. Köstlich!
                        </p>
                        <h3>
                            NÄCHTLICHE KÖSTLICHKEITEN
                        </h3>
                        <p>
                            Wenn Sie den ganzen Abend getrunken haben, sind Sie wahrscheinlich gegen Mitternacht in der Stimmung für ein paar Knabbereien. Glücklicherweise gibt es noch viele Restaurants, die bei Ihren verschiedenen  Gelüsten helfen können:
                        </p>

                        <div class="img-wrapper">
                          <img src=${getImgUrl() +
                            "/posts/7/3.jpg"} class="img-responsive" />
                        </div>

                        <h3>
                          Das SORAMELO
                        </h3>
                        <p>
                          Wenn Sie nach einer intensiven Nacht Lust auf etwas Süßes bekommen haben, holen Sie sich doch bei Soramelo am Aggripas Eingang zum Shuk ein paar Shuk-inspirierte Waffeln.  <br/>

                          Das Soramelo ist nach einer Nachbarschaftslegende benannt, die dafür bekannt war immer eine Geschichte über alles auf Lager zu haben und hat mittlerweile ohne Zweifel auch selbst die eine oder andere Geschichte hervorgebracht.<br/>

                         Das Soramelo ist die ganze Nacht hindurch mit Menschen gefüllt, die für ein Bier, einen Kaffee und auf einen süßen Happen vorbeikommen. Aber wirklich voll wird es, wenn die Leute spät in der Nacht zum Naschen kommen. Wenn Sie einer dieser Leute sind, haben Sie bis um 3 Uhr morgens Zeit, um das getrunkene Bier und den Arak zu neutralisieren. Probieren Sie eine Waffel mit Schokolade und Tahina – Sie werden nicht enttäuscht sein!<br/>
                        </p>

                        <h3>
                          Das MICHI’S
                        </h3>

                        <p>
                          Michi’s is a simple, yet delicious concept that makes for the perfect late-night eatery — high-quality hamburgers and meat sandwiches at a shockingly good price. You can get a simple 100-gram burger on a fresh bun with some serious fixings for just 17 NIS. If you’re really hungry, you can also get larger portions of meat, roast beef and chicken sandwiches and much more. Michi’s is open until 12 am.
                        </p>

                        <h3>
                          MEORAV YERUSHALMI
                        </h3>

                        <p>
                         Dies ist der wahrscheinlich beste Ort für den berühmten Jerusalem Grillteller, der aus verschiedenen Fleischsorten und Innereien besteht und im Fladenbrot mit Fritten und Salat als Beilage serviert wird. Neben dem traditionellen Rezept bietet das Lokal auch eine gemischte Grillplatte mit Fisch. Die Portionen sind wirklich beeindruckend und perfekt für all die, die einen großen Appetit haben. Stellen Sie nur sicher, dass Sie hier vor Mitternacht erscheinen.
                        </p>

                        <h3>
                         das PASTA BASTA
                        </h3>
                        <p>
                         Pasta Basta ist mit Abstand eines der beliebtesten Restaurants im Shuk und serviert köstliche, frische hausgemachte Pasta Gerichte die nebenbei auch Ihren Geldbeutel schonen. Alles was Sie tun müssen, ist eine Art von Pasta und Sauce wählen und schon ist Ihr Essen fertig. Die Preise hängen von der Sauce ab und variieren zwischen 19 und 26 NIS. Gnocchi, Ravioli und zusätzliche Beilagen kosten extra.
                         <br/>
                         Pasta Basta ist bis Mitternacht geöffnet, und seien Sie nicht überrascht, wenn Sie eine Schlange vor der Tür stehen sehen.
                        </p>

              
			`,
      };
    },
  },

  {
    id: 13,
    bgImage: "posts/bank/24/1.jpg",
    mobBgImage: "posts/bank/24/M.jpg",
    title: "Die Altstadt",
    isVid: true,
    ctg: "jerusalem",
    vidId: "k4OwoEk5wMw",
    smlTitle: "",
    html: function() {
      return {
        __html: `

			<h2>Feel the story come alive</h2>
			<p>
			   Become inspired by the world renowned treasures of the ancient city of Jerusalem.
			</p>
              
			`,
      };
    },
  },

  {
    id: 14,
    bgImage: "posts/bank/32/1.jpg",
    mobBgImage: "posts/bank/32/M.jpg",
    title: "DAS TOTE MEER",
    vidId: "DzEJxjnC_UQ",
    isVid: true,
    ctg: "deadsea",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<p>
			   Zeit für eine Auszeit in der glorreichen Natur Höchster Genuss am tiefstgelegenen Ort der Erde
			</p>
              
			`,
      };
    },
  },

  {
    id: 3,
    bgImage: "/posts/bank/deadsea1/1.jpg",
    mobBgImage: "/posts/bank/deadsea1/M.jpg",
    title: "DAS TOTE MEER",
    vidId: "DzEJxjnC_UQ",
    isVid: true,
    ctg: "deadsea",
    smlTitle: "",
    html: function() {
      return {
        __html: `

			<h2>Höchster Genuss am tiefstgelegenen Ort der Erde</h2>
              <p>
						The Dead Sea is one of the most unique natural phenomena on the planet. A crevice in the earth’s crust that is part of the Great Rift Valley allows the waters of the River Jordan to flow south into a lozenge-shaped lake at the lowest point on our planet. With no outlet, the rays of the blazing sun evaporates the Jordan water to a point where its mineral content is highly concentrated; and it is this density of minerals and salt that makes it impossible to sink in the sea: bathers float effortlessly on the water’s surface. Because the sun has to travel an additional 1,200 feet to reach the shore, ultra-violet rays are filtered out and oxygen is enriched to a point where even the fairest skins tan but do not burn.
              </p>
              <p>
              		This is why a visit to the Dead Sea enables sufferers of rheumatic diseases to breathe better, and why victims of psoriasis and other serious skin ailments receive temporary cures by bathing in the Dead Sea, slathering themselves with Dead Sea mud and baking in the non-burning sun.
              </p>
              <p>
              		The Dead Sea is lined with spas, bathing beaches and spa hotels.
              </p>
			`,
      };
    },
  },

  //No translation
  {
    id: 35,
    bgImage: "/posts/bank/47/1.jpg",
    mobBgImage: "/posts/bank/47/M/1.jpg",
    title: "Go To Guide",
    ctg: "telavivAndJerusalem",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
                      <h2>Travel from Tel Aviv and Jerusalem</h2>
					<p>
						One of the best things in visiting Tel Aviv and Jerusalem is how incredibly different yet amazingly close are these two fabulous destinations. In fact, the two cities are less than one hour’s drive(!) from one another, which means that should you wish, you could spend the day exploring the awesome and world-famous sites of Jerusalem and be back in time to watch the sunset from one of Tel Aviv stunning beaches before heading on to an all-night rager in one of the city’s hottest clubs. Talk about a full day’s fun…
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/36/1.jpg"} class="img-responsive" />
					</div>
					<p>
						Getting to and from Tel Aviv and Jerusalem is easy and there are several ways depending on your preference and budget:
					</p>
					<p>
						<strong>By Car:</strong> 
						Should you choose to hire a car you will find route 1 connects the two cities directly, and road signs to be pretty clear and come in three languages. However, you may want to use one of the local navigation apps to show you the way and help you avoid heavy traffic. 
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/36/2.jpg"} class="img-responsive" />
					</div>
					<p>
						<strong>By Bus:</strong> 
						there are several public buses which travel to and from Tel Aviv and Jerusalem. This is by far one of the most convenient and budget-friendly means of travel. 
					</p>
					<p>
						<strong>By Train:</strong> 
						A convenient train service operates in several main stations to and from Tel Aviv and Jerusalem. Works are currently underway and soon a fast new direct route will begin operating between the two cities. 
			            	</p>
					<p>
						<strong>By Taxi:</strong> 
						Taxis for interurban travel can be flagged on the street or booked via phone or designated apps such as Gett (GetTaxi).
			            	</p>
					<p>
						<strong>Sherut Taxis:</strong> 
						“Sherut” (service) taxis are 10 - 12 seater vans which generally follow major bus routes, in and between major cities. Pricewise, sherut taxi fares have a fixed price, similar to public bus fares. Sherut taxis also offer a replacement to service to buses on Fridays.  
			            	</p>
			            	<p>
			            		For information regarding train stations, routes and schedules, visit <a href="https://www.rail.co.il" target="_blank">www.rail.co.il</a>
			            	</p>
			            	<p>
			            		For information regarding bus routes and schedules visit  <a href="https://www.bus.co.il" target="_blank">www.bus.co.il</a>
			            	</p>
			            	<p>
			            		Public transport helpline   <a href="tel:*8787">*8787</a>
			            	</p>
			            	<p>
			            		Local public transport app - ‘Moovit’
			            	</p>
			            	<p>
						        So come check out Epic Tel Aviv and unforgettable Jerusalem, less than one hour away from each other!
			            	</p>

            	`,
      };
    },
  },

  {
    id: 36,
    bgImage: "/posts/bank/48/1.jpg",
    mobBgImage: "/posts/bank/48/M/1.jpg",
    title: "Ein Tag in Tel Aviv",
    isVid: false,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
                 <h2>Vom Hafen zum Hafen</h2>
				 <p>Beginnen Sie Ihren Tag im Jaffa-Hang-Park mit einem herrlichen Panorama über den größten Teil der israelischen Küste und dem historischen Ausgangspunkt der Metropole vor etwa 4000 Jahren. Gönnen Sie sich eine Tasse Kaffee im renovierten antiken Hafen und fahren Sie nach Norden, um einen schönen Spaziergang entlang der Promenade zu machen und den fantastischen Strand zu genießen.</p>
                    <div class="img-wrapper">
                      <img src=${getImgUrl() +
                        "/thingsToDo/posts/37/2.jpg"} class="img-responsive" />
                    </div>
                    <p>Überqueren Sie die Straße zum "Tachana Compound", einem fabelhaft renovierten Einkaufszentrum im Freien, das in einem ehemaligen Bahnhof untergebracht ist, der in den 1890er Jahren als Tel Aviv und Jaffas Hauptbahnhof erbaut wurde. </p>
                    <p>Begeben Sie sich in das malerische Viertel Neve Tzedek und spazieren Sie durch die malerischen Gassen. Gönnen Sie sich etwas Schönes in den lokalen Läden, bis Sie die bunte Hektik des Hacarmel Marktes erreichen. Halten Sie für ein ausgezeichnetes Straßenessen an, und wenn es zufälligerweise ein Dienstag oder Freitag ist - dann schätzen Sie sich glücklich und shoppen Sie auf der traditionellen Nachlat Binyamin Meile, wo lokale Handwerker ihre Arbeit präsentieren. </p>
                    <p>Weiter geht es zum wunderschönen Rothschild Boulevard, dem Herzstück der Bauhaus-Architektur, und zum UNESCO-Weltkulturerbe. Hier können Sie sich ein Fahrrad ausleihen und sich den Einheimischen anschließen, bis zum Habima-Platz, der Heimat des Nationaltheaters und des israelischen Philharmonischen Orchesters. Flanieren Sie auf der trendigen, belebten Dizengoff Street,nehmen Sie ein Häppchen in einem der Cafés rund um den Platz und laufen oder radeln Sie entlang des Hen Boulevard bis zum Rabin Square. </p>
                    <div class="img-wrapper">
                      <img src=${getImgUrl() +
                        "/thingsToDo/posts/37/1.jpg"} class="img-responsive" />
                    </div>
                    <p>Besuchen Sie die Eben Gabiroll Street, ein angesagtes Zentrum dieser fabelhaften Stadt. Hier gibt es eine große Auswahl an preisgekrönten Restaurants und ausgezeichnete Pubs und Bars, in denen Sie eine Mahlzeit oder einen frühen Drink genießen und mit den Einheimischen zusammensitzen können. </p>
                    <p>Nehmen Sie die Linie Nummer 5, eine urbane Ikone für sich selbst, und steigen Sie am Hafen von Tel Aviv aus. Genießen Sie den Sonnenuntergang und schauen Sie nach Süden Richtung der Skyline von Jaffa, wo der Tag begann. Verbringen Sie Ihren Abend in der Umgebung und beobachten Sie gespannt, wiesich diese plötzlich in das aufregendste Nachtleben der Stadt verwandelt, mit fabelhaften Bars und Clubs - wie gemacht für lange legendäre Nächte. </p>


            	`,
      };
    },
  },

  {
    id: 15,
    bgImage: "/posts/bank/50/1.jpg",
    mobBgImage: "/posts/bank/50/M/1.jpg",
    title: "Jerusalem",
    ctg: "culinary",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                    <h2>Kulinarische Highlights in Jerusalem </h2>
				 <p>Jerusalem ist eine faszinierende und magische Stadt. Viele Menschen, die Jerusalem besuchen, schwärmen von der unglaublichen Atmosphäre, den unvergesslichen Sehenswürdigkeiten, den atemberaubenden Aussichten und vielem mehr. Aber, um Jerusalem wirklich kennenzulernen, gibt es noch einige Dinge, die Sie einfach mit Ihrem Gaumen erfahren müssen. Hier sind nur einige Leckerbissen, die Sie wirklich probieren sollten, während Ihres Aufenthals in Jerusalem:</p>
                    <div class="img-wrapper">
                      <img src=${getImgUrl() +
                        "/thingsToDo/posts/39/1.jpg"} class="img-responsive" />
                    </div>
                    <p>Malabi: Eine einzigartige Kombination aus Getränk und Dessert, hergestellt aus einer Mischung aus Rosenwasser, Milch, Maisstärke und Zucker. Malabi ist ein sehr beliebtes Gericht aus Jerusalem, das in vielen östlichen Restaurants und Kiosken in der ganzen Stadt angeboten wird. Sie können sicher sein, dass Sie etwas Ähnliches bestimmt noch nie probiert haben. </p>
                    <p>Knafeh: Ein sehr interessantes und sensationell leckeres Gericht, wird ganz frisch zubereitet und zum Essen serviert. Knafeh ist im Grunde eine arabische Süßigkeit dieaus einer Art geschmolzenem Ziegenkäse besteht, der mit feinen orangefarbenen Teigfäden umhüllt ist und schließlich mit süßem Rosenwassersirup überträufelt wird. </p>
                    <p>Jerusalem Brezel: Wenn Sie die faszinierenden Sehenswürdigkeiten der Altstadt erkunden, müssen Sie nach einem der kleinen grünen Karren schauen um eine authentische Jerusalem-Brezel zu kaufen. Dazu gibt es ein duftendes regionales Gewürz namens Zaatar, das perfekt zum köstlichen warmen Gebäck passt. </p> 
                    <p>Meorav Yerushalmi: Direkt übersetzt bedeutet es „Mixed Jerusalem".Eine köstliche Mischung aus verschiedenen Fleischsorten in einer speziellen lokalen Gewürzmischung - einfach der Himmel auf Erden für alle Fleischliebhaber.</p>
                    <p> “Ashtanur”: kurz in Hebräisch für "Feuer im Ofen", Ashtanur ist ein authentisches Pitta-Brot, das Sie auf den Märkten während der Mittagszeit finden können. Wenn Sie besonders hungrig sind, versuchen Sie es mit einer Portion Shawarma oder Falafel.</p> 
                    <p>Sabich: Ein absolutes Original! Das Sabich ist ein wirklich einzigartiges lokales Gericht, das aus einem Pitta-Brot besteht, das mit gebratenen Auberginen, hart gekochten Eiern und Essiggurken gefüllt ist und üblicherweise mit Amba - einer würzigen Sauce gekrönt wird. Sobald Sie es probieren, werden Sie für immer süchtig sein. </p>


            	`,
      };
    },
  },

  {
    id: 86,
    bgImage: "/posts/bank/86/1.jpg",
    mobBgImage: "/posts/bank/86/M/1.jpg",
    title: "FEINSCHMECKERSZENE TEL AVIV",
    ctg: "culinary",
    isVid: true,
    vidId: "gGe4W8WaIiQ",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                        <h2>Dem köstlichen Frühstück in Tel Aviv kann auch Jamie Oliver nicht widerstehen.</h2>
						<small style="color:#000; display:block;position: relative;top: 5px;">
						Credit:  Israeli food channel
						</small>

            	`,
      };
    },
  },

  {
    id: 37,
    bgImage: "/posts/bank/49/1.jpg",
    mobBgImage: "/posts/bank/49/M/1.jpg",
    title: "Tel Aviv",
    isVid: false,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
                     <h2>Die ultimative Luxus-Destination</h2>
					<p>Vergessen Sie die Karibik, Cannes oder die Malediven. Wenn Sie einen Luxusurlaub wollen, ist Tel Aviv der richtige Ort für Sie! </p>

                    <p>Als allererstes ist zu erwähnen, dass diese Stadt, die von der NY Times "die Hauptstadt der Coolness" genannt wird, nur knappe 4 flugstunden entfernt ist. Das bedeutet für Sie, keine Sorgen auch nur eine Minute Ihres Traumurlaubs mit dem Jet Leg verschwenden zu müssen.</p>
                    <p>Sobald Sie hier sind, ist Ihre erste große Freude das herrliche, ganzjährig sonnige Wetter - genau richtig für uneingeschränktes Urlaubsvergnügen. </p>
                    <p>Entspannen Sie sich in einem der erstklassigen Hotels. Tel Aviv bietet eine großen Auswahl an luxuriösen Unterkünften - von Weltklasse-5-Sterne-Hotels mit Blick auf den Strand bis hin zu den zahlreichen atemberaubenden Boutique-Hotels an den interessantesten Orten in der ganzen Stadt. </p>
                    <div class="img-wrapper">
                      <img src=${getImgUrl() +
                        "/thingsToDo/posts/38/1.jpg"} class="img-responsive" />
                    </div>
                    <p> Was macht das Erlebnis perfekt? Natürlich ein Besuch an Tel Avivs wunderschönem Strand ,  der Ihnen jeglichen Komfort für einen fabelhaften Tag bietet. Das wunderbar blaue Mittelmeer empfängt Sie mit angenehmen Temperaturen und sorgt doch gleichzeitig für Erfrischung. </p>
                    <p>Fühlen Sie sich hungrig? Eine große Auswahl an Gourmetgerichten wartet auf Sie, die von lokaler bis zur Fusion-Küche reichen. Tel Aviv ist weltweit für seine qualitativ hochwertige Küche bekannt, die in preisgekrönten, exquisit gestalteten Chef-Restaurants angeboten wird. </p>
                    <p>Zeit für einen Einkaufsbummel - schnappen Sie sich Ihre Geldbörse und besuchen Sie die Designer-Boutiquen, die schicken Shops und Luxus-Einkaufszentren, in denen Sie alles finden werden, von Haute Couture bis zu den neuesten internationalen Trends. </p>
                    <p>Um den Tag ausklingen zu lassen, gönnen Sie sich ein Craft-Bier oder genießen einen exzellenten  Cocktail in einem der grandiosen Nachtclubs oder einer glamourösen Bar in der Stadt und tanzen Sie die Nacht durch, bevor Sie sich in Ihr Hotel begeben, um bei einen wohlverdienten 5-Sterne-Schlaf neue Energie zu schöpfen. </p>

                    <p>Luxus? Stil? Glanz? Wir haben alles! Warum Zeit verlieren? Buchen Sie noch heute Ihre Reise nach Tel Aviv! </p>


            	`,
      };
    },
  },

  {
    id: 38,
    bgImage: "/posts/bank/jerusalem3/1.jpg",
    mobBgImage: "/posts/bank/jerusalem3/M.jpg",
    title: "Jerusalem- Stadt der Überraschungen",
    ctg: "jerusalem",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h2>Eine Stadt, die alle Erwartungen übertrifft</h2>

				<p>Jerusalem ist eine weltweit bekannte Stadt und eines der beliebtesten Urlaubsziele der Welt. Viele Menschen besuchen Jerusalem jedes Jahr wegen seiner historischen Bedeutung, heiligen Stätten, seiner wunderschönen und einzigartigen Architektur und bemerkenswerten Atmosphäre.</p>
                  <p>Jerusalem ist aber auch eine Stadt der Überraschungen, und es gibt diverse Themen, die die meisten Menschen nicht sofort mit dieser erstaunlichen Stadt überhaupt in Verbindung bringen würden. Hier sind nur einige der Dinge, die Sie nicht unbedingt in Jerusalem erwarten würden:</p>
                  <div class="img-wrapper">
                    <img src=${getImgUrl() +
                      "/thingsToDo/posts/40/1.jpg"} class="img-responsive" />
                  </div>

                   <h3>Sommerfeste</h3>
                  <p>Jedes Jahr im Sommer wird das Zentrum von Jerusalem mit vielen Partys am Freitagmittag überflutet, gefüllt mit Musik, Tanz und großartigen Menschen aus der ganzen Welt. Ein mitreißender Party-Vibe fängt mit einem lauten Knistern an, entflammt jeden Feierfreudigen und das Wochenende kann starten. </p>


                   <h3>Der verrückte Markt</h3>
                  <p>Eine unvergessliches Erlebnis findet jede Donnerstagnacht statt, wenn der geschäftige Tagesmarkt von Machne Yehuda zu einer lebhaften Late-Night-Szene wird, vollgepackt mit fantastischen Bars, Pubs und Live-Musik die ganze Nacht lang. </p>


                   <h3>Festivals</h3>
                  <p>Jerusalem ist eine Stadt voller Festivals - vom berühmten Filmfestival bis zum Weinfestival, einem internationalen Puppenspielfestival und sogar einem Happening-Festival. Was auch immer Sie interessiert, Jerusalem bietet etwas das zu Ihrem Geschmack passt und irgendwo in der Stadt stattfindet. </p>

                   <h3>Jerusalem Marathon</h3>
                  <p>Ein fantastischer und äußerst beliebter Marathon, der eine Vielzahl von Strecken bietet, von professionell bis familienfreundlich, die an faszinierenden historischen Stätten vorbeiziehen, die 3.000 Jahre Geschichte Jerusalems beleuchten. Wir garantieren eine herausfordernde, spannende und unvergessliche Erfahrung für alle Läufer und Zuschauer.</p>
                   <h3>Museen und Ausstellungen</h3>
                  <p>Die Vielfältigkeit der Natur erstreckt sich ebenso auf die Museen und Kulturveranstaltungen in der ganzen Stadt. Vom weltberühmten Israel Museum bis Yad Vashem, zum unvergesslichen Licht- und Soundspektakel in der Zitadelle, der Wanderung über die Stdatmauern mit fantastischem Blick und noch vielem mehr. Die Stadt ist einfach übersät mit großartigen kulturellen Erfahrungen.</p>

                   <h3>Der Bauernmarkt</h3>
                  <p>Jeden Freitag finden Sie in der deutschen Kolonie, im Herzen der Stadt, den örtlichen Bauernmarkt . Er bietet eine eindrucksvolle Auswahl an erstklassigen Produkten, lokalen Köstlichkeiten und reizvollen Schnäppchen.</p>

                   <h3>Ein Aquarium der Weltklasse</h3>
                  <p>Es ist eines der größten Aquarien im Nahen Osten. Diese fabelhafte Attraktion für Kinder und Erwachsene öffnete dieses Jahr zum ersten Mal seine Türen für die Öffentlichkeit. Das Aquarium ist 7.000qm groß und beherbergt 40 Meeresarten in 33 Wasserbecken, von denen der größte 1,6 Millionen Liter enthält. </p>


            	`,
      };
    },
  },

  {
    id: 39,
    bgImage: "/posts/bank/52/1.jpg",
    mobBgImage: "/posts/bank/52/M/1.jpg",
    //   vidId: "88OV6xU0vPI",
    vidId: "5nqL-oIC0GA",
    isVid: true,
    ctg: "telaviv",
    title: "Tel Aviv",
    smltitle: "",
    html: function() {
      return {
        __html: `

					<h2>Mit dem Fahrrad in Tel Aviv</h2>
					<p> Als eine der angesagtesten Städte der Welt ist es keine Überraschung, dass sich Tel Aviv in den letzten Jahren ebenfalls dem Trend angeschlossen hat, der die berühmtesten Städte der Welt erobert hat - den Fahrradtrend. </p>
                    <p> In fast allen berühmten Städten der Welt hat sich ein Trend durchgesetzt: Der Fahrrad-Trend. Wen wundert es also, dass Tel Aviv – eine der angesagtesten Metropolen – sich diesem Trend angeschlossen hat. </p>
                    <p> Die Erkundung der Stadt mit dem Fahrrad hat viele Vorteile - es ist umweltbewusst und reduziert den CO2-Fußabdruck erheblich, erspart Ihnen aber ebens kostbare Urlaubszeit, die ansonsten im Kampf gegen den Verkehr aufgebracht werden müsste. Und natürlich ist Fahrradfahren gesund. Das Fahrrad ist ein unkompliziertes Fortbewegungsmittel und bietet Besuchern und Touristen eine tolle Möglichkeit, die Stadt und ihre Umgebung im eigenen Tempo  zu erkunden. Ein ausgezeichneter Weg, die Sehenswürdigkeiten und Attraktionendie Geräusche und Gerüche der Stadt aus nächster Nähe zu genießen. </p>
                    <div class="img-wrapper">
                      <img src=${getImgUrl() +
                        "/thingsToDo/posts/41/1.jpg"} class="img-responsive" />
                    </div>
                    <p> Hier sind nur einige der Dinge, die Tel Aviv zu einer fantastischen Stadt zum Radfahren machen: </p>
                    <p> Die Fahrradwege: Die Stadt Tel Aviv unterstützt das Radfahrern im Straßenverkehr sehr, und diese Unterstützung kann sich sehen lassen, weil es in der ganzen Stadt über 100 km Fahrradwege gibt, die für die Sicherheit und Bequemlichkeit der Radfahrer der Stadt angelegt wurden.</p>
                    <p> Das fantastische Wetter: Tel Aviv genießt das ganze Jahr über fantastische Wetterbedingungen mit sehr wenig Regen, und deshalb bietet es ideale Bedingungen zum Radfahren, während man die frische Luft vom Strand auf der schönen Promenade genießen kann, oder die atemberaubenden Innenstraßen mit ihrer fabelhaften Bauhaus-Architektur durchfährt. </p> 
                    <p> Tel-O-Fun: Der Tel-O-Fun ist ein einfaches und kostengünstiges öffentliches Leihsystem für Fahrräder. Mit Tel-O-Fun können Bewohner und Besucher mit einer Kreditkarte an 150 günstigen Stationen in der ganzen Stadt ausgezeichnete Qualitätsfahrräder abholen und abgeben.</p>
                    <p> Das Beste ist, dass in Tel Aviv alles nahe beieinanderliegt. Sie können mit dem Fahrrad zum Strand fahren und entlang der herrlichen Promenade radeln. Nehmen Sie Ihr Rad und machen Sie ein fantastisches Picknick im Park Ha'Yarkon oder fahren Sie abends in die Stadt um die fabelhaften Clubs und Bars von Dizengoff zu sehen oder zum Hafen. </p>
                    <p> Radfahren war noch nie einfacher, gesünder oder spaßiger als hier in der wunderschönen Stadt Tel Aviv. </p>


            	`,
      };
    },
  },

  {
    id: 40,
    bgImage: "/posts/bank/53/1.jpg",
    mobBgImage: "/posts/bank/53/M/1.jpg",
    title: "Tel Aviv",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
                    <h2>Tel Aviv ist cool, Tel Aviv ist anders</h2>
					<p>Tel Aviv ist weltberühmt als eine Stadt, die niemals schläft und bekannt für ihr aufregendes Nachtleben, die fabelhaften Strände, die großartige Kultur, die Kunst und vieles mehr. Aber hier kommen einige Insider-Tipps, die den Sommer in Tel Aviv für Sie noch aufregender machen.</p>
                    <div class="img-wrapper">
                      <img src=${getImgUrl() +
                        "/thingsToDo/posts/42/1.jpg"} class="img-responsive" />
                    </div>
                    <p>In Germany this „Flat-drinking“ is forbitten by law because some younger people died of this drinking excess – it has a very bad Image – please think about if you want to mention it. And if you mention, so  not at first but at last.</p>
                    <h3>Freitagnachmittag Trommelkreise</h3>
                    <p>Begeben Sie sich am Freitagnachmittag zum berühmten Banana- Beach und gönnen Sie sich gleich doppelt Spaß - genießen Sie die großartige Trommel-Session am Strand und schauen Sie sich den wunderschönen Sonnenuntergang an - beides völlig kostenlos! </p>
                    <h3>Rooftop - Spaß</h3>
                    <p>Vielleicht liegt es am Wetter, vielleicht ist es die schöne Aussicht - eines ist sicher, die Tel Aviver lieben die Natur, vor allem mit einem Drink in der Hand. Während des Sommers, finden Sie die meisten Bars und Pubs hoch auf die Dächer verlegt (buchstäblich!) oder umgestaltet in Veranstaltungsorte im Freien. Oft tauchen diese Bars auf den Dächern von Geschäfts- und Bürogebäuden auf. Folgen Sie einfach den Klängen von Musik, Tanz und Lebensfreude, dann finden Sie einen dieser fantastischen Rooftop-Orte. </p>
                    <h3>Outdoor- Fitness</h3>
                    <p>Nichts ist wichtiger als Ihre Gesundheit.Warum also nicht zu jeder Tages- und Nachtzeit, wann immer sie wollen, einige Trainingseinheiten absolvieren? Tel Aviv bietet einige großartige Möglichkeiten, um genau das zu tun -  Sie können im Meer schwimmen, entlang der Promenade laufen und durch die fabelhaften Straßen der Stadt radeln.  Sie können sogar in einem der vielen Outdoor-Fitnessstudios der Stadt trainieren, die kostenlos zu Verfügung stehen. </p>
                    <h3>Unglaubliche Veranstaltungen in Sommer</h3>
                    <p>Von weltberühmten internationalen Künstlern über fantastische Electronic-, Kunst- und Bierfestivals bis zu Galerien, Ausstellungen, Live-Straßenmusik, Open Air Kinos und Strandpartys, die die ganze Nacht dauern, ist Tel Aviv im Sommer eine endlose Quelle an Spaß und Unterhaltung, die Sie nicht verpassen dürfen! </p>


            	`,
      };
    },
  },

  {
    id: 1,
    bgImage: "/posts/bank/27/1.jpg",
    mobBgImage: "/posts/bank/27/M.jpg",
    title: "DIE HÄFEN VON TEL AVIV",
    smltitle: "",
    isVid: "true",
    vidId: "88OV6xU0vPI",
    ctg: "telavivAndJerusalem",
    html: function() {
      return {
        __html: `
                    <h2>Der hafen von Tel aviv and der haven von Jaffa. Zwei faszinierende Hafengebiete, jedes mit seinem eigenen Charakter und Charme</h2>
					<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/88OV6xU0vPI/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->
					<p>
                          Tel Aviv, a bustling a highly modern metropolis, boasts beaches with fine golden sand, a hip atmosphere and ample opportunities for fun infused with authentic Middle Eastern flavor, not to mention great food and coffee. Just forty minutes away, experience an entirely different beat and pulse: Jerusalem, a city of such unparalleled beauty, it will be easy to understand why for millennia it has been so inspirational for so many.
                          <br/>
                          While both Tel Aviv and Jerusalem are two busy, vital and intriguing cities that offer a multitude of must-see attractions, they couldn’t be more different. Despite their geographic proximity, they have entirely different landscapes, scents and flavors. Where else could you so easily combine the ultimate beach destination with one of the most ancient and holiest cities in history?
                          <br/>
                          So here’s a sample menu of what you can do on a vacation in both cities.
                      </p>
                      <h3>
                          Tel Aviv – the city that never sleeps
                      </h3>
                      <p>
                          So you’ve landed in Tel Aviv… Experience all the excitement the first Hebrew city dishes up. Discover the stunning azure hues of the Mediterranean, the quaint spots in the White City, its markets, restaurants, special flavors and scintillating night life. Catch a few waves and see exactly why Tel Aviv is known as the non-stop city, living and breathing vitality, 24 hours a day. <br/>
                          So let’s go.
                      </p>
                      <h3>
                          Neve Tzedek:
                      </h3>
                      <p>
                           Discover the magic of this spectacular and beautifully renovated neighborhood, located on the southern end of the Tel Aviv Promenade, next to Jaffa. Start your morning with a culinary experience that includes a typical Israeli breakfast: delicious baked goods, eggs, cheeses and dips, green salad or chopped salad, orange juice and, of course, excellent coffee. The recommended tour of Neve Zedek takes you to historical landmarks and small, wonderful museums.
                      </p>
                      <div class="img-wrapper">
                        <img src=${getImgUrl() +
                          "/posts/1/1.jpg"} class="img-responsive" />
                      </div>
                      <h3>
                          Hatachana:
                      </h3>
                      <p>
                          After recharging, go visit Hatachana, which is close by. There you can visit renovated Templar buildings, as well as Jaffa’s old train station, completely redone. The site tells the tale of the train station, with its Jaffa-Jerusalem line, that operated here from 1892-1948.
                      </p>
                      <h3>
                          Jaffa
                      </h3>
                      <p>
                          Next, take a walk along the stunning Tel Aviv beach promenade to Jaffa. We recommend visiting Jaffa Port, considered to be one of the world’s most ancient ports. Lounge at one of the many cafes that dot the wharf, and watch the fisherman at work. Then, continue towards the colorful flea market, where you can treat yourself to a vintage item, Armenian ceramics, a hamsa or any of a multitude of souvenirs. At night, the area transforms itself into a hopping bar and restaurant scene.
                      </p>
                      <h3>
                          Pedal down the beach:
                      </h3>
                      <p>
                          Tel Aviv is known as Israel’s bicycle capital. On a nice day, those of you with a sporty spirit can rent a bike at a one of the Tel-O-Fun stations or any other rental spot around town. Biking from Neve Zedek to Tel Baruch beach in the northern part of the city is a phenomenally fun experience.
                      </p>
                      <div class="img-wrapper">
                        <img src=${getImgUrl() +
                          "/posts/1/2.jpg"} class="img-responsive" />
                      </div>
                      <h3>
                          Eretz Israel Museum
                      </h3>
                      <p>
                          If you find yourself in the northern section of town, we suggest you visit the Eretz Israel Museum. It is a multidisciplinary museum that focuses on the history and culture of Israel through permanent and temporary exhibits dedicated to archeology, ethnography, post and philately, folklore, Judaica, traditional crafts, popular art, cultural history and local identity.
                      </p>
                      <h3>
                          Rothschild Boulevard
                      </h3>
                      <p>
                          Looking for an inviting location where you can enjoy a great meal? Try eating at one of the fine restaurants on or around Rothschild Boulevard, right in the heart of the city, it is one of the three zones that make up the White City, recognized by UNESCO as a World Cultural Heritage Site. This street, which perfectly defines the essence of Tel Aviv, offers you a prime opportunity for people watching. You can also take a stroll and take in the impressive Bauhaus architecture, the old kiosk and the small museums that relate the fascinating story of Tel Aviv and its first neighborhood, Ahuzat Bayit.
                      </p>
                      <h3>
                          Nightlife
                      </h3>
                      <p>
                           If you plan on staying in the city, you can opt to take a room at one of the big hotels located on the beach, near the promenade, or at one of the lovely boutique hotels. And if you’re still energized and raring to go, now’s the time to enjoy yourself at one of the popular bars, nightclubs, the Opera House, a dance performance or any of the many events and festivals in Tel Aviv.
                           <br/>
                           Done sampling the good life in Tel Aviv? Now enjoy the best of both worlds by heading out to Jerusalem. It’s only 40 minutes away!  The Holy City awaits you!
                      </p>
                      <div class="img-wrapper">
                        <img src=${getImgUrl() +
                          "/posts/1/3.jpg"} class="img-responsive" />
                      </div>
                      <h3>
                        Jerusalem – the world’s most beautiful city
                      </h3>
                      <p>
                        Discover the city most sacred to three religions: Judaism, Islam and Christianity. Visit the historic sites, breathe in the dizzying scents, taste the special dishes, inhale the clean mountain air and have fun at the many entertainment hot spots around the city.
                      </p>
                      <h3>
                        Ein Kerem
                      </h3>
                      <p>
                        Even before reaching the city, you can visit the picturesque neighborhood of Ein Kerem. Just a 20-minute drive from the city center, it is known for its idyllic character. Nestled in greenery, Ein Kerem brings you breathtaking views, charming stone houses, churches and mosques, fascinating historical sites, enchanting alleys, galleries and special boutique shops, cafes and fine restaurants, as well as exquisite hotels, both old and new.
                      </p>
                      <h3>
                        Bloomfield Science Museum
                      </h3>
                      <p>
                        Jerusalem’s science museum is a magical kingdom for adults and children alike, filled with moving objects, optical illusions, electrical experiments and everything that has made our world a user-friendly place.
                      </p>
                      <h3>
                        The Old City
                      </h3>
                      <p>
                        At the top of any Jerusalem itinerary! The Old City of Jerusalem is, simply put, an ancient treasure trove of discovery and delight. The true essence of Jerusalem is hidden in the narrow, winding alleyways of the Old City: the special atmosphere, fascinating history and secrets are revealed among its ancient stones. Visit the Western Wall to be moved by the sanctity of the remains of the Temple and to place a note with a request to the Holy One between the stones.
                      </p>
                      <div class="img-wrapper">
                        <img src=${getImgUrl() +
                          "/posts/1/4.jpg"} class="img-responsive" />
                      </div>
                      <p>
                        Follow in the footsteps of Jesus, down the Via Dolorosa, to the Church of the Holy Sepulchre – home to the two holiest sites of Christianity: the site where Jesus of Nazareth was crucified and the empty tomb, from which he is believed to have resurrected. Continue to Mount Zion, where you can visit the Cenacle (also known as the Upper Room), traditionally held to be the site of the Last Supper. Then, as Jesus did frequently, visit the Mount of Olives for a moment of meditation at Gethsemane, where Jesus prayed and his disciples slept the night before the crucifixion. And, ascend to the rooftop of the Austrian Hospice of the Holy Family for a truly magnificent view of Jerusalem and the Old City.
                        To immerse you even deeper into the roots of ancient Jerusalem, tour the Western Wall tunnels, visit the Dome of the Rock, the holy site where Muhammad is believed to have ascended to Heaven, and the Lutheran Church of the Redeemer, home to one of the most beautiful organs in Israel.
                      </p>
                      <h3>
                        Machane Yehuda Market
                      </h3>
                      <p>
                        You’ve been busy today. Starting to feel hungry? Now you can visit Machane Yehuda Market – Jerusalem’s bustling and vibrant open air market. Alongside the market’s well-known stands, many cafes and upscale food shops have sprung up in recent years.
                      </p>
                      <h3>
                        Shopping in Jerusalem:
                      </h3>
                      <p>
                        Ready for some shopping and souvenirs? Buy Armenian ceramics or Judaica in the special and beautiful stores in the Old City. You will also find stores selling a plethora of souvenirs from Israel in the city center. You’ll find numerous clothing stores located on the Ben-Yehuda Promenade. And don’t forget to check out the second hand shops if you want to purchase something a little more authentic. What’s more, don’t miss a visit to the upscale Mamila mall, considered one of the city’s most active shopping centers.
                      </p>
                      <p>
                        So diverse, so distinct and any yet just a short commute apart, Jerusalem and Tel Aviv make the perfect destination package. Together, they bring you history and modernity, ancient artifacts and modern arts, fun in the sun and the most spiritual journey of your life. It doesn’t get any better than that! So what are you waiting for? Book your vacation now!
                      </p>


           `,
      };
    },
  },

  {
    id: 21,
    bgImage: "/posts/bank/99/1.jpg",
    mobBgImage: "/posts/bank/99/M.jpg",
    player_id_post: "21",
    ctg: "culinary",
    isVid: true,
    // vidId: "n4kCnPXEX7g",
    vidId: "JQD9JpMaw9g",
    title: "Ein Feinschmeckerparadies",
    smltitle: "",
    html: function() {
      return {
        __html: `

                     <h2>Komm heraus in Tel Avivs genialer kulinarischer Szene</h2>
					<p>
								Wenn Sie zu den Feinschmeckern gehören (wir müssen ehrlich sein, das tun wir doch alle), müssen Sie unbedingt in Tel Aviv essen gehen.
          </p>
          <p>
								Die Küchenchefs von Israel sind weltweit für ihre innovativen Gerichte bekannt und die Gourmetszene in Tel Aviv ist absolut im Kommen.
          </p>
          <p>
								Mit über 4.500 Speiselokalen ist Tel Aviv ein Mekka für Feinschmecker. Viele Restaurants sind im Besitz von exzellenten, weltweit anerkannten Küchenchefs, die in den besten Küchen der Welt gelernt haben, bevor Sie nach Israel zurückgekehrt sind, um die lokale Gourmetszene zu prägen.
          </p>
          <p>
								Tel Aviv hat etwas für jeden Geschmack zu bieten. Von der US-Gourmet-Website The Daily Meal als „Top-Adresse für Veganer“ ausgezeichnet, hat Tel Aviv hat ungefähr 400 veganerfreundliche Restaurants zu bieten. Sie müssen unbedingt die exzellenten Favoriten der traditionellen Straßenküchen wie Falafel und Hummus probieren, aber auch unzähligen Delikatessen auf den lokalen Märkten. Wenn Sie sich ein fantastisches kulinarisches Erlebnis wünschen, sollten Sie sich die trendigen Restaurants im Hafen von Tel Aviv, an der Rothschild Avenue, in Neve Tzedek oder im atemberaubend renovierten Tachana-Komplex nicht entgehen lassen.
          </p>
          <p>
								Auf dem Markt von Sarona - einer ehemaligen Kolonie deutscher Templer - findet man mit Abstand die modernste Küche der Stadt. Dieser 8.700 m2 große Markt wurde sorgfältig restauriert und beherbergt heute 91 Geschäfte aller Kategorien, Stände und Restaurants, in denen Sie neue Gerichte erleben können, die nicht nur köstlich, sondern auch außergewöhnlich originell sind.
          </p>

         `,
      };
    },
  },

  // No translation
  // {
  //         id:2,
  //         bgImage : "/posts/bank/35/1.jpg",
  //         mobBgImage : "/posts/bank/35/M.jpg",
  //         title : "Tel Aviv: Nonstop excitement.",
  //         vidId_post : "88OV6xU0vPI",
  //         player_id_post :"2",
  //         smltitle : "Beautiful, colorful and unforgettable Tel Aviv",
  //         ctg: "telaviv",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 					<div class="responisve-iframe">
  // 					<iframe src="https://www.youtube.com/embed/88OV6xU0vPI/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
  // 					</div>
  // 					<p>
  // 					Energetic, inspirational or funfilled relaxation - Your holiday in the vibrant city of Tel Aviv can be
  // 					anything you want it to be. With great weather virtually all year round, you can chill on dazzling
  // 					stretches of golden beaches, take in the colorful markets, cutting edge culture and entertainment,
  // 					outstanding nightlife and an exciting culinary scene. You can also enjoy simply making your way through the streets with their fascinating Bauhaus buildings and just feel the city’s unique ‘non-stop’ vibe, which has made it one of the trendiest destinations for tourists worldwide.<br>
  // 					So get energized, get inspired, get ready – you’re gonna fall in love with Tel Aviv!

  // 					</p>

  // 					<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/posts/2/3.jpg"} class="img-responsive" />
  // 					</div>

  // 					<h3>
  // 					NON-STOP Tel Aviv<br> Ultimate Beach Fun
  // 					</h3>

  // 					<p>
  // 					Voted National Geographic Magazine “One of the ten best beach cities in the world” - with clear waters and action-packed beaches, each one of Tel Aviv’s 16 beaches has its own style and attracts certain personalities - from hippie casual to Riviera chic. Day or night, hanging out on the beach is one of the best ways to spend the time in Tel Aviv.
  // 					</p>

  // 					<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/posts/2/2.jpg"} class="img-responsive" />
  // 					</div>
  // 					<h3>
  // 					Sensational Nightlife
  // 					</h3>
  // 					<p>
  // 					The Israeli weekend starts on Thursday evening and continues until nearly the crack of dawn on Sunday—when the work week resumes. But pretty much every night is “party night” in Tel Aviv. The city that doesn’t stop keeps going all night long and is constantly buzzing with trendy, vibrant hotspots, home to some of the most epic clubs and parties in the world.
  // 					</p>

  // 					<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/posts/2/4.jpg"} class="img-responsive" />
  // 					</div>

  // 					<br>

  // 					<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/posts/2/5.jpg"} class="img-responsive" />
  // 					</div>

  // 					<br>

  // 					<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/posts/2/6.jpg"} class="img-responsive" />
  // 					</div>

  // 					<br>

  // 					<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/posts/2/7.jpg"} class="img-responsive" />
  // 					</div>

  //          `
  //     }
  //   }
  // },

  {
    id: 5,
    bgImage: "posts/bank/8/1.jpg",
    mobBgImage: "posts/bank/8/M.jpg",
    title: "DIE VEGANE SZENE IN TEL AVIV",
    ctg: "culinary",
    isVid: true,
    vidId: "tNl2QXNOHMk",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                    <h2>Probieren Sie diese Top-Auswahl an veganen Restaurants in Tel Aviv</h2>
					<p>
                          Dieses Jahr hat die Amerikanische Feinschmeckerwebseite The Daily Meal Tel Aviv als Top-Destination für vegane Touristen gekürt. Mit mehr als 400 vegan freundlichen Restaurants werden Sie in Tel Aviv nie hungrig sein müssen.
                        </p>
                        <h3>
                          Nanutschka
                        </h3>
                        <p>
                          2014 hat dieses traditionelle Georgische Restaurant den Wechsel zur veganen Küche gemacht. Jetzt serviert es vegane Georgische Gerichte, wie z.B. traditionelles  georgisches Gebäck gefüllt mit Pilzen anstatt von Rindfleisch.
                        </p>

                        <div class="img-wrapper">
                            <img src=${getImgUrl() +
                              "/posts/6/2.jpg"} class="img-responsive" />
                        </div>

                        <h3>
                           HaSchawarma HaTsimchonit
                        </h3>
                        <p>
                            Das vegane Schawarma ist eine Alternative für Veganer die traditionelle lokale Gerichte probieren möchten. Das scharfe Tofu- und Seitan-“Fleisch” kann in einem Brötchen, Pita, Tortilla, oder Focaccia bestellt werden. Aba Gil ist ein anderes Tel Aviver Restaurant das traditionelles Nahöstliches Essen in veganer Version anbietet.
                        </p>

                        <h3>
                            Buddha Burgers
                        </h3>
                        <p>
                            Diese Kette von veganfreundlichen Hamburger-Restaurants verfügt über Niederlassungen in Haifa und Eilat. Die vielfältige Speisekarte bietet Fast-Food-Favoriten aus der ganzen Welt, darunter indische, italienische und amerikanische Burger und Hot Dogs – natürlich komplett fleischfrei. Sie können sogar einen koscheren (Soja) Cheeseburger bekommen.
                        </p>
                        <h3>
                            Zakaim
                        </h3>

                        <div class="img-wrapper">
                          <img src=${getImgUrl() +
                            "/posts/6/3.jpg"} class="img-responsive" />
                        </div>

                        <p>
                            This boutique restaurant serves innovative dishes prepared with the freshest ingredients. The restaurant uses no plastic products and serves vegan variations on favorites like Caesar salad, stuffed cabbage and freekeh.
                        </p>

                        <p>
                            This restaurant serves up authentic Ethiopian cuisine but vegan-friendly. The delicious teff flour injera bread (gluten-free) will make you fall in love with this style of food. Visit on a Monday night and you’ll be treated to a live jazz performance.
                        </p>


			`,
      };
    },
  },

  {
    id: 13,
    bgImage: "/posts/bank/28/1.jpg",
    mobBgImage: "/posts/bank/28/M.jpg",
    title: "Küche in Jerusalem",
    ctg: "culinary",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <h2>Aufregend, vielfältig und ach so lecker</h2>
					<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/2CSCe2WC7Ns/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->
					<p>
							In Jerusalem gibt es viele lebendige und trendige Restaurants und Unterhaltungsmöglichkeiten. Die Stadt ist vollgepackt mit Bereichen, die hervorragende Möglichkeiten für jede Art von Tag- und Nachtunterhaltung bieten, wo Sie einen herrlichen Abend bei einem guten Essen, einem kühlen Bier oder Tanz zu guter Musik genießen können.
          </p>
          <p>
							In Jerusalem, viele sagen, dass sie für den Hummus kommen, aber wegen die unglaublich vielfältige Küche bleiben. Von traditionellem orientalischen und nordafrikanischen bis hin zu südamerikanischer, asiatischer Fusions- und kontinentaleuropäischer Küche; Vom Streetfood bis zur feine Speisen hat Jerusalem alles zu bieten. Jerusalems große Auswahl an kulinarischen Optionen finden Sie buchstäblich überall; von lokale Delikatessen auf Straßenständen bis hin authentische Restaurants auf den Märkten, und wenn Sie nach dem Gourmet-Erlebnis suchen, können Sie einen Platz in einem der vielen exklusiven Chef-Restaurants der Stadt reservieren.
          </p>

         `,
      };
    },
  },

  //No translation
  // {
  // 	id:10,
  // 	bgImage : "posts/bank/42/1.jpg",
  // 	mobBgImage : "posts/bank/42/M.jpg",
  // 	title: "Kaffee in Tel Aviv",

  // 	ctg:"culinary",
  // 	isVid:true,
  // 	vidId: "rVr0gqFC364",
  // 	smlTitle: "",
  // 	html: function(){
  // 		return {
  // 			__html:`
  // 			<p>
  // 			  Coffee shop culture is fundamental to Tel Aviv. So slow down the pace and soak up the vibe.
  // 			</p>

  // 			`
  // 		}
  // 	}

  // },

  {
    id: 11,
    bgImage: "posts/bank/33/1.jpg",
    mobBgImage: "posts/bank/33/M.jpg",
    title: "Feinschmeckerszene Tel Aviv",
    ctg: "culinary",
    isVid: true,
    vidId: "jfyHxk8ZRrI",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<small style="color:#000; display:block">
                      		A film by VIA TOLILA
                      	</small>\n
			<p>
			   Der perfekte Ort, an dem Sie die bunte Vielfalt der hochkarätigen Restaurants von Tel Aviv genießen können
			</p>
              
			`,
      };
    },
  },

  {
    id: 34,
    bgImage: "/posts/bank/deadsea1/1.jpg",
    mobBgImage: "/posts/bank/deadsea1/M.jpg",
    title: "Vergnügen am Toten Meer",
    ctg: "deadsea",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
            
				    <h2>Für eine schwimmend gute Zeit</h2>
                  <p>
                    Ein geologisches Wunder in einer einzigartig ruhigen Umgebung – das Tote Meer ist eine sehr beliebte Touristenattraktion. Erleben Sie die Ruhe des Wassers mit seinen einzigartigen heilenden Eigenschaften und genießen Sie die unvergleichliche Schönheit der umliegenden Landschaft. <strong>Das Tote Meer, auch bekannt als das älteste natürliche Heilbad der Welt, ist mit einer extrem hohen Salzkonzentration von 31,5% gesegnet, was Touristen von nah und fern das erstaunliche Erlebnis ermöglicht, mühelos auf den Gewässern des niedrigsten Ortes der Erde zu schweben. Während Sie hier sind, können Sie auch im gesunden schwarzen Schlamm der Gegend baden</strong> oder die faszinierende und historisch reiche Landschaft in der Umgebung erkunden.
                  </p>

                  <p>
                      Luxuriöse Hotels, eine abwechslungsreiche Küche von Gourmet-Restaurants bis hin zu Fastfood-Restaurants, großartige Souvenirläden, die außergewöhnliche Geschichte der nahegelegenen Festung Masada und viele kulturelle Aktivitäten während des ganzen Jahres machen das Tote Meer zu einem beliebten Ziel für Touristen und internationale Besucher.
                  </p>
				
            	 `,
      };
    },
  },

  {
    id: 22,
    bgImage: "/posts/bank/43/1.jpg",
    mobBgImage: "/posts/bank/43/M.jpg",
    title: "Susshuka Zeit",
    ctg: "culinary",
    isVid: true,
    vidId: "n4kCnPXEX7g",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h2>
				Lerne Sie, wie man das weltberühmte Shakshuka-Gericht zubereitet!</h2>
				<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/n4kCnPXEX7g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->

      		<p>
					Wenn man Leute fragt, die Tel Aviv und Jerusalem besuchen, was war ihr Lieblingsgericht, dass sie auf ihrer Reise probiert haben, die Antwort wird meistens Shkshuka sein. Diese mediterrane Delikatesse, ein definitiver lokaler Favorit, ist im Wesentlichen ein Gericht aus Eiern, die in einer Sauce aus Tomaten, Chilischoten und würzigen Zwiebeln pochiert werden und oft mit Brot und Tahini serviert werden. Natürlich gibt es viele Variationen zu diesem Gericht nach lokalen Stilen und Geschmäcken und es wird normalerweise zum Frühstück oder Brunch serviert, wobei Sie feststellen werden, dass es auch für ein fantastisches Abendessen sorgt.
      		</p>
      		<p>
					Die beste Art, Shakshuka zu essen, ist definitiv unter der fantastischen ganzjährigen Sonne von Tel Aviv oder Jerusalem, während Sie eine erstaunliche Städtereise voller Aromen und unvergesslicher Erlebnisse genießen.
      		</p>
      		<p>
					Sollten Sie jedoch Lust auf selbstgemachtes haben und den Geschmack des sensationellen Shakshuka in Ihrer eigenen Küche nachmachen wollen, so wirds gemacht:
      		</p>
      		<h3>
            Zutaten
          </h3>
          <ul>
             <li>2 Esslöffel Olivenöl</li>
             <li>1 Zwiebel, gehackt</li>
             <li>1 rote Paprika, entkernt und gewürfelt</li>
             <li>4 Knoblauchzehen, gehackt</li>
             <li>2 Dosen gewürfelter Tomaten</li>
             <li>6 Eier</li>
             <li>2 Esslöffel frischer Koriander, gehackt</li>
             <li>¾ Teelöffel Salz</li>
             <li>1 Teelöffel Paprika</li>
             <li>¼ Teelöffel schwarzer Pfeffer</li>
             <li>•	1 Jalapeno (optional)</li>
          </ul>
          <h3>
             Anleitung
          </h3>
          <ol>
              <li>Ofen auf 375 Grad vorheizen, während Sie warten.</li>
              <li>Erhitzen Sie das Olivenöl in einer schweren ofenfesten Pfanne bei mittlerer Hitze. Fügen Sie Zwiebel, Paprika und Jalapeno hinzu und braten Sie, bis Zwiebeln durchsichtig sind.</li>
              <li>Fügen Sie Knoblauch und Paprika hinzu. Fügen Sie Tomaten, Salz und schwarzen Pfeffer hinzu.</li>
              <li>Zum Kochen bringen und Hitze reduzieren. Kochen Sie für 10-15 Minuten.</li>
              <li>Erstellen Sie 6 kleine Leerfelder in der Sauce und knacken Sie vorsichtig jedes Ei in die Leerfelder.</li>
              <li>Stellen Sie die Pfanne in den vorgeheizten Ofen und garen Sie, bis die Eier weiß sind - ungefähr 10 Minuten.</li>
              <li>Vor dem Servieren Koriander als Beilage hinzufügen.</li>
              <li>Mit Brot und Tahini servieren und genießen! </li>
          </ol>

         `,
      };
    },
  },

  {
    id: 5,
    ctg: "jerusalem",
    isVid: true,
    // vidId: "MXtcTm_JXus",
    vidId: "V0Acsw3Hf_M",

    bgImage: "/posts/bank/30/1.jpg",
    mobBgImage: "/posts/bank/30/M.jpg",
    title: "Einkaufsfreuden",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h2>Andenken aus Jerusalem. Was wäre ein Besuch in Jerusalem ohne ein tolles Shopping-Erlebnis?</h2>
				  	<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/V0Acsw3Hf_M/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->
					<p>
                            Es gibt in Jerusalem mehrere Gegenden mit Shoppingpromenaden und ebenfalls einige Einkaufszentren. Wenn Sie in Jerusalem shoppen gehen, können Sie sich sicher sein für jedes Budget immer das Richtige zu finden.
                        </p>

                        <h3>
                            Im STADTZENTRUM: BEN YEHUDA UND BENACHBARTE STRASSEN
                        </h3>
                        <p>
                            Das gesamte Stadtzentrum von Jerusalem ist mittlerweile eine große Fußgängerzone. Der Kern des Stadtzentrums ist die Ben-Yehuda-Straße, eine Fußgängerzone voller Geschäfte und Restaurants. Durch die Sanierung der Straße vor einigen Jahren, entstand eine einladende Gegend mit neu gepflasterten Fußwegen aus Meleke, eleganten Laternenmasten, erhöhten Sitzmöglichkeiten und einem  kleinen Springbrunnen. Die Straßen in der Umgebung wurden ebenso mit schicken, grau gekachelten Fußwegen und denselben eleganten Laternenmasten wie auf der Ben-Yehuda-Straße saniert. Diese Sanierungsarbeiten wurden übrigens alle in Vorbereitung auf den Start der städtischen Lightrail Straßenbahn auf der Jaffastraße durchgeführt.
                        </p>

                        <p>
                            In Anbetracht der großen sanierten Gegend, ist eigentlich jede der Straßen im Zentrum einen Besuch wert, wenn Sie in Jerusalem shoppen gehen: Die Shatzstraße, die King-George-Straße, die Hillelstraße, die Ben-Yehuda-Straße, die Jaffastraße, die Yoel-Salomon-Straße und all ihre benachbarten Straßen. Tip: freitags sollten Sie tagsüber dem Künstlermarkt auf den Shatz und Betzalel Straßen einen Besuch abstatten – ein ausgezeichneter Ort um Jerusalemer Geschenke von lokalen Kunsthandwerkern zu erstehen.
                        </p>

                        <p>
                            Die Ben-Yehuda-Straße selbst ist ein Hügel, der die King-George-Straße an ihrem oberen Ende und die Jaffastraße an ihrem unteren Ende verbindet, wo sie sich schließlich dem Zionplatz (Kikar Zion) öffnet. Highlights auf der Ben Yehuda sind unter anderem die Zweige von zwei bekannten israelischen Geschäftsketten: Zum einen die Schönheits- und Pflegeprodukte des Toten Meeres von Ahava und die von Teva-Naot angebotenen Qualitätslederschuhe. Die Ben-Yehuda-Straße ist außerdem ein guter Ort um Judaika und christliche Souvenirs zu guten Preisen zu erstehen – hier sollten Sie auf jeden Fall verhandeln! In diesem Viertel finden Sie außerdem praktische Gegenstände des täglichen Gebrauchs, von Hüten und Schirmen bis hin zu elektronischen Geräten.
                        </p>

                        <p>
                            Am Fuße der Ben-Yehuda-Straße, am Zionplatz, befindet sich das neu errichtete HaMashbir LaTzarchan Kaufhaus (auch als ‘HaMashbir’ bekannt), wo sich das umfangreiche Angebot auf mehreren Etagen erstreckt. In der Nähe des Zionplatzes ist außerdem der Juwelier Baltinester (auf der Jaffa Straße), der für seine bestellbaren gravierten Namensketten bekannt ist. Vom Zionplatz gelangen Sie zudem direkt in das Viertel Nachalat Shiva, wo Sie insbesondere auf der Yoel Salomon Straße zahlreiche Töpfereien, Juweliere, kleine Künstlerläden und Boutiquen finden können.
                        </p>

                        <div class="img-wrapper">
                          <img src=${getImgUrl() +
                            "/posts/5/2.jpg"} class="img-responsive" />
                        </div>

                        <h3>
                          MAMILLA EINKAUFSZENTRUM & DER CARDO in DER ALTSTADT: GEHOBENES SHOPPING
                        </h3>

                        <p>
                           Wenn Sie sich vom Ben-Yehuda-Viertel Richtung Altstadt wegbewegen, treffen Sie auf die ausgesprochen edle Alrov Mamilla Shoppingmeile, deren stilvolle Architektur zum Flanieren an der frischen Luft einlädt. Sie beginnt am Mamilla 5-Sternehotel und zieht sich bis zum Jaffator, am Eingang der Altstadt. Hier sind renommierte internationale Marken wie Versace, H. Stern, Nike und Gap ebenso zu finden, wie hochwertige Judaika-Geschenke. Die noble Mamilla Shoppingmeile stellt außerdem regelmäßig Kunstwerke aus, bietet in ihrem Amphitheater Livemusik an und ist Sponsor von familienfreundlichen Events und Aktivitäten, insbesondere zur Ferienzeit. Werfen Sie einfach einen Blick in unseren <a href="//www.itraveljerusalem.com/de/eventcategory/cat_events_de/" target="_blank"><strong>Veranstaltungskalender</strong></a> für weitere Informationen.
                        </p>
                        <h3>
                           DAS JERUSALEMer MALCHA EINKAUFSZENTRUM
                        </h3>
                        <p>
                           Das Jerusalemer Malcha Einkaufszentrum ist eine solide Wahl für jeden, der lieber etwas außerhalb der Innenstadt einkaufen gehen möchte, sowie auch für Familien die es nach drinnen zieht. Das Jerusalem Malcha Einkaufszentrum ist zwar mittlerweile schon über 20 Jahre alt, wurde aber zum Zeitpunkt seiner Einweihung als ‘Größtes Einkaufszentrum im Nahen Osten’ bezeichnet. Heute hat das Malcha Einkaufszentrum definitiv seinen Platz als den größten Zusammenschluss von Geschäften in Jerusalem sicher. Insgesamt stehen hier über 250 Geschäfte zur Auswahl.
                        </p>

                        <p>
                           Das Einkaufszentrum beherbergt internationale und israelische Geschäfte, die eine Preisspanne von relativ niedrig über mittlere Budgets bis hin zu exklusiv und hochpreisig umfassen. Weltbekannte Markennamen wie H&M, Zara, Home Depot und Toys’R’Us haben hier Zweigstellen. Mehrere israelische Warenhäuser für verschiedenste Budgets sind hier vertreten, darunter auch eine Zweigstelle vom HaMashbir LaTzarchan Warenhaus (das selbe wie auch auf dem Zionplatz) und der Mega Supermarkt. Außerdem finden sich hier praktische Anlaufpunkte wie eine Synagoge, ein Postamt und eine Zweigstelle der Bank Hapoalim. Für die Verpflegung gibt es auf dem Food Court eine breite Auswahl an Lokalen und Imbissen, die allesamt koscher sind.
                        </p>

                        <p>
                           Zu den Freizeitaktivitäten gehört im Winter eine Eislaufbahn sowie Unterhaltungsangebote und Handwerksworkshops in der Ferienzeit – schauen Sie in unseren Veranstaltungskalender, um Ihren Ausflug zu planen. Zusätzlich gibt es im Shilav Babygeschäft ein Spiel- und Lerncenter für Kinder bis zu sechs Jahren. Das Malcha Einkaufszentrum ist in wenigen Minuten mit dem Bus vom Stadtzentrum aus, oder mit dem Taxi aus ganz Jerusalem zu erreichen.
                        </p>

                        <div class="img-wrapper">
                           <img src=${getImgUrl() +
                             "/posts/5/3.jpg"} class="img-responsive" />
                        </div>

                        <p>
                          Activities include an indoor ice skating rink during winter, and entertainment and crafts workshops during holiday seasons – check our&nbsp;<a href="//www.itraveljerusalem.com/jerusalem-events" target="_blank"><strong>events schedule</strong></a>&nbsp;to plan your outing. In addition, the Shilav baby store has a gymboree area good for ages up to six. <br>
                          Malcha Mall is an easy bus ride from center city or cab ride from anywhere.
                        </p>

                        <h3>
                            DER ARABISCHE SUQ IN DER ALTSTADT
                        </h3>
                        <p>
                             Wenn Sie auf der Suche nach authentischen, lokalen Produkten sind, ist der arabische Suq in der Altstadt genau das richtige für Sie. Betreten Sie die Altstadt durch das Jaffator um zu dem im muslimischen und christlichen Vierteln gelegen Suq zu gelangen. Gehen Sie vom Jaffator aus, direkt auf das muslimische Viertel zu. Wenn Sie dann hoch aufgehängte Kleider und Gewänder sehen, wissen Sie, dass Sie am richtigen Ort sind. Man könnte es auch „Klein Istanbul“ nennen – der arabische Suq in der Altstadt ist einfach ein typischer nahöstlicher Markt, in dem die heimische Kunstfertigkeit sich besonders bei der Kleidung und beim Essen zeigt. Sie finden hier auch christliche, jüdische und muslimische Souvenirs, oft zu einem günstigeren Preis als auf der Ben-Yehuda-Straße – das hängt ganz von Ihrem Knowhow und Ihren Verhandlungsfähigkeiten ab (Tip: Starten Sie bei der Hälfte des zuerst angebotenen Preises).
                        </p>
                        <p>
                            Im arabischen Suq bekommen Sie einen Eindruck davon wie es früher einmal war. Händler sind bereits seit Jahrtausenden tagein, tagaus in den engen Gässchen der Altstadt aktiv und die Würde dieses jahrhundertealten nahöstlichen Marktplatzes ist etwas Unerreichtes; in der westlichen Kultur im Allgemeinen und sogar ganz konkret innerhalb Israels.
                        </p>
                        <h3>
                             DerMAHANE YEHUDA Suq (MARKT)
                        </h3>

                        <p>
                            Der Mahane Yehuda Markt (oder Suq) ist hauptsächlich für sein Angebot von lokalem Jerusalemer Essen – frische Erzeugnisse und Nüsse, Bäckereien (beispielweise die Bäckerei ‘Marzipan’) und Schawarma- und Falafel-Lokale bekannt. Innerhalb der letzten Jahre haben sich die Lokale auf dem Mahane Yehuda Markt in eine noble Richtung entwickelt, so dass sich hier mittlerweile spezialisierte Wein- und Käsegeschäfte, Bio-Märkte, vegetarische Restaurants und sogar eine Zweigstelle der internationalen israelischen Kette Café Aroma tummeln. Zusätzlich zum Essen, finden Sie hier Geschenke, die Sie nach Hause mitbringen können, darunter Judaika, Schmuck und Töpferwaren. Sie können außerdem Elektronik, Handys und Zubehör sowie günstige Bekleidung finden, darunter Levi’s Jeans für rund 10 Euro (sie sehen jedenfalls wie Levi’s aus). Auch mit der Verwandlung hin zu einem etwas nobleren Ort der letzten Jahre, ist einfach nicht an der absolut authentischen und bodenständigen Jerusalemer Atmosphäre des Mahane Yehuda Marktes zu rütteln und das macht den Mahane Yehuda Suq einfach zu einem Muss.
                        </p>

                        <h3>
                            ZUsammenfassung
                        </h3>
                        <p>
                            Insgesamt spiegelt das Shoppingangebot in Jerusalem die Stadt selbst wieder: Hier gibt es das gesamte Spektrum von antik bis modern, mit vielen Optionen vom kleineren Budget bis hin zum gehobenem Shopping. Sie werden sehen, Shopping in Jerusalem ist auf jeden Fall eine aufregende und vielfältige Erfahrung.
                        </p>

         `,
      };
    },
  },

  {
    id: 17,
    ctg: "telaviv",
    isVid: true,
    // vidId: "LLOUxE-K_9Y",
    vidId: "tgF0zMUYY2g",
    bgImage: "/posts/bank/37/1.jpg",
    mobBgImage: "/posts/bank/37/M.jpg",
    title: "Absolutes Muss in Tel Aviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<H2>Top 5 Stätten, die Sie in der Nonstop-Stadt nicht verpassen wollen</H2>
					<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/tgF0zMUYY2g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->
					<h3>
            Die Altstadt von Jaffa
          </h3>
          <p>
						Obwohl es sich um Tausende von Jahren handelt, ist ein Besuch in der Altstadt von Jaffa immer eine aufregende Entdeckung. Bezaubernde verwinkelte Gassen, durchzogen mit Kunstgalerien, historischen Gebäuden, außergewöhnlichen Sehenswürdigkeiten und einer Vielzahl von uriger authentischer Restaurants. Eine Tour durch das alte Jaffa ist eine beeindruckende Erfahrung, ein absolutes Muss für jeden Touristen, der Israel besucht.
          </p>
          <h3>
						Jaffa-Hafen
          </h3>
          <p>
						Der Hafen von Jaffa, der als einer der ältesten Häfen der Welt gilt, diente schon seit Jahrtausenden Fischern, Seeleuten, Kaufleuten, Kreuzfahrern, Eroberern und Einwanderern. Heute dient der Hafen weiterhin als Fischereihafen und wird auch als städtische Attraktion renoviert und bietet Kultur- und Freizeitaktivitäten, Shopping und Tourismus unter Beibehaltung seines einzigartigen historischen und faszinierenden Charakters.
          </p>
          <h3>
						TA - Hafen
          </h3>
          <p>
						Kürzlich restauriert, hat das trendige Hafengebiet wirklich alles. Während des Tages können Sie durch bemerkenswerte Hänger-Stil-Räume für Marken- und Boutiquen-Shopping wandern und eine Mahlzeit teilen in Restaurants mit herrlichem Meerblick und an vielen Aktivitäten für die ganze Familie teilnehmen. Jede Nacht strömen unzählige Clubgänger durch das Stadtgebiet, dass sich zu einem der beliebtesten Hotspots der Stadt mit einigen der coolsten Clubs und Bars in Tel Aviv entwickelt.
          </p>
          <h3>
						Die weiße Stadt
          </h3>
          <p>
						Begeben Sie sich auf eine faszinierende Tour durch die "Weiße Stadt" von Tel Aviv und entdecken Sie, warum sie zum UNESCO-Weltkulturerbe erklärt wurde. Die Weiße Stadt beheimatet auch die weltweit größte Ansammlung von Gebäude im Internationalen Stil, dass auch als Bauhaus-Stil bekannt wurde. Das Viertel "Weiße Stadt", dass zu seinem ursprünglichen Glanz restauriert wurde, ist ein wahrhaft einzigartiger und unvergesslicher architektonischer Schatz.
          </p>
          <h3>
             Neve Tzedek
          </h3>
          <p>
						Machen Sie eine Pause von der Hektik des Tel Avivs; Dieses versteckte Juwel eines Viertels besticht durch seinen wunderschönen orientalischen Architekturstil und die bezaubernden engen Gassen, die das Viertel Neve Tzedek, (was wörtlich übersetzt "Oase der Gerechtigkeit" bedeutet), zu einer wahren Oase inmitten der hektischen Großstadt machen.
					</p>

         `,
      };
    },
  },

  {
    id: 88,
    bgImage: "/posts/bank/18/1.jpg",
    mobBgImage: "/posts/bank/18/M.jpg",
    title: "Die Nachtklubs Von Tel Aviv",
    ctg: "telaviv",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    // vidId:"WKfjMATNH8Q", - this is an old youtube video
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <h2>Finden Sie die besten Plätze in Tel Aviv, wo rund Tel Aviv Portsum die Uhr gefeiert wird und die Musik nie verstummt</h2>
					<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/WKfjMATNH8Q/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->

					<p>
						Du hast das kulturelle Leben von Tel Aviv nicht wirklich kennengelernt, bevor Du bis zum Sonnenaufgang in einem der berühmten Nachtklubs durchgetanzt hast.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/2.jpg"} class="img-responsive" />
					</div>

					<p>
                        <strong>HaOman 17 (88 Abarbanel St.)</strong> – In diesem unvergleichliche Mega-Club toben sich internationale DJs auf mehreren Tanzflächen aus, und jede Nach findet eine andere Art von Party statt.
                    </p>

					<p>
                    	<strong>Dizingoff (Dizingoff Square)</strong> – Ein echter Mega-Club mit wunderschönen Gästen und viel Mainstream-Musik.
                    </p>

                    <p>
                    	<strong>Cat and Dog (23 Carlibach St.) </strong> – Nichts für Zartbesaitete, denn hier beginnt die Party erst richtig, wenn andere Klubs ihre Türen schließen. Die Musik ist so vielseitig wie die Gäste.
                    </p>

                    <p>
                    	<strong>Biggy-Z (18 Bugrashov St.)  </strong> – Inspiriert vom Mardi Gras in New Orleans, mit Innen- und Außenbereich sowie einer sehr beliebten Nachfüllpolitik für die Besucher, die dass Armband des Klubs kaufen.
                    </p>

                    <p>
                    	<strong>Dream Exhibition (30 Ibn Gvirol St.)   </strong>– Ein eleganter Klub mit allen modernen Komforts. Hier tanzen die über 23-Jährigen zu Rock, Mainstream und House-Musik.
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/3.jpg"} class="img-responsive" />
					</div>

					<p>
                    	<strong>Valium (1 Ben Yehuda St.) </strong> – Ein Luxus-Nachtklub in großzügigen Räumlichkeiten im obersten Geschoss des Magdalor-Gebäudes. Genieße die Musik auf der Tanzfläche oder dem ruhigeren Dach.
                    </p>

                    <p>
                    	<strong>KTOVT (Mikveh Israel)  </strong> – Ein alternativer Klub mit interessantem Dekor und Musik von internationalen und lokalen DJs für diejenigen, die einfach nur tanzen möchten.
                    </p>

                     <p>
                    	<strong>The Block (157 Salame St.) </strong>  –  Techno-Trance ist die Musikrichtung der Wahl in diesem Klub, der für sein Soundsystem der Spitzenklasse berühmt ist.
                    </p>


                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/4.jpg"} class="img-responsive" />
					</div>

					<p>
                    	<strong>Kuli Alma (10 Mikveh Israel St.) </strong>  – In diesem künstlerischen Treffpunkt mit Innen- und Außenbereichen wird lokale Kunst ausgestellt, es gibt vegetarische Speisen und unterschiedliche Musikrichtungen.
                    </p>

                    <p>
                    	<strong>Schwule Nachtklubs – Das Evita (31 Yavne St.) </strong>  ist für alle Mitglieder der LGBT-Community da. Ein reiner Männerklub ist die
                    </p>

                 	<p>
                    	<strong>Apolo Bar (Allenby 46),  </strong>  und im
                    </p>

                     <p>
                    	<strong>Barvaz (Ha’Mehoga 10)  </strong> bleiben Frauen unter sich. Das
                    </p>

                     <p>
                    	<strong>Amazona (23 Lilienblum St.) </strong> öffnet seine Türen für alle über 23-Jährigen.
                    </p>
         `,
      };
    },
  },

  {
    id: 10,
    bgImage: "/posts/bank/12/1.jpg",
    mobBgImage: "/posts/bank/12/M.jpg",
    ctg: "telaviv",
    isVid: false,
    title: "Zeit für etwas Kultur",
    smltitle: "",
    html: function() {
      return {
        __html: `

					
                     <h2>Die Museen Von Yel Aviv. Tel Aviv bietet eine große Anzahl von Museen zu einer Vielfalt von Themen</h2>
				     <h3>
                               Tel-Aviv Museum of Art
                        </h3>
                        <p>
                                Das Tel Aviv Museum of Art präsentiert eine Vielfalt an permanenten und temporären Ausstellungen im Helena Rubenstein Pavillon am Shaul Hamelech Boulevard, direkt neben dem Mann Auditorium. Die permanente Ausstellung beinhaltet einige der besten israelischen Kunstwerke, sowie Skulpturen von den 1920ern bis Heute. Das Museum bietet europäische Kunstwerke – Impressionismus und Post-Impressionismus – vom 16ten bis zum 19ten Jahrhundert, sowie europäische und amerikanische Arbeiten aus dem 20ten Jahrhundert. Die graphische Sammlung des Museums beinhaltet mehr als 20.000 Drucke und Zeichnungen. Unter den vielen ausgezeichneten Arbeiten des Museums ist auch eine einzigartige Auswahl an frühen gemalten Reliefs von Alexander Archipenko und Arbeiten von Chagall, die er dem Museum vor seiner Gründung gespendet hat. Helena Rubinsteins bekannte Kollektion von Miniatuzimmern ist im, nach ihr benannten Pavillon, dauerhaft ausgestellt.

                               7716408316_f5987e72cc_z
                        </p>
                        <h3>
                                ÖFFNUNGSZEITEN:
                        </h3>
                        <p>
                                So geschlossen <br/>

                                Mo, Mi, Sa 10:00-18:00<br/>

                                Di, Do 10:00-22:00<br/>

                                Fr 10:00-14:00<br/>

                                Sa 10:00-16:00 (Juli-August am Sa geschlossen)
                        </p>

                        <p>
                                <a href="//www.tamuseum.org.il/en/default.aspx" target="_blank"><strong>www.tamuseum.org.il</strong></a>
                        </p>

                        <h3>
                                 Beit Hatfutsot: Das Diaspora Museum

                        </h3>

                        <p>
                                 Beit Hatefutsot – Das jüdische Diaspora Museum am Campus der Universität Tel Aviv gelegen, hat als das erste Museum der Geschichte des jüdischen Volkes, das den jüdischen Beitrag zur menschlichen Kreativität und Kultur über einen Zeitraum von mehr als 2000 Jahren ausstellt, Ehrenauszeichnungen aus der gesamten jüdischen Welt erhalten. Die permanente Ausstellung des Museums bringt durch Zeichnungen, Videoclips, Filme, rekonstruierte Modelle und andere Mittel, die Geschichte des jüdischen Volkes während der Diaspiora zum Leben. Die Ausstellung konzentriert sich auf verschiedene Themen – darunter “Der Lebenszyklus der jüdischen Familie”, “Gemeinschaft”, “Glauben” und “die Rückkehr nach Zion”.
                        </p>

                        <p>
                                 <a href="//www.bh.org.il/" target="_blank">Beit Hatfutsot: The Diaspora Museum</a>
                        </p>

                       <div class="img-wrapper">
                                 <img src=${getImgUrl() +
                                   "/posts/10/2.jpg"} class="img-responsive" />
                       </div>

                        <p>

                                  For more information, click to the&nbsp;<a href="//www.bh.org.il/" target="_blank">Beit Hatfutsot: The Diaspora Museum</a>

                       </p>

                       <h3>
                                 Eretz Israel Museum
                        </h3>
                        <p>
                                  Das Eretz Israel Museum Tel Aviv ist eine multidisziplinäre Institution. Es präsentiert die Geschichte des Landes und seiner Kultur in einer umfangreichen Dauerausstellung, zusätzlich zu einer Vielzahl von temporären Ausstellungen zu Themen wie Archäologie, Ethnographie, Folklore, Judaica, Kulturgeschichte, lokaler Identität, traditionellem Handwerk und funktionaler Kunst. Die Pavillons des Museums sind über einem großen Innenhof verstreut, in dessen Mitte der antike Ausgrabungshügel Tel Kassile, bei dem Ausgrabungen wertvolle Artefakte hervorbrachten, liegt. Das Museum beherbergt eine Vielzahl von rekonstruierten alten Produktionseinrichtungen, einschließlich Weinpressen, einer Ölpresse und einer Getreidemühle, zusammen mit einem “Handwerker Marktplatz”, der traditionelle Arbeitsinstrumente zeigt, die in Eretz Israel und der gesamten Region verwendet wurden. Es gibt auch ein modernes Planetarium mit einem “Reise zum Universum” Programm und einen Museumsshop, der eine einzigartige Auswahl an lokal produzierten Geschenken und Verzierungen anbietet.
                                  <br/>
                                  ÖFFNUNGSZEITEN: <br/>

                                  So-Mi 10:00-16:00 <br/>

                                  Do 10:00-20:00 <br/>

                                  Fr-Sa 10:00-14:00
                        </p>
                        <p><strong>&nbsp;</strong><a href="//www.eretzmuseum.org.il/e/" target="_blank">Eretz Israel Museum&nbsp;</a></p>
                        <h3>
                                  Beit Ha’ir
                        </h3>
                        <p>
                                    Das von der Stadtverwaltung renovierte Beit Ha’ir, war einmal das Rathaus von Tel Aviv-Jaffa in der Bialikstrasse und dient heutzutage als lebendige Ausstellung zur Geschichte der Stadt. Beit Ha’ir hat eine neue Ausstellung, die die umfangreiche Sammlung von Fotos und Geschichten über Geschehnisse, Orte und Erfahrungen der Anwohner, die sich im Laufe der Jahre angesammel haben, zusammenfasst. Das Projekt war sogar ein Teil der Hundertjahrfeier der Stadt. Der große Saal verfügt über eine visuelle Ausstellung mit hunderten von Dokumentarfilmen und tausenden an seltenen Fotos und Dokumenten welche die wichtigsten Ereignisse der ersten Jahre der Stadt zeigen. Im Beit Ha’ir können Sie auch das Dizengoff Haus, die restaurierte Residenz von Tel Aviv-Jaffas erstem Bürgermeister Meir Dizengoff besuchen. Auch hier gibt es eine Dauerausstellung zu besuchen.
                                    <br/>
                                    ÖFFNUNGSZEITEN:
                                    Sun Closed

                                    Mo-Do 9:00-17:00 <br/>

                                    Fr-Sa 10:00-14:00<br/>
                        </p>

                        <p> <a href="//beithair.org" target="_blank">Beit Ha’ir</a></p>

                        <h3>
                                    Das Olympic Experience Museum
                        </h3>
                        <p>
                                    Das Olympic Experience Museum, ein neues Museum in Tel Aviv-Jaffa, bietet eine einstündige Reise durch die besten olympischen Rekorde, mit einem besonderen Fokus auf Israels größten Momente. Die Olympia-Erfahrung bietet State-of-the-Art High-Tech-Imaging und Illustrationen, audio-visuelle Präsentationen, Hologramme, interaktive Bildschirme  und vieles, vieles mehr. <br/>

                                    Führungen für Gruppen alle 30 Minuten. Es wird empfohlen im Voraus Reservierungen aufzugeben.

                                    <br/>
                                    Öffnungszeiten: Sonntag-Donnerstag: 10:00-18:00, Freitag:  10:00-14:00
                                    <br/>
                                    The Olympic Experience, 6 Shitrit Strasse, Hadar-Yosef. Tel: +972-3-6498385
                        </p>

                        <p><a href="//www.olympic.one.co.il/General/Page.aspx?id=86&amp;siteid=2" target="_blank">The Olympic Experience Museum</a></p>
                        <h3>
                                    Ilana Goor Museum in Jaffa
                        </h3>
                        <p>
                                    Ilana Goor Museum in Jaffa
                                    The private home of this world renowned artist has been turned into a museum. You can see her sculptures, furniture, jewelry and get a glimpse into this unique Jaffa home <br/>
                                    OPENING HOURS: <br/>
                                    Sun-Fri 10:00-16:00 <br/>
                                    Sat 10:00-18:00<br/>
                                    <a href="//www.ilanagoormuseum.org/eng/">www.ilanagoormuseum.org</a>
                        </p>

                        <h3>
                                     Palmach Museum
                        </h3>
                        <p>
                                    Die Privatwohnung der weltbekannten Künstlerin wurde in ein Museum umgewandelt. Hier können Sie ihre Skulpturen, Möbel undSchmuck sehen und bekommen einen Einblick in dieses einzigartige Haus in Jaffa.
                                    <br/>
                                    ÖFFNUNGSZEITEN:
                                    So-Fr 10:00-16:00 <br/>
                                    Sa 10:00-18:00
                                    <a href="www.ilanagoormuseum.org">www.ilanagoormuseum.org</a>
                        </p>
                        <h3>
                                    Palmach Museum
                        </h3>
                        <p>
                                    Dieses Museum wurde von Trip Advisor als DAS Top Museum in Tel Aviv gewählt. Hier dreht sich alles um den Palmach, den militärischen Arm der Zionistischen Bewegung, der bis zur Gründung des Staates Israel aktiv war.
                        </p>
                                    <a href="info.palmach.org.il">info.palmach.org.il</a>


                        <h3>
                                     Andere einzigartige Museen
                        </h3>
                        <p>
                                     In Tel Aviv-Jaffa gibt es eine Vielzahl an kleineren, auf bestimmte Themen spezialisierte Museen, wie zum Beispiel das Beit Ben Gurion (Das David Ben Gurion, Israels erstem Premierminister), Beit Hatanach (Das Haus der Bibel), Das Haganah (Verteitigungs-) Museum, Das I.Z.L. (die Irgun Tzwa’i Le’umi – Nationale Militärorganisation) Museum, Beit Hasofer (Haus des Autors), Beit Reuven, Das Jabotinsky Museum, und viele andere. Jedes dieser kleinen Museum ist eine Fundgrube für Artefakte. Zum Beispie: Beit Bialik, das Haus des israelischen Nationalpoeten, stellt die Bücher, Möbel und Habseligkeiten von Israels renommierten nationalen Dichter aus. Bialiks persönliche Bibliothek, die mehr als 3000 Bücher umfasst, ist ebenso erhalten geblieben und die Archive des Museums beinhalten tausende an Manuskripten, inklusive der umfangreichsten Sammlung seiner Arbeiten.
                        </p>

                        <h3>
                                     ÖFFNUGSZEITEN VON MUSEEN IN TEL AVIV:
                        </h3>
                        <p>
                                    Etzel Museum: <br/>
                                    King George 38: So-Do 8:30-16:00 <br/>
                                    <a href="www.goisrael.com">www.goisrael.com</a>
                        </p>
                        <h3>
                                     Ben Gurion Haus:
                        </h3>
                        <p>
                                     So, Di-Do 8:00-15:00<br/>

                                      Mo 8:00-17:00<br/>

                                      Fr 8:00-13:00<br/>

                                      Sat 11:00-14:00<br/>
                                      <A HREF="www.bg-house.org">www.bg-house.org</A>
                        </p>

                        <h3>
                                       Jabotinsky Institut in Israel:
                        </h3>
                        <p>
                                      So-Do 8:00-16:00
                        </p>
                                      <a href="//en.jabotinsky.org">en.jabotinsky.org</a>

                        <h3>
                                      Das Israel Museum:
                        </h3>
                        <p>
                                      So, Mo, Mi 9:00-17:00<br/>
                                      <br/>
                                      Di, Do 9:00-19:00
                                      <br/>
                                      Fr 9:00-14:00
                                      <br/>
                                      <A href="//www.imj.org.il">www.imj.org.il</A>
                        </p>
                        <h3>
                                      Jaffa Besucherzentrum:
                        </h3>
                        <p>
                                      Sommer So-Do, Sat 9:00-20:00<br/>

                                      Fr 9:00-17:00<br/>

                                      Winter So-Do, Sat 9:00-18:00<br/>

                                      Fr 9:00-15:00<br/>
                                      <a href="//www.touristisrael.com">www.touristisrael.com</a>
                        </p>

                        <h3>
                                      Dizengoff Hause:
                        </h3>
                        <p>
                                      So-Do 9:00-17:00<br/>
                                      <br/>
                                      Fr 9:00-14:00<br/>
                                      <a href="//eng.ihi.org.il">eng.ihi.org.il</a>
                        </p>
                        <h3>
                                      Das Bibel Museum:
                        </h3>
                        <p>
                                      So-Fr 10:00-13:00 + 16:00-18:30 <br/>
                                      <a href="//www.blmj.org">www.blmj.org</a>
                        </p>
                        <h3>
                                      Joseph Bau Haus:
                        </h3>
                        <p>
                                      Nur mit Termin (auch am Wochenende)
                        </p>
                                      <a href="//www.josephbau.com">www.josephbau.com</a>
                        <h3>
                                      Rubin Museum:
                        </h3>
                        <p>
                                      So geschlossen <br/>

                                      Mo, Mi, Do 10:00-15:00<br/>
                                      <br/>
                                      Di 10:00-20:00
                                      <br/>
                                      Sat 11:00-14:00
                                      <br/>
                                      <a href="//www.rubinmuseum.org.il">www.rubinmuseum.org.il</a>
                        </p>
                        <h3>
                                      Kunstgalerien
                        </h3>
                        <p>
                                      Verpassen Sie nicht die dutzenden von edlen Galerien, die hauptsächlich entlang der Gordon Street und in der Altstadt von Jaffa gelegen sind. Hier finden Sie das Allerneueste an zeitgenössischer israelischer Kunst. Und jetzt sagen wir nichts mehr – jetzt lassen wir die Kunst für sich selbst sprechen.
                        </p>

         `,
      };
    },
  },

  {
    id: 99,
    bgImage: "/posts/bank/20/1.jpg",
    mobBgImage: "/posts/bank/20/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    vidId: "k4OwoEk5wMw",
    title: "Das Spirituelle Jerusalem",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h2>Die Wichtigsten Sehenswurdigkeiten In Jerusalem. Entdecken Sie die Jahrtausende alte Geschichte</h2>
					<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/k4OwoEk5wMw/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->
					<p>
             Wie in jeder Stadt lässt sich der Charme und der Charakter von Jerusalem am besten zu Fuß in den Straßen erkunden. Je nach Ihren persönlichen Interessen sollten Sie aber einige der folgenden Sehenswürdigkeiten auf keinen Fall auslassen.
            Bei Besuchen religiöser Orte ist eine zurückhaltende Bekleidung, die Ihre Knie und Ellbogen bedeckt, empfehlenswert.
            Ein guter Ausgangspunkt ist die Altstadt von Jerusalem mit ihrer einzigartigen und besonderen Atmosphäre. Hier finden Sie die wichtigsten Sehenswürdigkeiten der Stadt.
          </p>

          <div class="img-wrapper">
            <img src=${getImgUrl() + "/posts/9/2.jpg"} class="img-responsive" />
          </div>

          <h3>
          DIE KLAGEMAUER
          </h3>
          <p>
            Die westliche Außenmauer des Zweiten Tempels ist auch als Klagemauer oder Kotel bekannt. Sie gilt als heiligster Ort des Judentums. Die Mauer ist in Abschnitte für Männer und Frauen unterteilt, an denen sich Gläubige im Laufe des Tages für Morgen-, Nachmittags- und Abendandachten versammeln. Menschen unterschiedlicher Herkunft beten an der Mauer, stecken kleine Zettel mit Gebeten in die Fugen zwischen den Steinen oder nehmen einfach die Atmosphäre des Ortes in sich auf. <br/>
            Adresse: Jüdisches Viertel, Altstadt<br/>
            Tel.: +972-2-627-3515<br/>
            Öffnungszeiten: Immer geöffnet

          </p>

          <div class="img-wrapper">
            <img src=${getImgUrl() + "/posts/9/3.jpg"} class="img-responsive" />
          </div>

           <h3>
          VIA DOLOROSA
          </h3>
          <p>
            Diese Straße verläuft von Osten nach Westen durch das muslimische Viertel, entlang der letzten Schritte von Jesus Christus auf seinem Weg an das Kreuz. Die Strecke ist sowohl bei Pilgern als auch bei Touristen beliebt und markiert 14 Stationen entlang des letzten Gangs von Jesus. Außerdem ist sie von zahlreichen Läden und Ständen gesäumt. Ein Besuch lohnt sich besonders am Freitagnachmittag (15:00 Uhr im Winter, 16:00 Uhr im Sommer), wenn eine Prozession der Franziskaner über die Straße zieht.
            <br/>
            Adresse: Via Dolorosa, Muslimisches Viertel, Altstadt

          </p>

          <h3>
            GRABESKIRCHE JERUSALEM
          </h3>

          <p>
            Dieses eindrucksvolle Gebäude gehört zu den heiligsten Orten des Christentums und wird jedes Jahr von Millionen Pilgern aufgesucht. Der Gebäudekomplex soll auf dem Hügel von Golgatha (dem Kalvarienberg) stehen, wo dem Neuen Testament zufolge Jesus Christus gekreuzigt und begraben wurde und wieder auferstand.
            <br/>
            Adresse: Zwischen der Suq Khan e-Zeit und der Christian Quarter Road, Christliches Viertel, Altstadt <br/>
            Tel.: +972-2-627-3314<br/>
            Öffnungszeiten: So - Sa: 5:00 Uhr - 20:00 / 21:00 Uhr

          </p>

          <div class="img-wrapper">
            <img src=${getImgUrl() + "/posts/9/4.jpg"} class="img-responsive" />
          </div>

          <h3>
            FELSENDOM
          </h3>
          <p>
            Der Felsendom ist das dritte Heiligtum des Islam und steht auf dem Gipfel des Tempelbergs. Er prägt die Silhouette der Stadt Jerusalem. Im Herzen des Heiligtums befindet sich der Gründungsfels, von dem aus der islamischen Tradition zufolge der Prophet Mohammed seine Himmelsfahrt antrat. Ausländer erhalten keinen direkten Zugang zum Gründungsfels, können aber für eine begrenzte Anzahl von Stunden den Felsendom betreten.
            <br/>
            Adresse: Zugang zwischen Klagemauer und Dungtor, Altstadt <br/>
            Tel.: +972-2-628-3292 oder +972-2-628-3313<br/>
            Öffnungszeiten: So - Do: 7:30 Uhr – 11:00 Uhr, 13:30 Uhr – 14:30 Uhr (April - September), So - Do: 8:00 Uhr – 10:00 Uhr, 12:30 Uhr – 14:00 Uhr (Oktober - März), Fr - Sa: Geschlossen.

          </p>

          <h3>
            AUSSERHALB DER STADTMAUERN DER ALTSTADT
          </h3>

          <h3>
            DAVIDSZITADELLE
          </h3>
          <p>
              Die Davidszitadelle (auch für den Davidsturm bekannt) wurde ursprünglich im zweiten Jahrhundert v. Chr. errichtet, um einen schwachen Punkt in der Stadtverteidigung zu stärken. Sie wurde in den folgenden Jahrhunderten zahlreiche Male zerstört und wieder aufgebaut. Seit 1989 befindet sich hier ein faszinierendes Museum mit einer Ausstellung zur Geschichte Jerusalems. Sie sollten sich außerdem den hervorragenden Blick von den Mauern über Jerusalem nicht entgehen lassen.
            <br/>
             Adresse: Jaffator, Christliches Viertel, Altstadt<br/>
            Tel.: +972-2-626-5333<br/>
            Öffnungszeiten: So - Do: 10:00 Uhr - 16:00 Uhr, Fr: Geschlossen, Sa: 10:00 Uhr - 14: 00 Uhr (September - Juni), So - Do: 10:00 Uhr - 17:00 Uhr, Fr: 10:00 Uhr - 14:00 Uhr, Sa: 10:00 Uhr - 17:00 Uhr (Juli - August)

          </p>

          <h3>
              DAVIDSSTADT
          </h3>

          <p>
            Tief unter den Fundamenten des arabischen Dorfes Silwan befinden sich die Ruinen der ehemals prächtigen Zitadelle, in der eine Dynastie jüdischer Könige ihren Sitz hatte. Das enorme Besucherzentrum bietet eine Tour an, die an einem Aussichtspunkt mit Blick über die Überreste des historischen Jerusalem beginnt, dann unter die Erde zu den neuen archäologischen Funden führt und bei der Quelle Gihon endet, an der den Überlieferungen zufolge Salomo zum König gekrönt wurde. Besucher können auch durch das Wasser des 2.700 Jahre alten Hiskiatunnels waten
            <br/>
            Adresse: Silwan, Ost-Jerusalem<br/>
            Tel.: +972-2-626-2341<br/>
            Öffnungszeiten: So - Do: 8:00 Uhr – 17:00 Uhr (Winter), 8:00 Uhr – 19:00 Uhr (Sommer), Fr: 8:00 Uhr – 13:00 Uhr (Winter), 8:00 Uhr – 15:00 Uhr (Sommer)


          </p>


          <h3>ÖLBERG</h3>
          <p>
          Der Ölberg ist ein Hügel, der sich im Osten der Altstadt erhebt und einen großartigen Ausblick auf die Altstadt und den Felsendom bietet. Entlang seiner Hänge liegen zahlreiche Heiligtümer, Begräbnisstätten und einige große Kirchen, unter anderem die Kirche aller Nationen. Um alle Sehenswürdigkeiten genießen zu können, beginnt man am besten ganz oben in der Nähe der Himmelfahrtsmoschee und geht zu Fuß hügelabwärts zum Mariengrab. Der Ausblick auf die Altstadt ist morgens am besten.
          <br/>
          Adresse: Ölberg, Ost-Jerusalem
          </p>

          <h3>YEMIN MOSHE </h3>
          <p>
          Dieses charmante Viertel entlang der alten Stadtmauer wurde ursprünglich erreichtet, um die Überbevölkerung im 19. Jahrhundert aufzufangen. Es ist für seine Windmühle und seinen als Mishkenot Shaananim bekannten kommunalen Wohnblock bekannt, der heute als Kunst- und Kulturveranstaltungsort genutzt wird. Das Viertel ist bei Künstlern, Schriftstellern und Akademikern beliebt und berühmt für seine im orientalischen Stil errichteten Häuser, grünen Parks, ein Musik-Zentrum, das YMCA, das King David Hotel und das Grabmal der Herod-Familie.
          </p>

          <h3>STADTZENTRUM </h3>
          <p>
          MAMILLA ALROV AVENUE
          Die Mamilla Alrov Avenue ist eine zwischen dem Stadtzentrum und der Altstadt gelegene Fußgängerzone mit Luxusgeschäften und eleganten Restaurants und Cafes. Die Mamilla ist für ihren Schick und die geschmackvolle europäische Atmosphäre bekannt und bietet einen spektakulären Ausblick auf die Mauern der Altstadt.
           <br/>Adresse: 6 Yitzhak Kariv Street, Jerusalem<br/>
          Tel.: +972-2-636-0000<br/>
          Öffnungszeiten: So - Do: 10:00 Uhr – 21:30 Uhr (Winter), 10:00 Uhr – 22:30 Uhr (Sommer), Fr: 9:00 Uhr – 14:00 Uhr (Winter), 9:30 Uhr – 15:30 Uhr (Sommer), Sa: Eine Stunde nach Sabbat – 23.00 Uhr
          </p>
          <h3>BEN YEHUDA STREET </h3>
          <p>Einer der beliebtesten Treffpunkte in Jerusalem für Einheimische und Touristen gleichermaßen. Die Ben Yehuda Street ist eine Fußgängerzone zwischen der King George Street und der Jaffa Road im Stadtzentrum von Jerusalem. Die Straße wird von zahllosen Geschenkartikelläden, Falafel- und Eisverkäufern, Straßenmusikanten, Bettlern und Straßenkünstlern belebt. </p>

          <h3>NACHALAT SHIVA </h3>
          <p>Dieses charmante Kopfsteinpflasterviertel südlich der Ben Yehuda Street im Stadtzentrum bietet eine große Auswahl an Läden, Restaurants, Bars und Straßencafés. Hier lässt sich das lebhafte Treiben der Stadt im Sommer und bis spät in die Nacht genießen. </p>

          <h3>MEAH SHEARIM </h3>
          <p>Obwohl sie nur wenige Minuten zu Fuß von der modernen Ben Yehuda Street liegt, fühlt sich die ultraorthodoxe Enklave von Mea Shearim wie eine andere Welt an. Durch den Anblick der orthodoxen Juden in vollständiger traditioneller Kleidung mit langen schwarzen Mänteln, schwarzen Fellhüten und Strümpfen werden Sie sich fühlen, als wären Sie in das Europa des 18. Jahrhunderts getreten. Bei Besuchen sollten Sie ich sehr zurückhaltend kleiden, so dass Sie bis zu den Handgelenken und Knöcheln bedeckt sind, und Fotos diskret aufnehmen.
          Adresse: Meah Shearim Road, Jerusalem</p>

          <h3>Mahane Yehuda-Markt </h3>
          <p>Häufig als „der Shuk“ bezeichnet, bietet der Mahane Yehuda-Markt eine riesenhafte Auswahl frischer Feldfrüchte und Lebensmittel und eine Vielzahl anderer Läden z. B. für Bekleidung, Küchenartikel, Schmuck, Keramik und hochwertige Speiselokale. Der Shuk umfasst einen Freiluft- und einen geschlossenen Bereich, grenzt auf der einen Seite an die Jaffa Road und auf der anderen Seite an die geschäftige Agripas Street an. Es lohnt sich, mit öffentlichen Verkehrsmitteln zum Shuk zu fahren, weil Parkplätze knapp sind und der Verkehr sehr dicht ist. Wenn Ihnen Gedränge kein Problem bereitet, gehen Sie am Freitag, um das Gewimmel der letzten Einkäufe vorm Sabbat zu erleben.
          Adresse: Agripas Street und Jaffa Street, Jerusalem</p>

          <h3>
              ANDERE BEREICHE IN JERUSALEM
           </h3>

          <h3>
             YAD VASHEM
          </h3>
          <p>
              In Yad Veshem, der nationalen Holocaust-Gedenkstätte Israels, wird den sechs Millionen von den Nazis und deren Alliierten ermordeten Männern, Frauen und Kindern gedacht. Am Fuß des Herzlbergs gelegen, umfasst Yad Vashem mehrere bewegende Gedenkstätten, wie die Halle der Erinnerung und das beklemmende Denkmal der Kinder, das Holocaust-Geschichtsmuseum, das Museum der Holocaust-Kunst, Skulpturen und Installationen, ein riesiges Archiv und ein Forschungsinstituts. Achten Sie auf angemessene Kleidung und nehmen Sie sich mindestens ein paar Stunden für den Museumsbesuch Zeit. Adresse: Har Hazikaron
              Tel.: +972-2-644-3400
          </p>
          <h3>
               ISRAEL-MUSEUM
          </h3>
          <p>
              Für die größte Kulturinstitution Israels, das im Sommer nach einer großen Modernisierung wieder eröffnete Israel-Museum, wollen Sie sich mindestens einen Tag reservieren. Das Museum besteht aus mehreren unterschiedlichen Trakten und einer riesigen Kunstsammlung, archäologischen Funden und Judaica. Eines der wichtigsten Highlights ist der einzigartig gestaltete Schreib des Buches, der zahlreiche uralte Manuskripte wie die Schriftrollen vom Toten Meer beherbergt. Weitere Höhepunkte sind der Jugendtrakt für Kinder, der Billy Rose Art Garden, in dem die Entwicklung der westlichen Bildhauerei im Laufe der Jahrhunderte präsentiert wird, der Trakt der feinen Künste des Museums und sein Archäologietrakt.
          </p>

         `,
      };
    },
  },

  {
    id: 14,
    ctg: "telaviv",
    isVid: true,
    vidId: "XDei1Zy_cu4",
    bgImage: "/posts/bank/17/1.jpg",
    mobBgImage: "/posts/bank/17/M.jpg",
    title: "Die Stra Die Strande Von Tel Aviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h2>Packen Sie Ihren Sonnenschutz ein, schnappen Sie sich die Softball-Schläger, und auf geht's zum Strand</h2>
					<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/XDei1Zy_cu4/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->
					<p>
                          Tel Aviv rühmt sich mit einer langen Promenade die der Küste entlang verläuft und die westliche Grenze der Stadt bildet. Leute spazieren, joggen, fahren Fahrrad, oder sitzen auf Bänken und genießen die frische Luft. Und das alles, auf weitläufigen 14 Kilometern mit fantastischer Aussicht, blauem Horizont und weißen Segeln, die auf den Wellen schaukeln.
                          <br/>
                          Dutzende von Restaurants, Cafés und Eisdielen sind den ganzen Tag lang gut besucht, während Pubs, Diskotheken und Jazz-Clubs nach Einbruch der Dunkelheit aufblühen. Hier ist – völlig unabhängig von der Uhrzeit – immer etwas los. Clowns, Karikaturisten, Tätowierer, Haar-Flechter, Zauberer und natürlich der ständig wechselnde Fluss von Menschen, die an den nahe gelegenen Stränden spazieren gehen, laden zum Verweilen ein.
                          <br/>
                          Direkt an der Promenade finden Sie sauberen Sand, Liegestühle, Eisverkäufer, und ganzjahres Badeurlauber, die täglich hier schwimmen gehen, ganz egal ob Winter oder Sommer, da komme was wolle. Jeder von Tel Avivs 13 schönen Stränden verfügt über einzigartige Eigenschaften und bietet eine Vielzahl von Dienstleistungen, einschließlich Kiosken, Restaurants, Kinderspielplätzen, Open-Air Fitness-Studios, Rettungsposten und vieles mehr.
                          <br/>
                          Ein paar Tipps
                      </p>

                      <div class="img-wrapper">
                          <img src=${getImgUrl() +
                            "/posts/13/2.jpg"} class="img-responsive" />
                      </div>

                      <h3>
                           Ein paar Tipps
                      </h3>
                      <ul>
                              <li>Freitagnachmittags können Sie am Dolfinarium Beach bei einem improvisierten Trommel-Festival und Capoeira, einer brasilianischen Kombination aus Kampfkunst, Tanz und Musikmitmachen.</li>
                              <li>Gordon Beach ist großartig für Volleyball.</li>
                              <li>Für religiöse Besucher gibt es am Hof Hadatiyim (Nordau Beach), südlich vom Tel Aviv Hafen, geschlechterspezifische Schwimmzeiten. Frauen und Mädchen baden hier sonntags, dienstags und donnerstags, während Männer und Jungen montags, mittwochs und freitags das Wasser genießen können. Beide Geschlechter sind am Samstag willkommen.</li>
                              <li>Die Schwulen- und Lesbencommunity zieht es für gewöhnlich zum Standabschnitt vor dem Hilton Hotel, was ihm den inoffiziellen Titel als schwulenfreundlichster Strand der Stadt eingebracht hat.</li>
                              <li>Der schmale Sandstreifen in der Nähe der Marina ist weniger überfüllt und ruhiger als die anderen Strände. Am Yachthafen können Sie Windsurfbretter, Surfbretter, Segelboote, Motorboote und Tauchausrüstung ausleihen.</li>
                              <li>Surfen ist sehr beliebt am Hilton Beach, wo vor kurzem ein spezielles Lichtsystem installiert wurde, um Surfen auch nachts möglich zu machen.</li>
                              <li>Kiteboarden ist am Aviv Beach beliebt.</li>
                              <li>Zum Windsurfen geht man zum Dolfinarium Beach.</li>
                              <li>Volleyball kann man am Aviv Beach und am Gordon Beach spielen.</li>
                              <li>Die Strände der Stadt sind großzügig mit Umkleidekabinen, Duschen und Toiletten ausgestattet. Rettungsschwimmer sind während der Badesaison (Mai-Oktober) im Dienst und eine Touristenpolizei steht bereit um Sicherheit, Unterstützung und Informationen zu bieten.</li>
                      </ul>

                      <h3>
                           Lustiges und Interessantes
                      </h3>

                      <ul>
                            <li>8,500,000 Badegäste kommen jährlich an die Strände.</li>
                            <li>Die offizielle Badesaison geht von Mai-Oktober.</li>
                            <li>Es gibt 13 Strände entlang der Küste von Tel Aviv-Jaffa</li>
                            <li>Vier Strände sind für Menschen mit Einschränkungen zugänglich: Tzuk, Northern Tzuk, Metzizim und Hilton (alle im nördlichen Teil der Stadt).</li>
                            <li>Die Strände von Tel Aviv-Jaffa belegen hohe Ränge in den Tests des israelischen Ministeriums für Umwelt und werden als sehr sauber angesehen.</li>
                            <li>Eine israelische Version von Racquetball, <a href="//www.gomatkot.com/the-game/" target="_blank">Matkot</a> genannt, ist ein beliebter Sport der auf vielen Stränden gespielt wird (passen Sie auf Ihren Kopf auf!).</li>
                            <li>Wassermelone mit Fetakäse ist ein sehr beliebter Strandsnack. Artikim, oder Eis am Stiel, sind ebenfalls beliebt, wobei das Eis mit Banane-Schokolade-Geschmack bei den meisten Leuten den Top-Platz einnimmt.</li>
                      </ul>
                      <h3>
                            Strand-Richtlinien
                      </h3>

                      <ul>
                            <li>Badegäste müssen sich an die Anweisungen der Rettungsschwimmer und Rettungswachen halten.</li>
                            <li>Baden an Stränden ohne Rettungsdienst ist verboten.</li>
                            <li>Das Baden im Meer ist untersagt, wenn die schwarze Flagge gehisst wurde.</li>
                            <li>Die Ausübung JEGLICHEN Motorsports (Jet Skis, Boote) ist untersagt.</li>
                            <li>Motorisierte Fahrzeuge sind sowohl auf dem Strand wie auch auf der Promenade untersagt.</li>
                            <li>Die Errichtung von Lagerfeuern am Strand ist untersagt.</li>
                      </ul>



                      <h3>
                           Badesaison
                      </h3>

                      <div class="img-wrapper">
                            <img src=${getImgUrl() +
                              "/posts/13/3.jpg"} class="img-responsive" />
                      </div>

                      <p>
                            Während der gesamten Badesaison stehen Rettungsdienste, Badeaufsicht und Erste Hilfe an den folgenden Stränden zur Verfügung: North Beach Cliff, South Beach Cliff, Tel Baruch Beach, Hilton Beach, Gordon Beach, Frishman Beach, Borgashov Beach (Eröffnung auf Grund von Renovierungsarbeiten verzögert), Jerusalem Beach, Charles Clore Beach, Givat Aliyah Beach.
                      </p>
                      <h3>
                            Betriebszeiten:
                      </h3>
                      <p>
                           9-31 Mai: 7:00-17:00 <br/>
                          Juni: 7:00-18:00<br/>
                          Juli-August: 7:00-19:00<br/>
                          September-Oktober: 7:00-17:00
                          <br/>
                          Inspektionen und Reinigungsdienste werden an allen oben genannten Stränden von 7:00 bis in die Abendstunden verfügbar gemacht.
                      </p>
                      <h3>
                           Die Preisliste der Strände ist:
                      </h3>
                      <p>
                            Pita oder Brot mit Hummus oder Salat – 12 NIS <Br/>
                            Kleine Flasche Mineralwasser – 7 NIS<Br/>
                            Eis am Stiel – 5 NIS<Br/>
                            Strandliege für den gesamten Tag – 12 NIS<Br/>
                            Strandstuhl für den gesamten Tag – 6 NIS<Br/>
                            Sonnenschirm für den gesamten Tag – 6 NIS<Br/>
                      </p>

         `,
      };
    },
  },

  {
    id: 19,
    bgImage: "/posts/bank/39/1.jpg",
    mobBgImage: "/posts/bank/39/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    vidId: "TeLJmRatQeM",
    title: "Modern und lebendig",
    smltitle: "",
    html: function() {
      return {
        __html: `
                   <h2>Es gibt so viel zu sehen in Jerusalems pulsierendem Stadtzentrum</h2>
                   <!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/TeLJmRatQeM/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->

					<p>
							Die Innenstadt von Jerusalem ist das Herz der modernen Metropole, voller Nachtleben, Restaurants und kulturellen Möglichkeiten, die es mit jeder größeren Stadt der Welt aufnehmen können.
					          </p>
					          <p>
												Die Gegend besteht aus mehreren Stadtvierteln und den angesagtesten Orten, wie dem charmanten Nachlat Shiva, der belebte Yafo Straße und der Ben Yehuda Straße mit ihrer einzigartigen Persönlichkeit und Atmosphäre, die man nicht verpassen sollte.
					          </p>
					          <p>
												Das Zentrum von Jerusalem umfasst einige der charmantesten Viertel der Stadt und faszinierende Sehenswürdigkeiten. Für eine unschlagbare kulturelle Erfahrung, sehen Sie sich Jerusalems faszinierende Museen an, darunter das weltberühmte Israel Museum, das Bible-Land-Museum und  Wissenschafts Museum.
					          </p>
					          <h3>
												Machane Yehuda Market
					          </h3>
					          <p>
												Entdecken Sie die unvergleichliche Atmosphäre und Vielfalt dieses Marktes, die jeden Tag Tausende von Touristen anzieht. Sobald die Einkäufe erledigt sind und die Verkäufer die Läden zumachen, treffen sich den jungen trendigen Menschen, sowohl aus dem Ausland als auch aus der Region, die auf den Markt kommen, um bis in die frühen Morgenstunden in den Bars, Restaurants und Gassen zu trinken und zu feiern.
					          </p>
					          <h3>
												Nahalat Shiv’a
					          </h3>
					          <p>
												Dieses charmante gepflasterte Viertel im Herzen der Stadt bietet eine exzellente Auswahl an Geschäften, Restaurants, Bars und Straßencafés an. Nahalat Shiva ist die Heimat von Kikar Hamusica (Musikplatz)- ein lebhafter und trendiger Platz im Freien, wo jeden Tag während der Woche Live-Musik spielt.
					          </p>
					          <h3>
												Yemin Moshe
					          </h3>
					          <p>
												Dieses schöne Viertel mit Blick auf die alten Stadtmauern wurde ursprünglich im 19. Jahrhundert erbaut, um dem Problem der Überfüllung entgegenzuwirken. Yemin Moshe, Heimat von Künstlern, Schriftstellern und Akademikern, ist bekannt für seine schönen Windmühlen und Häuser im orientalischen Stil, grüne Parks, lebhaftes Musikzentrum und atemberaubende Ausblicke.
					          </p>
					          <h3>
												Ein Kerem
					          </h3>
					          <p>
												In einem friedlichen Tal zwischen den Bergen und den terrassierten Hügeln südwestlich von Jerusalem gelegen, ist Ein Kerem eines der malerischsten Viertel von Jerusalem. Mit ihren verwinkelten, gepflasterten Gassen, ihren charmanten Steinhäusern, die mit Bögen geschmückt sind, Kirchen, deren Glocken in der klaren Luft läuten, strahlt Ein Kerem Charme und Schönheit aus, wie eine Insel in einem Meer aus grünem Wald.
					          </p>

         `,
      };
    },
  },

  {
    id: 18,
    bgImage: "/posts/bank/38/1.jpg",
    mobBgImage: "/posts/bank/38/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    vidId: "k4OwoEk5wMw",
    title: "Absolutes 'Muss' in Jerusalem",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h2>5 Top-Dinge zu tun und zu sehen in der atemberaubenden Stadt</h2>
					<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/k4OwoEk5wMw/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->
					<h3>
									                Segway-Touren
									          </h3>
									          <p>
																	Diese adrenalingeladene Art, die Stadt zu sehen, erlaubt es Ihnen, die Schönheit Jerusalems aus einer ganz eigenen Perspektive zu betrachten. Die Segway-Touren starten von verschiedenen zentralen Orten aus, einschließlich des Armon HaNatziv Promenade (Ost-Talpiot), Yemin Moshe und die Altstadt, sowie in der Nähe die Knesset und der Museumsbereich.
									          </p>
									          <h3>
																	Die erste Station (Hatachana)
									          </h3>
									          <p>
																	Die Erste Station befindet sich im Herzen von Jerusalem, zwischen der Altstadt und dem Stadtzentrum, zwischen den historischen Vierteln der deutschen Kolonie und Yemin Moshe. Es ist der Standort des ersten Bahnhofs in Jerusalem, der im Jahr 1892 gebaut wurde. Nach der Renovierung und Konservierung, die Erste Station wurde als lebhafter Unterhaltungsort wiedereröffnet, der sieben Tage die Woche geöffnet ist.
									          </p>
									          <h3>
																	Der Zeit-Aufzug
									          </h3>
									          <p>
																	Wenn Sie ein Fan von Vergnügungsfahrten sind, werden Sie es lieben, Ihre Sinne durch den Zeit-Aufzug zu verwirren. Es ist ein interaktives Erlebnis, das die Besucher auf fabelhafte Reisen zu faszinierenden Orten bringt, in einer einzigartigen Halle der mit beweglichen Sitzen und mit zahlreichen Spezialeffekten ausgestattet ist.
									          </p>
									          <h3>
																	Der biblische Zoo
									          </h3>
									          <p>
																	Dieser schöne zweistöckige Zoo erstreckt sich über 62 Hektar und liegt an einem riesigen künstlichen See mit Wasserfällen und seitlichen Pools, umgeben von weitläufigen Rasenflächen und schattigen Rastplätzen. Zur Freude der Kinder und Erwachsene,  dort leben über 200 Tierarten, von denen die meisten in der Bibel erwähnt und in der Zwischenzeit fast ausgestorben sind.
																	Dies bedeutet nicht, dass normale Tiere nicht anwesend sind, sie haben sogar Pinguine hier. In der Nähe des Zoos befindet sich ein schönes, riesiges und eindrucksvolles Aquarium, das tagsüber und abends für Besucher geöffnet ist und Unterwasserwelt des Mittelmeers, Rotes Meer und noch mehr, darstellt.
									          </p>
									          <h3>
									                Teddy Park
									          </h3>
									          <p>
																	Benannt nach Teddy Kollek, der von 1965-1995 Bürgermeister von Jerusalem war; Teddy Park ist lustig, schön und historisch bedeutsam. Der Park ist ein bedeutender Treffpunkt zwischen dem Alten und Neuen Jerusalem und beinhaltet einen Wunschteich, eine beeindruckende Sonnenuhr Originalskulptur, sanierte historische Gebäude und eine fantastische Wasserbrunnenattraktion mit einer spektakulären Licht- und Musik-Abendshow.
									          </p>

         `,
      };
    },
  },

  {
    id: "Die_Wuste_Negev",
    bgImage: "/posts/bank/34/1.jpg",
    ctg: "eilat",
    isVid: true,
    vidId: "yXzhH92kREg",
    mobBgImage: "/posts/bank/34/M.jpg",
    title: "DIE WÜSTE NEGEV",
    smltitle: "",
    html: function() {
      return {
        __html: `
                      <h2>Ein zauberhafter Ort</h2>
					<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/yXzhH92kREg/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->
					<h3 class="negev-secondary-title">
								Die Wüste Negev - ein zauberhafter Ort
							</h3>


							\n

                            <!--negev text-->

						      <p>
						             Die israelische Wüste mit ihrer atemberaubenden Landschaft und verschiedenen Sehenswürdigkeiten bietet den perfekten Ort für einen Urlaub. In der Negev finden Besucher zahlreiche Möglichkeiten für viele spannende Erlebnisse.
						      </p>
						      <p>
						             Israel ist ein kleines Land, 62% der Gesamtfläche nimmt davon der Negev ein. Das rötliche schimmerndes Wüstengebiet wird von vielen beeindruckenden geologischen Felsformationen geprägt. Die Besucher genießen hier einen einzigartigen Blick auf eine unberührte Weite - still und majestätisch.
						      </p>
						      <p class="p-margin">
						             Spuren von vergangener Zivilisationen und ihrer Landwirtschaft sowie archäologische Stätten finden sich überall. Die Negev bildet einen unverwechselbaren Hintergrund für die Begegnung mit den Nomadenstämmen - dem Volk der Wüste.
						      </p>

						      <h2>
						             Gründe, warum die Wüste Israels so besonders ist:
						      </h2>

						      <ul class="p-margin">
						             <li>
						                  <b> Die Wüste liegt ganz in der Nähe:</b> nur 4 Flugstunden von Europa entfernt. Israel hat zwei internationale Flughäfen - Ben Gurion und Ovda, die allen Reisenden einen kurzen Trip in die Wüste garantieren (eine Stunde bis 90 Minuten).
						                  Ab November gibt es mehrere Direktflüge von Europa und Russland nach Ovda, z. B. mit Monarch, Ryanair, Wizzair und SAS.
						             </li>
						             <li>
						                  <b> Leichte Wanderung und radeln. :</b> In der Wüste gibt es viele markierte Wege. In Israel gibt es einige der eindrucksvollsten Wanderwege der Welt und Hunderte von sicheren Routen führen durch die israelische Wüste. Eine Auswahl von Wanderwegen finden sie auf den folgenden Websites:<br>
						                  <a href="//www.negevtour.co.il" target="_blank">www.negevtour.co.il</a>
						             </li>
						             <li>
						                  <b>Freundliche Bevölkerung:</b> Die Wüstenbewohner sind sehr gastfreundlich und machen das Wüstenerlebnis angenehm und spannend für alle Besucher.
						             </li>
						             <li>
						                  <b> Aktivitäten für Touristen:</b> Zusammen mit der Entwicklung von Unterkünften hat ein enormes Angebot touristischer Aktivitäten die Negev in den letzten Jahren zu einem beliebten, interessanten, vielseitigen und kreativen Reiseziel gemacht.
						             </li>
						             <li>
						             <b> Herrliche Landschaften:</b> Heute genießen zahlreichen Touristen den Charme der Negev-Wüste mit ihren vielfältigen Landschaften <br>
						      <ul>
						             <li>
						                   Im Norden gibt es spektakuläre Sanddünen.
						             </li>
						             <li>
						                   Im Zentrum liegt der Ramon-Krater mit seinen rauen Klippen und saisonalen Wasserquellen.
						             </li>
						             <li>
						                   Im Osten erlebt man die afrikanische Wüste mit weiten Savannen und Akazien überall.
						             </li>
						             <li>
						                   Und im Süden findet man roten und schwarzen Granit, der mit dem Sandstein des Vorgebirges angenehme Farbspiele bildet.
						             </li>
						      </ul>
						             Bei einer ca. 3-stündigen Fahrt durch die Wüste können sie das gesamte Spektrum der Wüstenlandschaft erleben und ihre Vielfalt genießen die man in anderen Wüsten oft nur mit einer langen Reise von mehreren Kilometern erlebt.
						             Viele Touristen entscheiden sich, 2 bis 3 Tage in der Negev-Region zu verbringen.

						      </li>
						            <li>
						                 <b> Der Negev ist sehr sicher zu reisen.</b> Die Rettungsteams, die bei Notfällen in der Region vor Ort sind, gehören zu den am besten ausgebildeten Rettungskräften der Welt und sind immer in der Nähe. Sollte jemand medizinische Hilfe benötigen, bietet Israel hochwertige, erstklassige westliche medizinische Dienstleistungen an.
						            </li>
						      </ul>
						      <h2>
						            Weitere Informationen und Hinweise für Übernachtungen und sonstige Empfehlungen:
						      </h2>
						     
						      <p>
						           <a href="//www.negevtour.co.il/homepage/accommodation/?lang=en" target="_blank">www.negevtour.co.il</a><br>
						           <a href="https://en.aravaway.co.il/business/category/1/" target="_blank">www.en.aravaway.co.il</a>
						      </p>




                            <!--Negev - Transportations-->

							  <h3>
						            NEGEV – STANDORT UND ANFAHRT
						      </h3>
						      <p class="p-margin">
						            Landung auf den Flughäfen von Ovda oder Eilat mit der Weiterreise nach Mitzpe Ramon oder Sde Boker:
						      </p>

						      <h2>
						            Öffentliche Verkehrsmittel:
						      </h2>
						      <p>
						            Bus 392 von Eilat nach Mitzpe Ramon und Be'erSheva, hält am Flughafen von Ovda am Sonntag um 07:13, 08:41, 09:43, 14:12, 15:41, 17:43.
						      </p>
						      <p>
						            Ankunft am zentralen Busbahnhof von Mitzpe Ramon nach ungefähr anderthalb Stunden.
						      </p>
						      <p>
						            Montags - Donnerstags um 07:13, 07:41, 09:43, 14:12, 15:41, 17:43.
						      </p>
						      <p class="p-margin">
						            <a href="//www.egged.co.il/HomePage.aspx" target="_blank">Bus service </a><br>
						            <a href="//www.egged.co.il/HomePage.aspx" target="_blank"> Shuttle-Service vom Ovda Flughafen </a>
						      </p>
						      <h2>
						            Autovermietung in Eilat, Mitzpe Ramon und Be'er Sheva:
						      </h2>
						      <p>
						            Mehrere Optionen ein Auto in diesen Städten zu mieten sind möglich.
						            Es stehen internationale und israelische Anbieter zur Auswahl.
						      </p>
						      <p class="p-margin">
						            Landung am Ben Gurion International Airport in der Nähe von Tel Aviv und Weiterreise nach Negev nach Mashabei Sadeh / Sde Boker / Mitzpe Ramon
						      </p>
						      <h2>
						            Öffentliche Verkehrsmittel:
						      </h2>
						      <p>
						            Buslinien 370/380 von Tel Aviv nach Be'erSheva, Routen 446/470 von Jerusalem nach Be'erSheva.
						      </p>
						      <p>
						            Von Be'erSheva fahren Buslinien 60, 64, 65, 660 jeden Morgen ab 6 Uhr (ca. alle 20 Minuten).
						            Ankunft in Mashabei Sadeh nach 35 Minuten / SdeBoker Gebiet in 55 Minuten / Mitzpe Ramon in 1 Stunde 20 Minuten.
						      </p>
						      <p class="p-margin">
						            Weitere Informationen zu den öffentlichen Verkehrsmitteln sind unter den folgenden Links vorhanden <a href="https://www.bus.co.il/otobusimmvc?Language=en" target="_blank">here</a> or <a href="//www.egged.co.il/HomePage.aspx">here</a>
						      </p>







                             <!--NEGEV DESERT-don't miss-->


                              <h3 class="margin-h">
						            NEGEV STRASSENENFERNUNGEN
						      </h3>
						      <table>
						            <tr>
						      <th></th>
						      <th>Tel Aviv</th>
						      <th>Jerusalem</th>
						      <th>Bee'r Sheva</th>
						      <th>Eilat</th>
						      </tr>
						      <tr>
						      <td class="place-table"> <strong>Old Town <br class="auf-Handy-zeigen"> Beer Sheva</strong></td>
						      <td>113 Km</td>
						      <td>122 Km</td>
						      <td></td>
						      <td>232 Km</td>
						      </tr>
						      <tr>
						      <td class="place-table"><strong>Tel Arad</strong></td>
						      <td>134 Km</td>
						      <td>144 Km</td>
						      <td>40 Km</td>
						      <td>229 Km</td>
						      </tr>
						      <tr>
						      <td class="place-table"><strong>Ben-Gurion's Haus <br class="auf-Handy-zeigen">im Sde Boker</strong></td>
						      <td>162 Km</td>
						      <td>171 Km</td>
						      <td>49 Km</td>
						      <td>185 Km</td>
						      </tr>
						      <tr>
						      <td class="place-table"><strong>Ramon Krater</strong></td>
						      <td>210 Km</td>
						      <td>192 Km</td>
						      <td>97 Km</td>
						      <td>141 Km</td>
						      </tr>
						      <tr>
						      <td class="place-table"><strong>Hai Bar Wildlife <br class="show-on-mobile"> Reservieren Yotvata</strong></td>
						      <td>323 Km</td>
						      <td>288 Km</td>
						      <td>202 Km</td>
						      <td>35 Km</td>
						      </tr>
						      <tr>
						      <td class="place-table"><strong>Timna Park</strong></td>
						      <td>330 Km</td>
						      <td>294 Km</td>
						      <td>208 Km</td>
						      <td>30 Km</td>
						      </tr>
						      </table>

						      <h3>
						            DIE WÜSTE NEGEV - NICHT VERPASSEN</h3>

						      <h2>
						            Ramon Krater
						      </h2>

						      <p>
						            Im Herzen der riesigen Negev-Wüste Israels liegt der Ramon-Krater, der größte Erosionskrater der Welt, der auch unter dem Namen Machtesch Ramon bekannt ist.
						            Er umfasst eine enorme Gesteinsvielfalt aus fantastischen Farben und Formen und ist ein faszinierendes Naturphänomen mit einem Ausmaß von 40 km Länge und zwischen 2 bis 10 km Breite. Er hat die Form eines langen Herzens und bildet Israels größten Nationalpark: das Ramon-Naturreservat.
						            Weit weg von den Lichtern und Menschenmassen der Stadt beeindruckt der Ramon-Krater durch seinen mehrfarbigen Sandstein, seinen Vulkanfelsen und Fossilien und wird oft als Israels eigener Grand Canyon bezeichnet.
						            Die wahrhaftig atemberaubende Aussicht vom 300 m hohen Aussichtspunkt des Machtesch Ramon, der an eine Hollywood-Kulisse erinnert, bietet ganzjährig ein beeindruckendes Erlebnis für Touristen aus der ganzen Welt.
						      </p>

                            <div class="img-wrapper img-page3">
						      <img src=${getImgUrl() + "/Negev/7.jpg"} class="img-responsive" />
						      Bildnachweis: Daphna Tal
						      </div>

						      <h2>
						      Timna Park
						      </h2>

						      <p>
						      In einem hufeisenförmigen Tal, das von steilen Klippen umgeben ist, ist der Timna Park ein atemberaubendes Erlebnis und ein absolutes Muss für Wanderfreunde. Hier werden Sie Zeuge der wunderbaren Naturschauspiele, der erstaunlichen Tierwelt, der Pflanzen und Bäume, die in der Wüste heimisch sind und unter extremen, trockenen Bedingungen leben.
						      Mit seinen vielen touristischen Attraktionen, bunten Sandstränden und schroffen Bergen ist der Timna Park ein unvergleichlicher Besuchermagnet.
						      </p>

						      <div class="img-wrapper img-page3">
						      <img src=${getImgUrl() + "/Negev/9.jpg"} class="img-responsive" />
						      Bildnachweis: Daphna Tal
						      </div>

							<h2 class="title-to-play">
								 KLICKEN SIE AUF “PLAY”: Timna Park - Ein aufregendes Wüstenabenteuer
							</h2>
							<div class="responisve-iframe">
							    <iframe src="https://www.youtube.com/embed/i_4QKtXIeto/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
							</div>

						

                            <h2>
							    Sandboarding in der Wüste
							</h2>
							 <p>
						      Eine kultige Wüstenerfahrung. Die schwungsvollen Sanddünen der Wüste Negev laden zum heruntergleiten ein, egal ob sitzend oder stehend, aber immer unglaublich schnell. Es ist eine fantastische und besondere Herausforderung, und sobald Sie sie meistern (es ist wirklich sehr einfach), können Sie sich bedenkenlos Sandsurfer nennen – ziemlich cool, oder?
						      </p>
						      <div class="img-wrapper img-page3">
						      <img src=${getImgUrl() + "/Negev/1.jpg"} class="img-responsive" />
						      </div>
						      <div class="img-wrapper img-page3">
						      <img src=${getImgUrl() + "/Negev/2.jpg"} class="img-responsive" />
						      </div>

						      <h2>
						      Negev bei Nacht
						      </h2>
						      <p>
						      Der Himmel über dem Negev bietet einen atemberaubenden Anblick. Schauen Sie einfach hinauf, sobald die Dunkelheit einbricht, und Sie werden augenblicklich von dem Pracht von Millionen funkelnder Sterne überwältigt, die die blau-schwarze Dunkelheit mit einem Schein aufhellen, den man nur in der Wüste sehen kann.
						      </p>

						      <div class="img-wrapper img-page3">
						      <img src=${getImgUrl() + "/Negev/4.jpg"} class="img-responsive" />
						      </div>

						      <h2>
						      Sonnenaufgang auf Masada
						      </h2>
						      <p>
						      Nur für diejenigen, die mutig genug sind, auf die Spitze zu Fuß zu klettern – der Sonnenaufgang auf Masada ist zweifellos eines der unvergesslichsten Erlebnisse in Israel. Die Sonne steigt langsam über den jordanischen Moab Bergen und dem Toten Meer auf und verbreitet ihr Licht über die Wüstenlandschaft. Es ist ein spektakulärer Anblick, den Sie nicht so schnell vergessen werden.
						      </p>

						      <div class="img-wrapper img-page3">
						      <img src=${getImgUrl() + "/Negev/6.jpg"} class="img-responsive" />
						      </div>


						      <h3>
						      DER NEGEV - ISRAELS MAJESTÄTISCHE WÜSTE
						      </h3>
						      <h2>
						      Wo Abenteuer und Inspiration warten
						      </h2>
						      <p>
						      Ein ideales Ziel für Reisende, die Abenteuer in der freien Natur lieben.
						      Der Süden von Israel ist dünn besiedelt, aber vollgepackt mit faszinierenden Sehenswürdigkeiten und Aktivitäten.

						      </p>
						      <p class="p-margin">
						      Mit erstaunlichen Naturwundern und Schönheiten bietet der Süden Israels einen herrlichen Blick, der Ihnen den Atem rauben wird: von Sonnenauf- bis Sonnenuntergang.
						      Doch nur eine Wüste, aber definitiv keine Ödnis: Hier gibt es so viel zu sehen und zu tun. Der Negev zeichnet sich durch seine außergewöhnlichen Gesteine und Formationen, bedeutenden Kulturdenkmäler und wunderbaren Naturschutzgebiete aus, wo Sie wandern, radfahren und kamelreiten, oder auch aufregende Safaritouren in der Wüste genießen können.
						      Einfach gesagt, ist diese majestätische Südregion eine der größten Vorzüge des Landes und ein absolutes Muss auf der Reiseroute.

						      </p>


						      <h2>
						      Sde Boker
						      </h2>

						      <p class="p-margin">
						      Ein bemerkenswerter Rückblick in die Geschichte des Staates Israel ist Sede Boker, ein Kibbuz, der ursprünglich von Siedlern gegründet wurde, mit der Mission, den Negev in den frühen 50er Jahren zu besiedeln.
						      Sde Boker ist bekannt als die Heimat von David Ben Gurion, Israels erstem Premierminister, dessen Heimat nun ein öffentlich zugängliches Museum ist.


						      </p>

						      <h2>
						      Vidor Center
						      </h2>

						      <p class="p-margin">
						      Eine wirklich einzigartige Attraktion, die eine multisensorische Erfahrung der außergewöhnlichen Natur der Region Arava bietet. Center-Besucher können fortschrittliche Landwirtschaftsmethoden, heimische Pflanzen- und Tierarten, klimatische Herausforderungen, und besondere Eigenschaften des Bodens und des Wassers in der Wüste erkunden.</p>



						      <h2>
						      Nevatim
						      </h2>

						      <p class="p-margin">
						      Ein Besuch in Nevati, der Heimat der Cochiner Juden, ist eine faszinierende Erfahrung. Die Cochin-Juden stammen ursprünglich aus Indien und sind nach der Staatsgründung Israels immigriert. Cochin Juden betrachten sich selbst als eine der ältesten jüdischen Gemeinden der Welt.
						      Das Zentrum für das Cochin-Kulturgut in der Moshav Nevatim erzählt die Geschichte dieser einzigartigen Gemeinschaft.
						      </p>

						      <h2>
						      MidBurn Festival
						      </h2>

						      <p class="p-margin">
						      Israels eigene Version des berühmten "Burning Man" Festivals; 6 Tage lang wird eine temporäre Stadt aufgebaut, die eine Plattform für gemeinschaftliches Miteinanderleben, mit Kreativität, Kunst und expressivem Selbstausdruck erschafft.
						      </p>

							<div class="responisve-iframe">
							    <iframe src="https://www.youtube.com/embed/QL3BGy2p77g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
							</div>

							<br>

                            <h2>
						      Das Beduinen-Erlebniss
						      </h2>

						      <p>
						      Die Gastfreundschaft der Beduinen ist sowohl unter emotionalen als auch unter kulturellen Aspekten ein unvergleichliches Erlebniss.
						      Beduinen in Israel sind eine Gruppe von Nomadenstämmen, die vor vielen hundert Jahren dort gelebt haben und hier immer noch auf traditionelle Weise leben. Sie werden Sie willkommen heißen in ihren Häusern und in ihrem Leben und machen Sie mit ihren Sitten und Gebräuchen vertraut. Vom Kamelreiten über traditionelle Beduinen bis hin zu Übernachtungen in traditionellen Beduinenzelten - all dies sind bei Touristen in der Region äußerst beliebte Attraktionen und eine Gelegenheit, um eine lange vergessene Lebensweise zu entdecken und zu verbinden.

						      </p>

						      <div class="img-wrapper img-page3">
						      <img src=${getImgUrl() + "/Negev/8.jpg"} class="img-responsive" />
						      Bildnachweis: Daphna Tal
						      </div>

						      <h2>
						      Die kulinarischen Königinnen von Yeruham
						      </h2>

						      <p class="p-margin">
						      Für ein wirklich denkwürdiges Erlebnis müssen Sie unbedingt „Die kulinarischen Königinnen von Yeruham“ besuchen – Ein einzigartiges Projekt, wo wundervolle Frauen aus Yeruham Touristen aller Welt mit einer hervorragenden traditionellen Mahlzeiten in ihren Häusern begrüßen und für unvergessliche Momente voller Düfte, Farben und Geschmack sorgen.
						      Lernen Sie das wahre Leben der Einheimischen durch ihre faszinierenden Geschichten kennen, während Sie die ethnischen Köstlichkeiten probieren und ihre erstaunliche Gastfreundschaft genießen.

						      </p>
						      <h2>
						      Die Altstadt Be'er Sheva
						      </h2>

						      <p class="p-margin">
						      -Angeblich vom biblischen Abraham gegründet- ist Be'er Sheva eine der ältesten Städte des Landes die nachweislich vor tausenden von Jahren schon besiedelt wurde. So bezaubernd wie historisch, die alte Stadt Be'er Sheva bietet ein faszinierendes Mosaik städtischer Räume an und die Erkundung der Altstadt wird einen seltenen Reichtum an einzigartiger Architektur, eine lange Geschichte, die so alt ist wie die Zeit selbst, enthüllen.
						      </p>
						      <h2>
						      Carasso Science Park
						      </h2>

						      <p>
						      Neu in der Altstadt von Be'er Sheva ist der Carasso Science Park, der sich über 4,25 Hektar erstreckt, der größte Wissenschaftspark Israels.
						      Der Carasso Science Park begeistert und beschäftigt Besucher jedes Alters mit Attraktionen, wie einem interaktiven Museum und einem wissenschaftlichen Garten mit Spielen und Mitmach-Aktivitäten. Der Park bietet auch zehn Ausstellungen über verschiedene Themen an, wie: Gen-Technik, Kommunikation, Mikroelektronik, Kernenergie und anderem.

						      </p>
						      <h2>
						      Arad
						      </h2>

						      <p class="p-margin">
						      Arad des neuen Jahrtausends ist eine Stadt mit jungem Geist und reicher Erfahrung. Arad ist von wunderschönen Landschaften, der Beschaulichkeit einer Wüste und vielen Wanderwegen umgeben, die für jedermann jeglichen Alters und jeden Stil geeignet sind.
						      Mit vielen Attraktionen und vielen touristischen Sehenswürdigkeiten in und um die Stadt, Arad ist der perfekte Ausgangspunkt und Ihr echtes Tor zu den perfekten Wüstenurlaub.

						      </p>


						      <h2>
						      Yotvata Hai-Bar
						      </h2>

						      <p>
						      Das Naturreservat Chai-Bar Yotvata ist das in dieser Region größte Zucht- und Ansiedlungszentrum für Tiere, bevor sie wieder in die Natur entlassen werden. Das Reservat ist stolz auf seine wundervollen Attraktionen, die Tierliebhaber begeistern werden. Es umfasst ein Gehege mit Raubtieren und kleinen Wüstentieren, ein Observatorium für nachtaktive Tiere, das sich auf 12 Quadratkilometer erstreckt und freilaufende Huf- und Weidetiere beherbergt.

						      </p>

						      <div class="img-wrapper img-page3">
						      <img src=${getImgUrl() + "/Negev/10.jpg"} class="img-responsive" />
						      Bildnachweis: Daphna Tal
						      </div>


						      <h2>
						      Extremabenteuer
						      </h2>

						      <p>
						      Der Süden Israels ist ein absolutes Traumziel für abenteuerlustige Reisende. Sein einzigartiges und anspruchsvolles Terrain eignet sich ideal für verschiedene Extremsportarten und -aktivitäten, darunter das Abseilen von Schluchten, Querfeldein- und Mountain-Biking, die in dieser Region äußerst beliebt sind, ebenso wie Geländefahren, für Einheimische und Touristen gleichermaßen.

						      </p>

						      <div class="img-wrapper img-page3">
						      <img src=${getImgUrl() + "/Negev/11.jpg"} class="img-responsive" />
						      Bildnachweis: Daphna Tal
						      </div>

						      <h2>
						      Kamelreiten
						      </h2>
						      <p>
						      Wie eine Rückkehr in die Vergangenheit, dies ist immer noch die authentischste Art, die wunderbare Wüstenumgebung zu erkunden. Das Reiten auf dem Rücken eines Kamels, das in vielen Kamelfarmen angeboten wird, bleibt Ihnen sicher in Erinnerung.
						      </p>

						      <div class="img-wrapper img-page3">
						      <img src=${getImgUrl() + "/Negev/5.jpg"} class="img-responsive" />
						      </div>

						      


                            <!--NEGEV - וPDATED TEXT SITES-->

                            <h3>
						         VERANSTALTUNGEN IN DER NEGEV: KALENDER
						    </h3>
						


							<div class="row-1 mounth-row">
						      <div class="mounths active">
						      <p id="myHeader1" data-div="newboxes1" href="">January <img src=${getImgUrl() +
                    "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
						      </div>


						      <div class="mounths month-mid">
						      <p id="myHeader2" data-div="newboxes2" href="">February <img src=${getImgUrl() +
                    "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
						      </div>


						      <div class="mounths" >
						      <p id="myHeader3" data-div="newboxes3" href="">May <img src=${getImgUrl() +
                    "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
						      </div>

						      <div class="mounths month-mid">
						      <p id="myHeader1" data-div="newboxes4" href="">June <img src=${getImgUrl() +
                    "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
						      </div>

						      <div class="mounths">
						      <p id="myHeader2" data-div="newboxes5" href="">July <img src=${getImgUrl() +
                    "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
						      </div>
						      </div>



						      <div class="row-2 mounth-row">
						      <div class="mounths" >
						      <p id="myHeader3" data-div="newboxes6" href="">August <img src=${getImgUrl() +
                    "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
						      </div>

						      <div class="mounths month-mid">
						      <p id="myHeader1" data-div="newboxes7" href="">October <img src=${getImgUrl() +
                    "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
						      </div>

						      <div class="mounths">
						      <p id="myHeader2" data-div="newboxes8"a href="">November <img src=${getImgUrl() +
                    "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
						      </div>


						      <div class="mounths month-mid" >
						      <p id="myHeader3" data-div="newboxes9" href="">December <img src=${getImgUrl() +
                    "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
						      </div>

						      </div>



					         <div class="newboxes" id="newboxes1"> <!--Jen-->
						      Über das Arava Radrennen - Das nach Yoni Friedman benannte 63 Kilometer lange Radrennen bietet Ihnen atemberaubenden Blick auf eine Wüstenlandschaft, sowie die Möglichkeit endlose Weiten der Natur, die Kraft der Spiritualität, Gelassenheit und eine Verbindung zu einem außergewöhnlichen sportlichen Erlebnis zu fühlen.<br>
						      <a href="https://www.arava-active.co.il/MenuDefault.aspx?id=4240" target="_blank">www.arava-active.co.il</a>
						      </div>
						      <div class="newboxes" id="newboxes2"><!--Feb-->
						      Darom Adom ist ein jährliches Festival, die tritt während der Blüte der roten Anemone Blumen. Das Festival bietet landwirtschaftlichen Fachexkursionen, Bauernmärkte und Unterkünfte auf dem Land, sowie sportliche Aktivitäten an; von den Märschen, Rennen, bis hin zur Fahrradtouren durch die roten Felder des nördlichen Negevs und auch noch viele andere Aktivitäten sowie künstlerische Darbietungen stehen zur Verfügung. Der lokale Tourismusverband "Shikma Besor" ist verantwortlich für das Festival und seine jährlichen Aktivitätenassociation.<br>
						      <a href="//daromadom.habsor.co.il/" target="_blank">www.daromadom.habsor.co.il</a>
						      </div>
						      <div class="newboxes" id="newboxes3"><!--May-->
						      Das Kirschfest findet im Yatir-Wald statt, dem größten Wald in Israel, in dem große Obstplantagen wachsen und der nur 5-Fahrminuten vom Be'er Sheva entfernt ist. Die Veranstaltung umfasst eine Kirschernte für die ganze Familie, süß-saure Snacks, Pita-Brotbacken, Schafhirten, Gibbon, lokalen Bauernmarkt, Klezmer-Melodien, Kletterwand, Omega und viele andere Aktivitäten für die ganze Familie.<br>
						      <a href="//kinderland.co.il/events/%D7%A4%D7%A1%D7%98%D7%99%D7%91%D7%9C-%D7%93%D7%95%D7%91%D7%93%D7%91%D7%9F-%D7%91%D7%99%D7%A2%D7%A8-2017-%D7%A7%D7%98%D7%99%D7%A3-%D7%A2%D7%A6%D7%9E%D7%99-%D7%A9%D7%9C-%D7%93%D7%91%D7%93%D7%91%D7%A0/" target="_blank">www.kinderland.co.il</a>
						      </div>

						      <div class="newboxes" id="newboxes4"><!--June-->
						      Erleben Sie den Zauber des Ramadan Nacht in Rahat - wenn die Nacht zum Tag wird und die Straßen voller Leben sind. Erleben Sie eine unvergessliche Tour zur schönsten Zeit des Jahres, die Ihnen einen einzigartigen Einblick in die Kultur der Beduinen in Rahat ermöglicht. Finden Sie die authentischen Gerichte, saugen Sie die Düfte von Gewürzen und geröstetem Kaffee in sich auf. Entdecken Sie die Geheimnisse von Rahat von lokalen Führern und genießen Sie Straßenaufführungen, Debka-Musik und noch mehr.<br>
						      <a href="//ramadan-nights.co.il/" target="_blank">www.ramadan-nights.co.il</a><br>
						      Das Kino Süd Festival, das von der School of Sound and Screen Arts an Sapir College realisiert wird, begann im Jahr 2002 mit einem Schwerpunkt Studentenfilme. Innerhalb weniger Jahre ist das Festival jedoch zu einem internationalen Filmfestival gewachsen das eine zentrale Bühne für israelisches Kino, internationale Qualität und radikales Kino anbietet. Das Festival dauert fünf Tage lang und findet jedes Jahr im Juni an verschiedenen Orten im nördlichen und westlichen Negev statt. Dies ist ein Festival, das kostenlos und mit offenen Türen allem  Gästen zur verfügung steht. Das South Cinema Festival wird von einer einzigartigen Kulturagenda produziert und ist wichtig für den Ort, wo es geschaffen wurde.<br>
						      <a href="//csf.sapir.ac.il/csf2017/csf.sapir.ac.il/index.html" target="_blank">www.csf.sapir.ac.il</a>
						      </div>
						      <div class="newboxes" id="newboxes5"><!--July-->
						      Das Internationale Fringe Festival Beer Sheva ist ein multidisziplinäres Festival das für alle Altersgruppen und Publikum geeignet ist und eine Qualitätsbühne für die besten israelischen und internationalen Künstler aus den Bereichen Theater, Tanz, Musik, Street Art und der bildenden Kunst darstellt. Das Festival gilt als eines der wichtigsten Rahmenveranstaltungen in Israel und als das größte und führende Kulturfestival im Süden des Landes. Das Festival wurde vor kurzem von der EFFE (European Festivals Association) empfangen und gewinnt einen Ruf als eine prestigeträchtige europäische Veranstaltung.<br>
						      <a href="https://www.iffb7.com/" target="_blank">www.iffb7.com</a>
						      </div>
						      <div class="newboxes" id="newboxes6"> <!--Aug-->
						      Negev der Sterne - Wie in jedem Sommer, die Splitter - die vom Kometen SWIFT-TATTLE zurückgelassen wurden - treffen die Erde. Diese Fragmente durchdringen unsere Atmosphäre und schaffen einen spektakulären Blick auf "Shooting Stars". Während dieser Zeit in der Negev feiern die Menschen die erstaunliche Erfahrung der Perseiden-Sternschnuppen und eine ganze Reihe von astronomischen Ereignissen - eine gemeinsame Beobachtung der Meteoritenschauer, Beobachtungspunkte mit aufwendigen Teleskopen, Vorträge und viele andere Aktivitäten.
						      </div>
						      <div class="newboxes" id="newboxes7"><!--Oct-->
						      Das Tamar Festival ist eine Kombination aus dem idealen israelischen Soundtrack und der spektakulären Aussicht auf Masada und die Region des Toten Meeres. Das außergewöhnliche Erlebnis dauert 24 Stunden über 4 Tage lang und Konzerten finden immer an verschiedenen Orten und zu verschiedenen Zeiten statt, was beiträgt dass das Publikum sich schließlich wagt die außergewöhnlichsten Landschaften des Landes zu besuchen.<br>
						      <a href="//www.tamarfestival.com/" target="_blank">www.tamarfestival.com</a><br>
						      Desert Magic Festival - Das erste Beduinen-Festival: Eine Vielzahl von Erlebnisaktivitäten für die ganze Familie, die einen authentischen Einblick in die alte Beduinen-Tradition bieten.<br>
						      <a href="//www.kesem-hamidbar.co.il/" target="_blank">www.kesem-hamidbar.co.il</a>
						      </div>
						      <div class="newboxes" id="newboxes8"><!--Nov-->
						      Das Arava Film Festival ist ein einzigartiges Ereignis, das seit einigen Jahren jeden November im Herzen des Naturschutzgebietes Arush, neben Tzukim, stattfindet. Die Filme des Festivals werden am Abend und in der Nacht unter freiem Sternenhimmel gezeigt. Sie sind die erste Linie der internationalen Produktion, die letztes Jahr auf Weltfilmfestivals gezeigt wurde. Zu den Filmen des Festivals gehören Filme für Kinder und Jugendliche sowie Kurzfilme, die im letzten Jahr in Arava produziert und gefilmt wurden. Die Filme werden auf einem riesigen Bildschirm gezeigt und das Publikum kann sich auf einer geräumigen und überraschend komfortablen Plattform entspannen, die speziell für diesen Zweck im Tal zwischen den Klippen des östlichen Negev gebaut wurde.<br>
						      <a href="https://www.aravaff.co.il/" target="_blank">www.aravaff.co.il</a>
						      </div>
						      <div class="newboxes" id="newboxes9"><!--Dec-->
						      Ben-Gurions Marsch findet seit mehr als 20 Jahren auf Initiative des Ramat Negev Regionalrats statt, nach dem täglichen Sport Marsch des ersten Premierministers, David Ben-Gurion, während seines Aufenthalts im Kibbuz Sde-Boker. Der Marsch findet auf drei Strecken statt - eine kurze Strecke für Familien (7 km), mittlere (15 km) und lange (22 km).<br>
						      <a href="//www.zaadatbg.org.il/" target="_blank">www.zaadatbg.org.il</a><br>
						      Docaviv Negev - Docaviv, das internationale Dokumentarfilmfestival von Tel Aviv, ist das größte Filmfestival in der Stadt Tel Aviv und das einzige Festival in Israel, das in seiner Gesamtheit Dokumentarfilmen gewidmet ist. Damit ein möglichst breites Publikum mit diesem dokumentarischem Arbeit angesprochen wird, organisiert die NPO auch eine regionalen Fest: Docaviv Negev, der in Yeruham gehalten wird, sowie Dutzende von dokumentarischen Filmvorführungen in Kulturzentrum im ganzen Land. Jedes Jahr vergibt Docaviv BSC Auszeichnungen für originale israelische Dokumentarfilmproduktion und, daneben, auch die Preise für den besten internationalen Film Award, Preise für die herausragende, noch studierende Filmemacher und ein zusätzlicher Preis innerhalb des Depth of Field-Rahmens für innovative, inspirierende Dokumentarfilme aus der ganzen Welt.<br>
						      <a href="//www.docaviv.co.il/" target="_blank">www.docaviv.co.il</a>
						      </div>




						      <a href="//graphics-lapam.org.il/clients/tayarut/negev/files/assets/basic-html/page-1.html#" target="_blank"> FÜR WEITERE INFORMATIONEN KLICKEN SIE HIER </a>


         `,
      };
    },
  },

  {
    ctg: "telavivAndJerusalem",
    isVid: false,
    id: 41,
    bgImage: "/posts/bank/46/1.jpg",
    mobBgImage: "/posts/bank/46/M/1.jpg",
    title: "Mit Kindern reisen -",
    smltitle: "",
    html: function() {
      return {
        __html: `

              		
                              <h2>Ununterbrochene Spannung für die ganze Familie</h2>
              		          <p>Mit Kindern nach Tel Aviv und Jerusalem zu reisen ist ein fantastisches Erlebnis. Beide Städte sind extrem familienorientiert und von der Natur bis zur Kultur gibt es jede Menge tolle Attraktionen und spannende Aktivitäten.</p>

                              <p>Mit bis zu 300 Sonnentagen im Jahr, bieten die wunderschönen Strände eine fabelhafte Kombination aus Sonne und Spaß. Die Strandpromenade ist ein großartiger Ort für Kinder zum Spazieren, Laufen, Fahrradfahren oder gar mit einem Mini-Scooter durch die Gegend rauschen. Vergessen Sie nicht das reiche Angebot an Museen und Straßenaufführungen zu erforschen, und einen wunderschönen Tag im Freien, im HaYarkon Park zu verbringen. </p>

                              <p>Ein Besuch in Jerusalem wird mit seinen malerischen Gassen, seinen einzigartigen Museen und mit seiner faszinierender Geschichte wird Ihre Phantasie beflügeln. Schattige Parks, Wasserspiele und Ausstellungen für Kinder und Shows - es ist für jeden Alter etwas dabei.</p>

                              <p>Das große Angebot an spannenden Aktivitäten garantiert einen unvergesslichen Besuch in Tel Aviv und Jerusalem für die ganze Familie. </p>
                              <p> Ein Besuch in Jerusalem und Tel Aviv ist das perfekte Ziel für Familien, die Spaß und Spannung suchen. Beide Städte sind ganz einfach vollgepackt mit tollen Aktivitäten und Attraktionen für die ganze Familie. Hier finden Sie nur einige jener fabelhaften Möglichkeiten, wie Sie die Zeit mit Ihrer Familie großartig in Jerusalem und Tel Aviv verbringen können - alles, was Sie und Ihre Familie machen müssen, ist zu eine Aktivität zu wählen und schon geht’s los: </p>
                              <div class="img-wrapper">
                                                <img src=${getImgUrl() +
                                                  "/thingsToDo/posts/35/1.jpg"} class="img-responsive" />
                                </div>
                              <h3>
                                              Tel Aviv
                              </h3>
                              <p><strong>"Luna Park":</strong> Ein fantastischer Vergnügungspark im Herzen der Stadt, mit einer Reihe von lustigen und aufregenden Achterbahnen und Attraktionen für die ganze Familie. Direkt gegenüber dem wunderschönen Hayarkon Park, der auch die grüne Lunge von Tel Aviv genannt wird.</p>
                              <p><strong>HaYarkon Park:</strong> Der ruhige Yarkon Park am Rande der ewig lebendigen Stadt, bietet wunderschöne Grünflächen, Bootsfahrten auf dem Fluss, Radtouren entlang den ausgebauten Radwegen, Sportplätze und vieles mehr für die ganze Familie. Genießen Sie ihr Picknick mit einem atemberaubenden Blick auf Tel Aviv.</p>
                              <p><strong>Heißluftballon:</strong> Nachdem Sie sich im wunderschönen HaYarkon Park erholt haben, gönnen Sie sich doch einen Blick auf das wunderschöne Tel Aviv, nämlich so, wie Sie es noch zuvor nie erlebt haben – lassen Sie sich über den Yarkon Park treiben – das Erlebnis für romantische Ausflüge, oder einfach nur aus Spaß mit Ihrer Familie.</p>
                              <p><strong>Observatorium:</strong> Wenn Sie in Azrieli sind, sollten Sie unbedingt das fantastische Observatorium im obersten Stockwerk besuchen, um einen 360°-Blick auf Tel Aviv zu werfen, den die Kleinen nicht so schnell vergessen werden. </p>
                              <p><strong>Das Planetarium:</strong> Mit einer lustigen Einführung in die Astronomie werden Sie mit interaktiven Ausstellungen, Drehsitzen und informativen Präsentationen für die ganze Familie in den Weltraum entführt.</p>
                              <p><strong>Safari:</strong> Mit der größten Sammlung von Tieren im Nahen Osten können Sie einen wunderschönen Tag in freier Wildbahn verbringen, nur 15 Minuten vom Herzen Tel Avivs entfernt, wo Sie sich auch die anderen Sehenswürdigkeiten der Stadt ansehen können.</p>
                              <p><strong>HaTachana, Tel Avivs alter Bahnhof:</strong> Ein Genuss für die ganze Familie - der alte Bahnhof bietet für jeden etwas - mit Restaurants, Kinderaktivitäten, Kunstgalerien, Straßenaufführungen und sogar einer Zugfahrt.</p>
                              <p><strong>Der Hafen von Tel Aviv:</strong> Atmen Sie die Seeluft ein und genießen Sie den herrlichen Yachthafen, holen Sie sich etwas zu essen in einem der vielen Restaurants oder Cafés, und schauen Sie sich die fantastischen Straßenaufführungen mit Musik, Zaubertheater und vieles mehr an, die speziell für die Freude der Kleinen ausgerichtet sind.</p>
                              <p><strong>Nachlat Binyamin Straßenmesse:</strong> Dies ist die größte Messe ihrer Art in Israel, sie ist eine heitere und belebende Erfahrung mit Kunsthandwerkern, Live-Musik, Straßenaufführungen und Cafés, die Menschen jeden Alters ansprechen wird.</p>
                              <p><strong>Sarona: </strong>Der überdachte Markt ist ein beliebtes Ziel für Paare, Gruppen und Familien, die die beliebtesten Orte der Stadt suchen.</p></p>

                              <h3>
                                    Museen: 
                              </h3>
                              <p><strong>Tel Aviv Kunstmuseum:</strong> Mit einer Vielzahl von Sammlungen, Führungen, kreativen und interaktiven Aktivitäten und Spielen ist das Museum eine wahre Schatztruhe für Eltern und Kinder.</p>
                              <p><strong>Naturhistorisches Museum:</strong> Das 2018 eröffnete, 5-stöckige Museum mit seinen 3.000 Ausstellungsobjekten bietet den Kindern die Möglichkeit, die Kreaturen des Landes hautnah zu erleben.</p>
                              <p><strong>Das Olympische Erlebnismuseum:</strong> Die Führungen bieten einen interaktiven Einblick in die Geschichte des Sports in Israel mit tollen Multimedia-Ausstellungen, die der ganzen Familie Spaß machen.</p>
                              <p><strong>Independence Hall (Halle der Unabhängigkeit) -</strong> der Geburtsort des Staates Israel und der Geburtsort der ersten hebräisch-sprachigen Stadt, Tel Aviv. Eine faszinierende Reise durch die Geschichte für die ganze Familie. </p>

                               <div class="img-wrapper">
                                    <img src=${getImgUrl() +
                                      "/thingsToDo/posts/35/2.jpg"} class="img-responsive" />
                                </div>
                              <h3>
                                            Jerusalem  
                              </h3>
                              <p><strong>Die Stadt Davids:</strong> Ein eindringliches archäologisches Erlebnis im Herzen des alten Jerusalems, mit archäologischen Ausgrabungen, Führungen und einem Spaziergang durch einen unterirdischen Wassertunnel.</p>
                              <p><strong>Nachtspektakel - Sound & Light Show:</strong> Eine atemberaubende Show die die erste ihrer Art ist, bei der die Mauern der Zitadelle zur Bühne für eine nächtliche Show werden, wo die 4.000 Jahre alte Geschichte Jerusalems mit Sehenswürdigkeiten und Klangeffekten gefeiert wird.</p>
                              <p><strong>Das Aquarium: </strong>Eine der heißesten Attraktionen in Jerusalem, die Ende 2017 eröffnet wurde, bietet ein fesselndes Abenteuer durch die vier Meere Israels, das jeden, von jung bis alt begeistern wird.</p>
                              <p><strong>Der Zeitaufzug:</strong> Tauchen Sie ein in die virtuelle Realität auf einer Reise durch die faszinierende Geschichte Jerusalems, mit sich rüttelnden Sitzen und Spezialeffekten, die die Jugendlichen unter Ihnen verblüffen werden.</p>
                              <p><strong>Der Botanische Garten: </strong>Ein atemberaubendes Juwel im Herzen der Stadt mit mehr als 6.000 Pflanzenarten aus der ganzen Welt - dies ist ein interessanter und ruhiger Ort für jedermann.</p>
                              <p><strong>Segway Tours:</strong> Geeignet für Jugendliche und Erwachsene – Segway Touren bieten ein unvergessliches Erlebnis mit der Fahrt durch die faszinierende Gegenden, die Ihnen ermöglichen, sowohl den modernen, aber auch den antiken Charakter der Stadt zu genießen.</p>
                              <p><strong>Mini-Israel: </strong>Mit hunderten von Mini-Repliken von israelischen Sehenswürdigkeiten, bietet es eine einzigartige Sicht aus der Vogelperspektive auf die historischen, religiösen und modernen Gebiete im ganzen Land.</p>

                              <h3>
                                   Museen:
                              </h3>
                              <p><strong>Israel Museum: </strong>Ein führendes Kunst- und Archäologiemuseum, das Sie in die reiche Geschichte und Kultur des Landes und seiner Menschen einweiht, mit Ausstellungen für Besucher jeden Alters.</p>
                              <p><strong>Der Turm Davids Museum:</strong> Der historische Eingang zur Altstadt von Jerusalem - die mittelalterliche Zitadelle bietet 3D-Modelle, versteckte Gänge, Familienführungen und auch andere Aktivitäten.</p>
                              <p><strong>Ein Yael Living Museum:</strong> Eine erlebnisreiche Reise durch eine alte römische Straße, kreative Workshops, Pita-Backen und Einzelgespräche mit zeitgenössischen Schauspielern – Familien werden diesen Tag lieben.</p>
                              <p><strong>Das Bloomfield Wissenschaftsmuseum:</strong> Ein fantastisches, kindgerechtes Kultur- und Bildungsmuseum, das herkömmliche, aber auch interaktive Ausstellungen zu den Themen der Wissenschaft und Technik präsentiert.</p>


            	`,
      };
    },
  },

  // No translation
  {
    ctg: "telaviv",
    isVid: false,
    id: 42,
    bgImage: "/posts/bank/78/1.jpg",
    mobBgImage: "/posts/bank/78/M.jpg",
    title: "Party Capital",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h2>Epic Nights in the non stop city</h2>

              		<p>
						Tel Aviv’s awesome nightlife scene has become famous worldwide. The city the doesn’t stop is teaming up with endless possibilities designed for an epic night out!
              		</p>
					<p>
						Start slow and easy in a bar at the chilled out Port of Tel Aviv, or grab yourself a shoreline table, perhaps at Jerusalem Beach. Order a beer, feel the sand between your toes, and watch the sunset.
					</p>
					<p>
						Now that you’re in a mellow mood, it’s time to get your groove on. you’ll be spoiled for choice with upscale clubs, bracelet bars, and other hangouts around Tel Aviv’s White City, Rothschild Boulevard and nearby streets (Levontin, Yehuda HaLevi, Lillenblum, and Allenby), with their trendy see and be seen vibe, filled with young party people all night long.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/78/1.jpg"} class="img-responsive" />
					</div>
					<p>
						A five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don’t miss the up and coming hipster style Flea Market area in Jaffa.
					</p>
					<p>
						Want a more mainstream approach to a night on the town? Three streets – King George, Dizengoff, and Ibn Gabirol – will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.
					</p>
					<p>
						Wherever you go, you will always find where to have an awesome night in nonstop Tel Aviv!
					</p>
            	`,
      };
    },
  },

  //No translation
  // {
  // 	ctg :"jerusalem",
  // 	isVid:false,
  // 	id:43,
  //               bgImage: "/posts/bank/79/1.jpg",
  //               mobBgImage: "/posts/bank/79/M.jpg",
  //               title :"FIRST TIME IN JERUSALEM",
  //               smltitle : "The must list for the first-time visitor",
  //               html: function(){
  // 			return {
  // 				__html: `

  //               		<p>
  // 						Scour the globe it’s hard to match Jerusalem for history, culture, and significance! So rich in sites and activities, it’s difficult to know where to begin. Here are a few suggestions…
  //               		</p>
  // 					<p>
  // 						Jerusalem is the nexus of three of the world’s great faiths. As such, you might want to consider religious, spiritual, or historical locations that will be meaningful to you.
  // 					</p>
  // 					<p>
  // 						Almost any itinerary will include Old City. Famous as the home of the Western Wall, and the Church of the Holy Sepulcher, you could spend days exploring its four quarters – Jewish, Christian, Muslim, and Armenian – and only see but a small part of its many treasures. Make sure to download the free Audio Tours of Jerusalem app, which offers dozens of walking routes, GPS maps, and geo-location alerts as you approach each site.
  // 					</p>
  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/79/1.jpg"} class="img-responsive" />
  // 					</div>
  // 					<p>
  // 						A five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don’t miss the up and coming hipster style Flea Market area in Jaffa.
  // 					</p>
  // 					<p>
  // 						Want a more mainstream approach to a night on the town? Three streets – King George, Dizengoff, and Ibn Gabirol – will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.
  // 					</p>
  // 					<p>
  // 						Wherever you go, you will always find where to have an awesome night in nonstop Tel Aviv!
  // 					</p>
  //             	`   }
  //   }
  // },

  // No translation
  // {
  // 	ctg :"telavivAndJerusalem",
  // 	isVid:false,
  // 	id:44,
  //               bgImage: "/posts/bank/80/1.jpg",
  //               mobBgImage: "/posts/bank/80/M.jpg",
  //               title :"TRAVELLING ON A BUDGET",
  //               smltitle : "Making It Count in Tel Aviv and Jerusalem!",
  //               html: function(){
  // 			return {
  // 				__html: `

  //               		<p>
  // 						So you’ve heard of the stunning beaches, the amazing sights and the fabulous cuisine and you are looking to travel to Jerusalem and Tel Aviv, but affordability is a concern. Well, pack your bags and worry no more! Both cities offer low-cost accommodations, transportation, and meals, as well as countless sites to see and things to do, which require little or no expense.
  //               		</p>
  // 					<p>
  // 						For affordable accommodation you can choose from the many hostels and smaller hotels, many of which are located only a few minutes’ walk from Tel Aviv’s Beaches and Jerusalem’s main attractions.
  // 					</p>
  // 					<p>
  // 						Getting around? In both cities it’s a snap with a Rav Kav card. Purchase one for little more than a dollar at”Al Hakav” (on the line) Service centers at central stations and other locations around the city. Jerusalem also offers an affordable City Pass option, and in Tel Aviv, the Tel Ofan bicycle rental municipal service is a great and low cost way to get around in the city.
  // 					</p>
  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/80/1.jpg"} class="img-responsive" />
  // 					</div>
  // 					<p>
  // 						What to do? Jerusalem and Tel Aviv are packed with sites, marketplaces, parks, nearby nature reserves and hiking trails. There are endless ways to not spend a dime and fill your trip with unforgettable experiences.
  // 					</p>
  // 					<p>
  // 						Finally, everyone’s gotta eat, from hummus to gourmet, both cities are famous for great street food and low-price restaurants offering cheap lunch time dining.
  // 					</p>
  // 					<p>
  // 						So come visit Tel Aviv and Jerusalem where you are guaranteed a fantastic time without breaking the bank.
  // 					</p>
  //             	`   }
  //   }
  // },

  //No translation
  // {
  // 	ctg :"jerusalem",
  // 	isVid:false,
  // 	id:45,
  //               bgImage: "/posts/bank/81/1.jpg",
  //               mobBgImage: "/posts/bank/81/M.jpg",
  //               title :"UPSCALE JERUSALEM",
  //               smltitle : "Modern luxuries for the pampered traveler",
  //               html: function(){
  // 			return {
  // 				__html: `

  //               		<p>
  // 						When it comes to luxury travel, high class accommodations, fine dining, and top-drawer shopping options Jerusalem is a city that’s truly arrived.
  //               		</p>
  // 					<p>
  // 						The city features numerous 5-star and boutique hotels ready to custom cater to your needs for comfort and relaxation, offering amazing rooftop views and inhouse spa treatments to boot.
  // 					</p>
  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/81/1.jpg"} class="img-responsive" />
  // 					</div>
  // 					<p>
  // 						Looking to delight your palette? Well, in 2018, several Jerusalem establishments were listed in the prestige French restaurant guide, Gault & Millau. Beyond that, the city features and is increasingly attracting some of the world’s best chefs.
  // 					</p>
  // 					<p>
  // 						When it comes to style, fashion, and swanky shopping, Jerusalem has any number of places you’ll want to visit. Among these are Arlov Mamilla Avenue. This happening and trendy outdoor mall complex is a must for your go-to city destinations. Even better, it’s situated just steps away from the Old City’s Jaffa Gate.
  // 					</p>
  // 					<p>
  // 						Another not-to-be-missed stop on your itinerary is the elegant The First Station. For over 100 years a railway depot, the site has been transformed into an urban shopping and culinary mecca that’s chock-a-block with restaurants, shops, art galleries and an artists’ marketplace three days a week, as well as live performances and more.
  // 					</p>
  // 					<p>
  // 						And as long as you’re in the neighborhood, treat yourself to a romantic afternoon or evening on Emek Refaim Street, the German Colony’s main thoroughfare. Its beguiling architecture laid back mood, stylish boutiques, intimate restaurants, and 1920s-era cinema offer an absolute treat for all the senses.
  // 					</p>
  //             	`   }
  //   }
  // },

  // End Posts

  {
    id: 5,

    ctg: "deadsea",
    isVid: false,
    bgImage: "posts/bank/100/1.jpg",
    mobBgImage: "posts/bank/100/M.jpg",
    title: "Dead Sea Joys",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                          <h2>For a floating good time</h2>
			              <p>
			                              A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction. 
			                              Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. 
			                              <strong>The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, 
			                              allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. 
			                              While here, you can bathe</strong> in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.
			              </p>

			              <p>
			                              Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.
			              </p>
			              
			`,
      };
    },
  },

  //No translation
  // {
  // 	id:24,
  //                bgImage : "/posts/bank/17/1.jpg",
  //         	mobBgImage : "/posts/bank/17/M.jpg",
  //               title : "ULTIMATE BEACH FUN",
  //               ctg:"telaviv",
  //               isVid:false,
  //               player_id_post :"",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  //                 <div class="responisve-iframe">
  // 					<iframe src="https://www.youtube.com/embed/I9a4BFWO_6w/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
  // 				</div>

  //             		<p>
  //                 		Israel has a wide selection of beaches to choose from. The wide Mediterranean stretch along the west side of the country boasts wide golden sands and the gorgeous blue waves of the med.

  //             		</p>

  //         		 	<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/24/1.jpg"} class="img-responsive" />

  // 					</div>

  //             		<p>
  //                 		The beaches by the main cities as offer the hustle and bustle, beach bars, restaurants, sporting activities and festivals alternatively if you just want to find a quiet spot there are plenty of coves and vast stretches that are untouched, popular with those who just want to relax. If you are into surfing there are certain beaches that have great spots to ride the waves.
  //             		</p>

  //             		<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/24/2.jpg"} class="img-responsive" />

  // 					</div>
  //             		<p>
  //                 		Up North the Sea of Galilee have some lovely beaches where you can camp out, barbeque and really make a day of it. The Galilee offer boat hire and water sport equipment for some water fun!
  //             		</p>
  // 	                <p>
  // 	                	The Dead Sea’s desert beaches possess a unique atmosphere in the clear air and of course a sea which is not for swimming but for floating and taking care of your skin.
  // 	                </p>
  // 	                <p>
  // 	                	Last but not least the beaches in Eilat boast crystal clear blue waters of the Red Sea that are very seldom wavey. Eilat is known for its beautiful diving spots and swimming with dolphins. They have wonderful beach bars, restaurants, water sports and attractions a perfect destination for holiday makers.
  // 	                </p>
  //             	 `
  //     }
  //   }
  // },

  // No translation
  // {
  // 	id:27,
  //               bgImage : "/posts/bank/30/1.jpg",
  //               mobBgImage : "/posts/bank/30/M.jpg",
  //               title : "WESTERN WALL WONDERS",
  //               ctg :"jerusalem",
  //               isVid:false,
  //               player_id_post :"",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				<p>
  // 					The Western Wall (or Kotel, in Hebrew) was part of the most magnificent building Jerusalem had ever seen, which was the Second Temple, built by the great King Herod.
  // 				</p>

  // 				<p>
  // 					The Second Temple was destroyed in the year 70 CE and despite the destruction that took place, all four of the Temple Mount support walls remained standing.  Throughout the generations since the Temple’s destruction, the Western Wall was the remnant closest to the site of the Temple’s ‘holies of holies - a place where only the Jewish High Priests were allowed, as it was there they believed God was present.  The actual remains of the Temple can be found the Western Wall Tunnels, which are an extraordinary journey through time.
  // 				</p>

  //              	<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/27/1.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					For centuries Jewish People from around the world have been going there to mourn the loss of this grand temple. You will often find hundreds of people of different nationalities and religions’ pouring out their heart with prayers as the wall is believed to have enormous spiritual significance.
  // 				</p>

  // 				<p>
  // 					It is tradition for the people that visit to write a note and place it in the cracks of the Western Wall, as it is believed the message will be taken to God. You will often find doves resting in the crevices of this impressive structure, which are a symbol of peace.
  // 				</p>

  // 				<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/27/2.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					The Western Wall is a national symbol as the ancient bricks have seen Israel and the Jewish peoples  birth, exile and redemption. It’s a very popular location for national ceremonies and even Bar Mitzvah to take place
  // 				</p>
  // 				<p>
  // 					For more information   <a  target="_blank" href="//www.thekotel.org">www.thekotel.org</a>
  // 				</p>

  //             	 `
  //     }
  //   }
  // },

  // No translation
  // {
  // 	id:28,
  //              bgImage : "/posts/bank/30/1.jpg",
  //               mobBgImage : "/posts/bank/30/M.jpg",
  //               title : "WHITE CITY SPLENDOR",
  //               ctg:"telaviv",
  //               isVid:false,
  //               player_id_post :"",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				<div class="responisve-iframe">
  // 					<iframe src="https://www.youtube.com/embed/MJ-gsGs1tqA/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
  // 				</div>

  // 				<p>
  // 					Tel Aviv’s “WHITE CITY” is a UNESCO World Heritage Site, because the city is home to more Bauhaus, modern and “International” architecture than any city on earth.
  // 				</p>

  //              	<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/28/1.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					Tel Aviv was founded in 1909 as a garden suburb of the crowded port city of Jaffa. Very quickly it grew into a bustling metropolis so that by 1929, it was a flourishing city that was the apex of the Zionist dream. With the rise to power of Hitler in 1933, dozens of German Jewish architects escaped to Palestine – many of whom were students or graduates of the legendary Bauhaus school of design. The burgeoning of Tel Aviv required more and more buildings, and the arriving architects very quickly adapted their northern European Bauhaus design to the needs of the eastern Mediterranean heat. A walk through central Tel Aviv will bring you face to face with dozens of these extraordinary office buildings, apartment buildings and stores.
  // 				</p>

  // 				<p>
  // 					<a  target="_blank" href="//www.bauhaus-center.com/">www.bauhaus-center.com/</a>
  // 				</p>

  //             	 `
  //     }
  //   }
  // },

  // No translation
  // {
  // 	id:29,
  //               bgImage : "/posts/bank/30/1.jpg",
  //               mobBgImage : "/posts/bank/30/M.jpg",
  //               title : "TOWER OF DAVID MUSEUM",
  //               ctg:"jerusalem",
  //               isVid:false,
  //               player_id_post :"",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				<p>
  // 					Jerusalem’s Citadel, known as the “Tower of David”, is a historical and archaeological asset of international significance. The Tower is a medieval fortress that is located near the Jaffa Gate, the historical entrance to the Old City and has been the symbol for the city of Jerusalem for generations.
  // 				</p>

  //              	<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/1.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					At the Tower of David Museum you are presented with Jerusalem’s astounding story. While absorbing yourself in legends of the past and their dramatic chronicles it will not take you long to realise that the very stones of the museum are part of this city’s living history.
  // 				</p>

  // 				<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/2.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					The 500-year-old walls are part of the Turkish citadel; its name derives from a tower so massive that early Jerusalemites ascribed it to their great King David and despite the name being ‘The Tower of David’ it was actually build by King Herod.
  // 				</p>

  // 				<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/3.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					Your visit can begin with a breath-taking view of old and new Jerusalem from the top of the tower. Each ancient room has been revamped to showcase a different period, allowing the tempestuous events of 4,000 years to fall perfectly into place in your mind.
  // 				</p>

  // 				<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/4.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					The windows frame glimpses of modern Jerusalem, and with each doorway you exit, you look down into the citadel’s central courtyard, where archaeologists have unearthed remains dating from the Maccabees to the Middle Ages. This incredible site really is a maze of time!
  // 				</p>

  // 				<p>
  // 					The museum also utilizes its unique space for multi-sensory exhibits by leading designers and artists from Israel and abroad. This One of a kind museum hosts the annual ‘Night Spectacular’ which is a unique sound and light show where the whole of the Citadel is lit up with stunning designs!
  // 				</p>

  // 				<p>
  // 					For more information:   <a href="//www.tod.org.il/en/">www.tod.org.il/en/</a>

  // 				</p>

  //             	 `
  //     }
  //   }
  // },

  // No translation
  // {
  // 	id:30,
  //              bgImage : "/posts/bank/55/1.jpg",
  //               mobBgImage : "/posts/bank/55/M.jpg",
  //               ctg :"telavivAndJerusalem",
  //               isVid:false,
  //               title : "ALL SENSORY MARKETS",
  //               player_id_post :"",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				<p>
  // 					For a genuine Middle Eastern experience you can’t beat a visit to one of Israel’s many markets (Shuks).  The different colours, textures, smells, tastes and sounds of these hives of activity can be a highlight of any Israel visit.
  // 				</p>

  // 				<p>
  // 					These markets are a melting pot of cultures and a great place to give your bartering skills a go. Through the winding cobbled streets you will find, fresh produce, souvenirs, art and handmade jewellery…the list is endless. Bring home a gift for your friends and family or just enjoy walking around and tasting different flavours.
  // 				</p>

  //              	<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/thingsToDo/posts/30/1.jpg"} class="img-responsive" />
  // 				</div>

  // 				<h3>
  // 					Tel Aviv
  // 				</h3>
  // 				<p>
  // 					The Carmel Market, or Shuk HaCarmel, is the most famous of all Tel Aviv’s marketplaces. In recent years, it’s even joined the ranks of Tel Aviv’s trendy spots for bars, restaurants, coffee shops and chef-owned food stalls. It’s no wonder Shuk HaCarmel is Tel Aviv’s largest and most-centrally located shuk: From hand-made Jachnun, a traditional Yemenite dish, to boutique cheeses, and from one-off cotton clothes to designer threads, HaCarmel has it all. Plan your visit around your tastebuds and food preferences - salted fish, cured meats, Middle Eastern fare, fresh baked French pastries, and local-roasted coffee or fresh-pressed fruit or vegetable juice blends to wash it all down.
  // 				</p>

  // 				<p>
  // 					<a target="_blank" href="//www.shuktlv.co.il/en/category/carmel-market">
  // 						www.shuktlv.co.il/en/category/carmel-market
  // 					</a>
  // 				</p>

  // 				<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/thingsToDo/posts/30/2.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					Nachlat Binyamin arts and crafts fair was established in 1988. It is the oldest and biggest of its kind in Israel, and one of the nicest in the world. The market is home to over two hundred artists who use materials such as wood, glass, fabric, plastic, paper…even rocks (almost anything) to hand-make what they sell on their stall.
  // 				</p>

  // 				<p>
  // 					<a target="_blank" href="//www.shuktlv.co.il/en/category/carmel-market">
  // 						www.shuktlv.co.il/en/category/carmel-market
  // 					</a>
  // 				</p>

  // 				<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/thingsToDo/posts/30/3.jpg"} class="img-responsive" />
  // 				</div>
  // 				<h3>
  // 					Jerusalem
  // 				</h3>

  // 				<p>
  // 					The Machane Yehuda market is widely recognized as a symbol of the Jerusalem, and for a very good reason: Jerusalemites see it as a place that represents them, symbolizes them, and gives them a unique identity in a larger Israeli social context. Jerusalem today has many shopping and entertainment centres, but there is something about the Machane Yehuda market that attracts people, even without a shopping list.  From the heady scent of spices to the colourful displays of fruits and vegetables, a trip to this market is pleasing for all your senses.
  // 				</p>

  // 				<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/thingsToDo/posts/29/4.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					One option of experiencing this market is by buying a ‘Machane Yehuda Bites Card’.  This card is comprised of vouchers curated in order to give you a chance to try a variety of products, flavours and the aromas of the market - without having to depend on an organized group or tour.  For more information please click here:
  // 				</p>

  // 				<p>
  // 					<a target="_blank" href="//www.machne.co.il/en/">
  // 						http://www.machne.co.il/en/
  // 					</a>
  // 				</p>

  //             	 `
  //     }
  //   }
  // },

  //No translation
  // {
  // 	id:31,
  //               bgImage : "/posts/bank/20/1.jpg",
  //               mobBgImage : "/posts/bank/20/M.jpg",
  //               title : "UNFORGETTABLE YAD VASHEM",
  //               ctg :"jerusalem",
  //               isVid:false,
  //               player_id_post :"",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				<p>
  // 					Yad Vashem, Israel’s main Holocaust remembrance and education centre is situated on the green slopes of Har HaZikaron, (the Mount of Remembrance) in Jerusalem.
  // 				</p>

  // 				<p>
  // 					Israel’s Holocaust commemoration project began in 1953 with the task of perpetuating the memory of Holocaust victims and documenting the history of the Jewish people during the Holocaust so that it will be remembered by future generations. This project was an important step for the young nation of Israel at the time and was significant for the citizens of Israel, particularly for the survivors of the ghettos and concentration camps.
  // 				</p>

  //              	<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/thingsToDo/posts/31/1.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					The new Yad Vashem museum was opened to the public in 2005. The museum is designed in the shape of a prism penetrating the mountain. Divided into nine galleries, the museum relates the stories of the Jewish communities before the Second World War and the series of events beginning from the rise of the Nazis to power, the pursuit of the Jews, their eviction to the ghettos and ending with “the Final Solution” and mass genocide
  // 				</p>

  // 				<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/thingsToDo/posts/31/2.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					The personal experiences and feelings of the victims of the Holocaust constitute the groundwork for the museum’s exhibits. Photographs, films, documents, letters, works of art, and personal items found in the camps and ghettos are all an integral part of the exhibits. As you exit the Museum itself is the Hall of Names, an inspiring memorial containing over three million names of Holocaust victims that were submitted by their families and relatives. Names can still be submitted by visitors to the memorial and added to the computerized archive.
  // 				</p>

  // 				<p>
  // 					In addition to the Holocaust History Museum Yad Vashem has other memorials and monuments including  the Hall of Remembrance, where the ashes of the dead are buried and an eternal flame burns in commemoration; Yad Layeled, the children’s memorial, commemorating the one and a half million Jewish children who were murdered in the Holocaust;
  // 				</p>

  // 				<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/thingsToDo/posts/31/3.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					The Memorial to the Deportees, an authentic railroad car hanging over the cliff on the road winding down from the mountain. The car was used to transport Jews who had been banished from their homes to the concentration camps.
  // 				</p>

  // 				<p>
  // 					The Avenue of the Righteous Among the Nations has over 2,000 trees which were planted in honor of non-Jews who endangered their lives in order to rescue Jews from the Nazis; The archives and library of Yad Vashem House the world’s largest repository of material about the Holocaust;
  // 				</p>

  // 				<p>
  // 					Visiting the Yad Vashem museum is an emotional and heartrending experience, but seeing the exhibits and remembering the Holocaust gives the more than one million individuals, world leaders and dignitaries who pass through its doors annually a meaningful way to commemorate the six million Jewish victims of the Holocaust.
  // 				</p>

  // 				<p>
  // 					For more information   <a target="_blank" href="//www.yadvashem.org/">www.yadvashem.org</a>
  // 				</p>

  //             	 `
  //     }
  //   }
  // },

  // GO POSTS
  {
    id: "The_Incense_Road",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    title: "DIE WEIHRAUCHSTRAßE",
    ctg: "eilat-negev",
    isVid: false,
    vidId: "",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                        <h2>Eine 2.000 Jahre alte Geschichte des Erfolgs</h2>

                        <p>Die legendäre Weihrauchstraße erzählt eine 2.000 Jahre alte Geschichte wirtschaftlichen Erfolgs.</p>
						
						<p>In Ermangelung verlässlicher Transportmittel Straßen oder Karten wurden damals lange Kamelkaravanen über gefährliche Pfade geführt, unter der steten Gefahr, Räubern, Plünderern, anderen Hindernissen oder unduldsamen Herrschern zum Opfer zu fallen. Wertvolle Güter wurden auf dieser Route, die im Osten im Jemen begann, durch Saudi-Arabien und Jordanien führte und in Israel im Hafen von Gaza endete, transportiert und dort schließlich auf Handelsschiffe verladen, die nach Europa segelten. Dort kamen die Frauen im römischen Reich in den Genuss des Parfüms aus Weihrauch und Myrrhe und bereicherten die Küche mit den Gewürzen aus dem Osten und dem nützlichen Salz, mit dem auch die Lebensmittel haltbar gemacht wurden.</p>
						<div class="img-wrapper">
                             <img src=${getImgUrl() +
                               "/posts/the-incense-road/1.jpg"} class="img-responsive" />
					 	</div>
						<p>Die Reise über die 2.400 Kilometer lange Weihrauchstraße dauerte ungefähr sechs Monate. Die Kamelkaravanen setzten sich aus Tausenden von Personen zusammen, die sich langsam entlang der 56 Wegpunkte bewegten, wo sie anhielten um zu rasten, die Tiere zu versorgen und Kraft für die nächsten Tage zu sammeln.</p>
						<p>Der israelische Abschnitt der Weihrauchstraße ist ungefähr 150 Kilometer lang. Die Spuren der Route sind in der Negev-Wüste immer noch zu finden, und es gibt viele Reisende, die ihnen folgen, um die Wüste zu erkunden und den Lebensstil der Wüstenschiffer zu erleben. Auch einige Anlaufpunkte haben überdauert, angefangen mit Moa, der Oase in der Arava Steinwüste an der Grenze nach Jordanien, wo die Ruinen eines Gasthauses, eines Wachpostens, von Höhlen, Lagerräumen und eines Aquädukts immer noch zu erkennen sind. Von hier aus verlief die Weihrauchstraße nordwestlich nach Mamshit, einer großen Stadt, wo sie auf die eindrucksvollen Ruinen eines Gasthauses, von Kirchen, einem Badehaus, Zisternen und anderen Bauwerken stoßen.</p>
						<p>Der nächste Halt lag in der Stadt Ovdat, die auf einer Anhöhe lag. Auch hier finden sich die Ruinen einer Befestigungsanlage, von Kirchen, einer Ölpresse, einer Keramikwerkstatt, von Häusern, einem Badehaus und sogar Höhlengräber.</p>
						<div class="img-wrapper">
                             <img src=${getImgUrl() +
                               "/posts/the-incense-road/2.jpg"} class="img-responsive" />
					 	</div>
						<p>Die Karavanen reisten weiter von Ovdat nach Shivta, einer kleinen Stadt mit gut entwickeltem Bewässerungssystem, Teichen, Ölpressen und einigen Kirchen. Die vorletzte und nördlichste Station war Halutsa, wo die Ruinen eines Theaters und einer Kirche erhalten sind. Von hier aus ging es direkt nach Gaza. Es &nbsp;siedelten sich einige kleine Raststätten entlang der Route – Kasra, Nekarot, Makhmal und Grafon – an sowie ein zusätzliches Gasthaus, Ein-Saharonim. Hier gibt es immer noch den von Werkstätten und einem Bad umgebenen Innenhof.</p>
						<p>Entlang der Straße gibt es Zisternen, Wachtürme, religiöse Stätten, Bademöglichkeiten und Meilensteine, die den Verlauf markierten.</p>
						<p>Moa, Mamshit, Ovdat, Shivta und Haluza sowie Ein-Saharonim sind mit allen Fahrzeugtypen zu erreichen. Die Weihrauchstraße selbst ist in den Wüstengebieten nur mit einem Jeep passierbar, obwohl die faszinierende Route natürlich auch mit dem Fahrrad oder zu Fuß erkundet werden kann. Im Jahr 2005 hat die UNESCO die Weihrauchstraße zu einem Weltkulturerbe erklärt. Israel lädt sie ein, in Negev und Arava in die Fußspuren der Nomaden zu treten und die eindrucksvollen Erzählungen sowie die großartigen historischen Zeugnisse eines stürmischen Zeitalters zu genießen.</p>
						                        

						
											

         	`,
      };
    },
  },
  {
    id: "The_Negev_Desert",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    title: "DIE NEGEV WÜSTE – NICHT VERPASSEN",
    ctg: "eilat-negev",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                        <h3>Sandboarding in der Wüste</h3>
						<p>Eine kultige Wüstenerfahrung. Die schwungsvollen Sanddünen der Wüste Negev laden zum heruntergleiten ein, egal ob sitzend oder stehend, aber immer unglaublich schnell. Es ist eine fantastische und besondere Herausforderung, und sobald Sie sie meistern (im Grunde genommen ist es ganz einfach), können Sie sich bedenkenlos Sandsurfer nennen – ziemlich cool, oder?</p>
						<div class="img-wrapper">

					         <img src=${getImgUrl() +
                     "/posts/the-negev-desert/1.jpg"} class="img-responsive" />
					 	</div>
						<h3>Negev bei Nacht</h3>
						<p>Der Himmel über dem Negev bietet einen atemberaubenden Anblick. Schauen Sie einfach hinauf, sobald die Dunkelheit einbricht, und Sie werden augenblicklich von dem Glanz von Millionen funkelnder Sterne überwältigt, die die blau-schwarze Dunkelheit mit einem Schein aufhellen, den man nur in der Wüste erleben kann.</p>
						
						<h3>Kamelreiten</h3>
						<p>Rückblickend ist es wohl noch der authentischste Weg die wundervolle Wüstenumgebung zu erkunden. Das Reiten auf dem Rücken eines Kamels, das in vielen Kamelfarmen angeboten wird, bleibt Ihnen garantiert in Erinnerung.</p>
						<div class="img-wrapper">

					         <img src=${getImgUrl() +
                     "/posts/the-negev-desert/2.jpg"} class="img-responsive" />
					 	</div>
						
						<h3>MidBurn Festival</h3>
						<p>Das ist Israels eigene Version des Festivals „Burning Man“; 6 Tage lang wird eine Stadt vorübergehend aufgebaut, die eine Plattform für gemeinschaftliches Miteinanderleben, mit Kreativität, Kunst, Musik und expressivem Selbstausdruck erschafft.</p>
						<h3>Sonnenaufgang auf Masada</h3>
						<p>Nur für diejenigen, die es wagen, auf die Spitze zu Fuß zu klettern – der Sonnenaufgang auf Masada ist zweifellos eines der unvergesslichsten Erlebnisse in Israel. Die Sonne steigt langsam über den jordanischen Moab Bergen und dem Toten Meer auf und verbreitet ihr Licht über die Wüstenlandschaft. Es ist ein spektakulärer Anblick, den man so schnell nicht wieder vergisst.</p>
						
							

         	`,
      };
    },
  },

  {
    id: "Masada",
    bgImage: "/posts/bank/negev2/1.jpg",
    mobBgImage: "/posts/bank/negev2/M.jpg",
    title: "ERKUNDEN SIE MASADA",
    ctg: "eilat-negev",
    isVid: true,
    vidId: "i8IjojQ39u0",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                        <h2>Mythos im Herzen der Judäischen Wüste</h2>
                        <p>Im Masada Nationalpark finden Sie die einzige, isolierte und antike Festung auf einem Hochplateau in der Judäischen Wüste vor mit wunderbarem Blick auf die Oase des Toten Meeres. Für den Aufstieg nutzen Sie den Schlangenpfad oder die römische Treppe am Fuß der Festung. Zudem besteht die Möglichkeit mit der Seilbahn auf das Plateau zu gelangen.das ca 40-30 v.Chr. erbaut wurde.</p>
						<div class="img-wrapper">
                             <img src=${getImgUrl() +
                               "/posts/masada/1.jpg"} class="img-responsive" />
					 	</div>
						<h3>Erkunden Sie majestätische Ruinen und fühlen Sie sich als Teil der Geschichte</h3>
						<p>Auf Masada befand sich einst ein prachtvolles Burgensemble. Hier wohnten zudem die Freiheitskämpfer, die sich nach der Zerstörung des Zweiten Tempels mutig im Krieg gegen das Römische Imperium aufgelehnt haben. Die kühlen Steinmauern Masadas erzählen die Geschichte jener kühnen Männer und Frauen, die lieber freiwillig einen frühen Tod wählten als erneut in die Sklaverei durch das feindliche Regime zu gelangen, das bereits dabei war, die oberen Klippen zu erstürmen</p>
						<h3>Kultur und Religion auf neuen Höhen</h3>
						<p>Erkunden Sie die Burgruinen und entdecken Sie die Räume und Bauten, sowie die archäologischen Funde, die das Leben von Masada während der römischen Belagerung kennzeichnen. Im nördlichen Bereich betreten Sie die Ruinen des Privatpalastes von König Herodes. &nbsp;</p>
						<div class="img-wrapper">
                             <img src=${getImgUrl() +
                               "/posts/masada/2.jpg"} class="img-responsive" />
					 	</div>
						<p>Ein Raum zeugt von einem tragischen Teil der Historie. Im „Auslosungsraum“ wurde die Reihenfolge gezogen, in welcher die Männer nach und nach den Freitod wählten.</p>
						<p>Auch finden sich auf Masada die Überreste einer byzantinischen Kirche mit kunstvollen Mosaiken, die wahrscheinlich jahrhundertelang von geflohenen christlichen Mönchen im 1. Jahrhundert genutzt wurde</p>
						<p>Erleben Sie Masada als eines der UNESCO Weltkulturerbe, beenden Sie den Tag mit einem Sonnenuntergang und einer Lichtshow am Fuß der Festung, die einen in das Leben und die Schlachten vergangener Jahrhunderte zurückversetzt.</p>
												

         	`,
      };
    },
  },

  // {
  // 	      id:"Masada",
  //               bgImage: "/HomeSlider/Home/3.jpg",
  //               mobBgImage: "/HomeSlider/M/3.jpg",
  //               title :"Masada",
  //               ctg:"eilat-negev",
  //               isVid:true,
  //               vidId:"i8IjojQ39u0",
  //               smlTitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `
  //                         <h2>Mythos im Herzen der Judäischen Wüste</h2>
  //                         <p>Im Masada Nationalpark finden Sie die einzige, isolierte und antike Festung auf einem Hochplateau in der Judäischen Wüste vor mit wunderbarem Blick auf die Oase des Toten Meeres. Für den Aufstieg nutzen Sie den Schlangenpfad oder die römische Treppe am Fuß der Festung. Zudem besteht die Möglichkeit mit der Seilbahn auf das Plateau zu gelangen.das ca 40-30 v.Chr. erbaut wurde.</p>
  // 						<div class="img-wrapper">
  //                              <img src=${getImgUrl() +  "/posts/masada/1.jpg"} class="img-responsive" />
  // 					 	</div>
  // 						<h3>Erkunden Sie majestätische Ruinen und fühlen Sie sich als Teil der Geschichte</h3>
  // 						<p>Auf Masada befand sich einst ein prachtvolles Burgensemble. Hier wohnten zudem die Freiheitskämpfer, die sich nach der Zerstörung des Zweiten Tempels mutig im Krieg gegen das Römische Imperium aufgelehnt haben. Die kühlen Steinmauern Masadas erzählen die Geschichte jener kühnen Männer und Frauen, die lieber freiwillig einen frühen Tod wählten als erneut in die Sklaverei durch das feindliche Regime zu gelangen, das bereits dabei war, die oberen Klippen zu erstürmen</p>
  // 						<h3>Kultur und Religion auf neuen Höhen</h3>
  // 						<p>Erkunden Sie die Burgruinen und entdecken Sie die Räume und Bauten, sowie die archäologischen Funde, die das Leben von Masada während der römischen Belagerung kennzeichnen. Im nördlichen Bereich betreten Sie die Ruinen des Privatpalastes von König Herodes. &nbsp;</p>
  // 						<div class="img-wrapper">
  //                              <img src=${getImgUrl() +  "/posts/masada/2.jpg"} class="img-responsive" />
  // 					 	</div>
  // 						<p>Ein Raum zeugt von einem tragischen Teil der Historie. Im „Auslosungsraum“ wurde die Reihenfolge gezogen, in welcher die Männer nach und nach den Freitod wählten.</p>
  // 						<p>Auch finden sich auf Masada die Überreste einer byzantinischen Kirche mit kunstvollen Mosaiken, die wahrscheinlich jahrhundertelang von geflohenen christlichen Mönchen im 1. Jahrhundert genutzt wurde</p>
  // 						<p>Erleben Sie Masada als eines der UNESCO Weltkulturerbe, beenden Sie den Tag mit einem Sonnenuntergang und einer Lichtshow am Fuß der Festung, die einen in das Leben und die Schlachten vergangener Jahrhunderte zurückversetzt.</p>

  //          	`   }
  //   }
  // },

  {
    id: "Hidden_Galilee",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    title: "ENTDECKEN SIE DIE VERBORGENEN JUWELEN VON GALILÄA",
    ctg: "north",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                        <h2>Ihr Traumurlaub in Israel voller Überraschungen</h2>
                        
						
						<p>Entdecken Sie die fruchtbare Landschaft im Norden Israels, wo malerische Städte die sanften Hügel des oberen und unteren Galiläa krönen und Boutique-Weingüter und Restaurants gleich neben uralten, historischen Stätten zu finden sind. Übernachten Sie in einem Luxushotel oder genießen Sie einen authentischen Urlaub auf dem Land in einem der berühmten „<em>Zimmer</em>“-Ferienhäuschen, die in den kleinen Dörfern von Familien betrieben werden – und Sie werden Israel mit anderen Augen sehen.</p>
						<div class="img-wrapper">
                             <img src=${getImgUrl() +
                               "/posts/hidden-galilee/1.jpg"} class="img-responsive" />
					 	</div>
						<h3>Wo Geschichte zum Leben erwacht</h3>
						<p>Galiläa ist voll von historischen Stätten. Reisen Sie in die alten Dörfer Kfar Nahum (Kapernaum) und Migdal (Magdala) und besuchen Sie das Haus des heiligen Petrus in Kapernaum. Besichtigen Sie die beeindruckenden Kirchen und Klöster rund um den See von Galiläa, die in die frühesten Tage des Christentums zurückführen. In Safed, einer der vier antiken spirituellen Städte des Judentums, können Sie den Glauben nahezu mit Händen fassen, während Sie das wichtigste kabbalistische Zentrum der Welt erkunden. Entdecken Sie die ältesten Synagogen der Welt an Orten wie Baram und die Kreuzritterfestungen von Montfort und Nimrod. Besuchen Sie die Gedenkstätte von Maimonides in der antiken Stadt Tiberias und bestaunen Sie die Wunder des alten Akko (Acre), z.&nbsp;B. die unterirdische Stadt der Kreuzritter sowie die Festung und den Tunnel der Tempelritter.</p>
						<div class="img-wrapper">
                             <img src=${getImgUrl() +
                               "/posts/hidden-galilee/2.jpg"} class="img-responsive" />
					 	</div>

						<h3>Ein Paradies für Gourmets in Galiläa</h3>
						<p>Boutique-Weingüter und handwerklich betriebene Molkereien begrüßen Sie in Galiläa überall, wie auch die authentischen, am offenen Feuer zubereiteten Gerichte der Drusen und Araber. Probieren Sie Lebensmittel direkt vom Erzeuger auf Biobetrieben, verweilen Sie in den im Familienbetrieb geführten Gourmet-Restaurants und genießen Sie die frischen Früchte der Obstgärten. Entdecken Sie Israel, wo nicht nur Milch und Honig fließen, sondern auch Wein, Olivenöl, Ziegenkäse und verführerisches Obst zuhause sind.</p>					

         	`,
      };
    },
  },

  {
    id: "Nazareth",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    title: "NAZARETH",
    ctg: "north",
    isVid: true,
    vidId: "aGMVTrHS8YA",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                        <h2>DIE WIEGE DES CHRISTENTUMS</h2>
                        
						

					 	<p>Eine antike Stadt, die von Geschichte, faszinierender Archäologie, moderner Kultur und orientalischem Charme geprägt ist.</p>
						<p>Nazareth, oder Natsrat, wie der Name auf Hebräisch ausgesprochen wird, ist die Wiege des Christentums. Die Stadt, in der laut Tradition der Erzengel Gabriel Maria erschien und prophezeite, dass Sie durch die Kraft des Heiligen Geistes ein Kind empfangen wird, und der Ort, an dem Jesus seine Kindheit und Jugend verbracht hat. Nazareth, im Unteren Galiläa, befindet sich im Herzen eines Tals inmitten von Bergen. Es ist eine Stadt der Religion und des Glaubens, Spiritualität und Heiligkeit, aber auch eine Stadt, die von Geschichte, faszinierender Archäologie, moderner Kultur und orientalischem Charme geprägt ist.</p>
						<!--<div class="img-wrapper">
                             <img src=${getImgUrl() +
                               "/posts/nazareth/1.jpg"} class="img-responsive" />
					 	</div>-->
						<h3>Die Wiege des Christentums</h3>
						<p>Nazareth war vor etwa 2.000 Jahren ein kleines jüdisches Dorf und wurde während der byzantinischen Zeit für mehrere Jahrhunderte zur Hochburg des Christentums. Während dieser Zeit hat sich der Name von Nazareth überall verbreitet und der Wunsch der Pilger, den Ort zu sehen, an dem die Jungfrau Maria und Jesus Christus lebten, haben die Stadt zu einem beliebten Wallfahrtsort gemacht. Diese Besuche führten zum Bau der ersten Kirche der Stadt - die Verkündigungsbasilika an der traditionellen Heimatstätte von Joseph und Maria.&nbsp; Viele weitere Kirchen wurden in der Stadt gebaut, und während der jahrhundertelangen wechselnden Herrschaft durch Muslime und Christen zum Teil zerstört und wieder aufgebaut. Im 19. Jahrhundert hat Nazareth neues Interesse geweckt, als Christen in die Stadt zurückgekehrt sind und Kirchen und Klöster neu errichteten. Heute ist Nazareth die größte arabische Stadt in Israel mit über 30 Kirchen und Klöstern sowie Moscheen und antiken Synagogen.</p>
						<h3>Eine Kostprobe der Altstadt</h3>
						<p>Bei jedem Rundgang durch Nazareth leben seine verschiedenen Epochen wieder auf. Jede Ära hinterließ ein mächtiges Symbol, das im modernen Zeitalter zu einer beliebten Touristenstätte wurde. Die meisten Stätten konzentrieren sich auf die Altstadt und wurden Mitte des 19. Jahrhunderts im orientalischen Baustil errichtet. Ein Spaziergang durch die engen Gassen zwischen den bezaubernden Häusern ist beeindruckend und es lohnt sich, langsam zu gehen, um die Schönheit zu genießen.</p>
						
						<p>In der Altstadt gibt es viele alte Kirchen, wobei die Verkündigungsbasilika die älteste ist. In der wieder aufgebauten Kirche konnten Teile der vorherigen Kirchen aus den Zeiten der Kreuzritter und Byzantiner erhalten werden. Zudem beherbergt die Kirche eine beeindruckende Gemäldesammlung.</p>
						<p>Direkt neben dieser Kirche steht die St. Joseph Kirche, die auf den Ruinen landwirtschaftlicher Gebäude errichtet wurde und in der, Joseph (Marias Ehemann) der Überlieferung nach, seine Zimmerwerkstatt hatte. Während die Verkündigungsbasilika am Haus von Maria erbaut wurde, wurde die griechisch orthodoxe Verkündigungsbasilika oberhalb von Marias Brunnen errichtet, aus dem Jesus‘ Mutter getrunken haben soll. Dies ist ein Bau aus der Zeit der Kreuzritter, der einige interessante Fresken aufweist. Direkt neben Marias Brunnen steht die griechisch-orthodoxe Verkündigungsbasilika in einem Kreuzrittersaal. Der Überlieferung nach ist das der Standort der Synagoge, in der Jesus betete.</p>
						<p>Zu den vielen anderen Kirchen in Nazareth gehören die Mensa&#8203; Christi Kirche, die Syrisch-Maronitische Kirche, St. Gabriel Kirche und die Salesianer Kirche. Des Weiteren stehen in der Altstadt wichtige Gebäude aus der osmanischen Zeit, wie etwa das Regierungsgebäude Saraya, das von Daher el Omar erbaut wurde, der im 18. Jahrhundert Statthalter von Galiläa war, und die Weiße Moschee, die heute als Gebetshaus sowie Ausbildungs- und Kulturzentrum genutzt wird. Die Weiße Moschee beherbergt außerdem ein Museum mit Ausstellungen zur Geschichte Nazareths.</p>
						<p>Bei einem Rundgang durch die Altstadt von Nazareth darf ein Besuch des Basars nicht fehlen, der dank seiner bunten Marktstände und Warenvielfalt sehr beliebt und bekannt ist. Der Basar ist mit seinen hochmodischen Trendstoffen, Gewürzen und regionalen Speisen, seinen Kunstwerken und Souvenirs ein einziger Augen- und Gaumenschmaus.&nbsp; Die Klänge, Gerüche und Aromen versprechen ein wahrhaft orientalisches Erlebnis.</p>
						<h3>Orientalischer Charme zieht alle Blicke auf sich</h3>
						<p>Nazareth steckt voller faszinierender und wunderschöner Ecken, die Ihr Herz erwärmen werden. Ein weiterer lohnenswerter Ort ist ein Spaziergang auf der Nabi Sain Ridge Promenade, von der aus Sie einen herrlichen Blick auf Galiläa haben. Sie können das antike Türkische Badehaus besichtigen, das während Sanierungsarbeiten an einem der Geschäfte der Stadt entdeckt wurde. Schauen Sie sich eins der schicken Herrenhäuser an, die von den Reichtümern und Bräuchen der osmanischen Oberschicht im 19. Jahrhundert verkünden und einige erstaunliche Fresken aufweisen. Darüber hinaus lohnt sich eine Besichtigung des griechisch-orthodoxen Bischofshauses, in dem Sie durch verschiedene unterirdische Gänge in den Hof gelangen. Eine weitere interessante, von den Russen erbaute Stätte ist ein Hostel für Wallfahrer.</p>
						<p>Nazareth, in dem jahrhundertelang Wallfahrer begrüßt wurden, hat christliche Hostels und schicke Hotels für Touristen, die sich an dieser wichtigen Stätte tummeln, vor allem um die Weihnachtszeit. Dutzende Restaurants mit köstlichen Delikatessen locken das ganze Jahr über Besucher an. Nazareth ist an Weihnachten prächtig dekoriert für die Festtage. Die Farben der Stadt und die aus den Kirchen ertönenden Gebete tragen zur besonderen Atmosphäre bei.</p>
												
         	`,
      };
    },
  },

  {
    id: "Culinary_In_Galilee",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    title: "EIN KULINARISCHER URLAUB IN GALILÄA",
    ctg: "culinarynorth",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                        <h2>Ein Paradies für Foodies</h2>
                        
						<p>Ein Besuch in Galiläa wird Sie mit Geschmacksrichtungen und Aromen in Berührung bringen, die Sie bisher noch nie erlebt haben. Vom handgemachten Käse der Käsemanufakturen bis zu den Weltklasseweinen der Boutique-Weingüter, von den Gourmetrestaurants im Familienbetrieb bis zu frisch geerntetem Obst und Gemüse, das vor Aroma strotzt: Galiläa ist ein Paradies für Foodies.</p>
						<div class="img-wrapper">
                             <img src=${getImgUrl() +
                               "/posts/culinary-in-galilee/1.jpg"} class="img-responsive" />
					 	</div>
						<h3>Das Land, in dem Milch und Wein fließen</h3>
						<p>Besuchen Sie eine Käsemanufaktur, um den reichen Geschmack der Käsesorten aus Galiläa zu entdecken, und lernen Sie den Rhythmus der Käseherstellung kennen. Ein fachkundiger Käser führt Sie durch eine Verkostung einer Auswahl der einzigartigen Weich-, Hart- und halbfesten Käsesorten der Region wie z.&nbsp;B. <em>Lebane</em>, ein cremiger und joghurtartiger Weichkäse aus Schaf- oder Ziegenmilch, der häufig mit lokalen Kräutern wie Za‘atar gemischt serviert wird, oder <em>Zefatit</em>, ein in einem Körbchen angerichteter Schafmilchtopfen, der nach der Region <em>Zefat</em> (oder Safed) benannt ist, in der er ursprünglich hergestellt wurde.</p>
						<div class="img-wrapper">
                             <img src=${getImgUrl() +
                               "/posts/culinary-in-galilee/2.jpg"} class="img-responsive" />
					 	</div>
						<p>Wenn Sie zu Ihrem Käse gerne einen Wein genießen, sind Sie am richtigen Ort. Jeder Wein wird besser sein als der vorherige. In letzter Zeit sind durch eine Revolution in der Weinwirtschaft zahlreiche Boutique-Weingüter entstanden, die auf dem variantenreichen Terroir Galiläas in ihren Weinbergen Trauben anbauen, deren Geschmack die jeweilige Bodenbeschaffenheit detailliert widerspiegelt. Lassen Sie Ihren Blick über die weinbedeckten Hügel schweifen, während Sie angeleitet von den führenden Winzern Israels in dunkel farbenen, fruchtigen, Rot- und frischen Weißweinen schwelgen. Erkunden Sie die Cuvées, aus denen die international preisgekrönten Weine entstanden sind, von denen viele außerhalb Israels nicht im Handel erhältlich sind.</p>					
						         
         	`,
      };
    },
  },

  {
    id: "Rosh_Pina",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    title: "ROSH PINA",
    ctg: "north",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                        <h2>Pastoraler Geheimtipp für Touristen in Galiläa</h2>
                        
						
					 	<h3>Drehen Sie die Zeit zurück im malerischen Dorf in Galiläa</h3>
						<p>Rosh Pina, auch bekannt als die Prinzessin von Galiläa, bietet eine perfekte Mischung aus Natur, Kultur, Geschichte und Unterhaltung. Ein wunderschön restauriertes Dorf im Norden, in dem alte Olivenbäume und idyllische Häuser von goldenen Feldern umgeben sind: Rosh Pina ist genau der Ort für Freizeit und Erholung, an dem Besucher das dörfliche Leben von vor einem Jahrhundert erleben können.</p>
						<!--<div class="img-wrapper">
                             <img src=${getImgUrl() +
                               "/posts/rosh-pina/1.jpg"} class="img-responsive" />
					 	</div>-->
						<h3>Wo magische Stille nur von Vogelgezwitscher unterbrochen wird</h3>
						<p>Suchen Sie einen ruhigen Ort in der Natur, der an die Toskana oder die Provence erinnert? Dann fahren Sie Richtung Rosh Pina. Hier gibt es fernab der Sehenswürdigkeiten des Dorfes ländliche Gebiete, die Sie in längst vergangene Zeiten zurückversetzen. Hier finden Sie eine Vielzahl von Gasthäusern, in denen Sie warmherzig empfangen werden.</p>
						<p>In den romantischen Gassen des Dorfes, fernab vom Trubel der Großstadt finden Sie Erholung und gleichermaßen Inspiration.</p>
						<!--<div class="img-wrapper">
                             <img src=${getImgUrl() +
                               "/posts/rosh-pina/2.jpg"} class="img-responsive" />
					 	</div>-->
						<p>Tauchen Sie ein in die natürliche Schönheit, wandern Sie entlang der grünen <strong>Wanderwege</strong> entlang des Fluss von Rosh Pina oder durch die <strong>Gärten des Barons von Rothschild</strong>, der Berichten zufolge den großen Gärten von Versailles nachempfunden wurde. Atmen Sie die frische Luft ein und genießen Sie beim Schlendern die schöne Aussicht. So werden Sie eins mit der Natur und können auftanken.</p>
						<h3>Eine Ferienanlage mit einzigartigem, künstlerischen Charme</h3>
						<p>Schlendern Sie die Kopfsteinpflasterstraßen entlang, die an alte europäische Städte erinnern, und Sie werden in eine herrliche kulturelle und künstlerische Atmosphäre eintauchen, die von den sanften Hügeln Galiläas umgeben sind. Ein Ort mit trendigen Cafés, Gourmetrestaurants, Kunstgalerien, Museen, Festivals, historischen Stätten und Einkaufszentren. In der Stadt wimmelt es von Antiquitäten, Kultur, kulinarischen Genüssen, die gemeinsam Geschichten von der ersten „Galiläa Moshava“ und der Gründung der jüdischen Gemeinden in Israel erzählen.</p>
						       
         	`,
      };
    },
  },

  {
    id: "F_A_Q",
    bgImage: "/HomeSlider/Home/3.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    title: "FAQ",
    ctg: "TouristInfo",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                        <h3>Häufig gestellte Fragen (FAQ) </h3>

                                    <p>
                                        <ol start="1">
									         <li>
								                <strong>Ich bin als Tourist in Israel und bin besorgt, dass ich COVID-19 haben könnte, an wen wende ich mich?</strong><br/>
								                Wenn Sie 38 °C Fieber oder höher, Husten, Atembeschwerden oder andere Atemwegssymptome haben, müssen Sie sich sofort in Quarantäne begeben und die Notfall-Hotline 101 anrufen, um medizinischen Rat zu erhalten.<br>Gehen Sie auf keinen Fall in eine HMO-Klinik oder eine Notfallstation.</b>
								              </li>
								              <li>
								                <strong>Wann wird Israel wieder für Besucher von außerhalb zugänglich sein?</strong><br/>
								                Zum gegenwärtigen Zeitpunkt ist kein Datum bekannt, an dem Israel für Besucher von außerhalb zugänglich sein wird.
								              </li>
									       
									      </ol>
                                    </p>
                        <h3>One of the world's 25 best cities for foodies</h3>
                        <p>Für einen Aufenthalt von bis zu drei Monaten benötigen Reisende einen Reisepass, der mindestens sechs Monate über das Reisedatum hinaus, gültig ist. Menschen ohne Nationalität benötigen einen gültigen Passierschein sowie ein Rückreisevisum in das ausstellende Land.</p>
						<p>Deutsche Reisende, die vor dem 01.01.1928 geboren sind, benötigen ein Visum. Dieses kann bei der Israelischen Botschaft in Berlin beantragt werden.</p>
						<h3>Es gibt keine generellen Einreisebeschränkungen für Reisende, die mit arabischen Visavermerken im Reisepass nach Israel einreisen möchten.</h3>
						<p>&nbsp;Es kann sein, dass sich der Reisende einer Sicherheitsbefragung unterziehen und erklärlich machen muss, welchen Zweck seine Reise in das entsprechende Land gehabt hat. Die endgültige Entscheidung über die Einreise trifft immer die Grenzbehörde am Grenzübergang.<br>&nbsp;<br>Einwohnern der folgenden Länder werden gebührenfreie Touristenvisa, bzw eine automatisch erstellte Einreisekarte ("Border Control Clearance") an jedem Hafen oder Einreiseterminal nach Israel ausgestellt -&nbsp;<strong>es gibt keinen Passstempel mehr</strong>:</p>
						<p>Albanien, Andorra, Argentinien, Australien, Bahamas, Barbados, Belgien, Belize, Bolivien, Brasilien, Bulgarien, Chile, Costa Rica, Dänemark, Deutschland (ab 1928 geborene), Dominica, Dominikanische Republik, Ecuador, El Salvador, Estland, Fiji, Finnland, Frankreich, Georgien, Gibraltar, Grenada, Griechenland, Großbritannien, Guatemala, Haiti, Honduras, Hongkong, Irland, Island, Italien, Jamaika, Japan, Kanada, Kolumbien, Kroatien, Lettland, Lesotho, Liechtenstein, Litauen, Luxemburg, Macao, Makedonien, Malawi, Malta, Mauritius, Mexico, Mikronesien, Monaco, Mongolei, Montenegro, Niederlande, Neuseeland, Norwegen, Österreich, Palau, Panama, Paraguay, Peru, Philippinen, Polen, Portugal, Rumänien, Russische Föderation, San Marino, Serbien (auch jugoslawische Pässe),Singapur, Slowakei, Slowenien, St. Lucia, Südafrika, Südkorea, Spanien, St. Kitts &amp; Nevis, St. Vincent und die Grenadinen, Surinam, Swasiland, Schweden, Schweiz, Taiwan, Tonga, Trinidad &amp; Tobago, Tschechische Republik, Ukraine, Ungarn, Uruguay, Vatikanstaat, Vanuatu, Vereinigte Staaten von Amerika, Zentralafrikanische Republik, Zypern.<br>&nbsp;<br>Für weitere Informationen besuchen Sie :&nbsp;<a href="//embassies.gov.il/berlin/ConsularServices/Pages/local-visa-information.aspx" target="_blank">www.israel.de</a></p>
						<p>Kinder benötigen für die Einreise nach Israel einen Kinderreisepass mit einer Mindestgültigkeit von 6 Monaten.<br>Kinder die alleine oder nur mit einem Elternteil reisen, benötigen die vom entsprechenden Konsulat beglaubigte Einverständniserklärung beider bzw. des nicht mitreisenden Elternteils.</p>
						<h3>WIE LAUTEN DIE ZOLLBESTIMMUNGEN<span dir="RTL">?</span></h3>
						<p>Die Ein- oder Ausfuhr von Geldmitteln (Bargeld, Barschecks, Reiseschecks) im Gegenwert von zusammen 80.000 Schekel und mehr muss angemeldet werden. Das entsprechende „Zoll-Formular Nr. 84“ kann telefonisch unter +972-2-658 7777 angefordert werden.</p>
						<p><a href="//embassies.gov.il/berlin/ConsularServices/Pages/Einreise.aspx" target="_blank">Welche Gegenstände darf ich nach Israel einführen?&nbsp;</a><br>&nbsp;<br>Welche Vorschriften gibt es bezüglich der Einfuhr von Haustieren nach Israel?<br>Pro Halter sind zwei Haustiere für die Einreise erlaubt.<br>Sie benötigen für die Tiere<br>- ein amtsärztliches Gesundheitszeugnis mit aktuellem Datum bis 7 Tage vor<br>Reiseantritt<br>- eine Erklärung, dass sie das Tier mindestens seit 90 Tagen besitzen<br>- eine internationale Impfbescheinigung (gegen Tollwut/ nicht älter als 1 Jahr<br>und mind. 1 Monat vor Einreise)<br>- das Tier muss mindestens 3 Monate alt sein</p>
						<h3>IST ES SICHER, NACH ISRAEL ZU REISEN<span dir="RTL">?</span></h3>
						<p>Israel ist für Touristen eines der sichersten Reiseländer. 2016&nbsp;besuchten 3,06&nbsp;Mio. Touristen aus aller Welt das Heilige Land. 180.035&nbsp;Gäste davon kamen aus Deutschland. Sie alle haben ohne besondere Vorkommnisse das Heilige Land bereist und sind wohlbehalten zurück nach Deutschland gekehrt.<br>Aufgrund der detaillierten Einreisebestimmungen konnten sich Besucher jederzeit sicher fühlen in Israel und sich frei im Land bewegen. Die Heiligtümer, Sehenswürdigkeiten und Kulturerbestätten sind in der Regel ganzjährig frei zugänglich.<br>Es ist jedoch ratsam, wie bei jedem anderen Reiseland auch, sich vor der Abreise über die aktuelle Situation vor Ort zu informieren.<br>Von den deutschen Besuchern kamen 70 Prozent als Individualreisende. An einer organisierten Rundreise nahmen 19 Prozent teil, während sieben Prozent ein Pauschalangebot buchten.<br>Sollten Sie weitere Fragen zur Sicherheit haben kontaktieren Sie auch unser Tourismusbüro in Berlin: Tel. 030 - 2039970 oder&nbsp;<a href="mailto:info-de@goisrael.gov.il">info-de@goisrael.gov.il</a></p>
						<h3>DÜRFEN TOURISTEN BEREICHE BETRETEN, DIE AUSSERHALB DER VERANTWORTLICHKEIT ISRAELS LIEGEN<span dir="RTL">?</span></h3>
						<p>Ein Durchgang zu den beiden Haupttouristenstädten Bethlehem und Jericho in palästinensischer Verantwortung ist direkt und ohne vorherige Abfertigung oder erforderliche Genehmigung möglich.<br>&nbsp;<br>Für die Gebiete, die in der Verantwortung der PA liegen, wird empfohlen, Anfragen an das IDF Public Relations Office (Büro für Öffentlichkeitsarbeit),<br>Fax: +972-2-5305724<br>zu senden. Alle Anfragen sollten enthalten: Name, Reisepassnationalität und Nummer, Ziel, Name des Abreiseortes in das zu überquerende, palästinensische Gebiet, falls bekannt; bei der Überquerung mit dem Auto – Name und Details des Fahrers, sowie die Fahrzeugbriefnummer des Wagens. Antworten per Fax werden ausschließlich an israelische Telefon/Faxnummern gesendet.</p>
						<h3>IST ES MÖGLICH, VON ISRAEL AUS NACH JORDANIEN ODER ÄGYPTEN ZU REISEN?</h3>
						<p>Ja. Sie können zwischen Israel, Jordanien und Ägypten hin- und herreisen. Für einen Ausflug nach Ägypten können Sie den Grenzübergang Eilat/Taba benutzen. Das Visum für Ägypten wird Ihnen direkt beim Grenzübergang (gegen Gebühr) ausgestellt.</p>
						<p>In das Nachbarland Jordanien führen 3 Grenzübergänge:</p>
						<h3> Allenby-/King Hussein-Brücke</h3>
						<p>&nbsp;(hier benötigen Sie vorab ein Visum, es wird nicht an der Grenze ausgestellt, es gelten besondere Konditionen)</p>
						<p>Die Grenze Allenby Bridge dient Palästinensern und Touristen als Übergang zwischen Israel und Jordanien sowie der Palästinensischen Behörde und Jordanien.<br>Zudem gibt es hier einen Fracht-Abschnitt, der den Warentransport zwischen Jordanien und der Palästinensischen Autonomiebehörde sowie zwischen Jordanien und Israel regelt.<br>Im Osloer Abkommen von 1994 wurde in Absprache mit der Palästinensischen Autonomiebehörde und mit der Unterzeichnung des Friedensabkommens festgelegt, dass der Grenzübergang Allenby Bridge der Israelischen Flughafenbehörde unterstellt ist. Er liegt im Jordantal, östlich von Jericho (Yerikho), rund eine Autostunde sowohl vom israelischen Jerusalem als auch vom jordanischen Amman auf der kürzesten Strecke zwischen Amman und den Städten in Israels Zentrum entfernt. &nbsp;Er ist ein wichtiger Knotenpunkt im Güterverkehrt zwischen Israel, der Palästinensischen Autonomiebehörde und Jordanien.<br>Israelis können den Grenzübergang mit einem gültigen Visum der jordanischen Botschaft überqueren.<br>Öffentliche Verkehrsmittel fahren von hier aus nach Jerusalem und Kirjat Schmona. Ebenso verkehren Einzel- und Sammeltaxis in alle Gegenden des Landes.</p>
						<p>Transfer&nbsp;<br>- Spezielle Tarif Taxen fahren in das ganze Land<br>- Taxiservice nach Ost-Jerusalem<br>- allgem. Taxen&nbsp;<br>- Buslinie 961 von Kiryat Shmona und von Jerusalem<br>- VIP Service (ca.110 $)</p>
						<p>Die Bushaltestelle befindet sich auf der Straße Nr. 90 direkt neben dem oberen Eingangsbereich zur Grenze. Dieser Bereich kann nur mit dem Taxi angefahren werden. Passagiere können nach überqueren der Grenze ein Taxi zum Bus nehmen und von dort nach Jerusalem oder bis in den Norden nach Tiberias fahren.</p>
						<p>Privatautos und Reisebusse dürfen nicht über die Grenze fahren.</p>
						<p>So - Do: 8.00 - 20.00 Uhr (Einreise nach Jordanien)<br>So - Do: 8.00 - 14.00 Uhr (Ausreise von Jordanien)<br>Fr/ Sa: &nbsp; 8.00 - 13.00 Uhr</p>
						<p>Hinweis: Für diesen Grenzübergang benötigen Sie, wenn Sie von Israel nach Jordanien reisen möchten, vorab ein Visum. Es wird Ihnen kein Visum direkt vor Ort ausgestellt.</p>
						<p>Touristengruppen werden gebeten sich bei einer Einreise von Jordanien nach Israel vorab per Mail &nbsp;anzumelden:<br><a href="mailto:Allenby-info@iaa.gov.il">Allenby-info@iaa.gov.il</a><br>Visa-Gebühr: 173 NIS (ca. 35 EUR)<br>(ohne Gewähr)</p>
						<p>Der Übergang ist am islamischen Neujahrstag und an Yom Kippur geschlossen.</p>
						<div>&nbsp;</div>
						<h3> Grenzübergang bei Eialt</h3>
						<p>Für Touristen-Gruppen&nbsp;werden vor Ort Visa ausgestellt, Einzelpersonen müssen ebenfalls vorab ein Visum beantragen.<br>Der Yitzhak-Rabin-Grenzübergang war der erste Übergang, der nach dem Friedensabkommen zwischen Jordanien und Israel geöffnet wurde. Er liegt ca. 3 km nördlich von Eilat und dient vor allem Personen und Gruppen, die an kurzen Besuchen in den jeweiligen Ländern interessiert sind. Diese Touren und Tagesausflüge - speziell nach Petra/ Jordanien - werden überwiegend von den einzelnen Hotels und dem Tourist Office in Eilat organisiert.<br>Der Grenzübergang wird von Touristen und Israelis sowie für den Güterverkehr genutzt.</p>
						<p>Transfer zum und vom Grenzübergang<br>- mit dem Taxi<br>- dem Shared-Service-Taxi von Eilat<br>- privater PKW<br>Reisende mit dem PKW können damit die Grenze passieren oder diesen am Übergang parken.</p>
						<p>So - Do: 6.30 - 20.00 Uhr<br>Fr/ Sa: &nbsp; 8.00 - 20.00 Uhr<br>HINWEIS:<br>Bitte treffen Sie eine Stunde vor Schließung am Grenzübergang ein.<br>Der Übergang ist am islamischen Neujahrstag und an Yom Kippur geschlossen.</p>
						<p>Passierschein:<br>Am Yitzhak Rabin Übergang erhalten israelische Bürger und Touristen ein Visum über 2 Wochen, mit Ausnahme jener Touristen, die laut der jordanischen Bestimmungen ein Vorab-Visum benötigen.<br>Gebühr $ 56<br>(ohne Gewähr)</p>
						<div>&nbsp;</div>
						<h3> Sheikh Hussein - Übergang/ Nordgrenze</h3>
						<p>&nbsp;(ganzjährig 27/7 geöffnet)</p>
						<p>Der Jordan-Grenzübergang liegt zwischen der Stadt Bet Sche'an und den Kibbuzim im Bet Sche´an-Tal und ist der nördliche Grenzübergang über den Jordan. Er befindet sich relativ nah an Amman, Haifa und dem Norden Israels und wird sowohl von Israelis als auch von Touristen genutzt. Busse und Taxis fahren von hier aus nach Bet Sche´an.</p>
						<p>Je nach Nationalität sollten Sie sich bei den entsprechenden Botschaften erkundigen, ob Sie ein Visum für diese Länder benötigen.</p>
						<p><span dir="RTL"><a href="//de.visitjordan.com/generalinformation/gettingaround/bordercrossings.aspx" target="_blank"><strong><span dir="LTR"> Weitere Informationen finden Sie auch beim Tourismusamt Jordanien</span></strong></a></span><br><a href="//international.visitjordan.com/generalinformation/entryintojordan.aspx#Northhttp://international.visitjordan.com/generalinformation/entryintojordan.aspx#North" target="_blank"><strong> Visakosten</strong></a></p>
												    
         	`,
      };
    },
  },

  {
    id: "Electrical_Appliances",
    bgImage: "/HomeSlider/Home/3.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    title: "ELEKTRISCHE GERÄTE",
    ctg: "TouristInfo",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                        <p<p dir="LTR">Das einphasige Stromnetz in Israel liefert 220 Volt bei 50 Hertz. Die meisten Steckdosen in Israel haben drei Steckkontakte, aber die meisten von ihnen sind mit zweipoligen europäischen Steckern kompatibel. Wer als Besucher mitgebrachte Rasierapparate, Bügeleisen und andere Kleingeräte verwenden möchte, benötigt ggf. sowohl Transformatoren als auch Adapterstecker.</p>>Das einphasige Stromnetz in Israel liefert 220 Volt bei 50 Hertz. Die meisten Steckdosen in Israel haben drei Steckkontakte, aber die meisten von ihnen sind mit zweipoligen europäischen Steckern kompatibel. Wer als Besucher mitgebrachte Rasierapparate, Bügeleisen und andere Kleingeräte verwenden möchte, benötigt ggf. sowohl Transformatoren als auch Adapterstecker.</p>
                        <p<p dir="LTR"><a href="https://info.goisrael.com/en/things-to-do" target="_blank">Reiseempfehlungen auf der Website der Touristeninformation anzeigen</a><br><a href="https://info.goisrael.com/en/organized-tourism" target="_blank">Besucherservice auf der Website der Touristeninformation anzeigen</a></p>><a href="https://info.goisrael.com/en/things-to-do" target="_blank">Reiseempfehlungen auf der Website der Touristeninformation anzeigen</a><br><a href="https://info.goisrael.com/en/organized-tourism" target="_blank">Besucherservice auf der Website der Touristeninformation anzeigen</a></p>
                        						    
         	`,
      };
    },
  },

  {
    id: "A_Magic_Place",
    bgImage: "/posts/bank/negev1/1.jpg",
    mobBgImage: "/posts/bank/negev1/M.jpg",
    title: "DIE NEGEV-WÜSTE EIN MAGISCHER ORT",
    ctg: "eilat-negev",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                       <p>Die israelische Wüste bietet sich durch ihre atemberaubende Landschaft und zahlreiche Attraktionen als perfekter Ort für ihren Urlaub an. In der Negev finden Besucher zahlreiche Möglichkeiten für spannende Erlebnisse.</p>
						<p>Israel ist ein kleines Land und die Wüste Negev macht 62&nbsp;% seiner Gesamtfläche aus. Charakteristisch für die rot leuchtende Wüstenlandschaft sind ihre beeindruckenden geologischen Felsformationen. Besucher genießen hier die einzigartige unberührte, stille und majestätische Weite.</p>
						<div class="img-wrapper">
                             <img src=${getImgUrl() +
                               "/posts/a-magic-place/1.jpg"} class="img-responsive" />
					 	</div>
						<p>In der Wüste finden sich Spuren vergangener Zivilisationen und ihrer Landwirtschaft sowie andere archäologische Fundstätten. Die Negev bildet einen unverwechselbaren Hintergrund für die Begegnung mit den Nomadenstämmen - dem Volk der Wüste.</p>
						<p><strong>Gründe, warum die Wüste Israels so besonders ist</strong>:</p>
						<ul style="padding-left: 18px;">
						<li>
						<strong>Die Wüste liegt ganz in der Nähe</strong> - und ist nach einem nur vierstündigen Flug von Europa erreichbar. Israel verfügt über zwei internationale Flughäfen, Ben Gurion und Ovda, was die Anreise zur Wüste für alle Reisenden kurz hält (eine Stunde bis 90 Minuten).</li>
						</ul>
						<div class="img-wrapper">
                             <img src=${getImgUrl() +
                               "/posts/a-magic-place/2.jpg"} class="img-responsive" />
					 	</div>
						<p>Ab November gibt es mehrere Direktflüge von Europa und Russland nach Ovda, z.&nbsp;B. mit <strong>Monarch</strong>, <strong>Ryanair</strong>, <strong>Wizzair</strong> und <strong>SAS</strong>.</p>
						<p">Weitere Informationen finden Sie unter dem folgenden Link: <a href="//www.iaa.gov.il/en-US/airports/ovda/Pages/default.aspx" target="_blank">www.iaa.gov.il</a></p>
						<ul style="padding-left: 18px;">
						<li>
						<strong>Vorbereitet auf Wanderer und Fahrradfahrer</strong>: In der Wüste finden sie zahlreiche markierte Wege. In Israel gibt es einige der eindrucksvollsten Wanderwege der Welt, und Hunderte von sicheren Routen führen durch die israelische Wüste. Eine Auswahl von Wanderwegen finden sie auf den folgenden Websites: <a href="//www.negevtour.co.il" target="_blank">www.negevtour.co.il</a> ; <a href="//www.en.aravaway.co.il" target="_blank">www.en.aravaway.co.il</a>&nbsp; &nbsp; &nbsp; &nbsp;</li>
						<li>
						<strong>Freundliche Bevölkerung</strong>: Die Wüstenbewohner sind sehr gastfreundlich und Machen das Wüstenerlebnis zu einer angenehmen und aufregenden Erfahrung für alle Besucher.</li>
						<li>
						<strong>Aktivitäten für Touristen</strong>: Parallel zur Entwicklung der Unterkünfte hat ein enormes Angebot touristischer Aktivitäten die Negev in den letzten Jahren zu einem beliebten, interessanten, vielseitigen und kreativen Reiseziel gemacht.</li>
						<li>
						<strong>Grandiose Panoramen</strong>: Heute genießen Touristen in großer Zahl den Charme der Negev-Wüste mit ihren vielfältigen Landschaften.
						<ul style="padding-left: 18px;">
						<li>Im Norden warten die spektakulären Sanddünen.</li>
						<li>Im Zentrum liegt der Ramon-Krater mit seinen rauen Klippen und saisonalen Wasserquellen.</li>
						<li>Im Osten fühlt man sich in die afrikanische Wüste mit weiten Savannen und Akazienbäumen versetzt.</li>
						<li>Und im Süden findet man roten und schwarzen Granit, der mit dem Sandstein des Vorgebirges reizvolle Farbspiele bildet.</li>
						</ul>
						</li>
						</ul>
						<p>Bei einer ca. 3-stündigen Fahrt durch die Wüste können sie das gesamte Spektrum der Wüstenlandschaft erleben und ihre Vielfalt genießen. In anderen Wüsten ist das nur mit langen Fahrten über viele Kilometer möglich.</p>
						<p>Viele Touristen entscheiden sich, 2 bis 3 Tage in der Negev-Region zu verbringen.</p>
						<ul style="padding-left: 18px;">
						<li>
						<strong>Reisen in der Negev-Wüste ist sehr sicher.</strong> Die Rettungsteams, die bei Notfällen in der Region vor Ort sind, gehören zu den am besten ausgebildeten Rettungskräften der Welt und sind immer in der Nähe. Sollte ein Besucher medizinische Versorgung benötigen, findet er in Israel moderne und erstklassige medizinische Einrichtungen.</li>
						</ul>
				<h3>Weitere Informationen und Hinweise für Übernachtungen und sonstige Empfehlungen:</h3>
						<p><a href="//www.negevtour.co.il" target="_blank">www.negevtour.co.il</a></p>
						<p><a href="//www.en.aravaway.co.il" target="_blank">www.en.aravaway.co.il</a></p>
						<p>Reiseangebote</p>						    
         	
         	`,
      };
    },
  },

  {
    id: "The_Arava",
    bgImage: "/posts/bank/negev2/1.jpg",
    mobBgImage: "/posts/bank/negev2/M.jpg",
    title: "DIE ARAVA: ÜBERRASCHE DICH SELBST!",
    ctg: "eilat-negev",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                       
						
						

					 	    <p>Zwischen der Menucha-Kreuzung im Norden bis zum ersten Kreisverkehr am Rand von Eilat, eingefasst von der Negev-Wüste und der Eilat-Gebirgskette im Westen und dem Edom-Gebirge im Osten: Das ist die Arava. Eine schmale, aber atemberaubender Landschaft, wo sie die Wüste mit allem, was sie zu bieten hat, <i>fühlen</i> - zu zweit, mit der Familie oder in der Gruppe. Besucher können die Arava auf verschiedene Weise erkunden - zu Fuß, mit dem Fahrrad, dem Auto oder Bus. Die Übernachtungsmöglichkeiten reichen von Luxushotels über „Glamping“ bis zum Schlafen im Freien unter dem Sternenhimmel. Hier stellen wir ihnen einige der Sehenswürdigkeiten und Aktivitäten vor, die sie nicht verpassen sollten:</p>
							<h3>Timna-Nationalpark</h3>
							<p>Das neue Besucherzentrum am Eingang zum Nationalpark heißt sie mit einer informativen Einführung in die erstaunliche Landschaft von Timna willkommen. Hier sorgt von der Natur geformter roter Sandstein gemeinsam mit den schwarzen und weißen Felsen für eine dramatische Szenerie. Der U-förmige Timna-Nationalpark birgt Schätze aus diversen Zeitaltern und erzählt die Geschichte von ägyptischen Kupferbergwerken, die bis heute Erz liefern, anhand echter Relikte und an den original Fundstätten.</p>
							<p>Im Timna-Park gibt es über 25 Wander- und Fahrradwege (darunter auch anspruchsvolle Trails) sowie Autostrecken mit fantasievollen Namen wie <b>Mushroom</b>, <b>Arches</b>, <b>Solomon‘s Pillar</b>, <b>Pink Canyon</b>, <b>Corkscrew</b> und <b>Faces</b>. Und es gibt noch mehr: eine exakte Replik des biblischen Tabernakels, das die Israelis bei ihrer Wanderung über die Sinai-Halbinsel mitführten, ein See mit Tretbooten, Flaschenherstellung aus farbigem Sand und andere Kunsthandwerke, einen Fahrradverleih, einen beaufsichtigten Campingplatz und das King Solomon's Inn, wo sie eine Erfrischung in der Wüste genießen und Souvenirs kaufen können.</p>
							
							<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/the-arava/1.jpg"} class="img-responsive" />
							 	</div>
							<h3>Naturschutzgebiet Hai-Bar</h3>
							<p>Die Zielsetzung des Hai Bar Biblical Wildiife Reserveist die Wiedereinführung von Tieren in die Natur Israels, die in der Bibel erwähnt werden.Heute leben die Tiere in ihren natürlichen Habitaten geschütz; sie werden gepflegt und können von Besuchern beobachtet werden.. Dazu werden auf den Rundstrecken für motorisierte Fahrzeuge auch Safaris angeboten, auf denen sie Oryxantilopen, Mendesantilopen und Strauße zu sehen bekommen, umgeben von Wüstenpflanzen, zu denen auch die biblische Akazie gehört. CDs mit Führungen in zahlreichen Sprachen können sie in unserem Shop käuflich erwerben. Geführte Touren finden samstags um 11:00 Uhr statt - wenn die Tiere ihren „Brunch“ bekommen. Es gibt auch einen Campingplatz mit Versorgungseinrichtungen.</p>
							
							<h3>Eilat Gewürzfarm</sh3>
							<p>Die Farm forscht auf dem Gebiet der Marikultur. Sie befindet sich an der Kreuzung der antiken Gewürzroute und Meeresroute mit Blick auf das Edom-Gebirge. Seetang, Muscheln, Artemia-Krebse und König-Salomon-Zwergbarsche (nach dem Besitzer der Farm, der sie entdeckt hat, auch als Fridmans Zwergbarsch bzw. Pseudochromis fridmani bekannt) werden hier gezogen.</p>
							<p>Das Besucherzentrum ist ein Fest für die Sinne. Nach dem Eintreten befindet man sich in einer Wolke von Düften der unzähligen Gewürze, Gewürzmischungen und Aufgüsse, die zum Kochen und zu medizinischen Zwecken verwendet werden. Hier gibt es auch besondere Kochgeräte und Küchenhilfen, in deren Gebrauch sie das freundliche Personal gerne einweist.</p>
							<h3>Ökologisches Leben in Neót Smadár</h3>
							<p>Spazieren sie selbständig durch die Gemeinde Neót Smadár, in der es ein fantastisches Kunstzentrum zu entdecken gibt, dessen Aufbau über 13 Jahre gedauert hat. Erkunden sie das Gelände, in dem eine Mischung Detailverliebtheit und Bodenständigkeit zum Ausdruck kommt, sowie die ökologischen Weinberge des südlichsten Weinguts in Israel.</p>
							<p>Im Kunstzentrum befinden sich Werkstätten von Kunsthandwerkern und eine Galerie, in der sie ihre Kunst ausstellen und verkaufen. Im Mittelpunkt des Bauwerks, gekennzeichnet durch seinen unverwechselbaren Turm, befindet sich ein Wasserschacht, mit dem das gesamte Gebäude anstelle einer konventionellen Klimaanlage gekühlt wird. Alle Innen- und Außenflächen des Zentrums sind mit Holzschnitzereien geschmückt, die von den Mitgliedern der Gemeinschaft angefertigt wurden.</p>
							<h3>Avara bei Nacht</h3>
							<p>Die Landschaft verändert sich in der Abenddämmerung: Das Edom-Gebirge wechselt zu immer dunkleren Rot- und Lilatönen und wird schließlich im Sternen- und Mondlicht gebadet. Und wenn es Zeit wird, schlafen zu gehen, helfen wir ihnen, die passende und bequemste Unterkunft zu finden. Sie erreichen uns (WHO IS US? HERE IS JUST A NUMBER?) telefonisch unter +972 (8) 6616976.</p>
																		    
							         	
         	`,
      };
    },
  },

  {
    id: "Action_Fun_In_Desert",
    bgImage: "/posts/bank/negev1/1.jpg",
    mobBgImage: "/posts/bank/negev1/M.jpg",
    title: "ACTION-SPAß IN DER WÜSTE ISRAELS",
    ctg: "eilat-negev",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                       
							    

							 	<p>In der israelischen Wüste gibt es wunderbare Panoramablicke, historische Sehenswürdigkeiten und reihenweise Möglichkeiten für spaßige Aktivitäten, die gründlich mit der Vorstellung aufräumen, die Wüste sei ein karger Ort.</p>
								<h2>Die einzigartige Wüste</h2>
								<p>Die Schönheit der Natur in den vier großen Wüstenzonen - dem Toten Meer, dem Eilat-Gebirge, der Negev-Wüste und der Judäische Wüste - wird ihnen die Sprache verschlagen. Touristen tauchen auf einer Wanderung durch das einzigartigen Farbspiel der Felsformationen des Ramon-Kraters und die dunkel glühenden Töne des Timna-Parks vor Eilat in eine andere Welt ein. Sich an den vielfarbigen Hängen abzuseilen oder auf dem staubigen Wüstentrail an seine Grenzen zu gehen ist noch besser, wenn am Ende eine erfrischende Oase wie Ein Gedi in der Nähe des Toten Meers lockt. Bei einer Übernachtung auf einem der Campingplätze mit umfassendem Serviceangebot werden sie mehr Sterne sehen, als sie je für möglich gehalten haben. Und vielleicht erhaschen sie sogar einen Blick auf die scheuen, nachtaktiven Tiere der Wüste!</p>
								<p>Frühling, Herbst und Winter sind die besten Jahreszeiten für einen Besuch im trockenen Klima der Wüsten Israels. Unternehmen sie in der berühmten Festung Masada eine Zeitreise in die Vergangenheit und erfahren sie mehr über das bittere Ende der letzten Schlachten der Juden gegen das römische Reich und lassen sie sich vom Prunk des Palasts von König Herod den Atem rauben. Erforschen sie unerwartete byzantinische Ruinen und die erstaunliche Kultur der uralten, aus dem Wüstenfels geschlagenen Siedlungen der Nabatäer, die auf ihre Erkundung warten.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/action-fun/1.jpg"} class="img-responsive" />
							 	</div>
								<h2>Spaß mit Action in der Wüste</h2>
								<p>Die Wüste Israels steckt voller spannender Aktivitäten. Bei einer aufregenden Jeep-Tour, die durch die einzigartige Landschaft der Negev-Wüste führt, kann man auch schon einmal richtig durchgeschüttelt werden. Oder sie mieten Mountain-Bikes, um sich selbst in der außergewöhnlichen Schönheit der farbigen Felsformationen im Timna Park oder auf den Wüstentrails herauszufordern. Entspannen sie sich gemeinsam mit der Familie oder Freunden bei einem entspannten Ausritt auf Pferden durch die Judäische Wüste, oder genießen reife Datteln bei einem Glas Minztee bei den gastfreundlichen Beduinen in der Negev-Wüste.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/action-fun/2.jpg"} class="img-responsive" />
							 	</div>
								<p>Reiben sie sich an den Ufern des Toten Meers mit dem heilendem Mineralschlamm ein, während sie das Panorama mit den majestätischen Gebirgszügen und dem blauen Wasser neben sich genießen. Extremsport-Fans können sich beim Sandsurfen an den gewaltigen Dünenhängen der Negev-Wüste dem Nervenkitzel hingeben, der mit der rasenden Fahrt über die meilenweiten Sandflächen einhergeht.</p>
								<p>In den Wüsten Israels wartet mehr Spaß auf sie, als sie sich vorstellen können.</p>
								
								
																    
							         	
         	`,
      };
    },
  },
  {
    id: "Eilat_Sensational",
    bgImage: "/posts/bank/eilat2/1.jpg",
    mobBgImage: "/posts/bank/eilat2/M.jpg",
    title: "SENSATIONELL - EIN ENDLOS LANGER SOMMER",
    ctg: "eilat-negev",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                       
							    <h3>Eilat ist die Stadt am Roten Meer und zugleich Israels beliebtester Ferienort, der jedes Jahr etwa 2,8 Millionen Besucher an die Strände des atemberaubenden Roten Meeres lockt.</h3>
								<p >Eilat ist die südlichste Stadt in Israel und bekannt für eine spektakuläre Kombination der umgebenden Wüstenlandschaft, dem schönen Strand und der Sommersonne, die das ganze Jahr über scheint.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/sensational/1.jpg"} class="img-responsive" />
							 	</div>
								<p >Ganz gleich, ob Sie mit der Familie, als Paar oder ganz allein in Eilat Urlaub machen, Sie werden eine Menge sehen und unternehmen. Unterkünfte finden sich von 5-Sterne-Luxushotels bis hin zu gemütlichen Privatunterkünften (Airbnb) und Jugendherbergen.</p>
								<p >Mit seinen 360 Sonnentagen im Jahr ist Eilat extrem populär bei Touristen von nah und fern, die aus ihrem kalten Winterklima flüchten.</p>
								<p >Ein Besuch in Eilat ist ein unterhaltsames Erlebnis, bei dem Sie entspannen und gleichzeitig auftanken können. Dieser lebendige Ferienort bietet eine Fülle an ganzjährigen Aktivitäten und Attraktionen, ausgezeichneten Restaurants und Cafés, Einkaufszentren und angesagten Bars und Clubs.<br>Und das Beste? Alles in Eilat ist nur einen Katzensprung vom Strand entfernt.</p>
								<h3>Tauchen Sie ein ins Rote Meer</h3>
								<p >Eine einmalige Attraktion an sich ist Eilats fantastisches Rote Meer und seine 10 Kilometer lange Küste, die den Mittelpunkt und die Hauptattraktion für Touristen aus aller Welt darstellen.<br>Mit seinem sauberen, klaren und unerwartet kühlen Wasser ist es ein willkommener Rückzugsort von den heißen Temperaturen und trockenen Luft der Stadt. Viele Sehenswürdigkeiten und Attraktionen erwarten Sie an den Stränden von Eilat, ein perfekter Ort zum Sonnenbaden und Entspannen.</p>
								
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/sensational/2.jpg"} class="img-responsive" />
							 	</div><p >Extremsportliebhaber werden die Wassersport-Clubs entlang der Süd- und Nordküste von Eilat lieben mit ihren Angeboten wie Jetskifahren, Bananenboot, Kayak- und Schlauchfahren und vieles mehr.</p>
								<h3>Spüren Sie die Atmosphäre</h3>
								<p >Am Abend geht die heiße Wüstensonne in Eilat unter und die Pools und Strände schließen. Genau die Zeit, sich für das fantastische Nachtleben in der Stadt fertig zu machen. Eilat hält einen einzigartigen Rekord: die Stadt mit den meisten Clubs, Bars und Veranstaltungsorten pro Kopf in Israel. Es mangelt also nicht an Auswahlmöglichkeiten für einen vergnüglichen Abend.</p>
								<h3>Ein Wüstenabenteuer</h3>
								<p >Nördlich der Stadt liegt die südliche Arava, eine Region mit atemberaubenden Ausblicken auf die Wüste und ein Ort, der absolut zu empfehlen ist. Hier können Sie die endlose Weite spüren und steilen Klippen und Bächen folgen sowie durch Täler wandern und vieles mehr.</p>
								<p >Die farbenprächtige und einzigartige Bergwelt von Eilat bietet nicht nur einen atemberaubenden Ausblick, sondern vor allem Naturliebhabern ein unvergessliches Erlebnis. Es gibt zahlreiche Routen und Stätten zu besichtigen, die es sich lohnt &nbsp;zu Fuß, mit dem Fahrrad, Auto oder dem Kamel zu erkunden. Extremsportler können sogar Klettern oder sich an atemberaubenden Berghängen abseilen.</p>
								<p >Worauf warten Sie noch? Besuchen Sie Eilat. Ab in die Sonne.</p>
								
								
																    
							         	
         	`,
      };
    },
  },

  {
    id: "Discover_Jerusalem",
    bgImage: "/posts/bank/jerusalem6/1.jpg",
    mobBgImage: "/posts/bank/jerusalem6/M.jpg",
    title: "JERUSALEM ENTDECKEN",
    ctg: "jerusalem",
    isVid: true,
    vidId: "1byfX1O7u4g",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                       
							   
								
								
                                 <h2>Entdecken Sie die Geheimnisse des jüdischen Jerusalem in der geschichtsträchtigen Altstadt</h2>
							 	<p>Begeben Sie sich auf eine unvergessliche spirituelle Reise in das atemberaubende Jerusalem</p>
								<p>Jerusalem lädt Sie ein – seien Sie gast dieser wunderbaren Stadt. Erklimmen Sie die Berge, flanieren Sie durch die Innenstadt und fühlen Sie die einzigartige Mischung aus Vergangenheit und Gegenwart, dem Alltäglichem und Außergewöhnlichem. Als eine der ältesten Städte der Welt, heilig für Juden, Christen und Muslime, bietet Jerusalem ein unvergleichliches Erlebnis für die Sinne und den Geist.</p>
								<h3>Eintreten. </h3>
								<p>Das Herz der heiligsten Stadt im Judentum ist die Altstadt. Betreten Sie den historischen Eingang, das <em>Jaffator</em>, oder gehen Sie durch das <em>Zionstor</em>, das direkt zum <strong>jüdischen Viertel </strong>führt, eins der vier Stadtviertel der von Mauern umgebenen Stadt und weitestgehend Heimat von Juden seit dem Jahr 8 vor unserer Zeitrechnung. Gehen Sie durch die Gassen, sehen Sie sich die Menschen an, besuchen Sie den <strong>Cardo</strong>, Jerusalems älteste Hauptstraße und saugen Sie die einzigartige Atmosphäre in sich auf. Sie wandern auf den Spuren des Königs und Propheten – das ist etwas ganz Besonderes.</p>
							     <div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/discover-jerusalem/1.jpg"} class="img-responsive" />
							 	</div>
								<h3>Erleben Sie, wie Geschichte lebendig wird und fühlen Sie die tiefe spirituelle Energie innerhalb der Mauern</h3>
								<h3>Was liegt vor Ihnen. </h3>
								<p>Die letzten Überreste der antiken Mauern, die den Zweiten Tempel umgaben, die <strong>Klagemauer</strong>, ist ein Symbol jüdischer Sehnsüchte nach einer angestammten und geistigen Heimat. Gläubige Juden beten auf dem Platz vor der Mauer ,der Platz, an dem laut Judentum Gott wohnt.&nbsp; Ganz gleich welchen Glauben Sie selbst haben, es ist ein Erlebnis voller Emotionen aber auch Demut. Würdigen Sie diesen Ort und hinterlassen Sie in der Mauer eine Notiz mit einem Gebet oder einem Wunsch</p>
								<h3>Was liegt daneben. </h3>
								<p>Jerusalem ist praktisch mit historischen Stätten übersät und das Eintauchen in die Historie bekommt hier eine vollkommen neue Bedeutung.</p>
								<p>Machen Sie einen Rundgang durch die faszinierenden <strong>Klagemauertunnel</strong> und entdecken Sie die verborgenen Bereiche der Klagemauer. Geschichte wird lebendig, sobald Sie die unterirdischen Gänge entlanggehen, entdecken Sie das Leben in Jerusalem während der Zweiten Tempel-Periode und erfahren Sie alles über Kunst, Architektur und Bauweisen.</p>
								<p>Besuchen Sie die nahegelegene archäologische interessante <strong>Davidsstadt</strong> und erfahren Sie mehr über die Geschichte der Stadt, die David vor 3.000 Jahren als vereinigte Hauptstadt der 12 Völker von Israel deklarierte. Machen Sie eine Reise zwischen den antiken Mauern und Festungen, verborgenen Quellen, an denen Könige gekrönt wurden und folgen Sie dem Pfad, auf dem die Einwohner Jerusalems nach der Eroberung der Stadt durch die Römer flüchteten.</p>
								<h3>Bestaunen Sie den atemberaubenden außergewöhnlichen Ausblick und lassen Sie es sich gut gehen</h3>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/discover-jerusalem/2.jpg"} class="img-responsive" />
							 	</div>
								<h3>Was liegt darüber. </h3>
								<p>Ursprünglich zum Schutz der Stadt vor Eindringlingen erbaut, ist Jerusalem von Mauern umgeben. Heute haben Sie von den <strong>Mauern Jerusalems</strong> aus die Möglichkeit, die Stadt aus einem anderen Blickwinkel zu erkunden. Hören Sie sich die Geschichten an und genießen Sie die Schönheit dieser Stadt von oben.</p>
								<p>Sie haben gerade erst die Oberfläche erreicht.</p>
								
																    
							         	
         	`,
      };
    },
  },

  {
    id: "Atractions_In_Eilat",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    title: "WAGEN SIE EINEN SPRUNG",
    ctg: "eilat-negev",
    isVid: true,
    vidId: "wTR-9PxXn-E",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                                 <h2>Erleben Sie die Wasserattraktionen in Eilat</h2>
							 	<p>Erfreuen Sie sich an den Wasserattraktionen in Eilat und erleben Sie einen ultimativen Strandausflug</p>
								<p>Eilat ist die südlichste Stadt in Israel umgeben von Wasser, eine nasse und wilde Abenteuerwelt wie sonst nirgendwo im Land. Eilat bietet erstklassige Strände, Wassersport, Aktivitäten und Attraktionen, die aufgrund des warmen Klimas das ganze Jahr über geöffnet sind.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/atractions-in-eilat/2.jpg"} class="img-responsive" />
							 	</div>
								<p>Tauchen Sie Ihre Zehen in das klare, blaue Wasser an Eilats Stränden, die auf etwa zwölf Kilometern Länge Sand, eine Strandpromenade, Hotels und viele Attraktionen anbieten. Entspannen Sie an einem der abgelegeneren, ruhigen Stände im Süden und schwimmen Sie um die Korallenriffs. Tauchen Sie ein in die lebhafte Touristenszene an den Stränden im Norden, an denen Hotels, Restaurants und Geschäfte auf Sie warten. Oder machen Sie einen Segeltörn und erkunden die Region vom Wasser aus: Sonne tanken, abschalten und Spaß haben.</p>
								<p>Erforschen Sie die einzigartige Schönheit des Coral Beach Naturreservats in Eilat. Ziehen Sie Ihre Schnorchelausrüstung an und beobachten Sie unter Wasser die Meerestiere.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/atractions-in-eilat/1.jpg"} class="img-responsive" />
							 	</div>
								<p>Eilat ist das Zentrum für alle Wasseraktivitäten in Israel. Spüren Sie den Wind in Ihrem Haar und die Sonne auf Ihrer Haut, wenn Sie beim Wasserski, Jetski, Bananenboot, Surfen oder bei einer Glasbodenboot-Fahrt durch das Wasser schnellen. Möchten Sie lieber über Wasser bleiben? Dann können Sie beim Parasegeln über die Eilat Bay das Wasser von oben aus betrachten.</p>
								<p>Oder bevorzugen Sie Tiere in der freien Natur? Schwimmen oder schnorcheln Sie mit Delfinen im Eilat Dolphin Reef. An diesem einzigartigen, ökologischen Standort inmitten eines bezaubernden Strandes können Besucher Delfine beobachten und an spannenden Outdoor-Abenteuern teilnehmen. Oder haben Sie Lust auf ein Unterwassererlebnis, bei dem Sie nicht nass werden? Dann machen Sie einen Ausflug zum Eilat Underwater Observatory, ein faszinierender Einblick in das Leben unterhalb des Meeresspiegels kombiniert mit interaktiven Angeboten und Sonderausstellungen.</p>
																						    
							         	
         	`,
      };
    },
  },
  {
    id: "The_Dolphin_Reef",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    title: "DAS DOLPHIN REEF EILAT",
    ctg: "eilat-negev",
    isVid: true,
    vidId: "HzBX-XW9T0c",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                                 <h2>Eine unvergessliche Begegnung mit der Tierwelt</h2>
							 	
							 	<p>Begegnen Sie Delfinen in Eilats einzigartiger Meeresattraktion</p>
								<p>Das Dolphin Reef Eilat ist ein Wildgehege an den Küste des Roten Meeres, wo Abenteuer mit Natur und Erholung aufeinandertrifft. Am Riff betreten Besucher einen Ort, der die Besucher sofort in seinen Bann zieht, &nbsp;Hier können Sie Delfine in ihrer natürlichen Umgebung begegnen; ein spektakulärer Strand, mit einer blütenprächtigen Pflanzenvielfalt und einer atemberaubenden Aussicht warten auf Sie.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/the-dolphin-reef/1.jpg"} class="img-responsive" />
							 	</div>
								<p>An einem langgedehnten Pier kann man die heimischen großen Tümmler dabei beobachten, wie sie ihrer täglichen Routine nachgehen beim Essen, Spielen und Jagen und ihr Sozialverhalten studieren - hin und wieder werden für Besucher auch begleitete Schnorchel- oder Tauch-Gänge angeboten.</p>
								<p>Ein schönes Erlebnis ist das Beobachten der Delfine während der Fütterung. Es ist spannend, Delfine beim Spielen zu Beobachten und das Kindliche in ihnen zu entdecken, wenn sie auf ihr Futter warten. Und wenn das Essen dann erst „angerichtet“ ist, löst die Freude der Tiere jedes Mal Beifall beim Publikum aus.</p>
								
								<p>Die Schönheit des Dolphin Reef liegt darin, dass Besucher ganz nah an die Tiere herankommen dürfen, z.B. beim Tauchen mit den Delfinen, und sie in ihrem Ökosystem beobachten können. Auf sechs Meter Tiefe abtauchen und das grandiose und verborgene Leben erleben. Besucher können auch an der Oberfläche mit den Delfinen schnorcheln und sich neben den Delfinen treiben lassen und mit ihnen interagieren.Bei allen Interaktionen obliegt es den Delfinen selbst „mitzumachen“.</p>
								<p>Am Entspannungspool des Dolphin Reef können Besucher Alltagsstress und Hektik &nbsp;bei entspannter Musik ganz einfach abklingen lassen. Für das leibliche Wohl ist auch gesorgt, sodass Besucher diese schöne Anlage nicht verlassen müssen.</p>
																	
         	`,
      };
    },
  },
  {
    id: "Jerusalem_",
    bgImage: "/posts/bank/jerusalem1/1.jpg",
    mobBgImage: "/posts/bank/jerusalem1/M.jpg",
    title: "ABENTEUER DURCH DIE ZEIT",
    ctg: "jerusalem",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                             
							 	
							    
								
							 	<h2>EINE STADT DER MAGIE UND MIT EINER AUSSTRAHLUNG JENSEITS IHRER VORSTELLUNGSKRAFT</h2>
								<p>Jerusalem ist die Hauptstadt von Israel und bei weitem die berühmteste und faszinierendste Stadt der Welt mit ihrer Jahrtausende alten, glorreichen Geschichte, die in das moderne Leben integriert wird.</p>
								<p>Entdecken Sie die überwältigende Kraft dieser 3.000 Jahre alten Stadt - ihre unzähligen historischen Stätten und archäologischen Wunder, ihre magischen Wege und herrlichen</p>
								<p>Aussichten, die garantiert einen bleibenden Eindruck hinterlassen. Gleichzeitig versprechen die modernen Attraktionen Spannung und Vergnügen rund um die Uhr für alle Liebhaber von Kultur, Kunst, Musik und kulinarischen Genüssen.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/jeru-salem/1.jpg"} class="img-responsive" />
							 	</div>
								<h3>Spazieren Sie durch 3.000 Jahre ruhmreiche Geschichte</h3>
								<p>Die Altstadt von Jerusalem ist bei allen Besuchern und auch bei Einheimischen sehr beliebt. Sie ist von einer antiken Mauer umgeben, die im Laufe der Geschichte wieder aufgebaut wurde. Es gibt sieben Tore, die zu historischen und heiligen Stätten führen. Bahnen Sie sich Ihren Weg durch Pflasterstraßen und eine über viertausend Jahre alte Geschichte, bei der Sie aus dem Staunen nicht mehr herauskommen, wenn moderne und vergangene Architekturen aufeinander treffen.</p>
								<h3>Lernen Sie das moderne, lebhafte Jerusalem kennen</h3>
								<p>Außerhalb der Altstadt finden Sie alles, was eine typische moderne Stadt zu bieten hat, wie Hotels, Promenaden, Restaurants und Einkaufszentren. Besuchen Sie Museen, wie das Israel Museum, die größte Kultureinrichtung in Israel und weltweit führend unter den Kunst- und Archäologiemuseen, in denen u.a. die berüchtigten Schriftrollen vom Toten Meer (die ältesten biblischen Manuskripte) zu finden sind. Landwirtschaftsbetriebe, Weingüter und Brauereien befinden sich um Jerusalem herum und bieten verschiedene Alternativen für Feinschmecker. Von der traditionellen israelischen Küche bis hin zu zeitgemäßer Cross-Over-Küche in Kombination mit preisgekrönten Weinen und Bieren, die Enthusiasten aus aller Welt anlocken.</p>
                                <div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/jeru-salem/2.jpg"} class="img-responsive" />
							 	</div>
								<p>Besuchen Sie Mahane Yehude, ein bunter und lebhafter Markt mit einer attraktiven Mischung aus Kultur und köstlichen Aromen der hier angebotenen Delikatessen.&nbsp; Warten Sie den Sonnenuntergang ab und erleben Sie, wie sich der „Shuk“ in eine trendige Szene mit Live-Musik für jeden Geschmack verwandelt. Eine wachsende „Street-Art“-Galerie mit außergewöhnlichem Essen und köstlichen Getränken. Mahane Yehuda ist ein besonderes Erlebnis. Gehen Sie die Straßen entlang, machen Sie an einem Essstand halt, gehen Sie tanzen und genießen Sie dabei ein Getränk.</p>
								<p>Mit Kunst, Geschichte, Kultur und seiner Vielfalt kann man in der Hauptstadt Israels eine tolle Zeit verbringen und sich dem historischen Charme und einem modernen Stadtleben hingeben. Wenn Sie in Jerusalem ankommen, können Sie die Kultur, Archäologie und Geschichte der vielen Nationen, die hier gelebt haben, gar nicht übersehen. Hier treffen sich Antike und Neuzeit zwischen den Mauern der Altstadt dieser einzigartigen Welthauptstadt.</p>
																									
         	`,
      };
    },
  },

  {
    id: "Haifa_Intoxicating_Beauty",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    title: "HAIFA BERAUSCHENDE SCHÖNHEIT",
    ctg: "north",
    isVid: true,
    vidId: "7_156GUZMF4",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                                
							 	<p><em>Städtische Ruhe und verzaubernde Landschaften</em></p>
								<p>Mit seinen Steilklippen an der Küste des Mittelmeers und den grünen Hügeln über dem Hafen von Haifa bietet die drittgrößte Stadt Israels die malerischsten Ausblicke im ganzen Land. Haifa ist ein traumhaft schöner, ruhiger Ort, an dem verschiedene Glaubensgemeinschaften miteinander leben – Haifa ist eine Lebensart. Gehen Sie entlang der Pinien spazieren und genießen Sie die kulturelle Diversität, eine geschäftige Intellektuellenszene, die friedliche Atmosphäre und unverkennbare Schönheit. Hier werden Sie inspiriert.</p>
								<h3>Umgeben Sie sich mit Ruhe und Zauber</h3>
								<p>Eine der wichtigsten Touristenattraktionen in Haifa sind die weltberühmten <strong>Gärten der Baha‘I</strong>. Sie wurden wegen ihres „außergewöhnlichen universellen Wertes“ 2008 von der UNESCO zum Weltkulturerbe ernannt. Es ist ein außergewöhnlich schöner Ort, der jährlich eine Million Besucher anlockt.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/haifa-intoxicating-beauty/1.jpg"} class="img-responsive" />
							 	</div>
								<p>Starten Sie Ihren Besuch oben am Karmel-Gebirge auf der sehenswerten Louis Promenade. Bestaunen Sie den atemberaubenden Blick, der sich von Haifa bis zur gesamten Küste und zu den entfernt gelegenen, grünen Bergen in Galiläa erstreckt.</p>
								<p>Erkunden Sie die Gärten auf eigene Faust oder nehmen Sie an einer Gratisführung teil. Gehen Sie die Terrassen mit ihren Hecken und Blumenbeeten entlang, die liebevoll angelegt wurden. Besichtigen Sie den goldenen Schrein des Bab, das Grabmal des Baha'i Propheten Herald undbewundern Sie die Farben und geometrischen Formen dieser einzigartigen hängenden Gärten und erfreuen Sie sich an der spürbaren Ruhe.</p>
								<h3>Entdecken Sie das Herz der Kulturszene von Haifa</h3>
								<p>Die Gärten der Baha‘I münden in das Stadtviertel der Deutschen Kolonie. Sie wurde in den 1860ern von der deutschen Tempelbewegung erbaut. Heute ist sie das Herz der Kulturszene in Haifa und ein Touristikzentrum mit Restaurants, Bars, Galerien und Boutique-Hotels. Bummeln Sie die Pflasterstraßen entlang, besuchen Sie die Galerien und erfreuen Sie sich an der schönen Architektur. Essen und trinken Sie in lokalen Cafés und Restaurants, erkunden Sie das Nachtleben und tauchen Sie ein in das bunte Treiben. Und bevor Sie schlafen gehen, werfen Sie noch einen Blick nach oben und schauen sich die wunderschöne Beleuchtung an, die sich von den Baha’I Gärten erhebt. Es wird Ihr Herz erwärmen.</p>
								<p><a href="//www.visit-haifa.org/ger/" target="_blank">http://www.visit-haifa.org/ger/</a></p>
																									
         	`,
      };
    },
  },

  {
    id: "The_Hula_Valley_Natural",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    title: "The Hula Valley Natural",
    ctg: "north",
    isVid: true,
    vidId: "h5TV5VwQeWY",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                               

							 	<h3>Entdecken Sie eine der besten Vogelbeobachtungsplätze der Welt</h3>
								<p>Im Herzen des pittoresken Hula-Tals im Oberen Galiläa, nur zwei Autostunden nördlich von Tel Aviv, liegt zwischen majestätischen Bergketten ein außergewöhnlich schönes Fleckchen Erde: der Hula-See. Dieses international anerkannte Naturreservat gilt als einer der wichtigsten Vogelbeobachtungsplätze der Welt und ist eine Oase für Vögel und Naturliebhaber. Es bietet die seltene und einzigartige Gelegenheit, grenzenlose Natur zu erleben - ein einmaliges Erlebnis.</p>
								
								<h3>Folgen Sie den Vögeln und bewundern Sie die Natur</h3>
								<p>Im Frühling und Herbst ziehen über 500 Millionen Vögel mit knapp 400 Arten durch das Hula-Tal. Dieses Feuchtbiotop ist ein perfekter Zwischenstopp für Kormorane, Reiher, Pelikane, Greifvögel und Kraniche.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/hulla-valley-natural/1.jpg"} class="img-responsive" />
							 	</div>
								<p>Das Hula-Tal (auch Hebrew Agamon Hula genannt) wurde von BBC Wildlife unter die besten zehn Vogelbeobachtungsplätze &nbsp;weltweit gewählt und zieht Vogelbeobachter aus aller Welt an. Kommen Sie zum internationalen Hula-Vogelfestival, das jedes Jahr im Herbst stattfindet, und genießen Sie ein einmaliges Erlebnis.</p>
								<p>Es gibt verschiedene Möglichkeiten, Zeuge dieses umwerfenden Phänomens zu werden. Wählen Sie einfach nur Ihr Abenteuer.</p>
								<p><strong>Erkunden Sie die Wege.</strong> Machen Sie einen Rundgang durch die wunderbar angelegten Wege des Parks. Sie können zu Fuß gehen, mit dem Rad oder mit einem Wagen die Pfade entlang fahren. Sie werden Obsthaine passieren und einen Einblick in das Feuchtbiotop erhalten.</p>
								<p><strong>Fahren Sie Traktor. </strong>Bei einer Führung in einem traktorbetriebenen „Safariwagen“ dringen Sie tief in das Gelände von Agamon vor. Mit dem getarnten Wagen bleiben Sie Vögeln „verborgen“ und kommen deshalb in den Genuss einer hautnahen Begegnung mit diesen wunderschönen Kreaturen.</p>
								<p><strong>Sonnenaufgang und Nachtführungen</strong> Für die Abenteurer unter Ihnen gibt es zwei spezielle Führungen. Bei der „Sunrise Tour“ erleben Sie eine einmalige Vogelsafari und die Möglichkeit, zu fotografieren. Alternativ hierzu haben Sie bei der „Night Owl Tour“ einen völlig anderen Blick auf das Reservat. Bei Lagerfeuer und Sternschnuppen können Sie einen Blick auf das Leben von Wildkatzen, Nachtvögeln und Flughunden erhaschen.</p>
								
								<h3>Erweitern Sie Ihren Horizont und seien Sie hautnah beim Naturschutz dabei</h3>
								<p><em>Agamon</em> Hula wurde weltweit anerkannt für sein nachhaltiges Ökosystem, das Natur, Tourismus und Landwirtschaft ausbalanciert.</p>
								<p>Besichtigen Sie die Beringungsstation für Vögel im Park und beobachten Sie die Naturschutzarbeiten. Machen Sie die „Bird Island Tour“ und vielleicht haben Sie die Chance, einen Vogel auszuwildern. Es gibt nichts besseres als das.</p>
								<p>Mit so vielen verschiedenen Tieren und dem unermüdlichen Einsatz im Naturschutz bietet das Hula-Tal ein Wohlfühlerlebnis, das Ihnen Herz und Sinne öffnet.</p>
																								
         	`,
      };
    },
  },
  {
    id: "Feel_Pudelwohl",
    bgImage: "/posts/bank/deadsea1/1.jpg",
    mobBgImage: "/posts/bank/deadsea1/M.jpg",
    title: "DAS TOTE MEER",
    ctg: "deadsea",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                               

							 	<h2>Fühlen Sie sich pudelwohl – am tiefstgelegenen Ort der Erde</h2>
								
							 	<h3>Erholung auf höchstem Niveau</h3>
								<p>Das Tote Meer, das offiziell als der tiefstgelegene Ort der Erde (428 Meter unter dem Meeresspiegel) und ein Kandidat in der engeren Auswahlliste für die sieben Naturwunder dieser Erde gilt, vereint natürliche Schönheit, spannende alte Geschichte und moderne Annehmlichkeiten zu einem faszinierenden und anregenden Urlaubserlebnis.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/feel-pudelwohl/1.jpg"} class="img-responsive" />
							 	</div>
								<p>Von den heilenden Kräften des kobaltblauen Wassers aus dem Toten Meer, über die atemberaubende Schönheit der Umgebung bis hin zu den unzähligen faszinierenden Sehenswürdigkeiten, die diese Region bietet, ist das Tote Meer ein Ort der Ruhe, Gesundheit und Inspiration für Körper und Geist.</p>
								<p>Lassen Sie sich auf dem Wasser treiben, nehmen Sie ein Schlammbad oder erkunden Sie an 330 Sonnentagen im Jahr die Region des Toten Meeres mit seinen eindrucksvollen Sehenswürdigkeiten, wie etwa natürliche Heilbäder, herrliche Wanderwege, Gourmet- und Fastfood-Restaurants sowie aufregende Attraktionen. Entlang des 75 Kilometer langen Hauptabschnitts mit seinen wunderschönen Stränden werden Sie außerdem Weltklasse-Hotels und Wellness-Einrichtungen finden für ein wahrhaft verwöhnendes Erlebnis.</p>
                                
								<h3>Die magischen Strände des Toten Meeres</h3>
								<p>Die Strände des Toten Meeres sind beispiellos auf dieser Erde. Kilometerlange wunderschöne und gut erhaltene Strände, wo Sie Sonne tanken und ihren Traumurlaub genießen können. Suchen Sie einen der felsigen Sandstrände aus und genießen Sie die atemberaubende Aussicht auf die unglaubliche Bergkulisse, die das Meer umgibt. Das warme Wasser des Toten Meeres ist immer ruhig und bietet sofort erstklassige Entspannung.</p>
								  <div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/feel-pudelwohl/2.jpg"} class="img-responsive" />
							 	</div>
								<p>An der Südküste am niedrigsten Punkt der Erde werden Sie eine Reihe von Hotels finden, in denen Sie sich am Sonnenaufgang über das Meer erfreuen können, der in kleinen Gewässern, die mit Salzformationen übersät sind, ein fantastisches Farbspektrum hinterlässt. Um das Erlebnis am Toten Meer abzurunden, tragen Sie etwas samtigen Schlamm auf Ihre Haut auf, damit sie die kostbaren Mineralien aufnehmen kann. Der Schlamm aus dem Toten Meer hat nachweislich positive Auswirkungen auf Haut und Körper. Sie werden sich erfrischt fühlen und Ihre Haut wird glatter und jünger aussehen. Gönnen Sie sich dieses Verwöhnprogramm. Sie haben es sich verdient. Machen Sie sich schmutzig mit dem Schlamm aus dem Toten Meer – er ist gesund!</p>

								<h3>Entdecken Sie die Wüste rund um das Tote Meer</h3>
								<p>Aber Sie können sich nicht nur in Heilbädern erholen und im Toten Meer treiben lassen. Wenn Sie südlich von Jerusalem reisen, machen Sie Halt beim Kibbutz Ein Gedi, eine natürliche Oase an den Hängen der Judäischen Wüste. Wandern Sie durch ein Naturschutzgebiet, in dem Sie wilde Tiere wie den Steinbock sehen und sich an den Wasserfällen und Teichen erfreuen, die an den Felswänden hinabfallen. Ein Gedi bietet außerdem Hotelunterkünfte und Heilbäder mit heißen Schwefelteichen. Dort werden auch verschiedene heilende und therapeutische Massagen angeboten. Setzen Sie Ihre Reise fort vom Süden zu der Felsenfestung&nbsp; Masada, ein nationales Wahrzeichen mit einer starken historischen Verbindung. Es befindet sich oben auf einem Bergmassiv, das von Abenteuersuchenden erklommen werden kann oder aber auch bequem mit der Seilbahn zu erreichen ist.</p>
																															
         	`,
      };
    },
  },

  {
    id: "Aufschwung_Fur_Geist",
    bgImage: "/HomeSlider/Home/3.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    title: "DAS TOTE MEER",
    ctg: "deadsea_2",
    isVid: true,
    vidId: "KijyxSgDpuY",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                               

							 	<h2>Aufschwung für Geist und Seele am tiefst gelegenen Ort der Erde</h2>
								
								
							 	<p>Entspannen Sie im wohltuenden Salz des Toten Meeres und erleben Sie einen unvergesslichen revitalisierenden Urlaub</p>
								<p>Mit seiner atemberaubenden, natürlichen Schönheit, seinen heilsamen, mineralhaltigen Heilquellen, der nachgewiesenen Heilqualitäte und vielen einzigartigen Erlebnissen wundert es nicht, dass sich das Tote Meer zu einem der weltweit prominentesten Reiseziele entwickelt hat. Dieser mysteriöse Salzsee hat alles, was Sie brauchen, um Körper und Geist perfekt zu entspannen.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/aufschwung-fur-geist/2.jpg"} class="img-responsive" />
							 	</div>
								<p><strong>Entspannen</strong>. Salz, Schlamm, Sonne... und vieles mehr. Tauchen Sie ein in die natürlichen (heißen) Schwefelquellen und genießen Sie die Heilbehandlungen. Vergessen Sie die Alltagshektik und lassen Sie die Seele baumeln. Genießen Sie einfach Ihren heilenden, revitalisierenden und erholsamen Urlaub.</p>
								
								<h3>Erfreuen Sie sich an den kostbarsten Geschenken der Natur</h3>
								<p><strong>Sich treiben lassen. </strong>Dank des außergewöhnlich hohen Salzgehaltes im Wasser, können Sie ein kleines „Wunder“ vollbringen, indem Sie zwar nicht auf dem Wasser laufen, sich aber &nbsp;auf der Oberfläche treiben lassen können. Gehen Sie ins Wasser, legen Sie sich hinein und lassen Sie der Natur ihren Lauf. Es kann einen Moment dauern, bis Sie sich daran gewöhnt haben, aber wir versprechen Ihnen, es ist wie Magie.</p>
								<p><strong>Heilen. </strong>Wenn man die Region des Toten Meeres kommt, ist es als wenn man eine andere Welt betritt. Eine andere Sicht, eine andere Geschwindigkeit, andere Luft und sogar die Sonne ist anders.</p>
								  <div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/aufschwung-fur-geist/1.jpg"} class="img-responsive" />
							 	</div>
								<p>Die spezielle Luft- und Lichtzusammensetzung ist das Resultat der besonderen geologischen Bedingungen der Region und der Hauptgrund für ihre Heilkraft.</p>
								<p>Die Atmosphäre ist anders, weil sich das Salz im Wasser in heilvolle Mineralstoffe auflöst, die Sie über die Luft aufnehmen. Die Sonne ist anders aufgrund des Standorts, so niedrig unter dem Meeresspiegel: sie ist schwächer und schädliche UV-Strahlen werden gefiltert. Gehen Sie nach draußen und genießen Sie die kostbarsten Geschenke der Natur.</p>
								<p><strong>Entdecken Sie das Kind in sich und geben Sie sich der Heilung durch die Natur hin</strong></p>
								<p><strong>Machen Sie sich schmutzig</strong> – Der Schlamm des Toten Meeres hat nachweislich eine gesundheitsfördernde Wirkung. Er verbessert, revitalisiert und entlastet Ihre Haut. Der Schlamm ist käuflich zu erwerben und kann zuhause angewandt werden. Aber warum sollten Sie sich die Gelegenheit nehmen lassen, sich mal wieder als Kind zu fühlen. Reiben Sie sich an Ort und Stelle an einem der Strände von Kopf bis Fuß mit dem schwarzen Schlamm ein und spüren Sie die wohltuende Wirkung der Mineralien. Machen Sie ruhig ein Selfie. Sie werden sehen, Sie sind mit diesem Urlaubsfoto Klassiker nicht allein.</p>
																																							
         	`,
      };
    },
  },

  {
    id: "TelAviv_And_Jerusalem",
    bgImage: "/HomeSlider/Home/3.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    title: "TEL AVIV & JERUSALEM",
    ctg: "telavivAndJerusalem",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                                <h2>Impuls und Inspiration ergänzen sich zu DEM perfekten Reisepaket</h2>
							 	<p>Wo sonst können Sie sich in der Sonne vergnügen, ein erstklassiges Kulturangebot genießen und sich in Veranstaltungen stürzen, die Geschichte geschrieben haben?</p>
								<p>Tel Aviv, eine pulsierende hochmoderne Metropole, umfasst Strände mit feinem, goldenem Sand, eine hippe Atmosphäre und viele Möglichkeiten, sich bei herausragenden Speisen und Kaffee in einer nahöstlichen Ambiente zu vergnügen. Nur vierzig Minuten entfernt erleben Sie einen völlig anderen Beat und Puls: Jerusalem, eine einzigartig schöne Stadt. Man wird leicht nachvollziehen können, weshalb so viele Menschen seit Tausenden von Jahren so begeistert von dieser Stadt sind.<br>Tel Aviv und Jerusalem sind zwar beides geschäftige, vitale und malerische Städte, die unzählige Attraktionen zu bieten haben, dennoch könnten sie unterschiedlicher nicht sein. Abgesehen von ihrer geografischen Lage, sind ihre Landschaften, Düfte und Gerüche komplett unterschiedlich. Wo sonst könnten Sie so leicht den ultimativen Strand mit einer der ältesten und heiligsten Städte der Geschichte verbinden?<br>Sehen Sie sich hier an, was Sie alles in Ihrem Urlaub in den beiden Städten unternehmen können.</p>
								<h3>Tel Aviv – die Stadt die niemals schläft</h3>
								<p>Sie sind in Tel Aviv gelandet... Erleben Sie den Reiz, der von der ersten hebräischen Stadt aufgetischt wird. Entdecken Sie die azurblauen Farbnuancen des Mittelmeeres, die malerischen Flecken in der Weißen Stadt, ihre Märkte, Restaurants, besonderen Aromen und das schillernde Nachtleben. Tauchen Sie ein und spüren Sie, weshalb Tel Aviv als die Non-Stop-City bekannt ist: Saugen Sie die Lebensfreude dieser Stand rund um die Uhr auf.<br>Dann legen wir mal los.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/telaviv-and-jerusalem/1.jpg"} class="img-responsive" />
							 	</div>
								<h3>Neve Tzedek</h3>
								<p>Entdecken Sie den Zauber dieser spektakulären und wunderschön renovierten Stadtteils im Süden der Tel Aviv Promenade, in der Nähe von Jaffa. Beginnen sie Ihren Morgen mit einem kulinarischen Erlebnis, einem typischen israelischen Frühstück: köstliche Backwaren, Eier, Käse und Dips, grüner Salat, Orangensaft und natürlich ausgezeichneten Kaffee. Die empfohlene Neve Zedek-Tour bringt Sie zu historischen Sehenswürdigkeiten und kleinen, wundervollen Museen.</p>
								<h3>Hatachana</h3>
								<p>Nach einer kurzen Verschnaufpause besichtigen Sie Hatachana ganz in der Nähe. Dort können Sie renovierte Tempelanlagen besichtigen sowie den alten Bahnhof von Jaffa, der komplett neu gestaltet wurde. Die Stätte erzählt die Geschichte des Bahnhofs mit seiner Bahnlinie von Jaffa nach Jerusalem, die von 1892 bis 1948 in Betrieb war.</p>
								<h3>Jaffa</h3>
								<p>Als nächstes spazieren wir die atemberaubende Standpromenade von Tel Aviv nach Jaffa entlang. Wir empfehlen einen Besuch des Jaffa Port, der als einer der ältesten Häfen der Welt gilt. Entspannen Sie in einem der vielen Cafés am Hafen und beobachten Sie die Fischer bei der Arbeit. Gehen Sie dann weiter zum farbenfrohen Flohmarkt, auf dem Sie sich Antiquitäten, armenische Keramik, die Hand der Fatima oder eins der zahlreichen Souvenirs gönnen können. Nachts verwandelt sich der Ort in eine Bar-Hopping- und Gastronomieszene.</p>
								<h3>Mit dem Rad den Strand entlang</h3>
								<p>Tel Aviv ist bekannt als die Fahrradhauptstadt Israels. An einem schönen Tag können Sie sich ein Fahrrad an einer der Tel-O-Fun-Stationen oder an einer anderen Mietstation in der Stadt ausleihen. Eine Radtour von Neve Zedek zum Tel Baruch-Strand im Norden der Stadt macht unglaublich viel Spaß.</p>
								<h3>Eretz Israel Museum</h3>
								<p>Wenn Sie sich im Norden der Stadt aufhalten, empfehlen wir Ihnen eine Besichtigung des Eretz Israel Museums. Es ist ein interdisziplinäres Museum mit dem Schwerpunkt auf der Geschichte und Kultur Israels, in dem sich ständige und Wechselausstellungen der Archäologie, Ethnografie, Post und Philatelie, Folkore, Judaika, traditionellem Handwerk, Popart, Kulturgeschichte und lokalen Identitäten widmen.</p>
								<h3>Rothschild Boulevard</h3>
								<p>Suchen Sie nach einer einladenden Lage, wo Sie hervorragend speisen können? Dann testen Sie doch mal eins der exquisiten Restaurants auf oder in der Nähe des Rothschild Boulevard, im Herzen der Stadt. Es ist eine der drei Zonen, die zur Weißen Stadt gehören und von der UNESCO zum Weltkulturerbe erklärt wurde. Diese Straße, die das Flair von Tel Aviv perfekt auffängt, bietet Ihnen eine erstklassige Gelegenheit, Menschen zu beobachten. Sie können auch einen Spaziergang machen und die beeindruckende Bauhaus-Architektur auf sich wirken lassen, der alte Kiosk und die kleinen Museen, welche die faszinierende Geschichte von Tel Aviv und seinem ersten Stadtteil, Ahuzat Bayit, erzählen.</p>
								<h3>Nachtleben</h3>
								<p>Wenn Sie in der Stadt bleiben möchten, können Sie wahlweise eins der großen Hotels direkt am Strand nahe der Promenade nehmen, oder eins der schönen Boutique-Hotels. Und wenn Sie dann immer noch aktiv und bereit sind, auszugehen, sollten Sie jetzt eine der populären Bars, Nachtclubs, die Oper, eine Tanz-Performance oder eine der vielen Veranstaltungen und Festivals in Tel Aviv besuchen.<br>Hat Ihnen die Kostprobe vom guten Leben in Tel Aviv gefallen? Dann freuen Sie sich jetzt auf einen Trip nach Jerusalem. Er dauert nur 40 Minuten! Die Heilige Stadt wartet auf Sie!</p>
								<h3>Jerusalem – die schönste Stadt der Welt</h3>
								<p>Entdecken Sie die drei heiligsten Religionen: Judentum, Islam und Christentum. Besichtigen Sie die historischen Stätten, nehmen Sie die atemberaubenden Düfte in sich auf, genießen Sie die besondere Küche, atmen Sie die klare Bergluft ein und amüsieren Sie sich bei den vielen Unterhaltungsmöglichkeiten überall in der Stadt.</p>
								<h3>Ein Kerem</h3>
								<p>Noch vor den Toren der Stadt können Sie das malerische Viertel Ein Kerem besichtigen.&nbsp; Es ist nur 20 Minuten Fahrt vom Stadtzentrum entfernt und bekannt für seinen bezaubernden Charakter. Ein Kerem ist im Grünen gelegen und bietet atemberaubende Ausblicke, eindrucksvolle Natursteinhäuser, Kirchen und Moscheen, faszinierende historische Stätten, idyllische Gassen, Galerien und spezielle kleine Geschäfte, Cafés und ausgezeichnete Restaurants sowie exquisite alte und neue Hotels.</p>
								<h3>Bloomfield Museum der Wissenschaften</h3>
								<p>Jerusalems Museum der Wissenschaft ist ein magisches Königreich für Erwachsene und Kinder gleichermaßen mit vielen beweglichen Objekten, optischen Täuschungen, elektrischen Experimenten und allem, was unsere Welt komfortabler macht.</p>
								<h3>Die Altstadt</h3>
								<p>An erster Stelle auf dem Jerusalem-Reiseplan! Die Altstadt von Jerusalem ist - einfach ausgedrückt - eine antike Schatztruhe der Entdeckungen und Begeisterung. Das wahre Leben von Jerusalem spielt sich in den schmalen Straßen ab, den verwinkelten Gassen der Altstadt. Die besondere Atmosphäre, die faszinierende Geschichte und Geheimnisse liegen hinter den antiken Gemäuern verborgen. Besuchen Sie die Klagemauer und geben Sie sich der Unantastbarkeit der Tempelruinen hin. Sie können in die Ritzen der Mauer Zettel mit Gebeten, Wünschen und Danksagungen hineinstecken.</p>
								<p>Folgen Sie den Spuren Jesu Christi entlang der Via Dolorosa bis hin zur Grabeskirche – Ort der beiden heiligsten Stätten des Christentums: der Ort, an dem Jesus von Nazareth gekreuzigt wurde und das leere Grab, aus dem er wieder auferstanden sein soll. Setzen Sie Ihre Route fort zum Berg Zion, auf dem Sie das Abendmahl (auch bekannt als der Abendmahlsaal) besichtigen können, das traditionell am Ort des letzten Abendmahls stattfand. Besichtigen Sie anschließend (wie Jesus es oft getan hat) den Ölberg für einen kurzen Moment der Meditation am Getsemani, an dem Jesus predigte und mit seinen Jüngern die Nacht vor der Kreuzigung verbracht hat. Besteigen Sie das Dach des österreichischen Hospiz zur Heiligen Familie für eine herrliche Aussicht auf Jerusalem und die Altstadt.<br>Und wenn Sie noch tiefer in die Wurzeln des antiken Jerusalem eintauchen möchten, machen Sie eine Tour durch die Klagemauertunnel, besichtigen Sie den Felsendom, die heilige Stätte, an der Mohammed in den Himmel aufgefahren sein soll, und die Erlöserkirche, in der die schönsten Orgeln von Israel zu finden sind.</p>
								<h3>Machane Yehuda Market</h3>
								<p>Sie waren heute viel unterwegs. Haben Sie schon Hunger? Sie können jetzt den Machane Yehuda Market besuchen – Jerusalems belebten und emsigen Markt. Entlang der renommierten Marktstände haben sich in den letzten Jahren viele Cafés und noble Lebensmittelgeschäfte etabliert.</p>
								<h3>Einkaufen in Jerusalem</h3>
								<p>Sind Sie bereit für eine Shopping- und Souvenir-Tour? Kaufen Sie armenische Keramik oder Judaika in speziellen Geschäften in der Altstadt. Sie werden im Stadtzentrum auch Geschäfte finden, die eine Fülle verschiedener Souvenirs aus Israel anbieten. Auf der Ben-Yehuda-Promenade werden Sie unzählige Bekleidungsgeschäfte finden. Und denken Sie daran, die Secondhand-Läden aufzusuchen, wenn Sie etwas Authentischeres kaufen möchten. Besuchen Sie auf jeden Fall das noble Einkaufszentrum Mamila Mall, das als eins der aktivsten Shoppingcenter der Stadt gilt.<br>Mit ihrem vielfältigen Angebot, ihrer Einzigartigkeit und den kurzen Wegstrecken sind Jerusalem und Tel Aviv das perfekte Reiseziel. Gemeinsam verbinden beide Städte Geschichte mit Moderne, antike Artefakte mit moderner Kunst, Sonnenspaß mit der spirituellsten Reise Ihres Lebens. Es kann kaum besser sein! Worauf warten Sie noch? Buchen Sie jetzt Ihre Reise!</p>
								<p>Weitere Informationen:</p>
								<p><a href="//www.visit-tel-aviv.com/" target="_blank">http://www.visit-tel-aviv.com/</a><br><a href="//www.itraveljerusalem.com/" target="_blank">http://www.itraveljerusalem.com</a></p>
																																														
         	`,
      };
    },
  },

  {
    id: "Caesarea_A_Time_Travel",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    title: "CAESAREA EINE ZEITREISE",
    ctg: "north",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                               
							 	
							 	<p>Entdecken Sie die Wunder aus vergangenen Zeiten, die von einem der größten Erbauer der Antike geschaffen wurden - König Herodes.</p>
								<p>In traumhafter Lage an den Ufern des türkisfarbenen Mittelmeeres und weniger als eine Autostunden von Tel Aviv entfernt liegt das antike und wunderschöne Caesarea.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/caesarea-time-travel/1.jpg"} class="img-responsive" />
							 	</div>
								<p>Die Stadt und ihre archäologischen Wunder sind Zeugnis ihrer Bedeutung im Laufe der Jahrhunderte. Ein Besuch des Nationalparks und des antiken Hafens, ein Rundgang durch das römische Hippodrom und Amphitheater sowie ein Spaziergang beim beeindruckenden Palast zwischen seinen vielen historischen Schätzen gleicht einer Reise zurück in die Zeit der großen Herrscher.</p>
								<p>Und auf jeden Fall sollten Sie sich „Travel through Time experience“ ansehen, ein faszinierendes Erlebnis, bei dem es sich um eine kleine „Sound- und Lichtshow“ handelt, die Sie in die zauberhafte Geschichte von Caesarea mitnimmt und durch die Jahrhunderte führt.</p>
								<p>Gespickt wird das Besuchererlebnis durch die natürliche Schönheit von Caesarea und seine modernen Annehmlichkeiten, wie etwa die schönen, malerischen Restaurants und Cafés und dem einzigen Golfplatz im Land.</p>
																																																						
         	`,
      };
    },
  },

  {
    id: "What_To_Pack",
    bgImage: "/HomeSlider/Home/3.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    title: "WAS SOLLTEN SIE EINPACKEN?",
    ctg: "TouristInfo",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                               
							 	
							 	<p>Israel ist ein modernes Land und Sie können nahezu alles kaufen, was Sie während Ihres Aufenthaltes brauchen: Kleidung, Kosmetik und Hygieneartikel.</p>
								<p>Wenn Sie Israel im Sommer bereisen, sollten Sie leichte Kleidung mitnehmen - kurzärmelige oder ärmellose T-Shirts, kurze Hosen, Sandalen, Strandschuhe und Badesachen. Ein Sweatshirt oder eine Jacke sind von Vorteil, da es nachts vor allem in den Bergen und der Wüste kühler werden kann.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/what-to-pack/1.jpg"} class="img-responsive" />
							 	</div>
								<p>Wenn Sie Israel im Winter bereisen, benötigen Sie wärmere Kleidung, ein Mantel (vorzugsweise auch ein Regenmantel), festes Schuhwerk, einen Regenschirm, Handschuhe, Schal und sonstige warme Kleidung. Es ist in Israel zwar nicht so kalt wie in Europa, aber es kann tagsüber regnen und kühl sein.</p>
								<p>Es ist auch von Vorteil, einen Rucksack oder eine Tasche für Tagesausflüge mitzunehmen. Wenn Sie nach Eilat oder ans Tote Meer reisen, sollten Sie Badesachen (Badeschuhe) mitnehmen, da es warm genug zum Schwimmen sein wird, auch im Winter.</p>
								<p>Sonnencreme, einen Sonnenhut und Sonnenbrille sind im ganzen Jahr hilfreich.</p>
								<p>Falls Sie wandern möchten, brauchen Sie auf jeden Fall gutes Schuhwerk und viel Trinkwasser, am besten in Feldflaschen. Falls Sie im Freien übernachten möchten, benötigen Sie außerdem einen Schlafsack, ein Zelt und Campingausrüstung. Die meisten Jugendherbergen stellen Bettwäsche zur Verfügung.</p>
																																																						
         	`,
      };
    },
  },
  {
    id: "Majestic_Desert",
    bgImage: "/posts/bank/negev1/1.jpg",
    mobBgImage: "/posts/bank/negev1/M.jpg",
    title: "ISRAELS MAJESTÄTISCHE WÜSTE",
    ctg: "eilat-negev",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                               
							 	
							 	
							 	<p>Der Süden Israels ist das ideale Ziel für Reisende, die Abenteuer in der freien Natur lieben. Er ist nur dünn besiedelt, zeichnet sich aber durch faszinierende Orte und Aktivitäten aus.</p>
								<p>Mit erstaunlichen Naturwundern und Schönheiten bietet der Süden Israels einen herrlichen Blick, der Ihnen den Atem rauben wird: von Sonnenauf- bis Sonnenuntergang.</p>
								<p dir="LTR">Zwar eine Wüste, aber definitiv keine Ödnis: Hier gibt es so viel zu sehen und zu unternehmen. Der Negev zeichnet sich durch seine außergewöhnlichen Gesteine und Formationen, bedeutenden Kulturdenkmäler und wundervollen Naturschutzgebiete aus, in denen Sie wandern, radfahren und kamelreiten, oder auch aufregende Safaritouren in der Wüste erleben können.<br>Einfach ausgedrückt ist diese majestätische südliche Region eines der kostbarsten Reichtümer des Landes und ein absolutes Muss auf der Reiseroute.</p>
								<h3>Ramon-Krater</h3>
								<p>Im Herzen der ausgedehnten Negev-Wüste liegt der Ramon-Krater, der weltweit größte Erosionskrater, der auch unter dem Namen Machtesch Ramon bekannt ist. Er umfasst eine enorme Gesteinsvielfalt aus fantastischen Farben und Formen und ist ein überwältigendes Naturphänomen mit einem Ausmaß von 40 km Länge und zwischen 2 bis 10 km Breite. Er hat die Form eines langen Herzens und bildet Israels größten Nationalpark: das Ramon-Naturreservat.</p>
								<p>Weit weg von den Lichtern und Menschenmassen der Stadt beeindruckt der Ramon-Krater durch seinen mehrfarbigen Sandstein, seinen Vulkanfelsen und seine Fossilien und wird oft als Grand Canyon Israels bezeichnet.</p>
								<p>Die wahrhaftig atemberaubende Aussicht vom 300 m hohen Aussichtspunkt des Machtesch Ramon, der an eine Hollywood-Kulisse erinnert, ist für Touristen aus aller Wellt das ganze Jahr über ein beeindruckendes Erlebnis.</p>
								
								<h3>Sede Boker</h3>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/majestic-desert/1.jpg"} class="img-responsive" />
							 	</div>
								<p>Ein bemerkenswerter Rückblick in die Geschichte des Staates Israel ist Sede Boker, ein Kibbuz, der ursprünglich von Siedlern gegründet wurde, mit der Mission, den Negev Anfang der 50er Jahre zu besiedeln.</p>
								<p>Der frühere israelische Ministerpräsident David Ben Gurion hatte ein Haus in Sede Boker, das heute ein öffentliches Museum ist.</p>
								<h3>Vidor Center</h3>
								<p>Eine wirklich einzigartige Sehenswürdigkeit und ein multisensorisches Erlebnis der außergewöhnlichen Natur der Region Arava. Center-Besucher können fortschrittliche Landwirtschaftsmethoden, heimische Pflanzen- und Tierarten, klimatische Herausforderungen, und besondere Eigenschaften des Bodens und des Wassers in der Wüste erkunden.</p>
								<h3>Nevatim</h3>
								<p>Ein Besuch in Nevatim, der Heimat der Cochin-Juden, ist eine faszinierende Erfahrung.</p>
								<p>Die Cochin-Juden stammen ursprünglich aus Indien und sind nach der Staatsgründung Israels immigriert. Sie glauben, aus einer der ältesten jüdischen Gemeinschaften zu kommen.</p>
								<p>Das Zentrum für das Cochin-Kulturgut in der Moshav Nevatim erzählt die Geschichte dieser Gemeinschaft.</p>
								<h3>Das Beduinen-Erlebnis</h3>
								<p>Die Gastfreundschaft der Beduinen ist sowohl unter emotionalen als auch unter kulturellen Aspekten ein unvergleichliches Erlebnis.</p>
								<p>Beduinen in Israel sind eine Gruppe von Nomadenstämmen, die vor vielen hundert Jahren dort gelebt haben und hier immer noch auf traditionelle Weise leben. Sie werden Sie willkommen heißen in ihren Häusern und in ihrem Leben und machen Sie mit ihren Sitten und Gebräuchen vertraut.</p>
								<p>Vom Kamelreiten bis hin zur traditionellen Beduinenküche und Übernachtungen in Beduinenzelten - all das sind beeindruckende Sehenswürdigkeiten und eine Chance, in ein langes, vergessenes Leben wieder einzutauchen.</p>
								
								<h3>Die kulinarischen Königinnen von Yeruham</h3>
								<p>Für ein wirklich denkwürdiges Erlebnis müssen Sie unbedingt „Die kulinarischen Königinnen von Yeruham“ besuchen – Ein einzigartiges Projekt, wo wundervolle Frauen aus Yeruham Touristen aller Welt mit einer hervorragenden traditionellen Mahlzeit in ihren Häusern begrüßen undfür unvergessliche Momente voller Düfte, Farben und Geschmack sorgen.</p>
								<p>Lernen Sie das wirkliche Leben der Einheimischen durch ihre Geschichten kennen, während Sie die original zubereiteten Delikatessen und die wundervolle Gastfreundschaft genießen.</p>
								<h3>Die Altstadt Be'er Sheva</h3>
								<p>Es heißt, dass Be'er Sheva von Abraham gegründet wurde. Es ist eine der ältesten Städte im Land, die nachweislich vor tausenden von Jahren schon besiedelt wurde. Die Altstadt Be'er Sheva bietet ein faszinierendes Mosaik urbaner Räume und wenn Sie die Stadt erkunden, werden Sie auf einzigartige Architektur und jahrhundertelange Historie stoßen.</p>
								<h3>Carasso Science Park</h3>
								<p>Neu in der Altstadt von Be’er Sheva, streckt sich der Carasso Science Park über mehr als 17 Quadratmeter und ist somit der größte Wissenschaftspark Israels.</p>
								<p>Der Carasso Science Park begeistert und beschäftigt Besucher jedes Alters mit Attraktionen, wie einem interaktiven Museum und einem wissenschaftlichen Garten mit Spielen und Aktivitäten zum mitmachen. Der Park bietet auch zehn Ausstellungen über verschiedene Themen an, wie: Gen-Technik, Kommunikation, Mikroelektronik, Kernenergie, und anderem.</p>
								<h3>Arad</h3>
								<p>Arad ist eine Stadt mit jungem Zeitgeist und reichhaltiger Erfahrung. Arad ist von wunderschönen Landschaften, der Beschaulichkeit einer Wüste und vielen Wanderwegen umgeben, die für jedermann jeglichen Alters geeignet sind.</p>
								<p>Es gibt viele Sehenswürdigkeiten und zahlreiche Touristenstätten in und um die Stadt, also der perfekte Ausgangspunkt und Ihr Tor für einen perfekten Wüstenurlaub.</p>
								<h3>Timna Park</h3>
								<p>Der Timna Park mit 60 Quadratkilometern ist ein hufeisenförmiges Tal, umgeben von steilen Klippen, ein außerordentliches Erlebnis und ein absoluter Genuss für Wanderbegeisterte. Hier werden Sie Zeugen der wunderbaren Werke der Natur, aber auch der herausragenden Tier- und Pflanzenwelt, die in der Wüste heimisch sind und unter extremen, trockenen Bedingungen leben. Mit vielen Attraktionen, buntem Sand und zerklüfteten Bergen wirkt der Timna Park bei Besuchern wie ein unvergleichbarer Magnet.</p>
								
								<h3>Naturreservat Chai-Bar Yotvata</h3>
								<p>Das Naturreservat Chai-Bar Yotvata ist das in dieser Region größte Zucht- und Ansiedlungszentrum für Tiere, bevor sie ausgewildert werden. Das Reservat ist stolz auf seine wundervollen Attraktionen, die Tierliebhaber begeistern werden. Es umfasst ein Gehege mit Raubtieren und kleinen Wüstentieren, ein Observatorium für nachtaktive Tiere, das sich auf 12 Quadratkilometer erstreckt und freilaufende Huf- und Weidetiere beherbergt.</p>
								
								<h3>Extremabenteuer</h3>
								<p>Im Süden Israels gibt es ein Traumreiseziel für abenteuerhungrige Reisende. Sein einzigartiges und anspruchsvolles Terrain eignet sich ideal für verschiedene Extremsportarten und -aktivitäten, wie etwa das Abseilen von Schluchten, Querfeldein- und Mountain-Biking, die in dieser Region äußerst beliebt sind, ebenso wie Geländefahren.</p>
								
							

         	`,
      };
    },
  },
  {
    id: "Transport",
    bgImage: "/HomeSlider/Home/3.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    title: "VERKEHRSMITTEL",
    ctg: "TouristInfo",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                               
							 	<p >Israel ist ein kleines Land, sodass man überall schnell und bequem ankommt. Taxen sind in Israel für den Stadt- und Überlandverkehr üblich und können auf der Straße angehalten oder telefonisch bzw. über spezielle internationale Apps wie etwa GetText gebucht werden.</p>
								<p >Hauptsächlich werden Busse und der nationale Bahnverkehr genutzt, die ein bequemes und preisgünstiges Verkehrsmittel zu nahegelegen Zielen im Land sind.</p>
								<p >Zugauskunft: <a href="https://www.rail.co.il/en/" target="_blank" rel="noopener">www.rail.co.il</a> / Telefon: 08-6831222 oder *5770.</p>
								<p >Busauskunft: <a href="https://www.egged.co.il/HomePage.aspx" target="_blank" rel="noopener">Egged</a> oder<br><a href="//bus.gov.il/?language=en#/origindestination/1/0"  target="_blank" rel="noopener">www.bus.co.il</a> / Telefon: 1-900-72-1111</p>
								<p >Tickets sind an Ticketschaltern an Busbahnhöfen der Städte oder direkt beim Fahrer erhältlich. Die meisten Buslinien fahren nicht am Sabbat oder an jüdischen Feiertagen. Der Betrieb endet freitagnachmittags und wird samstagabends wieder aufgenommen.</p>
								<p >Studenten können zu günstigeren Tarifen Intercity-Buslinien nutzen. Hierfür müssen Sie beim Kartenkauf einen gültigen internationalen Studentenausweis vorlegen.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/transportation/1.jpg"} class="img-responsive" />
							 	</div>
								<h3>Smart Ride-Karte - Rav Kav</h3>
								<p >Touristen können eine sogenannten Rav Kav Card kaufen. Sie kann für einen günstigen Preis &nbsp;im Bus gekauft und dann mit einem normalen Multi-Ride- oder Single-Ticket wieder aufgeladen werden, normalerweise im Rahmen eines Regionen-Rabatts von 20%.</p>
								<p >Touristen können keine Persönliche Rav Kav Card kaufen, auf der die persönlichen Daten des Fahrgastes stehen, diese ist nur für Einwohner.</p>
								<p >Bitte beachten Sie:</p>
								<p >-&nbsp;Die Rav Kav kann für die Zahlung für den Transport mehrerer Fahrgäste benutzt werden,</p>
								<p >-&nbsp;Kinder zahlen genauso viel wie Erwachsene.</p>
								<p >-&nbsp;Die Rav Kav kann in einer Region genutzt werden und nicht zwischen Regionen, es sei denn, sie wurde speziell für die gewünschten Routen wieder aufgeladen.</p>
								<p >-&nbsp;In manchen Regionen kann man Tageskarten innerhalb einer Region kaufen.<br><br>Please give Price List here!</p>
								<h3>Inlandsflüge</h3>
								<p >Israel ist ein kleines Land und daher lohnt es sich nur, zwischen Eilat und Tel Aviv zu fliegen. Verschiedene Fluggesellschaften bieten Flüge von Eilat zum Flughafen Ben Gurion oder Sde Dov im Norden von Tel Aviv an. Die Flugtarife sind günstig, aber natürlich höher als ein Busticket.</p>
								<p >Es gibt auch Privatunternehmen, die auf Anfrage spezielle Flüge innerhalb des Landes anbieten.</p>
								<p >Arkia: <a href="https://www.arkia.com/flights-in-israel" target="_blank" rel="noopener">www.arkia.com/flights-in-israel</a> Telefon: 00 972 3 690 2222,</p>
								<p>Israair: <a href="https://int.israirairlines.com/cat_domestic.asp"  target="_blank" rel="noopener">&nbsp;int.israirairlines.com/cat_domestic.asp</a> Telefon: 00 972 3 795 5777</p>
								<h3>Autovermietung</h3>
								<p>Die meisten internationalen Mietwagenfirmen und lokale Firmen haben Büros in den Großstädten und am Flughafen Ben Gurion. Es ist zu empfehlen, einen Wagen vom Ausland aus im Voraus zu reservieren.</p>
								<p>Um ein Auto zu mieten, muss man älter als 24 Jahre sein und einen gültigen internationalen Führerschein sowie eine Kreditkarte haben.</p>
								<p>Das Straßensystem in Israel ist flächendeckend und in der Regel deutlich beschildert (auf Hebräisch, Englisch und Arabisch).</p>
								<h3>Autofahren in Israel</sh3>
								<p><strong>Das Mindestalter</strong> für Autofahrer ist in Israel 17 Jahre und es herrscht Rechtsverkehr. Die Geschwindigkeitsbegrenzung liegt bei 30 bis 50&nbsp;km/h in Städten, 80 bis 90&nbsp;km/h auf Landstraßen sowie 130&nbsp;km/h auf Autobahnen und der Route Nr. 6. Sicherheitsgurt sind Pflicht. Und wenn Sie das Nachtleben in der Stadt genießen, denken Sie daran, dass die Promillegrenze beim Fahren bei Null Prozent liegt. Organisieren Sie daher einen Fahrer, damit Sie unbesorgt genießen können.</p>
								<h3>Highway 6</h3>
								<p>Highway 6 betreibt ein elektronisches Mautsystem, das weder Schranken an Ein- und Ausfahrten noch Ampeln hat, sodass der Verkehr frei fließen kann. Fortgeschrittene Computersysteme (wie etwa elektronische Mautstellen), die an der Autobahn montiert sind, erkennen Fahrzeuge, kategorisieren Gebührenarten (Abos oder nicht registriert) und ermitteln die Anzahl an Autobahnabschnitten, die jedes Fahrzeug passiert. Jede Fahrt wird automatisch erfasst und berechnet. Für Fahrer ist es äußerst komfortabel und sicher bei einem Geschwindigkeitslimit von 130 km/h.</p>
								<p>Touristen mit einem Mietwagen werden über Kreditkarte abgerechnet. Informationen zu Bedingungen und Tarifen erhalten Sie bei Ihrer Autovermietung.</p>
								<p>Die meisten Autovermietungen bieten keine Versicherung für die Regionen in der Palästinensischen Behörde für das Westjordanland an. Touristen, die mit einem Mietwagen in diese Regionen fahren möchten, wird empfohlen, eine entsprechende Versicherung abzuschließen.<br>&nbsp;</p>
								<p>PLEASE ADD:<br><br><strong>Route 1 Jerusalem - Totes Meer</strong></p>
								<p>Sie können mit ihrem Wagen problemlos auf der Bundesstraße 1 von Jerusalem direkt an das Tote Meer fahren. Sie passieren dabei lediglich zwei Checkpoints.<br><br><strong>Route 90 Totes Meer – See Genezareth</strong><br><br>Auch die Bundesstraße 90 können Sie in der Regel problemlos mit ihrem Mietwagen entlangfahren. Die Bundesstraße 90 verbindet auf direktem Weg das Tote Meer mit dem See Genezareth. Auch hier passieren Sie nur zwei Checkpoints.<br>(Es gibt einige Ausnahmen vereinzelter Mietwagenfirmen, die das Passieren der Route 90 nicht gestatten. Informieren Sie sich diesbezüglich im Vorfeld)</p>
									
																																														
         	`,
      };
    },
  },
  {
    id: "Shoping_In_Israel",
    bgImage: "/posts/bank/jerusalem4/1.jpg",
    mobBgImage: "/posts/bank/jerusalem4/M.jpg",
    title: "EINZIGARTIGES KAUFERLEBNIS IN ISRAEL",
    ctg: "jerusalem",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                               
							 	
							 	<p>Israel ist auch das Land der schönen Dinge. Aufgrund der verschiedenen Religionen und kulturellen Hintergründe seiner Bewohner finden Sie hier auch die unterschiedlichsten Formen an Souvenirs. Auf den Märkten, in den Geschäften und Galerien werden Sie eine unglaubliche Fülle an Produkten sehen, bei denen sicher etwas für Sie dabei ist und sich ebenso als schöne Urlaubserinnerung und Geschenk für ihre Freunde und Familie eignet.</p>
								<h3>Souvenirs von den heiligen Stätten</h3>
								<p>Einige der schönsten Momente Ihrer Reise in Israel warten auf Sie an den heiligen Stätten Israels in Galiäa und Jerusalem. Auffällige blaue und weiße Keramik aus Armenien, die mit Familienmotiven dekoriert sind, werden gerne als Erinnerungstücke mitgenommen. Jahrhundertealte Handwerkskunst verzieren mit Olivenholz und Perlmutt jetzt Bibeln, Schachteln, Broschen und viele andere Gegenstände, die Ihren Aufenthalt in guter Erinnerung behalten.</p>
								<h3>Einzigartige Judaika</h3>
								<p>Was würde sich nicht besser als Erinnerung an Safed, Jerusalem oder Jaffa eignen als das schöne jüdische Kunsthandwerk, auch Judaika genannt. Empfinden Sie den Sabbat nach und schmücken Sie ihren Tisch zuhause mit einem handbestickten Challah- oder Matzah-Bezug (leicht und einfach zu verstauen!), oder Kerzen, einem Kidduschbecher oder nehmen Sie eine Chanukkah-Menora in zeitgemäßem oder traditionellen Silber, aus Zinn, Glas oder Keramik als Erinnerung mit. Mesusas (eine Schriftrollenkapsel für den Türpfosten) eignen sich perfekt als Einweihungsgeschenk und ein Gebetsschal ist eine lebenslange Bar/Bat Mitzwah-Erinnerung.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/shoping-in-israel/1.jpg"} class="img-responsive" />
							 	</div>
								<h3>Produkte aus dem Toten Meer</h3>
								<p>Israel ist Heimat des weltgrößten Heilbads - das Tote Meer. Nach einem Bad in seinem mineralienreichen Wasser fühlen sich Ihre Haut und Ihre Haare seidig weich an. Und ja, es wird auch in Flaschen abgefüllt! Sie können ein ganzes Produktsortiment an Mineralien aus dem Toten Meer kaufen, wunderschön als Geschenk aus Israel verpackt.</p>
								<h3>Einkaufen</h3>
								<p>Sicher möchten Sie durch die Fabrikoutlets schlendern, um sich dort auf die Suche zu begeben nach neuen Lieblingsstücken für ihren Kleiderschrank und um die angesagten Outfits der weltberühmten israelischen Modedesigner zu entdecken. Ebenfalls beliebt: die schöne kreative Babybekleidung aus 100% Baumwolle, die Sie mühelos in Ihrem Koffer verstauen und als Geschenk mitbringen können. Haben Sie sich die Füße in Israel platt gelaufen? Bevor Sie nachhause fliegen sollten Sie sich noch ein paar bequeme, in Israel gefertigte Sandalen oder Schuhe zum unschlagbaren Preis kaufen.</p>
								<h3>Schmuck</h3>
								<p>Israelische Schmuckdesigner verbreiten sich mehr und mehr bei eleganten Juwelieren weltweit. Wenn Sie bei den Designern in Israel kaufen, sind sie direkt an der Quelle. Trendige Armreifen sind hoch im Rennen mit ihren mehrfarbigen Kristallen und Perlen, in scheinbar endlosen Schattierungen. Außerdem Kreationen in elegantem grün-blauem Malachit (Eilat-Stein), an denen man erkennen kann, dass Sie in Israel waren.</p>
								<p>Israel ist seit langem berühmt für seine geschliffenen Diamanten und für das Wissen und die Kompetenz seiner Diamatenexperten. Als diamantenexportierendes Land kann Israel in diesem Bereich einen Kaufvorteil anbieten. Außerdem haben Sie die Möglichkeit, eine Diamantenmanufaktur zu besichtigen, in der Sie alles Wissenswerte über diesen Industriezweig erfahren.</p>
								<h3>Nicht zu vergessen das Essen</h3>
								<p>Ein großartiges Souvenir sind auch die vielen Feinschmeckerprodukte mit Delikatessen der Landesküche in Israel. Es gibt Gewürze wie die biblische Ysop-Pflanze und süße Datteln schön verpackt als Mitbringsel für zuhause sowie eine Vielzahl verschiedener Kräutertees, Honig, preisgekrönte Weine und andere Produkte.</p>
								<p>Und wenn Sie mit Ihren Geschenken am Flughafen ankommen, kommen Sie auch noch in den Genuss der Mehrwertsteuerrückerstattung bei Käufen im Wert von über 100 US-Dollar in teilnehmenden Geschäften.</p>
																																																						
         	`,
      };
    },
  },
  {
    id: "Park_Timna",
    bgImage: "/posts/bank/negev4/1.jpg",
    mobBgImage: "/posts/bank/negev4/M.jpg",
    title: "TIMNA PARK",
    ctg: "eilat-negev",
    isVid: true,
    vidId: "Id0U0OeDs7Y",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                                <h2>Ein begeisterndes Wüstenabenteuer</h2>
							 	
							 	<p>Erkunden Sie die natürliche Schönheit und spannende Attraktionen des Timna Parks</p>
								<p>Der Timna Park ist ein einmaliges Erlebnis nur 20 Minuten von Eilat entfernt im Herzen der Wüste Negev und eingebettet inmitten einer atemberaubenden Naturkulisse. Zahlreiche Attraktionen und Aktivitäten vereinen Natur, historische Altertümer und Abenteuer auf einem weitläufigen Gelände, das Besuchern aller Altersgruppen und Interessen jede Menge Unterhaltung bietet.</p>
								<h3>Werden Sie Zeuge eines herausragenden Naturphänomens</h3>
								<p>Bestaunen Sie beim Spazieren durch den Park die <strong>einzigartigen Felsformationen </strong>mit interessanten Namen und seltenen Formen, die Sie mit der Hand berühren können; “Mushroom,” “Mushroom &amp; a Half,” “Pink Canyon,” “Arches,” “Solomon’s Pillars” und “Valley of Rock Drawings -” sie bezeichnen das Leben einer längst vergangenen Zeit.</p>
								
								<h3>Wandern in freier Natur</h3>
								<p>Starten Sie an einem der 20 gut beschilderten <strong>Wanderwege</strong>, die sich im Schwierigkeitsgrad unterscheiden und auf die jeweiligen Bedürfnisse und Fähigkeiten zugeschnitten sind. Wandern Sie auf spektakulären, geologisch und archäologisch bedeutsamen Wegen oder gehen Sie ganz gemütlich den im Schatten liegenden <strong>Timna Lake</strong> und seinem angrenzenden Campingplatz entlang, vorbei an König Solomons Khan-Restaurant, wo man Wüstenhandwerk wie etwa Flaschen hergestellt aus gefärbtem Sand findet oder Tretboote ausleihen kann.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/park-timna/1.jpg"} class="img-responsive" />
							 	</div>
								<p>Sind Sie mehr für <strong>Extremsport</strong>? Wie wäre es mit Abseilen von den Klippen, Seilbahn fahren und einer Radtour im Park, danach fühlen Sie sich garantiert wie neu geboren.</p>
								<h3>Erleben Sie alte Zeiten</h3>
								<p>Bei einer Führung durch den wieder aufgebauten <strong>Tabernakel </strong>(„Hütte“ oder auch „Gasthaus“), der mit einer Nachbildung des Altars, dem Allerheiligsten und der Arche vervollständigt wurde, erfahren Sie alles über die biblische Geschichte in der Wüste.&nbsp; Jüngere Besucher stehen zum Teil ehrfürchtig vor der Reproduktion dieses Heiligtums, das Gott den Juden befohlen hat, in der Wüste aufzubauen - ältere Besucher hingegen neigen dazu die Rekonstruktion auf ihre historische Präzision hin zu untersuchen.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/park-timna/2.jpg"} class="img-responsive" />
							 	</div>
								<p>Timna Park. Hier trifft die Geschichte auf Abenteuerlust.</p>
																																														
         	`,
      };
    },
  },
  {
    id: "Passport_Visa",
    bgImage: "/HomeSlider/Home/3.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    title: "REISEPASS UND VISUM",
    ctg: "TouristInfo",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                               
							 	
							 	<p>Alle Besucher müssen bei ihrer Ankunft in Israel einen Pass vorweisen, der mindestens sechs Monate ab Ausreisedatum gültig ist. Menschen, die keine Staatangehörigkeit besitzen, müssen einen gültigen Passierschein sowie ein Visum für die Rückreise in das Land mit sich führen, von dem es ausgestellt wurde.</p>
								<p>Besucher sind berechtigt, sich ab ihrer Ankunft bis zu drei Monate in Israel aufzuhalten gemäß der Bedingungen des für sie ausgestellten Visums. Besucher, die in Israel arbeiten möchten, müssen eine Anfrage auf ein spezielles Visum an das Ministry of the Interior (Innenministerium) stellen.</p>
								<p>Israel stempelt keine Pässe mehr an Flughäfen sowie an den meisten Landesgrenzen. Jedoch kann es aufgrund technischer Probleme manchmal dazu kommen, dass an Grenzkontrollen auf die Methode des Stempels im Pass zurückgegriffen wird. Wir empfehlen, dass Touristen, die von Israel aus weiter in arabische Länder reisen möchten, einen <strong>offiziellen Antrag</strong> stellen, ihren Pass nicht mit einem israelischen Stempel zu versehen. Der Tourist muss den Beamten über diesen Antrag in Kenntnis setzen, bevor die Dokumente gestempelt werden.<br><br><strong>Der „Electronic Gate Pass“</strong></p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/passports-visa/1.jpg"} class="img-responsive" />
							 	</div>
								<p>Nach Artikel 13 des Gesetzes über die Einreise nach Israel von 1952 kann ein offizieller Inspektor oder Polizist die Identifizierung und den Nachweis des rechtlichen Status in Israel anfordern. Zu diesem Zweck wird an der Grenzkontrollstation per Knopfdruck eine Karte inklusive der wichtigsten Angaben des Reisenden (entnommen der ersten Seite des Passes) ausgedruckt. Auf der Karte werden auch das Ankunftsdatum und die Visaangaben angezeigt. Diese Karte ist der „Electronic Gate Pass. Es ist ein neues und modernes technisches System, das maßgeblich dazu beiträgt, die Bedürfnisse der verschiedenen Einwanderungs-, Sicherheits-, Flughafen- und Touristikbehörden zu erfüllen, und das Touristen den erforderlichen Nachweise ihres Visastatus belegt. <strong>Der „Electronic Gate Pass“ ersetzt das System, bei dem der Pass gestempelt wird.</strong> Am Flughafen ermöglicht diese Karte dem Reisenden, den Ankunftsterminal ohne weitere Verzögerung zu verlassen.</p>
								<p><strong>Der Gate Pass ist ein amtlicher Ausweis für den Aufenthalt in Israel. </strong>Wir bitte alle Touristen, die Karte als Nachweis ihres Visastatus immer mit sich zu führen. Am Flughafen und an festgelegten Grenzübergängen ermöglicht diese Karte dem Reisenden, den Ankunftsterminal zu verlassen und sich zur Gepäckausgabe zu begeben.</p>
								<p><strong>Touristen werden gebeten, die Karte als Nachweis immer mit sich zu führen.</strong></p>
								<h3>Weitere Visinformationen</h3>
								<p><a href="//embassies.gov.il/berlin/ConsularServices/visainformation/Pages/Visainformation.aspx">http://embassies.gov.il/berlin/ConsularServices/visainformation/Pages/Visainformation.aspx</a></p>
								<h3>Touristenvisa</h3>
								<p>Wir heißen Sie in Israel herzlich willkommen. Viele Länder haben ein Visumsbefreiungsabkommen mit Israel, das ihren Einwohnern ermöglicht, Israel zu besuchen, ohne im Vorfeld ein Visum auszustellen. Vor Reiseantritt sollten Reisende, die auf ihrem Weg in andere Zielgebiete in Israel Zwischenstopp machen möchten, prüfen, ob Sie ein Touristenvisum im Voraus beantragen müssen. Die Liste der Länder in folgendem Link gibt an, aus welchen Ländern Touristen im Voraus ein Visum beantragen müssen.</p>
								<p><a href="//mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf">http://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</a></p>
								<p>Alle Reisenden, die aus visumsbefreiten Ländern kommen, müssen einen maschineleserlichen Pass am Eingangsflughafen vorweisen, um in Israel ohne Visum einzureisen; ansonsten ist ein Visum erforderlich. Dies gilt für Touristen, die mit einem Passierschein aus Ländern mit Visumbefreiung kommen.</p>
								<h3>Aufenthaltsverlängerung</h3>
								<p>Ihr Visum kann bei einem Ministry of the Interior (Innenministerium) in Ihrer Nähe verlängert werden (gegen Gebühr). Bitte rufen Sie hierzu an unter: Durchwahl 3450 oder wählen Sie 12223450.</p>
																																																						
         	`,
      };
    },
  },
  {
    id: "Stay_In_THe_Negev",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    title: "ÜBERNACHTEN IN DER NEGEV WÜSTE",
    ctg: "eilat-negev",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                               
							 	
							 	<p>Bei einer Reise in den Negev warten nicht nur grandiose Panoramen und die Stille der Natur auf Sie, die einem bei dem Gedanken an eine Wüste sofort vor dem inneren Auge entstehen. Selbstverständlich findet man die Schönheit der Natur, die Ruhe und die wundervollen Ausblicke, die sich Wüstenreisende wünschen - der Negev ist aber auch ein Ort, der Urlaubsmöglichkeiten mit dem vollen Komfort der westlichen Welt und spannenden, abenteuerlichen Aktivitäten zu bieten hat.</p>
								<p>Im Negev finden Sie eine große Auswahl an Übernachtungsmöglichkeiten. Die gewählte Unterkunft ist nicht nur ein Platz zum Übernachten, sondern bietet Ihnen die Gelegenheit, das unbestreitbare Juwel des Negev kennen zu lernen – die Menschen vor Ort. Von den Kibbuz-Bewohnern über abgelegen lebende Bauern bis hin zu den Beduinen: Die Bewohner des Negev sind warmherzige und hilfsbereite Gastgeber. Hier folgt eine kleine Auswahl der Unterbringungsmöglichkeiten, die im Negev auf Sie warten:</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/stay-in-negev/1.jpg"} class="img-responsive" />
							 	</div>
								<p>Hotels – Im Negev gibt es eine große Auswahl an Hotels, die von Budget-Hotels bis zu preisgekrönten 5-Sterne-Luxushotels reichen, in denen Sie sich während Ihrer Auszeit in der Wüste stilvoll entspannen können.</p>
								<p>Hostels – erschwingliche Unterkünfte, die sich vor allem an junge Reisende richten. Hier genießen viele Touristen die Gelegenheit, sich mit anderen gleichgesinnten Reisenden aus der ganzen Welt zu treffen, sich zu unterhalten und abends andere Menschen kennenzulernen und oft dauerhafte Freundschaften zu knüpfen.</p>
								<p>Zimmers - Die israelische Version des Bed and Breakfast, normalerweise getrennt von den eigenen vier Wänden der Eigentümer. Zimmers sind oft etwas abgelegene und gemütliche Unterkünfte, die sich gut für Reisende auf der Suche nach Romantik und Ruhe eignen.&nbsp;</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/stay-in-negev/2.jpg"} class="img-responsive" />
							 	</div>
								<p>Hotelzelte der Beduinen – Diese wahrhaft einzigartige und authentische Form der Gastfreundschaft ist ein absolutes Muss im Negev. Sie lernen die Lebensweise der einheimischen Beduinen kennen und haben die außergewöhnliche Chance, an ihren Bräuchen in ihrer natürlichen Umgebung teilzuhaben – sehr zu empfehlen.</p>
								<p>Khans – Noch eine einzigartige Unterbringungsform im Negev. Die beliebten Kahns sind große Freiluftkomplexe, in denen Sie in Hütten oder Gemeinschaftsschlafräumen übernachten und alle Einrichtungen für den täglichen Bedarf finden. Kahns sind häufig eine einfachere und rustikalere Form der Unterbringung, sie sind aber auch eine ausgezeichnete Möglichkeit, die entspannte Atmosphäre der Region zu genießen, mit anderen Reisenden und Einheimischen in Kontakt zu kommen und sich als Teil der natürlichen Wüstenlandschaft zu fühlen.</p>
								<p>Abgelegene Bauernhöfe – Abgelegene Bauernhöfe haben sich in jüngerer Zeit als Form der Unterkunft entwickelt. Hier kommen Gäste über die gesamte Negev-Region verteilt in den Gästezimmern uriger, abgeschiedener Familienbetriebe unter.&nbsp; Sie verbinden eine ruhige Atmosphäre mit heimischem Komfort. Die Gehöfte bieten Privatsphäre, unglaubliche Panoramen und eine Gelegenheit, die sagenhafte Wüstenatmosphäre des Negev wie ein Einheimischer zu erleben.</p>
								<p>Kibbuz -&nbsp;Eine typisch israelische Form der Kommune: Unterkünfte im Kibbuz bieten gute Leistungen zu erschwinglichen Preisen. Der wahre Reiz der Kibbuzim liegt aber ohne Zweifel in ihrer besonderen Atmosphäre und dem Gemeinschaftsgefühl, das die freundliche, offenherzige und gastfreundliche Stimmung der Bewohner verbreitet und das einen angenehmen und unvergesslichen Aufenthalt garantiert.</p>
																																																						
         	`,
      };
    },
  },
  {
    id: "Desert_Adventure",
    bgImage: "/posts/bank/negev2/1.jpg",
    mobBgImage: "/posts/bank/negev2/M.jpg",
    title: "DER NEGEV",
    ctg: "eilat-negev",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                                <h2>Der Negev er perfekte Ort für Ihr persönliches Wüstenabenteuer</h2>
							 	
							 	<p>Für einen atemberaubend, erholsamen Urlaub unter der Wüstensonne gibt es keinen besseren Ort als den Negev.</p>
								<p >Ein Besuch in Israels Negev Wüste wird Sie begeistern. Der Negev bedeckt mehr als die Hälfte der gesamten Landfläche Israels und ist reich an Sand, Sonne, Naturschutzgebieten und touristischen Attraktionen. Das macht die südliche Region des Landes zu einem absoluten Muss auf Ihrer nächsten Israelreise, besonders wenn Sie eine klare, sternenhelle Nacht in der israelischen Wüste erleben möchten.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/desert-adventure/1.jpg"} class="img-responsive" />
							 	</div>
								<h3 >Entspannen Sie sich inmitten der Schönheit der Natur</h3>
								<p >Fahren Sie nach Süden in die israelische Negev Wüste, wo Sand und Sonne zusammentreffen, und lernen Sie die Region über ihre interessanten Wanderwege, atemberaubenden Ausblicke, historischen Stätten und touristischen Attraktionen genauer kennen. Sie können zahlreiche Aktivitäten ausprobieren, die Ihren individuellen Interessen entsprechen, und sich dabei unter die Einheimischen mischen, majestätische Tiere beobachten und historische Kulturen kennenlernen. Besuchen Sie den Ramon Krater, wo Ihr Blick in unendliche Weiten schweift. Entrollen Sie eine Yogamatte oder setzen Sie sich direkt in den farbigen Sand, um einen Moment tiefer Entspannung und intensiver Meditation zu genießen. Wenn die Sonne untergeht und der Himmel sich mit Sternen füllt, fahren Sie in ein Beduinen-Camp, wo Gäste wie Könige mit köstlichen Leckereien verwöhnt werden, aufregende Kamelritte machen oder in der Wüste zelten können. Oder Sie reisen entlang der Weihrauchroute und besuchen die vier Städte, die durch den Handel mit Gewürzen zu Reichtum kamen und heute Weltkulturerbe sind.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/desert-adventure/2.jpg"} class="img-responsive" />
							 	</div>
								<h3 >Familienurlaub unter dem Wüstenhimmel ist das Größte</h3>
								<p >In der Wüste Israels werden die Bedürfnisse jeder Familie auf Reisen mit spannenden Aktivitäten und wunderbarer Gastfreundschaft erfüllt - wobei in kurzer Zeit auch zahlreiche moderne Hotels und malerische Gästehäuser erreichbar sind. Der Negev steckt voller erstaunlicher Sehenswürdigkeiten und Aktivitäten und ist ein großartiger Ort, um sich auf einfache Weise zu vergnügen, z.&nbsp;B. mit einer Wanderung durch die Nationalparks, beim Radfahren auf den Radwegen der Region oder auf Touren mit dem Jeep (oder ATV) über die Dünenkämme und -täler. Bereits der Aufenthalt in der unglaublichen Weite und den Hügeln der Region ist ein aufregendes Abenteuer, unabhängig von der Aktivität, die Sie wählen. Und wenn Sie Ihren Urlaub entspannter verbringen möchten, besuchen Sie eines der Weingüter im Negev, träumen an einer kristallklaren Quelle im Herzen der israelischen Wüste oder lassen sich über einen Bauernhof im Süden führen, um sich in den Obstgärten zu erfrischen. Sie können Ihren Besuch in der Wüste auch nutzen, um sich nach einer kurzen Weiterreise im salzigen Toten Meer treiben zu lassen und Ihre Haut mit dem samtigen Schlamm der Region zu reinigen.</p>
								
																																																						
         	`,
      };
    },
  },
  {
    id: "Adventures_In_Galilea",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    title: "AKTIVURLAUB IN GALILÄA",
    ctg: "north",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                                <h2>Aktiv Abenteuer erleben in Galiläa</h2>
							 	
							 	<p>Die Vielfalt der Flüsse und Seen und die Küste Galiläas bieten jede Menge Spaß für alle Altersgruppen. Abenteuerlustige spüren beim Kajakrennen im Wildwasser mit ihren Freunden die Gischt auf den Gesichtern, während Familien oder Paare sich gemeinsam auf einem der vielen Flüsse Galiläas an den kühlen grünen Ufern entlang treiben lassen. Abkühlung finden Sie auch beim aufregendem Wassersport wie Wasserski, Tubing oder Kitesurfen auf dem See Genezareth. Bei Touristen ist es sehr beliebt, sich an den heißen Sandstränden Galiläas entlang der Küste zu entspannen oder die geheimnisvoll leuchtende Schönheit der Rosh Hanikra-Grotten zu bewundern.</p>
								<p>Und wer mag, kann zu Lande, in der Luft und auf dem Wasser der Extremsportart seiner Wahl nachgehen. Aktivtouristen holen sich Ihren Adrenalinkick beim Fallschirmspringen, Offroad-Fahrten über raue Bergpfade oder beim Abseilen an anspruchsvollen Klippen. Im Winter lockt das Hermon-Gebirge Wintersportler mit Ski und Snowboarding auf leichten oder anspruchsvollen Pisten.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/adventures-in-galilea/2.jpg"} class="img-responsive" />
							 	</div>
								<h3>Der atemberaubende Reichtum der Natur Galiläas</h3>
								<p>Galiläa ist mit einer Fülle landschaftlich reizvoller Gebiete gesegnet, wo Familien, Paare Alleinreisende und Gruppen die Umwelt auf Wanderungen genießen, die Tierwelt bestaunen oder einfach nur ein Picknick in der Stille der Natur genießen können. Bei Ausritten zu Pferde auf ruhigen Wegen oder beim Wandern oder Radfahren auf gut markierten Pfaden belohnt Galiläa Sie immer mit seiner Schönheit und mit Spaß und Spannung. Erleben Sie die Natur auf entspannte Art und Weise beim Beobachten von Vögeln und Wildtieren im Naturschutzgebiet Hula Valley, oder lassen Sie sich beim Aufsteigen in einem Heißluftballon in der Gilboa von dem Flickenteppich aus Wald, Feldern und Flüssen, der sich unter Ihnen ausbreitet, begeistern. Ein Erlebnis ganz anderer Art wartet beim Eintauchen in die religiöse Atmosphäre der heiligen Stätten von Christen, Juden und Baha‘i auf Sie.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/adventures-in-galilea/1.jpg"} class="img-responsive" />
							 	</div>
								<p>Die vielen Wanderwege in Galiläa ziehen das ganze Jahr lang Wanderer jeden Alters an. Ob Sie lieber schattige Spaziergänge entlang sanfter Bäche, den Nervenkitzel beim Bergsteigen und Abseilen oder die fantastische Aussicht vom Gipfel nach einem anspruchsvollen Anstieg genießen, hier finden Sie den perfekten Weg für sich. In Galiläa stehen Ihnen alle Optionen offen.</p>
								<p>photo credit: Itamar Grinberg</p>
																																														
         	`,
      };
    },
  },
  {
    id: "Eilat_",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    title: "WAS MACHT EILAT ZUM ULTIMATIVEN URLAUBSZIEL?",
    ctg: "eilat-negev",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                               <h2>Erkunden Sie die Stadt des ewigen Sonnenscheins</h2>
							 	
							 	<p><strong>Eilat</strong>, die südlichste Stadt Israels, bietet Ihnen alles, was Sie für einen perfekten Urlaub brauchen. Ob Sie romantisch in den Urlaub starten möchten, einen Familienurlaub planen, ein actionreiches Abenteuer suchen oder auf ein Partywochenende mit Ihren Freunden aus sind: dieser lebhafte Ferienort am Roten Meer ist das richtige Reiseziel für Sie. Die Mittelmeersonne, kristallklares Wasser, entspannende SPAs, ein pulsierendes Nachtleben, steuerfreies Einkaufen und unzählige Attraktionen - das ist Eilat für Sie!</p>
								<p><strong>Baden Sie in der Sonne! </strong>Weil in Eilat das ganze Jahr über die Sonne scheint, ist die beste Zeit für einen Besuch ... jederzeit! Selbst wenn Europa mitten im eisigen Winter friert, finden Sie in Eilat eine Zuflucht vor der Kälte. Springen Sie kurzentschlossen ins Flugzeug, um sich nach wenigen Stunden ganz neu belebt zu fühlen.</p>
								<p><strong>Wählen Sie Ihr zu Hause für den Urlaub. </strong>Hostels und kostengünstige Herbergen oder Luxushotels der Weltklasse und Boutique-Hotels stehen zur Auswahl. Ebenso familien- und gruppenfreundliche Ferienanlagen oder abgeschiedene, ruhige und romantische Ferienhäuser - Eilat bietet eine große Vielfalt an Unterkünften für jedes Budget und jeden Bedarf.</p>
								<p><strong>Springen Sie ins Wasser.</strong> Mit über 7 Kilometern atemberaubender Küste am Roten Meer hat Eilat in Sachen Wassersport viel zu bieten. Von Schnorcheln und Tauchen bis hin zu Windsurfen, Kitesurfen, Segeln und vielem mehr - in dieser Stadt finden Sie immer das passende Angebot.</p>
                                <div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/eilat1/1.jpg"} class="img-responsive" />
							 	</div>
								<p>Erleben Sie das <strong>Dolphin's Reef</strong>, einen familienfreundlichen Öko-Strand mit einem wunderschönen botanischen Garten, Entspannungspools und der Hauptattraktion - einer Chance, Delphine zu beobachten, sie zu berühren, mit ihnen zu schwimmen und zu tauchen. (<em>Und keine Sorge: Über alle Interaktionen mit den Delphinen entscheiden diese wundervollen Geschöpfen vollkommen nach eigenem Willen.</em>)</p>
								<p>Besuchen Sie das <strong>Unterwasser-Observatorium</strong>, eine der beliebtesten Attraktionen von Eilat, in dem Sie und Ihre Familie die einzigartige Unterwasserwelt des Roten Meeres kennenlernen können. Durch die riesigen Glasfenster können Sie die Haie, Schildkröten, Stachelrochen und farbenfrohen Fische des Roten Meers beobachten. Auf einer Fahrt mit einem Glasbodenschiff werden Sie sich wie ein Teil dieser magischen Unterwasserwelt fühlen.</p>
								
								<p>Verpassen Sie nicht das weltberühmte <strong>Naturreservat Coral Beach</strong> mit seinem atemberaubenden Korallenriff. Beim Schnorcheln und Tauchen sehen Sie die farbenfrohen Fische und außergewöhnlichen Wasserpflanzen in diesem seltenen empfindlichen natürlichen Lebensraum aus unmittelbarer Nähe.</p>
								<p><strong>Erleben Sie ein Wüstenabenteuer. </strong>Die Wüste Negev hat einige der spektakulärsten Panoramarouten in Israel zu bieten. Beim Wandern, auf dem Mountainbike oder bei einer Jeep-Tour haben Sie Gelegenheit, die Schönheit in Ihrer Umgebung zu entdecken und zu bestaunen.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/eilat1/2.jpg"} class="img-responsive" />
							 	</div>
								<p>Nur 25 Kilometer nördlich von Eilat liegt das <strong>Timna Park Valley</strong>. Machen Sie eine Tour mit, erkunden Sie die wunderschöne Landschaft und die besonderen Spuren der ersten Kupfermine der Welt und genießen Sie die vielen Attraktionen, die dort auf Familien und Abenteurer warten.</p>
								<p>Noch mehr Abenteuer gefällig? Von der Stadt aus erreichen Sie ganz einfach die übrigen Regionen Israels. Unternehmen Sie einen Tagesausflug an das Tote Meer oder nach Jerusalem.</p>
								<p><strong>Entspannen Sie sich. </strong>Eilat ist eine entspannte Stadt, in der Sie relaxen und sich wirklich ausruhen können. Diesem Charakter entsprechend finden Sie dort fantastische SPAs, in denen Sie sich mit zahlreichen Behandlungen von traditionellen Massagen bis hin zur Aquatherapie verwöhnen lassen können. <em>Vertrauen Sie uns, es lohnt sich!</em></p>
								<p><strong>Einkaufen, Speisen, Trinken und Feiern. </strong>Shoppen Sie im Basar an der Promenade, auf der luxuriösen Einkaufsmeile und in den zahlreichen Einkaufszentren der Stadt - alles ZOLLFREI!</p>
								<p><strong>Feiern Sie durch die Nacht.</strong> Lassen Sie sich von der beeindruckenden audiovisuellen Show des musikalischen Springbrunnens unterhalten: Auf Sie wartet eine Show im Broadway-Stil, die Tanz, Akrobatik, Lichteffekte, ein großartiger Soundtrack und viele weitere Überraschungen miteinander kombiniert.</p>
								<p>Essen Sie in einem der vielen Restaurants oder einer Bar in der Stadt, um danach die Tanzfläche in einem Club zu erobern.</p>
								<p>Es gibt nichts Besseres.</p>
																																														
         	`,
      };
    },
  },
  {
    id: "Mystic_And_Worldly_Meeting",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    title: "SAFED",
    ctg: "north",
    isVid: true,
    vidId: "i3_ihL51bHo",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                               
							 	
                                <h2>Wo Mystik und Weltliches aufeinandertreffen</h2>
							 	<p><strong>Tauchen Sie ein in die Kunst und eine heilige Atmosphäre, um sich für Ihr Leben inspirieren zu lassen</strong></p>
								<p>Das weithin unbegrenzte Panorama und die unberührte Bergluft von Safed werden Sie sofort bei Ihrer Ankunft in ihren Bann ziehen. Diese atemberaubende alte Bergstadt ist als Hauptstadt der historischen und modernen jüdischen Mystik und als höchste Stadt Galiläas und ganz Israels bekannt - in geologischer und spiritueller Hinsicht. Safed gehört zu den vier heiligen Städten im Judentum und vibriert mit einer spürbaren mystischen Kraft, die Sie in Erstaunen versetzen wird.</p>
								<p>Nur eine kurze Fahrt vom biblischen See Genezareth entfernt, empfängt Sie Safed mit malerischen Kopfsteinpflasterstraßen und inspirierender Architektur. Lauschen Sie auf die Geschichten der zahlreichen Seelen, die ihre Geheimnisse in den Mauern der alten Festung der Kreuzritter, die Zeugin der mamlukischen, osmanischen und britischer Einflüsse wurde, bewahren. Sie ist ein Mahnmal für den Unabhängigkeitskrieg während die außergewöhnlichen Synagogen und antiken Gräber weiterhin die reiche Geschichte des Ortes verkörpern und so mit ihnen teilen.</p>
								<div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/mystic-and-worldly-meeting/1.jpg"} class="img-responsive" />
							 	</div>
								<p><strong>Die ewige Hauptstadt der Kabbalah</strong></p>
								<p>Von Rabbi Shimon Bar-Yohai, der im 2. Jahrhundert das unter dem Namen Zohar bekannte Basiswerk über die Kabbalah verfasste, bis zu Ari HaKadosh, dem Vater der zeitgenössischen Kabbalah, war Safed immer die Heimat der wichtigsten Mystiker des Judentums und ihrer Schüler. Es war Ari HaKadosh, der im 16. Jahrhundert die kabbalistischen Lehren „demokratisierte“, indem er sie neu auslegte - so dass die Kabbalah auch für Laien erreichbar wurde.</p>
								<p>Wenn Sie sich Ihren Weg von einer Synagoge zur nächsten suchen, werden Sie spüren, warum Safed zur ewigen Heimat einer so langen Linie spirituell Suchender wurde, unabhängig von allem, was die Geschichte für sie vorgesehen haben mochte. Die Abuhav-Synagoge, deren architektonische Elemente den numerischen Mystizismus verkörpern, die Ari Ashkenazi-Synagoge, die Ari HaKadosh gewidmet ist, und die Yosef Caro-Synagoge werden Sie auf einer Reise durch die Zeit und in die oberen Zirkel der Mystik begleiten.</p>
								<p><strong>Eine Altstadt voller Inspirationen</strong></p>
								<p>Bereichern Sie Ihre Reise um weitere unvergessliche Momente, indem Sie durch die verwinkelten Kopfsteinpflastergassen der Altstadt spazieren, die einzigartigen Steingebäude betrachten und schließlich zur Künstlerkolonie gelangen. Dieser Teil der Altstadt beherbergt hochwertige Galerien, in denen Sie die exquisiten Werke einheimischer Künstler und vielfältige Judaica finden können - das ideale Viertel für Liebhaber aller Künste. Für Kulturbeflissene führt außerdem kein Weg an einem Besuch im Puppenmuseum und im Museum für Druckkunst vorbei.</p>
								<p>Safed kann für Ihren Körper genauso nahrhaft sein wie für Ihre Seele - die vielseitige Gastronomie der Altstadt hält für jeden Geschmack und Geldbeutel das Richtige bereit. Von jemenitischen Pfannkuchen und Speisen von den Straßenständen bis hin zu unerwarteten Köstlichkeiten in den Restaurants finden Sie in dieser liebenswerten Stadt mit reichhaltiger Tradition alles, was Sie gesucht haben - und noch viel mehr.</p>
																																																						
         	`,
      };
    },
  },
  {
    id: "Nazareth_The_Historical_Center",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    title: "NAZARETH: EIN JUWEL MIT VIELEN FACETTEN",
    ctg: "north",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                               
							 	
							 	<p>Nazareth ist weltweit als die Stadt bekannt, in der Jesus aufwuchs, und ist ein beliebtes Reiseziel für christliche Pilger. Diese Stadt ist ein wahres Juwel, das darauf wartet, von Ihnen entdeckt zu werden. Die Päpste Johannes Paul II. und Benedikt XVI. haben die Stadt bei ihren Besuchen in der Region aufgesucht, ebenso wie Zehntausende von Touristen, die jedes Jahr nach Nazareth strömen.</p>
								<p>Unzählige heilige Stätten, eine ereignisreiche Geschichte, farbenfrohe Märkte, eine dynamische kulinarische Szene, erstaunliche Gastfreundschaft und zahlreiche Sehenswürdigkeiten sind nur eine Auswahl der Gründe, warum eine Reise nach Israel nur mit einem Aufenthalt in Nazareth komplett ist.</p>
								<p>Erleben Sie die spannende, faszinierende, multikulturelle Vielfalt dieser Stadt. Sie werden sich verlieben.</p>
								<h3>Gehen Sie in den Fußspuren von Jesus von Nazareth</h3>
								<p>Erkunden Sie die Wiege des Christentums und nehmen dabei die einzigartige spirituelle Atmosphäre der Stadt in sich auf. Wandeln Sie in den Fußspuren von Jesus von Nazareth, der hier mit seiner Familie seine Kindheit und Jugend verbrachte.</p>
								<p>Besuchen Sie die faszinierende <strong>Verkündigungsbasilika</strong>, die dem christlichem Glauben zufolge genau an dem Ort steht, wo der Engel Gabriel Maria verkündigte, dass sie mit Jesus schwanger sei. Besuchen Sie die bezaubernde Kirche <strong>St. Gabriel</strong> und waten Sie durch den <strong>Marienbrunnen</strong>, dessen Wasser Heilkräfte besitzen soll. Und lassen Sie nicht die <strong>Synagogenkirche</strong> aus, die auf den Ruinen der alten Synagoge Jesu gebaut sein soll.</p>
                                  <div class="img-wrapper">
		                             <img src=${getImgUrl() +
                                   "/posts/nazareth-the-historical-center/1.jpg"} class="img-responsive" />
							 	</div>
								<p>Erkunden Sie weitere Teile der Stadt und lassen Sie sich von Ihren vielen Sehenswürdigkeiten bezaubern. Besuchen Sie das <strong>Dorf Nazareth</strong> und das <strong>internationale Zentrum „Maria von Nazareth“</strong>, wo die Geschichte zum Leben erwacht. Wandern Sie zum<strong> Berg Precipice</strong>, wo der Überlieferung zufolge das Volk von Nazareth versuchte, Jesus in den Abgrund zu stoßen. Nehmen Sie die besondere Energie des Ortes und den atemberaubenden Panoramablick in sich auf.</p>
								<p>Tipp: Weil es so viel zu tun und zu sehen gibt, könnte eine Führung das Richtige für den Besuch sein. Nichts ist so gut, wie einen Ort aus der Perspektive der Einheimischen kennenzulernen.</p>
								<p><strong>Lernen Sie die zahlreichen Sehenswürdigkeiten und die berühmte Gastfreundschaft von Nazareth kennen</strong></p>
								<p>Die größte arabische Stadt Israels hat seit Ihren Ursprüngen als kleines Dorf zu Römerzeiten einen weiten Weg zurückgelegt: Heute ist sie eine aufregende, moderne und lebendige Mini-Metropole mit aktiver Kulturszene, spannender Kulinarik und berühmter Gastfreundschaft.</p>
								<p>Lassen Sie sich ein auf ein Stadtabenteuer. Wandern Sie durch die Kopfsteinpflastergassen der lebhaften Märkte und nehmen Sie die Gerüche, Aromen und Geräusche in sich auf. Setzen Sie sich in ein Café und erfreuen Sie sich an dem guten Essen und dem authentischen kulturellen Leben. Dabei stehen immer auch Musik und faszinierende Gespräche auf dem Menü. Essen Sie in den einheimischen Restaurants, um einige der besten und kreativsten Gerichte zu genießen, die Sie je probiert haben. Unser Tipp: Auf keinen Fall das Dessert vergessen!</p>
								<p>Erkunden Sie die Architektur und die Museen der Stadt und besuchen Sie vielleicht sogar eine „Halva“-Fabrik. Übernachten Sie in einem der zahlreichen Hotels, Gasthäusern, Hostels oder nutzen Sie eine der sonstigen Möglichkeiten. Aus der Ferne ertönen die Kirchenglocken, die jeden Tag um Mittag in perfekter Harmonie läuten, um dem Augenblick der Verkündigung zu gedenken. In Nazareth laufen alle Fäden zusammen.</p>

																																														
         	`,
      };
    },
  },
  {
    id: 9,
    ctg: "telaviv",
    bgImage: "/posts/bank/crazy-night/1.jpg",
    mobBgImage: "/posts/bank/crazy-night/M.jpg",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    title: "Auf der Suche nach dem ultimativen Nachtleben?",
    smltitle: "",
    html: function() {
      return {
        __html: `

                               <div class="ac-cradit">
                                <span class="ac-cradit-text">Credits:</span>
                                    <br/>
                                    <span class="ac-cradit-text-1">Tel Aviv Jaffa municipality<br/></span<
                                    <span class="ac-cradit-text-2">UDINI prodactions<br/></span>
                                </div>
                                <p></p>
                                </div>
                               <h2>
                                 Buche jetzt deinen Trip nach Tel Aviv!

                               </h2>
                               <p>
                                 Amazing nightlife in Tel Aviv <a href="https://en.citiesbreak.com/Posts/telaviv/Amazing_Nightlife" target="_blank">Click here >> </a>
                               </p>
                                `,
      };
    },
  },

  {
    id: 10,
    ctg: "jerusalem",
    bgImage: "/posts/bank/heart-of-the-world/1.jpg",
    mobBgImage: "/posts/bank/heart-of-the-world/M.jpg",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    title: "Jerusalem - Das Herz der Welt",
    smltitle: "",
    html: function() {
      return {
        __html: `
                               
                                `,
      };
    },
  },

  {
    id: "Privacy_Policy",
    ctg: "telaviv",
    bgImage: "/HomeSlider/desktop/1.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "PRIVACY POLICY",
    smltitle: "",
    html: function() {
      return {
        __html: `
  
  
                  <p><u><span>Last updated</span></u><span>: March 4, 2020</span></p>
                  
                  <h3><span>OUR COMMITMENT TO YOU</span><span>&nbsp;</span></h3>
                  <p>We, at&nbsp;The Israeli government, the Ministry of Tourism ("<strong>us</strong>", "<strong>we</strong>" or the<strong>&nbsp;"Ministry</strong>") respect the privacy of our users (each, a "<strong>User</strong>" or "<strong>you</strong>") and are committed to protect the privacy of Users who access, download, install, register, use or engage with our website, our mobile application(s), and any other service we provide (the<strong>&nbsp;</strong>"<strong>Website</strong>" and "<strong>App</strong>" respectively, and collectively the "<strong>Service(s)</strong>"). &nbsp;</p>
                  <p>We've prepared this Privacy Policy to outline our practices with respect to collecting, using and disclosing your information when you use the Services. We encourage you to read this Privacy Policy carefully and use it to make informed decisions. By using the Services, you agree to the terms of this Privacy Policy and your continued use of the Services constitutes your ongoing agreement to the Privacy Policy.</p>
                  
                  <h3><span>CONTENTS</span></h3>
                  <p>
                    <a href="#Grounds" style="color:#000"><span>1. </span>GROUNDS FOR DATA COLLECTION</a><br/>
  
                    <a href="#WhatType" style="color:#000"><span>2. </span>WHAT TYPE OF DATA WE COLLECT?</a><br/>
  
                    <a href="#HowDoWeUse" style="color:#000"><span>3. </span>HOW DO WE USE THE DATA WE COLLECT?</a><br/>
  
                    <a href="#Tracking" style="color:#000"><span>4. </span>TRACKING TECHNOLOGIES</a><br/>
  
                    <a href="#WitWhom" style="color:#000"><span>5. </span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</a><br/>
  
                    <a href="#HowWeProtect" style="color:#000"><span>6. </span>HOW WE PROTECT YOUR INFORMATION</a><br/>
  
                    <a href="#Retention" style="color:#000"><span>7. </span>RETENTION</a><br/>
  
                    <a href="#UserRigths" style="color:#000"><span>8. </span>USER RIGHTS</a><br/>
  
                    <a href="#Transfer" style="color:#000"><span>9. </span>TRANSFER OF DATA OUTSIDE THE EEA</a><br/>
  
                    <a href="#OurPolicy" style="color:#000"><span>10. </span>OUR POLICY TOWARD CHILDREN</a><br/>
  
                    <a href="#HowToContactUs" style="color:#000"><span>11. </span>HOW TO CONTACT US?</a><br/>
  
                    <a href="#Updates" style="color:#000"><span>12. </span>UPDATES TO THIS POLICY</a><br/>
                  </p>
  
                  
                  <h3 id="Grounds"><span>GROUNDS FOR DATA COLLECTION</span><span>&nbsp;</span></h3>
                  <p><span>Processing of your “<strong>Personal Data</strong>” (meaning any information which may potentially allow your identification, either directly or by using reasonable means) is necessary for the performance of our contractual obligations towards you, for providing you with our Services and the operation of our Website, to protect our legitimate interests and for compliance with legal and regulatory obligations to which we are subject.</span></p>
                  <p><span>When you use our Services, you consent to the collection, storage, use, disclosure and other uses of your Personal Information as described in this Privacy Policy.</span></p>
                  
                  <h3 id="WhatType"><span>WHAT TYPE OF DATA WE COLLECT?</span></h3>
                  <h3><span>Personal Data</span></h3>
                  <p><span>In the course of using the Services, we may collect certain Personal Data to provide and improve the Services, to contact or identify you, to enable you to access certain parts of the Service</span><span>&nbsp;or as otherwise indicated in this Policy. We collect the following Personal Data about you</span><span>:</span></p>
                  <ul style="list-style-type: disc;margin-left:0in;">
                    <li><span>When you send us an email&nbsp;</span><span>or contact us through a contact form on the Website, we will collect your name and email address so we could respond to your inquiry. We may also collect any Personal Data that you choose to include in your inquiry to us.</span></li>
                    <li><span>Our webserver may also automatically collect your IP address, and unique online identifiers. These details are pseudonymized (cannot directly identify you) and are collected for the purpose of delivering relevant content and operating and improving our Service.</span></li>
                  </ul>
                  <h3><span>Non-Personal Data</span></h3>
                  <p><span>We also collect data about the use of our Service and the characteristics and activities of users, in order to operate it and improve it. We may collect the following non-Personal Data:&nbsp;</span><span>Your operating system, device type, session start/stop time, time zone, network connection type (e.g., Wi-Fi, cellular), your general location (city and country), and general information regarding your browser and device.</span></p>
                  <p><span>If we combine Personal Data with non-Personal Data, the combined data will be treated as Personal Data.&nbsp;</span></p>
                  
                  <h3 id="HowDoWeUse"><span>HOW DO WE USE THE DATA WE COLLECT?</span></h3>
                  <ul>
                    <li><strong><span>Provision of the Service</span></strong><em><span>&nbsp;–&nbsp;</span></em><span>we will use the Personal Data you provide us for the provision and improvement of our Service, providing customer support and to respond to your queries.&nbsp;</span></li>
                    <li><strong><span>Service announcements</span></strong><span>&nbsp;- we will use your Personal Data to communicate with you and to keep you informed of our latest updates to our Service and offer you service offers.</span></li>
                    <li><strong><span>Analytics, surveys and research</span></strong><span>&nbsp;- from time to time, we may conduct surveys or test features, and analyze the data we have to develop, evaluate and improve these features, all in order to improve our Services and offerings, and think of new and exciting features for our users.</span></li>
                    <li><strong><span>Protecting our interests</span></strong><em><span>&nbsp;-&nbsp;</span></em><span>we may use your Personal Data when we believe it’s necessary in order to take precautions against liabilities, investigate and defend ourselves against any third party claims or allegations, investigate and protect ourselves from fraud, protect the security or integrity of our services and protect the rights and property of the Ministry, its users and/or partners.&nbsp;</span></li>
                    <li><strong><span>Enforcing of policies</span></strong><span>&nbsp;- we may use your Personal Data in order to enforce our policies, including but not limited to our <a href="https://goisrael.com/Posts/telaviv/Privacy_Policy" style="text-decoration:underline;color:#000" target="_blank"> Terms </a></span><span style="line-height:115%;font-family:Calibri;font-size:8.0pt;color:windowtext;">
                       
                      </span><span style="line-height:;font-family:Calibri;line-height:;color:windowtext;">.&nbsp;</span></li>
                    <li><strong><span>Compliance with legal and regulatory requirements</span></strong><span>&nbsp;- we may use your Personal Data to investigate violations, and as required by law, regulation or other governmental authority, or to comply with a subpoena or similar legal process.</span></li>
                    <li><strong><span>Newsletter</span></strong><span>&nbsp;- we may use your Personal Data in order to send you our newsletter, if you subscribed to it. &nbsp;</span>
                      <ol style="list-style-type: circle;">
                        <li><u><span>Opt-out of receiving our newsletter</span></u><span>&nbsp;- You may choose not to receive our newsletter by clicking on the “unsubscribe” link contained therein. Please note that even if you unsubscribe, we may continue to send you Service-related updates and notifications, or reply to your queries and feedback you provide us.&nbsp;</span></li>
                      </ol>
                    </li>
                  </ul>
                  
                  <h3 id="Tracking"><span>TRACKING TECHNOLOGIES</span></h3>
                  <p><span>When you visit or access our Services we use (and authorize 3<sup>rd</sup> parties to use) pixels, cookies, events and other technologies (collectively, "<strong>Tracking Technologies</strong>"). Those allow us to automatically collect information about you, your device and your online behavior, in order to enhance your navigation in our Services, improve our Services’ performance, perform analytics and customize your experience. In addition, we may merge data we have with data collected through these tracking technologies and data we may obtain from other sources and, as a result, such data may become Personal Data.</span></p>
                  <p>If you do not accept the use of cookies by us, please disable cookies by following the instructions below. However, please note that disabling cookies might seriously affect the function, User experience and other features of our Services.</p>
                  <h3>Types of Tracking Technologies We Use</h3>
                  <p>There are two broad categories of cookies: (a) <strong>First party cookies</strong>, served directly by us to your computer or mobile device, and (b) <strong>Third party cookies</strong>, served by a third party. We use third party cookies for functionality, performance and analytics, and social media purposes.</p>
                  <p>Cookies can remain on your computer or mobile device for different periods of time. Some cookies are "session cookies" and expires upon closing of your browser. Other cookies are "persistent cookies", meaning that they survive after your browser is closed. They can be used by websites to recognize your computer when you open your browser and browse the Internet again.</p>
                  <p>For example, we use a performance tracking technology tool called “<strong>Google Analytics</strong>” to collect information about the use of the Website. Google Analytics collects information such as how often users visit this site, what pages they visit when they do so, and what other sites they used prior to coming to this Site. We use the information we get from Google Analytics to maintain and improve the Site and our products. We do not combine the information collected through the use of Google Analytics with personally identifiable information. Google’s ability to use and share information collected by Google Analytics about your visits to this Site is restricted by the Google Analytics Terms of Service, available at 
                    <a href="//www.google.com/analytics/terms/us.html" target="_blank" style="text-decoration:underline;color:#000">www.google.com/analytics/</a>, and the Google Privacy Policy, available at 
                    <a href="//www.google.com/policies/privacy/" target="_blank" style="text-decoration:underline;color:#000">www.google.com/policies/</a>. You can opt-out of Google's collection of Personal Data through Google Analytics by downloading and installing the Google Analytics Opt-out Browser Add-on, available at 
                    <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" style="text-decoration:underline;color:#000">tools.google.com/dlpage/gaoptout</a>.
                  </p>
                  <h3><span>Interest-Based Advertising &amp; User Choice</span></h3>
                  <p>Through our Services, we may display advertisements that are tailored to you, for example ads or partner services that are based on your recent browsing behavior. In order to tailor advertisements and services in which you might be interested, we as well as certain third parties may use Tracking Technologies to display advertisements based on your visits to the Websites, to target advertisements to you for products and services in which you might be interested, and to measure the effectiveness of the ads. You can turn off certain third party Tracking Technologies used for behavioral advertising purposes by visiting the Network Advertising Initiative&nbsp;or by visiting the&nbsp;DAA opt-out program&nbsp;or the&nbsp;EDAA consumer choice page&nbsp;(if you reside in the EU) using the links provided below. Please note that certain Tracking Technologies operate at the device and browser level, so to fully opt-out across devices, you will need to do so on each device and browser individually, as described below as well.</p>
                  <h3><span>How to Manage Your Tracking Technologies Settings</span></h3>
                  <p>There are various ways in which you can manage and control your Tracking Technologies settings. Please remember that, by deleting or blocking Tracking Technologies, some of the features of the Services may not work properly or as effectively.</p>
                  <p style="margin-bottom:6.0pt;"><strong>Turning off cookies via your web browser
                      <br>&nbsp;
                    </strong>Most web browsers will provide you with some general information about cookies, enable you to see what cookies are stored on your device, allow you to delete them all or on an individual basis, and enable you to block or allow cookies for all websites or individually selected websites. You can also normally turn off third party cookies separately. Please note that the settings offered by a browser or device often only apply to that particular browser or device. Information about cookies is usually found in the "Help" section of the web browser. Below are some links to some commonly used web browsers:</p>
                  <p>
                    <a href="https://support.google.com/chrome/answer/95647?hl=en" target="_blank" style="text-decoration:underline;color:#000"><span>Google Chrome</span></a><br/>
  
                    <a href="https://support.microsoft.com/en-us/kb/260971" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Explorer</span></a><br/>
  
                    <a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank" style="text-decoration:underline;color:#000"><span>Mozilla Firefox</span></a><br/>
  
                    <a href="https://support.apple.com/kb/PH5042?locale=en_US" target="_blank" style="text-decoration:underline;color:#000"><span>Safari (Desktop)</span></a><br/>
  
                    <a href="https://support.apple.com/en-us/HT201265" target="_blank" style="text-decoration:underline;color:#000"><span>Safari (Mobile)</span></a><br/>
  
                    <a href="//support.google.com/ics/nexus/bin/answer.py?hl=en&amp;answer=2425067" target="_blank" style="text-decoration:underline;color:#000"><span>Android Browser</span></a><br/>
  
                    <a href="//www.opera.com/help" target="_blank" style="text-decoration:underline;color:#000"><span>Opera</span></a><br/>
  
                    <a href="//www.opera.com/help/mobile/android#privacy" target="_blank" style="text-decoration:underline;color:#000"><span>Opera Mobile</span></a>
                  </p>
                  <p>For other browsers, please consult the documentation that your browser manufacturer provides.</p>
                  <p style="margin-bottom:6.0pt;"><strong>Turning off third party cookies
                      <br>&nbsp;
                    </strong>You can turn off certain third party targeting/advertising cookies by visiting the following link:&nbsp;
                    <a href="//www.networkadvertising.org/choices/" target="_blank" style="text-decoration:underline;color:#000">Network Advertising Initiative</a>.
                  </p>
                  <h3><span>Other helpful resources</span><br/></h3>
                  <p>
                  <span>To learn more about advertisers’ use of cookies the following links may be helpful:</span><br/>
                    <a href="//www.youronlinechoices.eu/" target="_blank" style="text-decoration:underline;color:#000"><span>European Interactive Digital Advertising Alliance (EU)</span></a><br/>
  
                    <a href="//www.iab.net/" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Advertising Bureau (US)</span></a><br/>
  
                    <a href="//www.iabeurope.eu/" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Advertising Bureau (EU)</span></a>
                  </p>
                  <p style="margin-top:6.0pt;margin-right:0in;margin-bottom:.0001pt;margin-left:0in;text-align:justify;"><strong>Turning off cookies on a mobile device</strong></h3>
                  <p>You can-opt out of certain types of interest-based advertising, by accessing the “settings” on your device:</p>
                  <ul style="list-style-type: disc;margin-left:undefined;">
                    <li><strong><span>If you're using an Apple device</span></strong><span>&nbsp;you can configure your device to limit ad tracking to by clicking on "settings" &gt; "privacy" &gt; "advertising" and toggling "limit ad tracking" to ‘on.’</span></strong></li>
                    <li><strong><span>If you're using an Android device</span></strong><span>&nbsp;you can opt out of most app-based tracking for advertising by opening the "Google Settings" app on your device, selecting "Ads", and then selecting the option to opt-out of interest-based ads.</span></strong></li>
                  </ul>
                  <p>Please note that the above information may change when manufacturers update their systems. Also note, that your device may use another platform, not described above. In that case, please consult the manufacturer documentation for further instructions.</p>
                  
                  <h3 id="WitWhom"><span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</span></h3>
                  <ul>
                    <li><strong><span>Internal concerned parties</span></strong><span>&nbsp;- we may share your information with other</span><span style="color:windowtext;">&nbsp;</span><span>government ministries, as well as our employees, as needed to provide our Services.</span></li>
                    <li><strong><span>Business partners</span></strong><span>&nbsp;- we may share your information with business partners such as storage and analytics providers who help us provide you with our Services. These third parties may have access to your Personal Data so that they may perform these tasks on our behalf, but they are obligated to comply with the highest security standards and applicable data protection legislation, and may not use your Personal Data for any other purpose.</span></li>
                    <li><strong><span>Compliance with laws and law enforcement entities</span></strong><span>&nbsp;- we cooperate with other governmental agencies and law enforcement officials to enforce and comply with the law. We will disclose Personal Data about you to government or law enforcement officials or private parties if we, in our sole discretion, believe necessary or appropriate to respond to claims and legal process (including but not limited to subpoenas), to protect our or a third party's property and rights, to protect the safety of the public or any person, or to prevent or stop any activity we may consider to be, or to pose a risk of being, illegal, unethical, inappropriate or legally actionable.&nbsp;</span></li>
                  </ul>
                  
                  <h3 id="HowWeProtect"><span>HOW WE PROTECT YOUR INFORMATION</span></h3>
                  <p><span>We have implemented administrative, technical, and physical safeguards to help prevent unauthorized access, use, or disclosure of your Personal Data. Your data is stored on secure servers and isn’t publicly available. We limit access of your information only to those employees or partners on a “need to know” basis, in order to enable the carrying out of the agreement between us.&nbsp;</span></p>
                  <p><span>While we seek to protect your information to ensure that it is kept confidential, we cannot absolutely guarantee its security. You should be aware that there is always some risk involved in transmitting information over the internet. While we strive to protect your Personal Data, we cannot ensure or warrant the security and privacy of your Personal Data or other content you transmit using the Service, and you do so at your own risk.&nbsp;</span></p>
                  
                  <h3 id="Retention"><span>RETENTION</span></h3>
                  <p><span>We will retain your Personal Data for as long as necessary to provide our Services, and as necessary to comply with our legal obligations, resolve disputes, and enforce our policies. Retention periods will be determined taking into account the type of information that is collected and the purpose for which it is collected, bearing in mind the requirements applicable to the situation and the need to destroy outdated, unused information at the earliest reasonable time. Under applicable regulations, we will keep records containing Personal Data, communications and anything else as required by applicable laws and regulations.&nbsp;</span></p>
                  
                  <h3  id="UserRigths"><span>USER RIGHTS</span></h3>
                  <h4><strong><span style="font-family:&quot;Calibri&quot;,sans-serif;color:windowtext;font-style:normal;">EU User Rights</span></strong></h4>
                  <p><span>As an EU resident, you may request to:&nbsp;</span></p>
                  <ol start="1" style="list-style-type: lower-alpha;margin-left: 0px;">
                    <li><span>Receive confirmation as to whether or not Personal Data concerning you is being processed, and access your stored Personal Data, together with supplementary information.&nbsp;</span></li>
                    <li><span>Receive a copy of Personal Data you directly volunteer to us in a structured, commonly used and machine-readable format.&nbsp;</span></li>
                    <li><span>Request rectification of your Personal Data that is in our control.</span></li>
                    <li><span>Request erasure of your Personal Data.&nbsp;</span></li>
                    <li><span>Object to the processing of Personal Data by us.&nbsp;</span></li>
                    <li><span>Request to restrict processing of your Personal Data by us.</span></li>
                    <li><span>Lodge a complaint with a supervisory authority.</span></li>
                  </ol>
                  <p><span>Please note that these rights pertain to EU residents only, are not absolute, and may be subject to our own legitimate interests and regulatory requirements.&nbsp;</span></p>
                  <p><span>Users Outside the EU -&nbsp;</span></strong><span>Some of the aforementioned rights are applicable in certain jurisdictions outside the EU as well. Users residing outside the EU are welcome to contact us for any questions or requests by using the details provided below.</span></p>
                  
                  <h3 id="Transfer"><span>TRANSFER OF DATA OUTSIDE THE EEA</span><span>&nbsp;</span></h3>
                  <p><span>If you reside in the European Union ("<strong>EU</strong>"), please note that some data recipients may be located outside the EEA. In such cases we will transfer your data only to such countries as approved by the European Commission as providing adequate level of data protection, or enter into legal agreements ensuring an adequate level of data protection.</span></p>
                  
                  <h3 id="OurPolicy"><span>OUR POLICY TOWARD CHILDREN</span></h3>
                  <p>We do not knowingly collect or solicit personal information from anyone under 18 years of age, (or the age of consent as determined under the applicable laws where the individual resides; “<strong>Age of Consent</strong>”). By accessing, using or interacting with our Services, you certify to us that you are not under the Age of Consent. In the event that we learn that we have collected personal information from an individual under the Age of Consent without verification of parental consent, we will delete that information upon discovery. If you believe that we might have any information from or about an individual under the Age of Consent, then please contact us through the contact details available below.</p>
                  
                  <h3 id="HowToContactUs"><span>HOW TO CONTACT US?</span></h3>
                  <p><span>If you wish to exercise any of the aforementioned rights, or receive more information, please contact us using the details below:</span><br/>Email:<a href="mailto:Dpo@tourism.gov.il" style="text-decoration:underline;color:#000"> Dpo@tourism.gov.il</a>
                  </p>
                  
                  <h3 id="Updates"><span>UPDATES TO THIS POLICY</span></h3>
                  <p>This Privacy Policy is subject to changes from time to time, in our sole discretion. The most current version will always be posted on our Services (as reflected in the "Last Updated" heading). You are advised to check for updates regularly. By continuing to access or use our Services after any revisions become effective, you agree to be bound by the updated Privacy Policy.&nbsp;</p>
  
                                 
                              `,
      };
    },
  },

  {
    id: "Destination_For_All",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: true,
    vidId: "QWA7qwsbbGY",
    title: "EIN REISEZIEL FÜR JEDEN GESCHMACK",
    smltitle: "",
    html: function() {
      return {
        __html: `
		
		
					<p>Israels Besucherzahlen verzeichnen ein beispielloses Wachstum. Immer mehr Menschen aus aller Welt erfüllen sich ihren Traum von einer Reise nach Israel. Das Ministerium für Tourismus setzt sich dafür ein, dass jeder, der einen Besuch machen möchte, dies auch tun kann – ungeachtet möglicher Beeinträchtigungen.</p>
					<p>Im Hinblick auf Barrierefreiheit ist Israels Gesetzgebung weltweit führend. Von der Infrastruktur bis zum Service bietet Israel beste Voraussetzungen, um einen problemlosen und angenehmen Aufenthalt zu ermöglichen.</p>
					<p class="ac-margin-bottom-5">Nachfolgend finden Sie Links zu allen Einrichtungen, die einen reibungslosen und barrierefreien Aufenthalt ermöglichen und gewährleisten.</p>
				   <div class="img-wrapper">
					   <img src=${"https://goisrael.com/assets/img//posts/destination-for-all/1.jpg"} class="img-responsive">
					</div><br>
					<h2 class="ac-margin-bottom-20">Nichtregierungsorganisationen (NGOs) im Tourismus</h2>
					<p><b>Keren Kayemeth LeIsrael</b></p>
					<p><u>Barrierefreie Wälder, Parks und Sehenswürdigkeiten in Israel</u><br/>
					In den letzten Jahren hat sich das KKL-JNF in seinen Wäldern und Parks um die Schaffung geeigneter Einrichtungen für Menschen mit körperlichen Beeinträchtigungen bemüht. Ziel ist es, die Natur allen Bevölkerungsgruppen zugänglich zu machen – indem eine Umgebung geschaffen wird, in der sich Menschen mit eingeschränkter Mobilität sicher und bequem bewegen können. Darüber hinaus ist man einen Schritt weiter gegangen und hat mit einzigartigen Projekten in Sonderschulen die Natur auf den Schulhof gebracht. 
					<br/>
					<a href="//www.kkl-jnf.org/tourism-and-recreation/accessible-forests-parks-sites-israel/" target="_blank">www.kkl-jnf.org</a>
				   </p>
		
				 	<p><b>Israelische Natur- und Parkbehörde</b></p>

				   <p>
				   Die INPA hat in den letzten Jahren viel dafür geleistet, ihre Einrichtungen für Menschen mit Behinderungen zugänglich zu machen. In allen Nationalparks und Naturreservaten, an historischen Sehenswürdigkeiten und Kulturdenkmälern wird an der Verbesserung der Zugangsmöglichkeiten und der Bereitstellung von Zugangshilfen gearbeitet.
				   </p>

				   <p>
				  	 Die INPA setzt alles daran, die Zahl der Besucher mit Behinderungen zu erhöhen, die die Stätten mit all ihren Aktivitäten besichtigen und genießen können.
					Auf der Website finden Sie weitere Informationen und entsprechende Karten. 
					<br/>
					<a href="https://www.parks.org.il">
						www.parks.org.il 
					</a>
				   </p>
					<div class="img-wrapper">
					<img src=${"https://goisrael.com/assets/img//posts/destination-for-all/2.jpg"} class="img-responsive">
				 </div><br>
					 <p><b>Yad Sarah für Touristen (Yad Sarah for Tourists)</b></p>
					 <p>
					 	Reisen ins Ausland stellen für Menschen mit besonderen Bedürfnissen eine besondere Herausforderung dar. Yad Sarah for Tourists bietet Hilfe, die einen angenehmen und erholsamen Urlaub für Betroffene und ihre Familie ermöglicht. Sobald die Pläne mit dem Tourismusbüro ausgearbeitet sind, kann sich der Besucher entspannt zurücklehnen – in dem Wissen, dass alle Vorbereitungen in den kompetenten Händen eines Yad Sarah-Vertreters liegen.
					 </p>
				   
						<p> <u>Einige der verfügbaren Services:</u>:<br/>
						 
						•  Ausleihe benötigter medizinischer Ausrüstung. Die Lieferung in ein Hotel oder eine Unterkunft kann gegen eine geringe Gebühr organisiert werden.<br/>
						•  Besondere Ausstattung des Hotelzimmers, um den Aufenthalt komfortabler zu gestalten, einschließlich spezieller Betten, Stühle etc.<br/>
						•  Ausleihe von Sauerstoffflaschen/Konzentratoren.<br/>
						•  Transport in rollstuhlgerechten Kleinbussen, einschließlich des Transfers zum und vom Flughafen und zum Besuch von Sehenswürdigkeiten.<br/>
						•  Empfehlung von Reiseführern, die auf die Führung von Touristen mit eingeschränkter Mobilität und besonderen Bedürfnissen spezialisiert sind, einschließlich Beratung über leicht zugängliche touristische Ziele.<br/>
						<br/>
						Der persönliche Service von Yad Sarah ist nach vorheriger Absprache mit dem Touristenbüro für jeden Reisenden mit besonderen Bedürfnissen in ganz Israel verfügbar.<br/>
					
					Für weitere Informationen oder um einen Transport oder eine Tour zu arrangieren, rufen Sie bitte das Touristenbüro unter +972-2-6444382 an oder senden Sie eine E-Mail an
					<a href="mailto:chaimvi@yadsarah.org.il">chaimvi@yadsarah.org.il </a>
					</p>
					<div class="img-wrapper">
					<img src=${"https://goisrael.com/assets/img//posts/destination-for-all/3.jpg"} class="img-responsive">
				 </div><br>
					<p><b>Access Israel</b></p>
					<p>Access Israel ist eine gemeinnützige Organisation, die den Zugang und die Integration von Menschen mit Behinderungen und älteren Menschen in allen Lebensbereichen fördert. Access Israel wurde 1999 von Yuval Wagner, einem ehemaligen Hubschrauberpiloten gegründet, der infolge eines Helikopterunfalls an den Rollstuhl gefesselt war. Access Israel realisiert verschiedene Projekte mit dem Ziel einer vollständig zugänglichen und integrativen Gesellschaft, darunter Aufklärungsprojekte in Schulen, Beratung in Sachen Barrierefreiheit für Firmen, Kurse zum Thema Barrierefreiheit, Gebärdensprachkurse, Konferenzen zu verschiedenen Themen und vieles mehr. Darüber hinaus setzt sich Access Israel für die Förderung der Barrierefreiheit im israelischen Recht ein, betreibt ein Beschwerdezentrum für Barrierefreiheit und organisiert Veranstaltungen zur Aufklärung der Öffentlichkeit. Access Israel fördert die Barrierefreiheit und die Integration in allen Lebensbereichen, in der Bildung, im Tourismus, in der Kultur, 
						in Notsituationen und mehr. Besuchen Sie die <br/>
						<a href="https://www.aisrael.org/?CategoryID=3030" target="_blank">Accessible Tourism on Access Israel website</a></p>
		
						<p><u>LOTEM</u> ist Israels größte Organisation für Outdoor-Lernaktivitäten für Kinder mit besonderen Bedürfnissen, die sowohl pädagogische Aktivitäten im Freien als auch barrierefreie Wanderungen anbietet. Surin Hershko, ein Kriegsheld, der 1976 bei der Operation Entebbe schwer verletzt wurde, ist Gründer und Vorsitzender von LOTEM. Seine Inspiration kommt aus dem Herzen: "Kindern das Grundrecht zu geben, das Leben im Freien zu genießen, ist der Sinn meines Lebens und erfüllt mich mit großer Freude." Der Hauptsitz, Emek HaShalom (Tal des Friedens), ist eine 40 Hektar große Farm im Norden Israels nahe Yokneam. Die Farm liegt in der Mitte eines wunderschönen Tals, umgeben von blühender Natur und einem friedlich dahinfließenden Fluss. Sie bietet praktische Lern- und Lebenserfahrung mit einem Lehrgarten, rollstuhlgerechten Oliven- und Weinpressen, einer Bäckerei und rollstuhlgerechten Wegen.</p>
						<p><u>LOTEM</u> versteht die bedeutende Rolle, die die Natur im Leben der Menschen in Israel spielt und die immense Wirkung, die der Zugang zur Gesellschaft hat – nicht nur für Einzelne mit besonderen Bedürfnissen, sondern auch für deren Familie und die Gemeinschaft. Als Teil seiner Arbeit mit der sichergestellt werden soll, dass kein Mitglied der Gesellschaft zurückbleibt, bietet LOTEM Kindern und Erwachsenen mit besonderen Anforderungen die Möglichkeit, im ganzen Land an Aktivitäten in freier Natur teilzunehmen und zu lernen. www.lotem.net  
						<a href="https://www.lotem.net/?page_id=386" target="_blank">www.lotem.net</a></p>
		
						<h2 class="ac-margin-bottom-20 ac-margin-top-20"> Verkehrsmittel</h2>
						<p><b>Israelische Flughafenbehörde</b></p>
						<p>Die israelische Flughafenbehörde ist in den ihr unterstehenden Einrichtungen gesetzlich zur Bereitstellung einer Infrastruktur verpflichtet, die der Barrierefreiheit von Passagieren mit besonderen Bedürfnissen dient. Nach den Transportvorschriften liegt die Verantwortung für die Abfertigung der betreuten Fluggäste und ihres Gepäcks ab dem Zeitpunkt ihres Eintretens in das Terminal oder ihres Aussteigens aus dem Flugzeug bei der jeweiligen Fluggesellschaft, mit der die Fluggäste reisen. Die eigentliche Dienstleistung am Flughafen Ben Gurion wird von speziellen Abfertigungsunternehmen erbracht. Der Service umfasst die Begleitung und Unterstützung behinderter Passagiere im Rahmen von Abflug und Ankunft. <br/>
						<a href="https://www.iaa.gov.il/en-us/airports/bengurion/pages/accessibility.aspx" target="_blank">www.iaa.gov.il</a></p>
						<p><b>Diese Abfertigungsgesellschaften kümmern sich vor Ort:</b></p>
						<p>Aero Handling: <a href="//www.aerohandling.com/" target="_blank">www.aerohandling.com</a><br/>
						Laufer Aviation: GHI: <a href="//lauferghi.com/" target="_blank">www.lauferghi.com</a><br/>
						QAS: <a href="//www.qasisrael.co.il" target="_blank">www.qasisrael.co.il</a><br/>
		
		
						</p>
						<div class="img-wrapper">
						<img src=${"https://goisrael.com/assets/img/posts/destination-for-all/4.jpg"} class="img-responsive">
					 </div><br>
		
						<p>Hotline des Verkehrsministeriums (Ortsgespräch) <a href="tel:5678*">5678*</a></p>
						
						<p><b>Öffentliche Verkehrsmittel</b></p>
						<p><u>Züge:</u> Sollten Sie beim Einsteigen in den Zug oder beim Verlassen des Zuges Hilfe durch einen Mitarbeiter am Bahnhof benötigen, stimmen Sie Ihre Reise bitte im Voraus mit 'Israel Railways' ab, entweder über die Website oder über die Service-Hotline unter <a href="tel:*5770">*5770</a>.</p>
						 
						<p><u>Israel Railways‘</u> tut sein Möglichstes, um Ihnen einen optimalen Service zu bieten, selbst wenn Sie Ihre Reise nicht im Voraus abgestimmt haben.</p>
						<p>Bitte stimmen Sie Fahrten zwischen 20:00 Uhr und 06:00 Uhr morgens sowie Fahrten am Samstagabend in jedem Fall im Voraus ab.</p>
						<p><u>Busse</u>: Alle Stadtbuslinien sind so eingerichtet, dass sie für alle zugänglich sind. Überlandbusse sind teilweise zugänglich.</p>
						<p><u>Taxis</u>: Es ist eher unwahrscheinlich unterwegs ein barrierefreies Taxi zu bekommen. Es wird empfohlen, ein Taxi aus  <a href="https://www.aisrael.org/?CategoryID=2657&ArticleID=64179" target="_blank">aus dieser Liste </a>vorzubestellen.</p>
		
		
						<h2  class="ac-margin-bottom-20 ac-margin-top-20">Unterkünfte</h2>
						<p>Alle Arten von Unterkünften in Israel, die 7 oder mehr Zimmer haben, sind gesetzlich verpflichtet, mindestens 1 barrierefreies Zimmer anzubieten. Alle Anbieter mit mindestens 25 Mitarbeitern müssen außerdem einen Beauftragten für Barrierefreiheit haben. Diese Gesetze stellen sicher, dass es in Israel keine Gegend gibt, in der nicht die perfekte Unterkunftslösung gefunden werden kann. Eine E-Mail-Koordination der Anforderungen vor dem Besuch ist zu empfehlen.</p>
						<div class="img-wrapper">
						<img src=${"https://goisrael.com/assets/img/posts/destination-for-all/5.jpg"} class="img-responsive">
					 </div><br>
						
						
						<div id="ac-left-nav">
						<h2 class="ac-margin-bottom-20 pr-fs-28 chapter-title inline-block">
											<!-- ngIf: Guide.ShowChaptersIndex -->
											<span class="ng-binding">Accessibility for those with special needs at the beaches:</span>
										</h2>
						<ul id="chaptersList" class="list-unstyled xs-mb-0">
							
								<!-- ngRepeat: chapter in Guide.Chapters -->
								<li data-show="1" class="ac-active ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope light-gray-e7-background blue-border-right-5px" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0">
									<!-- ngIf: Guide.ShowChaptersIndex -->
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt nounderline  ng-binding reforma-bold">Northern District</span>						                  
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
								
								</li><!-- end ngRepeat: chapter in Guide.Chapters -->
								<li data-show="2" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Haifa District</span>
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
								</li><!-- end ngRepeat: chapter in Guide.Chapters -->
								<li data-show="3" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Central District</span>
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
							
								</li><!-- end ngRepeat: chapter in Guide.Chapters -->
								<div class="clear show-on-mobile"></div>
								<li data-show="4" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Tel Aviv District</span>
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
							
								</li>
								<!-- end ngRepeat: chapter in Guide.Chapters --><li data-show="5" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Southern District</span>
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
							
								</li><!-- end ngRepeat: chapter in Guide.Chapters -->
								<div class="clear"></div>
							</ul>
						</div>
		
						<div id="res">
							<!-- ac part -->
							<div class="ac-part ac-part-1 ac-part-active">
		
								<div ng-include="chapterItem" class="row row-gov ng-scope">
									<!-- Sub Title -->
									<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
										<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
											<!-- ngIf: Guide.ShowChaptersIndex -->
											<span class="ng-binding">Northern District</span>
										</h2>
									</div>
		
									<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
										<!-- IMAGE TAG  ------->
										<!--- Image-->
		
								<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
									<div class="position-relative col-lg-10 lg-p-0">
										<!-- ngIf: CurrChapter.Image.ClickURLRef -->
		
										<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
										</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
										<!--Image desc-->
										<div>
											<div class="position-absolute">
												<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
											</div>
											<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
												<span class="small-txt ng-binding"></span>
												<span class="small-txt ng-binding"></span>
											</div><!-- end ngIf: CurrChapter.Image -->
										</div>
									</div>
								</div><!-- end ngIf: CurrChapter.Image -->
															<!-- End IMAGE TAG  ------->
		
															<div class="row row-gov no-gutters">
																<!--Content Text-->
																<div id="GuidesChapterContent-1" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
									<tbody>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Kineret Municipal Unio</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking&nbsp;&nbsp; &nbsp;</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Tzinbari</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
											<td>No</td>
											<td>No</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Berniki</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>At the nearby Shikmim beach</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Shikmim</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Hukok</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
											<td>No</td>
											<td>No</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Amnon</td>
											<td>Yes&nbsp;</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
											<td>No</td>
											<td>No</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Kinar</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Doga</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>Closed</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Tze’elon</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Kursi</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>At the nearby Levanon beach</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Levanon</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Halukim</td>
											<td>At the nearby Levanon beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>At the nearby Levanon beach</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Shizaf</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Dugit – Golan</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Gofra</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Tiberias</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Guy</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Galei Kineret - Rimonim</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Leonardo Pacific</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>Closed for renovations</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Coco Hot / Holiday Inn</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Jordan Valley Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Ein Gev Vacation</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Ginnosar</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Migdal Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Restal Magdala</td>
											<td>Yes</td>
											<td>No</td>
											<td>&nbsp;</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td class="rtecenter" colspan="6"><strong>Mateh Asher Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Banana Beach Achziv</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Nahariya</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Sokolov</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Galil Central</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Acco</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Argaman Central</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Hatmarim</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
									</tbody>
								</table></div></div>
		
								<p>&nbsp;</p>
								</div>
		
																<!--Chapters/Collapse-->
																<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
																	<!-- ngRepeat: collapse in CurrChapter.Collapses -->
																</div>
		
																<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
																<!--End of Chapters/Collapse-->
		
																<div class="col-12 xs-mb-25 lg-mb-30">
																	<!-- Files for Download-->
																	<!-- Files for Download-->
								<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
		
																	<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
		
																		<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
																			<!-- horizontal line -->
																			<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
																				<div class="horizontal-line"></div>
																			</div>
																		</div><!-- end ngIf: Guide.Chapters.length > 1 -->
		
																		<!--arrows subject nav  דפדוף-->
																		<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
																			<!--  לדף הקודם -->
																			<!-- ngIf: CurrChapterindex > 0 -->
		
																			<!--  לדף הבא -->
																			<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
																				<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
																					<span class="small-txt gray-txt width-100">Next page:</span>
																					<span class="reforma description-txt blue-txt width-100 ng-binding">Haifa District</span>
																				</div>
																				<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
																			</div>
																		</div>
																	</div><!-- end ngIf: !isOnPrintMode -->
																</div>
															</div>
														</div>
													</div>
		
							</div>
							<!-- ac- part -->
		
							<!-- ac part 2 -->
							<div class="ac-part ac-part-2">
							<div ng-include="chapterItem" class="row row-gov ng-scope">
							<!-- Sub Title -->
							<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
								<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
									<!-- ngIf: Guide.ShowChaptersIndex -->
									<span class="ng-binding">Haifa District</span>
								</h2>
							</div>
		
							<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
								<!-- IMAGE TAG  ------->
								<!--- Image-->
		
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
		<div class="position-relative col-lg-10 lg-p-0">
			<!-- ngIf: CurrChapter.Image.ClickURLRef -->
		
			<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
			</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
			<!--Image desc-->
			<div>
				<div class="position-absolute">
					<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
				</div>
				<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
					<span class="small-txt ng-binding"></span>
					<span class="small-txt ng-binding"></span>
				</div><!-- end ngIf: CurrChapter.Image -->
			</div>
		</div>
		</div><!-- end ngIf: CurrChapter.Image -->
								<!-- End IMAGE TAG  ------->
		
								<div class="row row-gov no-gutters">
									<!--Content Text-->
									<div id="GuidesChapterContent-2" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table align="left" cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
		<tbody>
			<tr style="background-color: rgb(255, 255, 255);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Kiryat Yam</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Zevulun</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Haifa</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Zamir 1</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Zamir 2</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Neot Kiryat Haim Central</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Bat Galim 1</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Bat Galim 2</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td class="rtecenter" colspan="6"><strong>Hof Hacarmel Regional Council</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Dor Central 2</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Neve Yam</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Aqueduct</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>Jisr a-Zarka Regional Council</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Jisr</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Hadera</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Kfar Yam&nbsp;</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Olga Central 2</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
		</tbody>
		</table></div></div>
		
		<p>&nbsp;</p>
		</div>
		
									<!--Chapters/Collapse-->
									<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
										<!-- ngRepeat: collapse in CurrChapter.Collapses -->
									</div>
		
									<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
									<!--End of Chapters/Collapse-->
		
									<div class="col-12 xs-mb-25 lg-mb-30">
										<!-- Files for Download-->
										<!-- Files for Download-->
		<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
		
										<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
		
											<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
												<!-- horizontal line -->
												<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
													<div class="horizontal-line"></div>
												</div>
											</div><!-- end ngIf: Guide.Chapters.length > 1 -->
		
											<!--arrows subject nav  דפדוף-->
											<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
												<!--  לדף הקודם -->
												<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
													<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
													<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
														<span class="small-txt gray-txt width-100"> Previous page:</span>
														<span class="reforma description-txt blue-txt width-100 ng-binding">Northern District</span>
													</div>
												</div><!-- end ngIf: CurrChapterindex > 0 -->
		
												<!--  לדף הבא -->
												<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
													<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
														<span class="small-txt gray-txt width-100">Next page:</span>
														<span class="reforma description-txt blue-txt width-100 ng-binding">Central District</span>
													</div>
													<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
												</div>
											</div>
										</div><!-- end ngIf: !isOnPrintMode -->
									</div>
								</div>
							</div>
						</div>
							</div>
							<!-- end ac part-2 -->
		
							<!-- ac-part-3 -->
							<div class="ac-part ac-part-3">
														<div ng-include="chapterItem" class="row row-gov ng-scope">
														<!-- Sub Title -->
														<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
															<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
																<!-- ngIf: Guide.ShowChaptersIndex -->
																<span class="ng-binding">Central District</span>
															</h2>
														</div>
								
														<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
															<!-- IMAGE TAG  ------->
															<!--- Image-->
								
								<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
									<div class="position-relative col-lg-10 lg-p-0">
										<!-- ngIf: CurrChapter.Image.ClickURLRef -->
								
										<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
										</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
										<!--Image desc-->
										<div>
											<div class="position-absolute">
												<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
											</div>
											<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
												<span class="small-txt ng-binding"></span>
												<span class="small-txt ng-binding"></span>
											</div><!-- end ngIf: CurrChapter.Image -->
										</div>
									</div>
								</div><!-- end ngIf: CurrChapter.Image -->
															<!-- End IMAGE TAG  ------->
								
															<div class="row row-gov no-gutters">
																<!--Content Text-->
																<div id="GuidesChapterContent-3" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
									<tbody>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Emek Hefer Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Michmoret – Station number 1</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Michmoret – Station number 2</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>Joint with number 1</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Beit Yannai</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>NeUrim Beach</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Netanya</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Kiryat Tzanz</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>HaOnot Beach</td>
											<td>Parking</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Ampi Beach</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Herzl</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>No</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Sironit Beach A</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Sironit Beach B</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Argaman Beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Poleg Beach</td>
											<td>Yes</td>
											<td>Bathrooms only</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Hof Hasharon Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Shefayim (Ga’ash)</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Rishon Le-Zion</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Beach number 1 – Hakachol (Blue) Beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Beach number 2 – Neve Hof Beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Beach number 3 – Hofit Beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Beach number 4 – Tel Yonah Beach</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Beach number 5 – Hayeladim (Children’s) Beach</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Beach number 6 – separate beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td class="rtecenter" colspan="6"><strong>Gan Raveh Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Palmahim Beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
									</tbody>
								</table></div></div>
								
								<p>&nbsp;</p>
								</div>
								
																<!--Chapters/Collapse-->
																<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
																	<!-- ngRepeat: collapse in CurrChapter.Collapses -->
																</div>
								
																<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
																<!--End of Chapters/Collapse-->
								
																<div class="col-12 xs-mb-25 lg-mb-30">
																	<!-- Files for Download-->
																	<!-- Files for Download-->
								<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
								
																	<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
								
																		<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
																			<!-- horizontal line -->
																			<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
																				<div class="horizontal-line"></div>
																			</div>
																		</div><!-- end ngIf: Guide.Chapters.length > 1 -->
								
																		<!--arrows subject nav  דפדוף-->
																		<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
																			<!--  לדף הקודם -->
																			<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
																				<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
																				<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
																					<span class="small-txt gray-txt width-100"> Previous page:</span>
																					<span class="reforma description-txt blue-txt width-100 ng-binding">Haifa District</span>
																				</div>
																			</div><!-- end ngIf: CurrChapterindex > 0 -->
								
																			<!--  לדף הבא -->
																			<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
																				<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
																					<span class="small-txt gray-txt width-100">Next page:</span>
																					<span class="reforma description-txt blue-txt width-100 ng-binding">Tel Aviv District</span>
																				</div>
																				<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
																			</div>
																		</div>
																	</div><!-- end ngIf: !isOnPrintMode -->
																</div>
															</div>
														</div>
													</div>
							</div>
							<!-- end ac-part-3 -->
		
							<!-- ac-part-4 -->
							<div class="ac-part ac-part-4">
							<div ng-include="chapterItem" class="row row-gov ng-scope">
					<!-- Sub Title -->
					<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
						<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
							<!-- ngIf: Guide.ShowChaptersIndex -->
							<span class="ng-binding">Tel Aviv District</span>
						</h2>
					</div>
		
					<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
						<!-- IMAGE TAG  ------->
						<!--- Image-->
		
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
		<div class="position-relative col-lg-10 lg-p-0">
		<!-- ngIf: CurrChapter.Image.ClickURLRef -->
		
		<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
		</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
		<!--Image desc-->
		<div>
		<div class="position-absolute">
			<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
		</div>
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
			<span class="small-txt ng-binding"></span>
			<span class="small-txt ng-binding"></span>
		</div><!-- end ngIf: CurrChapter.Image -->
		</div>
		</div>
		</div><!-- end ngIf: CurrChapter.Image -->
						<!-- End IMAGE TAG  ------->
		
						<div class="row row-gov no-gutters">
							<!--Content Text-->
							<div id="GuidesChapterContent-4" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
		<tbody>
		<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Herzliya</strong></td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Nof Yam</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Hasharon&nbsp;&nbsp; &nbsp;Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Zevulun</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Acadia North Beach&nbsp;&nbsp; &nbsp;</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Acadia South Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Acadia South Beach – Disabled</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Separate beach</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Tel Aviv - Jaffa</strong></td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>HaTzuk Beach – Station number 1</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Tel Baruch Beach – Station number 1</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Nordau (Metzitzim) Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Nordau separate beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Gordon</td>
		<td>No</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Bograshov</td>
		<td>No</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Allenby (Jerusalem)</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Charles Clore</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Jaffa – Givat HaAliyah</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Hilton North</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>HaTzuk Beach – Station number 2</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Frishman</td>
		<td>No</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Aviv Beach</td>
		<td>No</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Bat Yam</strong></td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>HaSela – Station number 1</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>HaSela – Station number 2</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>HaSela – Station number 3</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Sample Beach</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Riviera</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Separate beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Tayo</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		</tbody>
		</table></div></div>
		
		<p>&nbsp;</p>
		</div>
		
							<!--Chapters/Collapse-->
							<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
								<!-- ngRepeat: collapse in CurrChapter.Collapses -->
							</div>
		
							<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
							<!--End of Chapters/Collapse-->
		
							<div class="col-12 xs-mb-25 lg-mb-30">
								<!-- Files for Download-->
								<!-- Files for Download-->
		<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
		
								<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
		
									<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
										<!-- horizontal line -->
										<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
											<div class="horizontal-line"></div>
										</div>
									</div><!-- end ngIf: Guide.Chapters.length > 1 -->
		
									<!--arrows subject nav  דפדוף-->
									<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
										<!--  לדף הקודם -->
										<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
											<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
											<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
												<span class="small-txt gray-txt width-100"> Previous page:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding">Central District</span>
											</div>
										</div><!-- end ngIf: CurrChapterindex > 0 -->
		
										<!--  לדף הבא -->
										<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
											<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
												<span class="small-txt gray-txt width-100">Next page:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding">Southern District</span>
											</div>
											<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
										</div>
									</div>
								</div><!-- end ngIf: !isOnPrintMode -->
							</div>
						</div>
					</div>
				</div>
							</div>
							<!-- end ac-part-4 -->
		
							<!-- ac-part-5 -->
							<div class="ac-part ac-part-5">
							<div ng-include="chapterItem" class="row row-gov ng-scope">
							<!-- Sub Title -->
							<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
								<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
									<!-- ngIf: Guide.ShowChaptersIndex -->
									<span class="ng-binding">Southern District</span>
								</h2>
							</div>
		
							<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
								<!-- IMAGE TAG  ------->
								<!--- Image-->
		
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
		<div class="position-relative col-lg-10 lg-p-0">
			<!-- ngIf: CurrChapter.Image.ClickURLRef -->
		
			<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
			</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
			<!--Image desc-->
			<div>
				<div class="position-absolute">
					<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
				</div>
				<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
					<span class="small-txt ng-binding"></span>
					<span class="small-txt ng-binding"></span>
				</div><!-- end ngIf: CurrChapter.Image -->
			</div>
		</div>
		</div><!-- end ngIf: CurrChapter.Image -->
								<!-- End IMAGE TAG  ------->
		
								<div class="row row-gov no-gutters">
									<!--Content Text-->
									<div id="GuidesChapterContent-5" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
		<tbody>
			<tr style="background-color: rgb(255, 255, 255);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Ashdod</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Mei Ami Beach</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Lido</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>&nbsp;</td>
				<td>&nbsp;</td>
				<td>&nbsp;</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Oranim</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>Yes</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Hakshatot</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Separate beach</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Rova K</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Riviera</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td colspan="6" style="text-align: center;"><strong>Hof Ashkelon Regional Council</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Nitzanim</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Zikim</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Ashkelon</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Bar Kochva North</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Bar Kochva South</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Delila North</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Delila South</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Ashkelon National Park Beach</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Separate beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>לא</td>
				<td>לא</td>
				<td>לא</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>Tamar Regional Council</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Mazor Springs</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Meridian Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Hod Hotel Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Tzel Harim</td>
				<td>Yes</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Crown Plaza Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Lot</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Lot’s Wife</td>
				<td>Yes</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Ein Bokek South</td>
				<td>Yes</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Daniel Hotel Beach</td>
				<td>Yes</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Solarium Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Isrotel Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>International Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Leonardo Plaza Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Zohar Springs (North)</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Separate beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Leonardo Club Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Eilat&nbsp;&nbsp; &nbsp;</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><br>
				Separate beach</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Herod’s beach</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><br>
				Northwestern Beach</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
			</tr>
		</tbody>
		</table></div></div>
		
		<p>&nbsp;</p>
		</div>
		
									<!--Chapters/Collapse-->
									<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
										<!-- ngRepeat: collapse in CurrChapter.Collapses -->
									</div>
		
									<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
									<!--End of Chapters/Collapse-->
		
									<div class="col-12 xs-mb-25 lg-mb-30">
										<!-- Files for Download-->
										<!-- Files for Download-->
		<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
		
										<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
		
											<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
												<!-- horizontal line -->
												<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
													<div class="horizontal-line"></div>
												</div>
											</div><!-- end ngIf: Guide.Chapters.length > 1 -->
		
											<!--arrows subject nav  דפדוף-->
											<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-start" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
												<!--  לדף הקודם -->
												<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
													<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
													<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
														<span class="small-txt gray-txt width-100"> Previous page:</span>
														<span class="reforma description-txt blue-txt width-100 ng-binding">Tel Aviv District</span>
													</div>
												</div><!-- end ngIf: CurrChapterindex > 0 -->
		
												<!--  לדף הבא -->
												<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer ng-hide" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="true">
													<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
														<span class="small-txt gray-txt width-100">Next page:</span>
														<span class="reforma description-txt blue-txt width-100 ng-binding"></span>
													</div>
													<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
												</div>
											</div>
										</div><!-- end ngIf: !isOnPrintMode -->
									</div>
								</div>
							</div>
						</div>
							</div>
							<!-- end ac-part-5 -->
		
						</div>
						<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/destination-for-all/6.jpg"} class="img-responsive">
					 </div><br>
							
							`,
      };
    },
  },
];



// WEBPACK FOOTER //
// ./src/Posts/PostsData.js